/**
 * Generated by @openapi-codegen
 *
 * @version 1
 */
import * as reactQuery from "@tanstack/react-query";
import { useApiContext, ApiContext, queryKeyFn } from "./apiContext";
import type * as Fetcher from "./apiFetcher";
import { apiFetch } from "./apiFetcher";
import type * as Schemas from "./apiSchemas";

export type ApiBulkCreateEntityPermissionsPathParams = {
  entityId: string;
};

export type ApiBulkCreateEntityPermissionsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiBulkCreateEntityPermissionsResponse =
  Schemas.EntityPermissionOrMembershipOut[];

export type ApiBulkCreateEntityPermissionsRequestBody =
  Schemas.EntityPermissionIn[];

export type ApiBulkCreateEntityPermissionsVariables = {
  body?: ApiBulkCreateEntityPermissionsRequestBody;
  pathParams: ApiBulkCreateEntityPermissionsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiBulkCreateEntityPermissions = (
  variables: ApiBulkCreateEntityPermissionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiBulkCreateEntityPermissionsResponse,
    ApiBulkCreateEntityPermissionsError,
    ApiBulkCreateEntityPermissionsRequestBody,
    {},
    {},
    ApiBulkCreateEntityPermissionsPathParams
  >({
    url: "/resource/all/{entityId}/permissions_v2/bulk/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiBulkCreateEntityPermissions = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiBulkCreateEntityPermissionsResponse,
      ApiBulkCreateEntityPermissionsError,
      ApiBulkCreateEntityPermissionsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiBulkCreateEntityPermissionsResponse,
    ApiBulkCreateEntityPermissionsError,
    ApiBulkCreateEntityPermissionsVariables
  >({
    mutationFn: (variables: ApiBulkCreateEntityPermissionsVariables) =>
      fetchApiBulkCreateEntityPermissions({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetEntityGroupedPermissionsPathParams = {
  entityId: string;
};

export type ApiGetEntityGroupedPermissionsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetEntityGroupedPermissionsResponse =
  Schemas.GroupedPermissionsResponse[];

export type ApiGetEntityGroupedPermissionsVariables = {
  pathParams: ApiGetEntityGroupedPermissionsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetEntityGroupedPermissions = (
  variables: ApiGetEntityGroupedPermissionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetEntityGroupedPermissionsResponse,
    ApiGetEntityGroupedPermissionsError,
    undefined,
    {},
    {},
    ApiGetEntityGroupedPermissionsPathParams
  >({
    url: "/resource/all/{entityId}/permissions_v2/grouped_permissions/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetEntityGroupedPermissionsQueryKey = (
  variables: ApiGetEntityGroupedPermissionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all/{entityId}/permissions_v2/grouped_permissions/",
    operationId: "apiGetEntityGroupedPermissions",
    variables,
  });

export const useApiGetEntityGroupedPermissions = <
  TData = ApiGetEntityGroupedPermissionsResponse,
>(
  variables: ApiGetEntityGroupedPermissionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetEntityGroupedPermissionsResponse,
      ApiGetEntityGroupedPermissionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all/{entityId}/permissions_v2/grouped_permissions/",
    operationId: "apiGetEntityGroupedPermissions",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetEntityGroupedPermissionsResponse,
    ApiGetEntityGroupedPermissionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityGroupedPermissions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetEntityGroupedPermissions = <
  TData = ApiGetEntityGroupedPermissionsResponse,
>(
  variables: ApiGetEntityGroupedPermissionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetEntityGroupedPermissionsResponse,
      ApiGetEntityGroupedPermissionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all/{entityId}/permissions_v2/grouped_permissions/",
    operationId: "apiGetEntityGroupedPermissions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetEntityGroupedPermissionsResponse,
    ApiGetEntityGroupedPermissionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityGroupedPermissions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiAlterEntityPermissionPathParams = {
  entityId: string;
};

export type ApiAlterEntityPermissionError = Fetcher.ErrorWrapper<undefined>;

export type ApiAlterEntityPermissionVariables = {
  body: Schemas.AlterEntityPermissionRequest;
  pathParams: ApiAlterEntityPermissionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiAlterEntityPermission = (
  variables: ApiAlterEntityPermissionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiAlterEntityPermissionError,
    Schemas.AlterEntityPermissionRequest,
    {},
    {},
    ApiAlterEntityPermissionPathParams
  >({
    url: "/resource/all/{entityId}/permissions_v2/alter/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiAlterEntityPermission = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiAlterEntityPermissionError,
      ApiAlterEntityPermissionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiAlterEntityPermissionError,
    ApiAlterEntityPermissionVariables
  >({
    mutationFn: (variables: ApiAlterEntityPermissionVariables) =>
      fetchApiAlterEntityPermission({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiEntityHasCustomPermissionsPathParams = {
  entityId: string;
};

export type ApiEntityHasCustomPermissionsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiEntityHasCustomPermissionsVariables = {
  pathParams: ApiEntityHasCustomPermissionsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiEntityHasCustomPermissions = (
  variables: ApiEntityHasCustomPermissionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    boolean,
    ApiEntityHasCustomPermissionsError,
    undefined,
    {},
    {},
    ApiEntityHasCustomPermissionsPathParams
  >({
    url: "/resource/all/{entityId}/permissions_v2/has_custom/",
    method: "get",
    ...variables,
    signal,
  });

export const apiEntityHasCustomPermissionsQueryKey = (
  variables: ApiEntityHasCustomPermissionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all/{entityId}/permissions_v2/has_custom/",
    operationId: "apiEntityHasCustomPermissions",
    variables,
  });

export const useApiEntityHasCustomPermissions = <TData = boolean,>(
  variables: ApiEntityHasCustomPermissionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      boolean,
      ApiEntityHasCustomPermissionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all/{entityId}/permissions_v2/has_custom/",
    operationId: "apiEntityHasCustomPermissions",
    variables,
  });
  const result = reactQuery.useQuery<
    boolean,
    ApiEntityHasCustomPermissionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiEntityHasCustomPermissions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiEntityHasCustomPermissions = <TData = boolean,>(
  variables: ApiEntityHasCustomPermissionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      boolean,
      ApiEntityHasCustomPermissionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all/{entityId}/permissions_v2/has_custom/",
    operationId: "apiEntityHasCustomPermissions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    boolean,
    ApiEntityHasCustomPermissionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiEntityHasCustomPermissions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiResetEntityCustomPermissionsPathParams = {
  entityId: string;
};

export type ApiResetEntityCustomPermissionsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiResetEntityCustomPermissionsVariables = {
  pathParams: ApiResetEntityCustomPermissionsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiResetEntityCustomPermissions = (
  variables: ApiResetEntityCustomPermissionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiResetEntityCustomPermissionsError,
    undefined,
    {},
    {},
    ApiResetEntityCustomPermissionsPathParams
  >({
    url: "/resource/all/{entityId}/permissions_v2/reset_custom/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiResetEntityCustomPermissions = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiResetEntityCustomPermissionsError,
      ApiResetEntityCustomPermissionsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiResetEntityCustomPermissionsError,
    ApiResetEntityCustomPermissionsVariables
  >({
    mutationFn: (variables: ApiResetEntityCustomPermissionsVariables) =>
      fetchApiResetEntityCustomPermissions({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetEntityAccessControlRolesPathParams = {
  entityId: string;
};

export type GetEntityAccessControlRolesQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type GetEntityAccessControlRolesError = Fetcher.ErrorWrapper<undefined>;

export type GetEntityAccessControlRolesVariables = {
  pathParams: GetEntityAccessControlRolesPathParams;
  queryParams?: GetEntityAccessControlRolesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchGetEntityAccessControlRoles = (
  variables: GetEntityAccessControlRolesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedAccessControlEntityOut,
    GetEntityAccessControlRolesError,
    undefined,
    {},
    GetEntityAccessControlRolesQueryParams,
    GetEntityAccessControlRolesPathParams
  >({
    url: "/resource/{entityId}/access_control/roles/",
    method: "get",
    ...variables,
    signal,
  });

export const getEntityAccessControlRolesQueryKey = (
  variables: GetEntityAccessControlRolesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/{entityId}/access_control/roles/",
    operationId: "getEntityAccessControlRoles",
    variables,
  });

export const useGetEntityAccessControlRoles = <
  TData = Schemas.PagedAccessControlEntityOut,
>(
  variables: GetEntityAccessControlRolesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedAccessControlEntityOut,
      GetEntityAccessControlRolesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/{entityId}/access_control/roles/",
    operationId: "getEntityAccessControlRoles",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedAccessControlEntityOut,
    GetEntityAccessControlRolesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetEntityAccessControlRoles(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetEntityAccessControlRoles = <
  TData = Schemas.PagedAccessControlEntityOut,
>(
  variables: GetEntityAccessControlRolesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedAccessControlEntityOut,
      GetEntityAccessControlRolesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/{entityId}/access_control/roles/",
    operationId: "getEntityAccessControlRoles",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedAccessControlEntityOut,
    GetEntityAccessControlRolesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetEntityAccessControlRoles(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetEntityAccessControlRolePathParams = {
  entityId: string;
  roleId: string;
};

export type GetEntityAccessControlRoleQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type GetEntityAccessControlRoleError = Fetcher.ErrorWrapper<undefined>;

export type GetEntityAccessControlRoleVariables = {
  pathParams: GetEntityAccessControlRolePathParams;
  queryParams?: GetEntityAccessControlRoleQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchGetEntityAccessControlRole = (
  variables: GetEntityAccessControlRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedAccessControlRelationshipOut,
    GetEntityAccessControlRoleError,
    undefined,
    {},
    GetEntityAccessControlRoleQueryParams,
    GetEntityAccessControlRolePathParams
  >({
    url: "/resource/{entityId}/access_control/roles/{roleId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getEntityAccessControlRoleQueryKey = (
  variables: GetEntityAccessControlRoleVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/{entityId}/access_control/roles/{roleId}/",
    operationId: "getEntityAccessControlRole",
    variables,
  });

export const useGetEntityAccessControlRole = <
  TData = Schemas.PagedAccessControlRelationshipOut,
>(
  variables: GetEntityAccessControlRoleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedAccessControlRelationshipOut,
      GetEntityAccessControlRoleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/{entityId}/access_control/roles/{roleId}/",
    operationId: "getEntityAccessControlRole",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedAccessControlRelationshipOut,
    GetEntityAccessControlRoleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetEntityAccessControlRole(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetEntityAccessControlRole = <
  TData = Schemas.PagedAccessControlRelationshipOut,
>(
  variables: GetEntityAccessControlRoleVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedAccessControlRelationshipOut,
      GetEntityAccessControlRoleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/{entityId}/access_control/roles/{roleId}/",
    operationId: "getEntityAccessControlRole",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedAccessControlRelationshipOut,
    GetEntityAccessControlRoleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetEntityAccessControlRole(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetTablePreviewPathParams = {
  entityId: string;
};

export type ApiGetTablePreviewError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetTablePreviewVariables = {
  pathParams: ApiGetTablePreviewPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetTablePreview = (
  variables: ApiGetTablePreviewVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataFramePreviewResponse,
    ApiGetTablePreviewError,
    undefined,
    {},
    {},
    ApiGetTablePreviewPathParams
  >({
    url: "/resource/preview_v2/table/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetTablePreviewQueryKey = (
  variables: ApiGetTablePreviewVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/preview_v2/table/{entityId}/",
    operationId: "apiGetTablePreview",
    variables,
  });

export const useApiGetTablePreview = <
  TData = Schemas.DataFramePreviewResponse,
>(
  variables: ApiGetTablePreviewVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DataFramePreviewResponse,
      ApiGetTablePreviewError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/preview_v2/table/{entityId}/",
    operationId: "apiGetTablePreview",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DataFramePreviewResponse,
    ApiGetTablePreviewError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetTablePreview({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetTablePreview = <
  TData = Schemas.DataFramePreviewResponse,
>(
  variables: ApiGetTablePreviewVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DataFramePreviewResponse,
      ApiGetTablePreviewError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/preview_v2/table/{entityId}/",
    operationId: "apiGetTablePreview",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DataFramePreviewResponse,
    ApiGetTablePreviewError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetTablePreview({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetUrlPreviewPathParams = {
  entityId: string;
};

export type ApiGetUrlPreviewError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetUrlPreviewVariables = {
  pathParams: ApiGetUrlPreviewPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetUrlPreview = (
  variables: ApiGetUrlPreviewVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.UrlPreviewResponse,
    ApiGetUrlPreviewError,
    undefined,
    {},
    {},
    ApiGetUrlPreviewPathParams
  >({
    url: "/resource/preview_v2/url/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetUrlPreviewQueryKey = (
  variables: ApiGetUrlPreviewVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/preview_v2/url/{entityId}/",
    operationId: "apiGetUrlPreview",
    variables,
  });

export const useApiGetUrlPreview = <TData = Schemas.UrlPreviewResponse,>(
  variables: ApiGetUrlPreviewVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UrlPreviewResponse,
      ApiGetUrlPreviewError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/preview_v2/url/{entityId}/",
    operationId: "apiGetUrlPreview",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.UrlPreviewResponse,
    ApiGetUrlPreviewError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetUrlPreview({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetUrlPreview = <
  TData = Schemas.UrlPreviewResponse,
>(
  variables: ApiGetUrlPreviewVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.UrlPreviewResponse,
      ApiGetUrlPreviewError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/preview_v2/url/{entityId}/",
    operationId: "apiGetUrlPreview",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.UrlPreviewResponse,
    ApiGetUrlPreviewError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetUrlPreview({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiTablePropertiesGenerateProfilePathParams = {
  entityId: string;
};

export type ApiTablePropertiesGenerateProfileError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiTablePropertiesGenerateProfileVariables = {
  pathParams: ApiTablePropertiesGenerateProfilePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiTablePropertiesGenerateProfile = (
  variables: ApiTablePropertiesGenerateProfileVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    ApiTablePropertiesGenerateProfileError,
    undefined,
    {},
    {},
    ApiTablePropertiesGenerateProfilePathParams
  >({
    url: "/resource/table_properties/{entityId}/generate_profile/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiTablePropertiesGenerateProfile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BackgroundJobOut,
      ApiTablePropertiesGenerateProfileError,
      ApiTablePropertiesGenerateProfileVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BackgroundJobOut,
    ApiTablePropertiesGenerateProfileError,
    ApiTablePropertiesGenerateProfileVariables
  >({
    mutationFn: (variables: ApiTablePropertiesGenerateProfileVariables) =>
      fetchApiTablePropertiesGenerateProfile({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiGetEntityStakeholdersPathParams = {
  entityId: string;
};

export type ApiGetEntityStakeholdersError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetEntityStakeholdersVariables = {
  pathParams: ApiGetEntityStakeholdersPathParams;
} & ApiContext["fetcherOptions"];

/**
 * This endpoint is deprecated. Use the v2 endpoint instead.
 * Its kept for backwards compatibility.
 */
export const fetchApiGetEntityStakeholders = (
  variables: ApiGetEntityStakeholdersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityStakeholderResponse,
    ApiGetEntityStakeholdersError,
    undefined,
    {},
    {},
    ApiGetEntityStakeholdersPathParams
  >({
    url: "/resource/all_v2/{entityId}/stakeholders/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetEntityStakeholdersQueryKey = (
  variables: ApiGetEntityStakeholdersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/{entityId}/stakeholders/",
    operationId: "apiGetEntityStakeholders",
    variables,
  });

/**
 * This endpoint is deprecated. Use the v2 endpoint instead.
 * Its kept for backwards compatibility.
 */
export const useApiGetEntityStakeholders = <
  TData = Schemas.EntityStakeholderResponse,
>(
  variables: ApiGetEntityStakeholdersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EntityStakeholderResponse,
      ApiGetEntityStakeholdersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/{entityId}/stakeholders/",
    operationId: "apiGetEntityStakeholders",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.EntityStakeholderResponse,
    ApiGetEntityStakeholdersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityStakeholders(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * This endpoint is deprecated. Use the v2 endpoint instead.
 * Its kept for backwards compatibility.
 */
export const useSuspenseApiGetEntityStakeholders = <
  TData = Schemas.EntityStakeholderResponse,
>(
  variables: ApiGetEntityStakeholdersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.EntityStakeholderResponse,
      ApiGetEntityStakeholdersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/{entityId}/stakeholders/",
    operationId: "apiGetEntityStakeholders",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.EntityStakeholderResponse,
    ApiGetEntityStakeholdersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityStakeholders(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetResourcePossibleArchivedPathParams = {
  entityId: string;
};

export type ApiGetResourcePossibleArchivedError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetResourcePossibleArchivedVariables = {
  pathParams: ApiGetResourcePossibleArchivedPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetResourcePossibleArchived = (
  variables: ApiGetResourcePossibleArchivedVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityOut,
    ApiGetResourcePossibleArchivedError,
    undefined,
    {},
    {},
    ApiGetResourcePossibleArchivedPathParams
  >({
    url: "/resource/all_v2/entity/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetResourcePossibleArchivedQueryKey = (
  variables: ApiGetResourcePossibleArchivedVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/entity/{entityId}/",
    operationId: "apiGetResourcePossibleArchived",
    variables,
  });

export const useApiGetResourcePossibleArchived = <TData = Schemas.EntityOut,>(
  variables: ApiGetResourcePossibleArchivedVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EntityOut,
      ApiGetResourcePossibleArchivedError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/entity/{entityId}/",
    operationId: "apiGetResourcePossibleArchived",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.EntityOut,
    ApiGetResourcePossibleArchivedError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetResourcePossibleArchived(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetResourcePossibleArchived = <
  TData = Schemas.EntityOut,
>(
  variables: ApiGetResourcePossibleArchivedVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.EntityOut,
      ApiGetResourcePossibleArchivedError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/entity/{entityId}/",
    operationId: "apiGetResourcePossibleArchived",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.EntityOut,
    ApiGetResourcePossibleArchivedError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetResourcePossibleArchived(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMonitorPossibleStaledPathParams = {
  monitorId: string;
};

export type ApiGetMonitorPossibleStaledError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetMonitorPossibleStaledVariables = {
  pathParams: ApiGetMonitorPossibleStaledPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMonitorPossibleStaled = (
  variables: ApiGetMonitorPossibleStaledVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MonitorPreviewOut,
    ApiGetMonitorPossibleStaledError,
    undefined,
    {},
    {},
    ApiGetMonitorPossibleStaledPathParams
  >({
    url: "/resource/all_v2/monitor_preview/{monitorId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetMonitorPossibleStaledQueryKey = (
  variables: ApiGetMonitorPossibleStaledVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/monitor_preview/{monitorId}/",
    operationId: "apiGetMonitorPossibleStaled",
    variables,
  });

export const useApiGetMonitorPossibleStaled = <
  TData = Schemas.MonitorPreviewOut,
>(
  variables: ApiGetMonitorPossibleStaledVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.MonitorPreviewOut,
      ApiGetMonitorPossibleStaledError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/monitor_preview/{monitorId}/",
    operationId: "apiGetMonitorPossibleStaled",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.MonitorPreviewOut,
    ApiGetMonitorPossibleStaledError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorPossibleStaled(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMonitorPossibleStaled = <
  TData = Schemas.MonitorPreviewOut,
>(
  variables: ApiGetMonitorPossibleStaledVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.MonitorPreviewOut,
      ApiGetMonitorPossibleStaledError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/monitor_preview/{monitorId}/",
    operationId: "apiGetMonitorPossibleStaled",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.MonitorPreviewOut,
    ApiGetMonitorPossibleStaledError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorPossibleStaled(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPopularityUserQueriesPathParams = {
  entityId: string;
};

export type ApiGetPopularityUserQueriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPopularityUserQueriesResponse =
  Schemas.UserQueryPopularityOut[];

export type ApiGetPopularityUserQueriesVariables = {
  pathParams: ApiGetPopularityUserQueriesPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetPopularityUserQueries = (
  variables: ApiGetPopularityUserQueriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetPopularityUserQueriesResponse,
    ApiGetPopularityUserQueriesError,
    undefined,
    {},
    {},
    ApiGetPopularityUserQueriesPathParams
  >({
    url: "/resource/all_v2/user_queries/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetPopularityUserQueriesQueryKey = (
  variables: ApiGetPopularityUserQueriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/user_queries/{entityId}/",
    operationId: "apiGetPopularityUserQueries",
    variables,
  });

export const useApiGetPopularityUserQueries = <
  TData = ApiGetPopularityUserQueriesResponse,
>(
  variables: ApiGetPopularityUserQueriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetPopularityUserQueriesResponse,
      ApiGetPopularityUserQueriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/user_queries/{entityId}/",
    operationId: "apiGetPopularityUserQueries",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetPopularityUserQueriesResponse,
    ApiGetPopularityUserQueriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPopularityUserQueries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetPopularityUserQueries = <
  TData = ApiGetPopularityUserQueriesResponse,
>(
  variables: ApiGetPopularityUserQueriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetPopularityUserQueriesResponse,
      ApiGetPopularityUserQueriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/user_queries/{entityId}/",
    operationId: "apiGetPopularityUserQueries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetPopularityUserQueriesResponse,
    ApiGetPopularityUserQueriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPopularityUserQueries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiRemoveEntityFromTeamPathParams = {
  entityId: string;
};

export type ApiRemoveEntityFromTeamError = Fetcher.ErrorWrapper<undefined>;

export type ApiRemoveEntityFromTeamVariables = {
  body: Schemas.RemoveFromTeamBody;
  pathParams: ApiRemoveEntityFromTeamPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRemoveEntityFromTeam = (
  variables: ApiRemoveEntityFromTeamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiRemoveEntityFromTeamError,
    Schemas.RemoveFromTeamBody,
    {},
    {},
    ApiRemoveEntityFromTeamPathParams
  >({
    url: "/resource/all_v2/{entityId}/remove_from_team/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiRemoveEntityFromTeam = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiRemoveEntityFromTeamError,
      ApiRemoveEntityFromTeamVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiRemoveEntityFromTeamError,
    ApiRemoveEntityFromTeamVariables
  >({
    mutationFn: (variables: ApiRemoveEntityFromTeamVariables) =>
      fetchApiRemoveEntityFromTeam({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiAsyncBulkUpdateEntityError = Fetcher.ErrorWrapper<undefined>;

export type ApiAsyncBulkUpdateEntityRequestBody = Schemas.BulkUpdateEntity[];

export type ApiAsyncBulkUpdateEntityVariables = {
  body?: ApiAsyncBulkUpdateEntityRequestBody;
} & ApiContext["fetcherOptions"];

export const fetchApiAsyncBulkUpdateEntity = (
  variables: ApiAsyncBulkUpdateEntityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    ApiAsyncBulkUpdateEntityError,
    ApiAsyncBulkUpdateEntityRequestBody,
    {},
    {},
    {}
  >({
    url: "/resource/all_v2/async_bulk_update/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiAsyncBulkUpdateEntity = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      ApiAsyncBulkUpdateEntityError,
      ApiAsyncBulkUpdateEntityVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    string,
    ApiAsyncBulkUpdateEntityError,
    ApiAsyncBulkUpdateEntityVariables
  >({
    mutationFn: (variables: ApiAsyncBulkUpdateEntityVariables) =>
      fetchApiAsyncBulkUpdateEntity({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListCustomPropertiesError = Fetcher.ErrorWrapper<undefined>;

export type ListCustomPropertiesResponse = Schemas.CustomPropertyOut[];

export type ListCustomPropertiesVariables = ApiContext["fetcherOptions"];

/**
 * Get all custom properties in the workspace.
 */
export const fetchListCustomProperties = (
  variables: ListCustomPropertiesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ListCustomPropertiesResponse,
    ListCustomPropertiesError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/resource/all_v2/custom_properties/",
    method: "get",
    ...variables,
    signal,
  });

export const listCustomPropertiesQueryKey = (
  variables: ListCustomPropertiesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/custom_properties/",
    operationId: "listCustomProperties",
    variables,
  });

/**
 * Get all custom properties in the workspace.
 */
export const useListCustomProperties = <TData = ListCustomPropertiesResponse,>(
  variables: ListCustomPropertiesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListCustomPropertiesResponse,
      ListCustomPropertiesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/custom_properties/",
    operationId: "listCustomProperties",
    variables,
  });
  const result = reactQuery.useQuery<
    ListCustomPropertiesResponse,
    ListCustomPropertiesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListCustomProperties({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all custom properties in the workspace.
 */
export const useSuspenseListCustomProperties = <
  TData = ListCustomPropertiesResponse,
>(
  variables: ListCustomPropertiesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ListCustomPropertiesResponse,
      ListCustomPropertiesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/custom_properties/",
    operationId: "listCustomProperties",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ListCustomPropertiesResponse,
    ListCustomPropertiesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListCustomProperties({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CreateCustomPropertyError = Fetcher.ErrorWrapper<undefined>;

export type CreateCustomPropertyVariables = {
  body: Schemas.CustomPropertyIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a new custom property in the workspace.
 */
export const fetchCreateCustomProperty = (
  variables: CreateCustomPropertyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomPropertyOut,
    CreateCustomPropertyError,
    Schemas.CustomPropertyIn,
    {},
    {},
    {}
  >({
    url: "/resource/all_v2/custom_properties/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create a new custom property in the workspace.
 */
export const useCreateCustomProperty = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CustomPropertyOut,
      CreateCustomPropertyError,
      CreateCustomPropertyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CustomPropertyOut,
    CreateCustomPropertyError,
    CreateCustomPropertyVariables
  >({
    mutationFn: (variables: CreateCustomPropertyVariables) =>
      fetchCreateCustomProperty({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetCustomPropertyPathParams = {
  customPropertyId: string;
};

export type GetCustomPropertyError = Fetcher.ErrorWrapper<undefined>;

export type GetCustomPropertyVariables = {
  pathParams: GetCustomPropertyPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get details of a specific custom property.
 */
export const fetchGetCustomProperty = (
  variables: GetCustomPropertyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomPropertyOut,
    GetCustomPropertyError,
    undefined,
    {},
    {},
    GetCustomPropertyPathParams
  >({
    url: "/resource/all_v2/custom_properties/{customPropertyId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getCustomPropertyQueryKey = (
  variables: GetCustomPropertyVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/custom_properties/{customPropertyId}/",
    operationId: "getCustomProperty",
    variables,
  });

/**
 * Get details of a specific custom property.
 */
export const useGetCustomProperty = <TData = Schemas.CustomPropertyOut,>(
  variables: GetCustomPropertyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CustomPropertyOut,
      GetCustomPropertyError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/custom_properties/{customPropertyId}/",
    operationId: "getCustomProperty",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CustomPropertyOut,
    GetCustomPropertyError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCustomProperty({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get details of a specific custom property.
 */
export const useSuspenseGetCustomProperty = <
  TData = Schemas.CustomPropertyOut,
>(
  variables: GetCustomPropertyVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CustomPropertyOut,
      GetCustomPropertyError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/custom_properties/{customPropertyId}/",
    operationId: "getCustomProperty",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CustomPropertyOut,
    GetCustomPropertyError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCustomProperty({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type UpdateCustomPropertyPathParams = {
  customPropertyId: string;
};

export type UpdateCustomPropertyError = Fetcher.ErrorWrapper<undefined>;

export type UpdateCustomPropertyVariables = {
  body: Schemas.CustomPropertyIn;
  pathParams: UpdateCustomPropertyPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update an existing custom property.
 */
export const fetchUpdateCustomProperty = (
  variables: UpdateCustomPropertyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomPropertyOut,
    UpdateCustomPropertyError,
    Schemas.CustomPropertyIn,
    {},
    {},
    UpdateCustomPropertyPathParams
  >({
    url: "/resource/all_v2/custom_properties/{customPropertyId}/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update an existing custom property.
 */
export const useUpdateCustomProperty = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CustomPropertyOut,
      UpdateCustomPropertyError,
      UpdateCustomPropertyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CustomPropertyOut,
    UpdateCustomPropertyError,
    UpdateCustomPropertyVariables
  >({
    mutationFn: (variables: UpdateCustomPropertyVariables) =>
      fetchUpdateCustomProperty({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteCustomPropertyPathParams = {
  customPropertyId: string;
};

export type DeleteCustomPropertyError = Fetcher.ErrorWrapper<undefined>;

export type DeleteCustomPropertyVariables = {
  pathParams: DeleteCustomPropertyPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete a custom property.
 */
export const fetchDeleteCustomProperty = (
  variables: DeleteCustomPropertyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DeleteCustomPropertyError,
    undefined,
    {},
    {},
    DeleteCustomPropertyPathParams
  >({
    url: "/resource/all_v2/custom_properties/{customPropertyId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete a custom property.
 */
export const useDeleteCustomProperty = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteCustomPropertyError,
      DeleteCustomPropertyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteCustomPropertyError,
    DeleteCustomPropertyVariables
  >({
    mutationFn: (variables: DeleteCustomPropertyVariables) =>
      fetchDeleteCustomProperty({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type BulkUpdateEntityCustomPropertiesError =
  Fetcher.ErrorWrapper<undefined>;

export type BulkUpdateEntityCustomPropertiesVariables = {
  body: Schemas.CustomPropertyBulkUpdateIn;
} & ApiContext["fetcherOptions"];

/**
 * Update custom property values for multiple entities in a single request.
 * To bulk delete custom property values, set their values to an empty string ("").
 */
export const fetchBulkUpdateEntityCustomProperties = (
  variables: BulkUpdateEntityCustomPropertiesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomPropertyBulkUpdateOut,
    BulkUpdateEntityCustomPropertiesError,
    Schemas.CustomPropertyBulkUpdateIn,
    {},
    {},
    {}
  >({
    url: "/resource/all_v2/bulk_update/custom_properties/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update custom property values for multiple entities in a single request.
 * To bulk delete custom property values, set their values to an empty string ("").
 */
export const useBulkUpdateEntityCustomProperties = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CustomPropertyBulkUpdateOut,
      BulkUpdateEntityCustomPropertiesError,
      BulkUpdateEntityCustomPropertiesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CustomPropertyBulkUpdateOut,
    BulkUpdateEntityCustomPropertiesError,
    BulkUpdateEntityCustomPropertiesVariables
  >({
    mutationFn: (variables: BulkUpdateEntityCustomPropertiesVariables) =>
      fetchBulkUpdateEntityCustomProperties({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type UpdateEntityCustomPropertyPathParams = {
  customPropertyId: string;
  entityId: string;
};

export type UpdateEntityCustomPropertyError = Fetcher.ErrorWrapper<undefined>;

export type UpdateEntityCustomPropertyVariables = {
  body: Schemas.CustomPropertyValueIn;
  pathParams: UpdateEntityCustomPropertyPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update the value of a custom property for a specific entity.
 */
export const fetchUpdateEntityCustomProperty = (
  variables: UpdateEntityCustomPropertyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityWithCustomPropertyOut,
    UpdateEntityCustomPropertyError,
    Schemas.CustomPropertyValueIn,
    {},
    {},
    UpdateEntityCustomPropertyPathParams
  >({
    url: "/resource/all_v2/custom_properties/{customPropertyId}/{entityId}/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update the value of a custom property for a specific entity.
 */
export const useUpdateEntityCustomProperty = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EntityWithCustomPropertyOut,
      UpdateEntityCustomPropertyError,
      UpdateEntityCustomPropertyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EntityWithCustomPropertyOut,
    UpdateEntityCustomPropertyError,
    UpdateEntityCustomPropertyVariables
  >({
    mutationFn: (variables: UpdateEntityCustomPropertyVariables) =>
      fetchUpdateEntityCustomProperty({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiExportCatalogCsvQueryParams = {
  allow?: string[];
  search_term?: string | null;
  entity_type?: string | null;
  /**
   * @default {}
   */
  filter?: string | null;
  /**
   * @default {}
   */
  sort?: string | null;
  team_id: string;
  nesting_field?: string | null;
  /**
   * @default []
   */
  nested_ids?: string | null;
};

export type ApiExportCatalogCsvError = Fetcher.ErrorWrapper<undefined>;

export type ApiExportCatalogCsvVariables = {
  queryParams: ApiExportCatalogCsvQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Export catalog items to CSV based on the provided filters and search criteria.
 * Creates a background job to handle the export asynchronously.
 */
export const fetchApiExportCatalogCsv = (
  variables: ApiExportCatalogCsvVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    ApiExportCatalogCsvError,
    undefined,
    {},
    ApiExportCatalogCsvQueryParams,
    {}
  >({
    url: "/resource/all_v2/async_export_csv/",
    method: "get",
    ...variables,
    signal,
  });

export const apiExportCatalogCsvQueryKey = (
  variables: ApiExportCatalogCsvVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/async_export_csv/",
    operationId: "apiExportCatalogCsv",
    variables,
  });

/**
 * Export catalog items to CSV based on the provided filters and search criteria.
 * Creates a background job to handle the export asynchronously.
 */
export const useApiExportCatalogCsv = <TData = Schemas.BackgroundJobOut,>(
  variables: ApiExportCatalogCsvVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BackgroundJobOut,
      ApiExportCatalogCsvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/async_export_csv/",
    operationId: "apiExportCatalogCsv",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.BackgroundJobOut,
    ApiExportCatalogCsvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiExportCatalogCsv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Export catalog items to CSV based on the provided filters and search criteria.
 * Creates a background job to handle the export asynchronously.
 */
export const useSuspenseApiExportCatalogCsv = <
  TData = Schemas.BackgroundJobOut,
>(
  variables: ApiExportCatalogCsvVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.BackgroundJobOut,
      ApiExportCatalogCsvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/async_export_csv/",
    operationId: "apiExportCatalogCsv",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.BackgroundJobOut,
    ApiExportCatalogCsvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiExportCatalogCsv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiExportEntityPathParams = {
  entityId: string;
};

export type ApiExportEntityQueryParams = {
  allow?: string[];
  export_type: "json" | "csv";
  /**
   * @default direct_children
   */
  include?: "single_entity" | "direct_children" | "all_descendants";
};

export type ApiExportEntityError = Fetcher.ErrorWrapper<undefined>;

export type ApiExportEntityVariables = {
  pathParams: ApiExportEntityPathParams;
  queryParams: ApiExportEntityQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Export entity and its direct children entities to CSV or JSON.
 * Creates a background job to handle the export asynchronously.
 */
export const fetchApiExportEntity = (
  variables: ApiExportEntityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    ApiExportEntityError,
    undefined,
    {},
    ApiExportEntityQueryParams,
    ApiExportEntityPathParams
  >({
    url: "/resource/all_v2/async_export_entity/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiExportEntityQueryKey = (
  variables: ApiExportEntityVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/async_export_entity/{entityId}/",
    operationId: "apiExportEntity",
    variables,
  });

/**
 * Export entity and its direct children entities to CSV or JSON.
 * Creates a background job to handle the export asynchronously.
 */
export const useApiExportEntity = <TData = Schemas.BackgroundJobOut,>(
  variables: ApiExportEntityVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BackgroundJobOut,
      ApiExportEntityError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/async_export_entity/{entityId}/",
    operationId: "apiExportEntity",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.BackgroundJobOut,
    ApiExportEntityError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiExportEntity({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Export entity and its direct children entities to CSV or JSON.
 * Creates a background job to handle the export asynchronously.
 */
export const useSuspenseApiExportEntity = <TData = Schemas.BackgroundJobOut,>(
  variables: ApiExportEntityVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.BackgroundJobOut,
      ApiExportEntityError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/async_export_entity/{entityId}/",
    operationId: "apiExportEntity",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.BackgroundJobOut,
    ApiExportEntityError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiExportEntity({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiArchivedRestoreEntitiesError = Fetcher.ErrorWrapper<undefined>;

export type ApiArchivedRestoreEntitiesRequestBody = string[];

export type ApiArchivedRestoreEntitiesVariables = {
  body?: ApiArchivedRestoreEntitiesRequestBody;
} & ApiContext["fetcherOptions"];

export const fetchApiArchivedRestoreEntities = (
  variables: ApiArchivedRestoreEntitiesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiArchivedRestoreEntitiesError,
    ApiArchivedRestoreEntitiesRequestBody,
    {},
    {},
    {}
  >({ url: "/resource/all_v2/restore/", method: "post", ...variables, signal });

export const useApiArchivedRestoreEntities = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiArchivedRestoreEntitiesError,
      ApiArchivedRestoreEntitiesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiArchivedRestoreEntitiesError,
    ApiArchivedRestoreEntitiesVariables
  >({
    mutationFn: (variables: ApiArchivedRestoreEntitiesVariables) =>
      fetchApiArchivedRestoreEntities({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetInferredTablesDatatreeQueryParams = {
  team_id: string;
  integration_id: string;
};

export type ApiGetInferredTablesDatatreeError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetInferredTablesDatatreeResponse =
  Schemas.InferredDatabaseNode[];

export type ApiGetInferredTablesDatatreeVariables = {
  queryParams: ApiGetInferredTablesDatatreeQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetInferredTablesDatatree = (
  variables: ApiGetInferredTablesDatatreeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetInferredTablesDatatreeResponse,
    ApiGetInferredTablesDatatreeError,
    undefined,
    {},
    ApiGetInferredTablesDatatreeQueryParams,
    {}
  >({
    url: "/resource/all_v2/inferred_tables_datatree/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetInferredTablesDatatreeQueryKey = (
  variables: ApiGetInferredTablesDatatreeVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/inferred_tables_datatree/",
    operationId: "apiGetInferredTablesDatatree",
    variables,
  });

export const useApiGetInferredTablesDatatree = <
  TData = ApiGetInferredTablesDatatreeResponse,
>(
  variables: ApiGetInferredTablesDatatreeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetInferredTablesDatatreeResponse,
      ApiGetInferredTablesDatatreeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/inferred_tables_datatree/",
    operationId: "apiGetInferredTablesDatatree",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetInferredTablesDatatreeResponse,
    ApiGetInferredTablesDatatreeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetInferredTablesDatatree(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetInferredTablesDatatree = <
  TData = ApiGetInferredTablesDatatreeResponse,
>(
  variables: ApiGetInferredTablesDatatreeVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetInferredTablesDatatreeResponse,
      ApiGetInferredTablesDatatreeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/inferred_tables_datatree/",
    operationId: "apiGetInferredTablesDatatree",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetInferredTablesDatatreeResponse,
    ApiGetInferredTablesDatatreeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetInferredTablesDatatree(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetBottomUpCatalogTreeIntegrationsQueryParams = {
  team_id: string;
};

export type ApiGetBottomUpCatalogTreeIntegrationsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetBottomUpCatalogTreeIntegrationsResponse =
  Schemas.IntegrationNode[];

export type ApiGetBottomUpCatalogTreeIntegrationsVariables = {
  queryParams: ApiGetBottomUpCatalogTreeIntegrationsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetBottomUpCatalogTreeIntegrations = (
  variables: ApiGetBottomUpCatalogTreeIntegrationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetBottomUpCatalogTreeIntegrationsResponse,
    ApiGetBottomUpCatalogTreeIntegrationsError,
    undefined,
    {},
    ApiGetBottomUpCatalogTreeIntegrationsQueryParams,
    {}
  >({
    url: "/resource/all_v2/bottom_up_catalog_tree_integrations/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetBottomUpCatalogTreeIntegrationsQueryKey = (
  variables: ApiGetBottomUpCatalogTreeIntegrationsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/bottom_up_catalog_tree_integrations/",
    operationId: "apiGetBottomUpCatalogTreeIntegrations",
    variables,
  });

export const useApiGetBottomUpCatalogTreeIntegrations = <
  TData = ApiGetBottomUpCatalogTreeIntegrationsResponse,
>(
  variables: ApiGetBottomUpCatalogTreeIntegrationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetBottomUpCatalogTreeIntegrationsResponse,
      ApiGetBottomUpCatalogTreeIntegrationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/bottom_up_catalog_tree_integrations/",
    operationId: "apiGetBottomUpCatalogTreeIntegrations",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetBottomUpCatalogTreeIntegrationsResponse,
    ApiGetBottomUpCatalogTreeIntegrationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBottomUpCatalogTreeIntegrations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetBottomUpCatalogTreeIntegrations = <
  TData = ApiGetBottomUpCatalogTreeIntegrationsResponse,
>(
  variables: ApiGetBottomUpCatalogTreeIntegrationsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetBottomUpCatalogTreeIntegrationsResponse,
      ApiGetBottomUpCatalogTreeIntegrationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/bottom_up_catalog_tree_integrations/",
    operationId: "apiGetBottomUpCatalogTreeIntegrations",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetBottomUpCatalogTreeIntegrationsResponse,
    ApiGetBottomUpCatalogTreeIntegrationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBottomUpCatalogTreeIntegrations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetBottomUpDatatreeQueryParams = {
  team_id: string;
  filters: string;
};

export type ApiGetBottomUpDatatreeError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetBottomUpDatatreeResponse = {
  [key: string]: Schemas.DataTreeNode;
};

export type ApiGetBottomUpDatatreeVariables = {
  queryParams: ApiGetBottomUpDatatreeQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Calculates a partial catalog tree in a bottom-up manner, starting with a filtered set of entities
 * and building up through their ancestors.
 *
 * This method builds a hierarchical tree structure by:
 * 1. Finding all entities that match the provided filters
 * 2. Building upwards to include their parent and grandparent entities
 * 3. Organizing them into a tree structure where each node contains its children
 *
 * The tree is built "bottom-up" because we start with the leaf nodes (entities matching the filters)
 * and work our way up to their ancestors, rather than starting at the root and working down.
 *
 * Args:
 *     request: The HTTP request object
 *     team_id: The ID of the team to filter entities by
 *     filters: JSON string containing filter criteria for the initial entity set
 *
 * Returns:
 *     Dict[str, DataTreeNode]: A dictionary mapping root entity IDs to their nodes,
 *     where each node contains the full tree of entities under it.
 */
export const fetchApiGetBottomUpDatatree = (
  variables: ApiGetBottomUpDatatreeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetBottomUpDatatreeResponse,
    ApiGetBottomUpDatatreeError,
    undefined,
    {},
    ApiGetBottomUpDatatreeQueryParams,
    {}
  >({
    url: "/resource/all_v2/bottom_up_datatree/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetBottomUpDatatreeQueryKey = (
  variables: ApiGetBottomUpDatatreeVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/bottom_up_datatree/",
    operationId: "apiGetBottomUpDatatree",
    variables,
  });

/**
 * Calculates a partial catalog tree in a bottom-up manner, starting with a filtered set of entities
 * and building up through their ancestors.
 *
 * This method builds a hierarchical tree structure by:
 * 1. Finding all entities that match the provided filters
 * 2. Building upwards to include their parent and grandparent entities
 * 3. Organizing them into a tree structure where each node contains its children
 *
 * The tree is built "bottom-up" because we start with the leaf nodes (entities matching the filters)
 * and work our way up to their ancestors, rather than starting at the root and working down.
 *
 * Args:
 *     request: The HTTP request object
 *     team_id: The ID of the team to filter entities by
 *     filters: JSON string containing filter criteria for the initial entity set
 *
 * Returns:
 *     Dict[str, DataTreeNode]: A dictionary mapping root entity IDs to their nodes,
 *     where each node contains the full tree of entities under it.
 */
export const useApiGetBottomUpDatatree = <
  TData = ApiGetBottomUpDatatreeResponse,
>(
  variables: ApiGetBottomUpDatatreeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetBottomUpDatatreeResponse,
      ApiGetBottomUpDatatreeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/bottom_up_datatree/",
    operationId: "apiGetBottomUpDatatree",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetBottomUpDatatreeResponse,
    ApiGetBottomUpDatatreeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBottomUpDatatree({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Calculates a partial catalog tree in a bottom-up manner, starting with a filtered set of entities
 * and building up through their ancestors.
 *
 * This method builds a hierarchical tree structure by:
 * 1. Finding all entities that match the provided filters
 * 2. Building upwards to include their parent and grandparent entities
 * 3. Organizing them into a tree structure where each node contains its children
 *
 * The tree is built "bottom-up" because we start with the leaf nodes (entities matching the filters)
 * and work our way up to their ancestors, rather than starting at the root and working down.
 *
 * Args:
 *     request: The HTTP request object
 *     team_id: The ID of the team to filter entities by
 *     filters: JSON string containing filter criteria for the initial entity set
 *
 * Returns:
 *     Dict[str, DataTreeNode]: A dictionary mapping root entity IDs to their nodes,
 *     where each node contains the full tree of entities under it.
 */
export const useSuspenseApiGetBottomUpDatatree = <
  TData = ApiGetBottomUpDatatreeResponse,
>(
  variables: ApiGetBottomUpDatatreeVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetBottomUpDatatreeResponse,
      ApiGetBottomUpDatatreeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/bottom_up_datatree/",
    operationId: "apiGetBottomUpDatatree",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetBottomUpDatatreeResponse,
    ApiGetBottomUpDatatreeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBottomUpDatatree({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetEntityCountsQueryParams = {
  entity_id: string;
};

export type ApiGetEntityCountsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetEntityCountsVariables = {
  queryParams: ApiGetEntityCountsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetEntityCounts = (
  variables: ApiGetEntityCountsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityCountsOut,
    ApiGetEntityCountsError,
    undefined,
    {},
    ApiGetEntityCountsQueryParams,
    {}
  >({
    url: "/resource/all_v2/entity_counts/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetEntityCountsQueryKey = (
  variables: ApiGetEntityCountsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/entity_counts/",
    operationId: "apiGetEntityCounts",
    variables,
  });

export const useApiGetEntityCounts = <TData = Schemas.EntityCountsOut,>(
  variables: ApiGetEntityCountsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EntityCountsOut,
      ApiGetEntityCountsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/entity_counts/",
    operationId: "apiGetEntityCounts",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.EntityCountsOut,
    ApiGetEntityCountsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityCounts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetEntityCounts = <TData = Schemas.EntityCountsOut,>(
  variables: ApiGetEntityCountsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.EntityCountsOut,
      ApiGetEntityCountsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/entity_counts/",
    operationId: "apiGetEntityCounts",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.EntityCountsOut,
    ApiGetEntityCountsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityCounts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetEntityTeamsQueryParams = {
  entity_id: string;
};

export type ApiGetEntityTeamsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetEntityTeamsVariables = {
  queryParams: ApiGetEntityTeamsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetEntityTeams = (
  variables: ApiGetEntityTeamsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.InheritedTeamsOut,
    ApiGetEntityTeamsError,
    undefined,
    {},
    ApiGetEntityTeamsQueryParams,
    {}
  >({
    url: "/resource/all_v2/inherited_teams/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetEntityTeamsQueryKey = (
  variables: ApiGetEntityTeamsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/all_v2/inherited_teams/",
    operationId: "apiGetEntityTeams",
    variables,
  });

export const useApiGetEntityTeams = <TData = Schemas.InheritedTeamsOut,>(
  variables: ApiGetEntityTeamsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.InheritedTeamsOut,
      ApiGetEntityTeamsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/inherited_teams/",
    operationId: "apiGetEntityTeams",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.InheritedTeamsOut,
    ApiGetEntityTeamsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityTeams({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetEntityTeams = <
  TData = Schemas.InheritedTeamsOut,
>(
  variables: ApiGetEntityTeamsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.InheritedTeamsOut,
      ApiGetEntityTeamsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/all_v2/inherited_teams/",
    operationId: "apiGetEntityTeams",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.InheritedTeamsOut,
    ApiGetEntityTeamsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityTeams({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiAddBookmarkToEntityPathParams = {
  entityId: string;
};

export type ApiAddBookmarkToEntityError = Fetcher.ErrorWrapper<undefined>;

export type ApiAddBookmarkToEntityVariables = {
  pathParams: ApiAddBookmarkToEntityPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiAddBookmarkToEntity = (
  variables: ApiAddBookmarkToEntityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityBookmarkOut,
    ApiAddBookmarkToEntityError,
    undefined,
    {},
    {},
    ApiAddBookmarkToEntityPathParams
  >({
    url: "/resource/all_v2/{entityId}/bookmark/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiAddBookmarkToEntity = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EntityBookmarkOut,
      ApiAddBookmarkToEntityError,
      ApiAddBookmarkToEntityVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EntityBookmarkOut,
    ApiAddBookmarkToEntityError,
    ApiAddBookmarkToEntityVariables
  >({
    mutationFn: (variables: ApiAddBookmarkToEntityVariables) =>
      fetchApiAddBookmarkToEntity({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRemoveBookmarkFromEntityPathParams = {
  entityId: string;
};

export type ApiRemoveBookmarkFromEntityError = Fetcher.ErrorWrapper<undefined>;

export type ApiRemoveBookmarkFromEntityVariables = {
  pathParams: ApiRemoveBookmarkFromEntityPathParams;
} & ApiContext["fetcherOptions"];

/**
 * We use a separate endpoint for this because all users should be able to add/remove themselves from bookmarks.
 */
export const fetchApiRemoveBookmarkFromEntity = (
  variables: ApiRemoveBookmarkFromEntityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityBookmarkOut,
    ApiRemoveBookmarkFromEntityError,
    undefined,
    {},
    {},
    ApiRemoveBookmarkFromEntityPathParams
  >({
    url: "/resource/all_v2/{entityId}/bookmark/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * We use a separate endpoint for this because all users should be able to add/remove themselves from bookmarks.
 */
export const useApiRemoveBookmarkFromEntity = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EntityBookmarkOut,
      ApiRemoveBookmarkFromEntityError,
      ApiRemoveBookmarkFromEntityVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EntityBookmarkOut,
    ApiRemoveBookmarkFromEntityError,
    ApiRemoveBookmarkFromEntityVariables
  >({
    mutationFn: (variables: ApiRemoveBookmarkFromEntityVariables) =>
      fetchApiRemoveBookmarkFromEntity({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetBreadcrumbTeamPathParams = {
  entityId: string;
};

export type ApiGetBreadcrumbTeamQueryParams = {
  preferred_team_id?: string | null;
};

export type ApiGetBreadcrumbTeamError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetBreadcrumbTeamVariables = {
  pathParams: ApiGetBreadcrumbTeamPathParams;
  queryParams?: ApiGetBreadcrumbTeamQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get an entity's team for breadcrumb navigation.
 */
export const fetchApiGetBreadcrumbTeam = (
  variables: ApiGetBreadcrumbTeamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TeamOut | null,
    ApiGetBreadcrumbTeamError,
    undefined,
    {},
    ApiGetBreadcrumbTeamQueryParams,
    ApiGetBreadcrumbTeamPathParams
  >({
    url: "/resource/breadcrumbs/{entityId}/team/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetBreadcrumbTeamQueryKey = (
  variables: ApiGetBreadcrumbTeamVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/resource/breadcrumbs/{entityId}/team/",
    operationId: "apiGetBreadcrumbTeam",
    variables,
  });

/**
 * Get an entity's team for breadcrumb navigation.
 */
export const useApiGetBreadcrumbTeam = <TData = Schemas.TeamOut | null,>(
  variables: ApiGetBreadcrumbTeamVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.TeamOut | null,
      ApiGetBreadcrumbTeamError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/breadcrumbs/{entityId}/team/",
    operationId: "apiGetBreadcrumbTeam",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.TeamOut | null,
    ApiGetBreadcrumbTeamError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBreadcrumbTeam({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get an entity's team for breadcrumb navigation.
 */
export const useSuspenseApiGetBreadcrumbTeam = <
  TData = Schemas.TeamOut | null,
>(
  variables: ApiGetBreadcrumbTeamVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.TeamOut | null,
      ApiGetBreadcrumbTeamError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/resource/breadcrumbs/{entityId}/team/",
    operationId: "apiGetBreadcrumbTeam",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.TeamOut | null,
    ApiGetBreadcrumbTeamError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBreadcrumbTeam({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPresignedDownloadError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPresignedDownloadVariables = ApiContext["fetcherOptions"];

export const fetchApiGetPresignedDownload = (
  variables: ApiGetPresignedDownloadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DownloadResponse,
    ApiGetPresignedDownloadError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/s3_postgres/presign_download/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetPresignedDownloadQueryKey = (
  variables: ApiGetPresignedDownloadVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/s3_postgres/presign_download/",
    operationId: "apiGetPresignedDownload",
    variables,
  });

export const useApiGetPresignedDownload = <TData = Schemas.DownloadResponse,>(
  variables: ApiGetPresignedDownloadVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DownloadResponse,
      ApiGetPresignedDownloadError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/s3_postgres/presign_download/",
    operationId: "apiGetPresignedDownload",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DownloadResponse,
    ApiGetPresignedDownloadError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPresignedDownload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetPresignedDownload = <
  TData = Schemas.DownloadResponse,
>(
  variables: ApiGetPresignedDownloadVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DownloadResponse,
      ApiGetPresignedDownloadError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/s3_postgres/presign_download/",
    operationId: "apiGetPresignedDownload",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DownloadResponse,
    ApiGetPresignedDownloadError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPresignedDownload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPresignedUploadError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPresignedUploadVariables = ApiContext["fetcherOptions"];

export const fetchApiGetPresignedUpload = (
  variables: ApiGetPresignedUploadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.UploadResponse,
    ApiGetPresignedUploadError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/s3_postgres/presign_upload/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiGetPresignedUpload = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UploadResponse,
      ApiGetPresignedUploadError,
      ApiGetPresignedUploadVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.UploadResponse,
    ApiGetPresignedUploadError,
    ApiGetPresignedUploadVariables
  >({
    mutationFn: (variables: ApiGetPresignedUploadVariables) =>
      fetchApiGetPresignedUpload({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPublicEnvError = Fetcher.ErrorWrapper<undefined>;

export type ApiPublicEnvVariables = ApiContext["fetcherOptions"];

/**
 * Get only the deployment values required to start authentication.
 */
export const fetchApiPublicEnv = (
  variables: ApiPublicEnvVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.PublicEnvResponse, ApiPublicEnvError, undefined, {}, {}, {}>(
    { url: "/public/env/", method: "get", ...variables, signal },
  );

export const apiPublicEnvQueryKey = (
  variables: ApiPublicEnvVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/public/env/",
    operationId: "apiPublicEnv",
    variables,
  });

/**
 * Get only the deployment values required to start authentication.
 */
export const useApiPublicEnv = <TData = Schemas.PublicEnvResponse,>(
  variables: ApiPublicEnvVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PublicEnvResponse,
      ApiPublicEnvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/public/env/",
    operationId: "apiPublicEnv",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PublicEnvResponse,
    ApiPublicEnvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiPublicEnv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get only the deployment values required to start authentication.
 */
export const useSuspenseApiPublicEnv = <TData = Schemas.PublicEnvResponse,>(
  variables: ApiPublicEnvVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PublicEnvResponse,
      ApiPublicEnvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/public/env/",
    operationId: "apiPublicEnv",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PublicEnvResponse,
    ApiPublicEnvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiPublicEnv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiMemberEnvError = Fetcher.ErrorWrapper<undefined>;

export type ApiMemberEnvVariables = ApiContext["fetcherOptions"];

/**
 * Get member-only environment variables for the frontend.
 *
 * Note: WORKSPACE_LINEAGE_GENERATED indicates if workspace lineage graphs are enabled
 * and have been generated. This checks both the feature flag and lineage_hash.
 */
export const fetchApiMemberEnv = (
  variables: ApiMemberEnvVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.MemberEnvResponse, ApiMemberEnvError, undefined, {}, {}, {}>(
    { url: "/member/env/", method: "get", ...variables, signal },
  );

export const apiMemberEnvQueryKey = (
  variables: ApiMemberEnvVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/member/env/",
    operationId: "apiMemberEnv",
    variables,
  });

/**
 * Get member-only environment variables for the frontend.
 *
 * Note: WORKSPACE_LINEAGE_GENERATED indicates if workspace lineage graphs are enabled
 * and have been generated. This checks both the feature flag and lineage_hash.
 */
export const useApiMemberEnv = <TData = Schemas.MemberEnvResponse,>(
  variables: ApiMemberEnvVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.MemberEnvResponse,
      ApiMemberEnvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/member/env/",
    operationId: "apiMemberEnv",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.MemberEnvResponse,
    ApiMemberEnvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiMemberEnv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get member-only environment variables for the frontend.
 *
 * Note: WORKSPACE_LINEAGE_GENERATED indicates if workspace lineage graphs are enabled
 * and have been generated. This checks both the feature flag and lineage_hash.
 */
export const useSuspenseApiMemberEnv = <TData = Schemas.MemberEnvResponse,>(
  variables: ApiMemberEnvVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.MemberEnvResponse,
      ApiMemberEnvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/member/env/",
    operationId: "apiMemberEnv",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.MemberEnvResponse,
    ApiMemberEnvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiMemberEnv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetBackgroundJobQueryParams = {
  type?: string | null;
  since?: string | null;
};

export type ApiGetBackgroundJobError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetBackgroundJobResponse = Schemas.BackgroundJobOut[];

export type ApiGetBackgroundJobVariables = {
  queryParams?: ApiGetBackgroundJobQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetBackgroundJob = (
  variables: ApiGetBackgroundJobVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetBackgroundJobResponse,
    ApiGetBackgroundJobError,
    undefined,
    {},
    ApiGetBackgroundJobQueryParams,
    {}
  >({ url: "/admin/background_job/", method: "get", ...variables, signal });

export const apiGetBackgroundJobQueryKey = (
  variables: ApiGetBackgroundJobVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/background_job/",
    operationId: "apiGetBackgroundJob",
    variables,
  });

export const useApiGetBackgroundJob = <TData = ApiGetBackgroundJobResponse,>(
  variables: ApiGetBackgroundJobVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetBackgroundJobResponse,
      ApiGetBackgroundJobError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/background_job/",
    operationId: "apiGetBackgroundJob",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetBackgroundJobResponse,
    ApiGetBackgroundJobError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBackgroundJob({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetBackgroundJob = <
  TData = ApiGetBackgroundJobResponse,
>(
  variables: ApiGetBackgroundJobVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetBackgroundJobResponse,
      ApiGetBackgroundJobError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/background_job/",
    operationId: "apiGetBackgroundJob",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetBackgroundJobResponse,
    ApiGetBackgroundJobError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBackgroundJob({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateBackgroundJobError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: {
    [key: string]: any;
  };
}>;

export type ApiCreateBackgroundJobVariables = {
  body: Schemas.BackgroundJobIn;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateBackgroundJob = (
  variables: ApiCreateBackgroundJobVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    ApiCreateBackgroundJobError,
    Schemas.BackgroundJobIn,
    {},
    {},
    {}
  >({
    url: "/admin/background_job/create/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCreateBackgroundJob = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BackgroundJobOut,
      ApiCreateBackgroundJobError,
      ApiCreateBackgroundJobVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BackgroundJobOut,
    ApiCreateBackgroundJobError,
    ApiCreateBackgroundJobVariables
  >({
    mutationFn: (variables: ApiCreateBackgroundJobVariables) =>
      fetchApiCreateBackgroundJob({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiTerminateBackgroundJobPathParams = {
  jobId: string;
};

export type ApiTerminateBackgroundJobError = Fetcher.ErrorWrapper<undefined>;

export type ApiTerminateBackgroundJobVariables = {
  pathParams: ApiTerminateBackgroundJobPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiTerminateBackgroundJob = (
  variables: ApiTerminateBackgroundJobVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    ApiTerminateBackgroundJobError,
    undefined,
    {},
    {},
    ApiTerminateBackgroundJobPathParams
  >({
    url: "/admin/background_job/terminate/{jobId}/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiTerminateBackgroundJob = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BackgroundJobOut,
      ApiTerminateBackgroundJobError,
      ApiTerminateBackgroundJobVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BackgroundJobOut,
    ApiTerminateBackgroundJobError,
    ApiTerminateBackgroundJobVariables
  >({
    mutationFn: (variables: ApiTerminateBackgroundJobVariables) =>
      fetchApiTerminateBackgroundJob({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiSuperuserGetWorkspaceQueryParams = {
  search_term?: string | null;
};

export type ApiSuperuserGetWorkspaceError = Fetcher.ErrorWrapper<undefined>;

export type ApiSuperuserGetWorkspaceResponse = Schemas.LiteWorkspace[];

export type ApiSuperuserGetWorkspaceVariables = {
  queryParams?: ApiSuperuserGetWorkspaceQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiSuperuserGetWorkspace = (
  variables: ApiSuperuserGetWorkspaceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiSuperuserGetWorkspaceResponse,
    ApiSuperuserGetWorkspaceError,
    undefined,
    {},
    ApiSuperuserGetWorkspaceQueryParams,
    {}
  >({ url: "/admin/common/workspaces/", method: "get", ...variables, signal });

export const apiSuperuserGetWorkspaceQueryKey = (
  variables: ApiSuperuserGetWorkspaceVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/common/workspaces/",
    operationId: "apiSuperuserGetWorkspace",
    variables,
  });

export const useApiSuperuserGetWorkspace = <
  TData = ApiSuperuserGetWorkspaceResponse,
>(
  variables: ApiSuperuserGetWorkspaceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiSuperuserGetWorkspaceResponse,
      ApiSuperuserGetWorkspaceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/common/workspaces/",
    operationId: "apiSuperuserGetWorkspace",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiSuperuserGetWorkspaceResponse,
    ApiSuperuserGetWorkspaceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetWorkspace(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiSuperuserGetWorkspace = <
  TData = ApiSuperuserGetWorkspaceResponse,
>(
  variables: ApiSuperuserGetWorkspaceVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiSuperuserGetWorkspaceResponse,
      ApiSuperuserGetWorkspaceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/common/workspaces/",
    operationId: "apiSuperuserGetWorkspace",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiSuperuserGetWorkspaceResponse,
    ApiSuperuserGetWorkspaceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetWorkspace(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSuperuserGetIntegrationQueryParams = {
  workspace_id?: string | null;
  search_term?: string | null;
};

export type ApiSuperuserGetIntegrationError = Fetcher.ErrorWrapper<undefined>;

export type ApiSuperuserGetIntegrationResponse = Schemas.LiteIntegration[];

export type ApiSuperuserGetIntegrationVariables = {
  queryParams?: ApiSuperuserGetIntegrationQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiSuperuserGetIntegration = (
  variables: ApiSuperuserGetIntegrationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiSuperuserGetIntegrationResponse,
    ApiSuperuserGetIntegrationError,
    undefined,
    {},
    ApiSuperuserGetIntegrationQueryParams,
    {}
  >({
    url: "/admin/common/integrations/",
    method: "get",
    ...variables,
    signal,
  });

export const apiSuperuserGetIntegrationQueryKey = (
  variables: ApiSuperuserGetIntegrationVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/common/integrations/",
    operationId: "apiSuperuserGetIntegration",
    variables,
  });

export const useApiSuperuserGetIntegration = <
  TData = ApiSuperuserGetIntegrationResponse,
>(
  variables: ApiSuperuserGetIntegrationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiSuperuserGetIntegrationResponse,
      ApiSuperuserGetIntegrationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/common/integrations/",
    operationId: "apiSuperuserGetIntegration",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiSuperuserGetIntegrationResponse,
    ApiSuperuserGetIntegrationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetIntegration(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiSuperuserGetIntegration = <
  TData = ApiSuperuserGetIntegrationResponse,
>(
  variables: ApiSuperuserGetIntegrationVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiSuperuserGetIntegrationResponse,
      ApiSuperuserGetIntegrationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/common/integrations/",
    operationId: "apiSuperuserGetIntegration",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiSuperuserGetIntegrationResponse,
    ApiSuperuserGetIntegrationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetIntegration(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSuperuserGetUsersQueryParams = {
  search_term?: string | null;
};

export type ApiSuperuserGetUsersError = Fetcher.ErrorWrapper<undefined>;

export type ApiSuperuserGetUsersVariables = {
  queryParams?: ApiSuperuserGetUsersQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Uses the viewset to serve this request until we port it to Ninja
 * We have to wrap the output in SecodaNinjaPaginationOutput schema as
 * thats what the viewset returns.
 *
 * Having search_term in the args list means OpenAPI spec uses that as a parameter
 * for our codegen process. It is used in the viewset call.
 */
export const fetchApiSuperuserGetUsers = (
  variables: ApiSuperuserGetUsersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaNinjaPaginationOutputLiteUserOut,
    ApiSuperuserGetUsersError,
    undefined,
    {},
    ApiSuperuserGetUsersQueryParams,
    {}
  >({ url: "/admin/common/users/", method: "get", ...variables, signal });

export const apiSuperuserGetUsersQueryKey = (
  variables: ApiSuperuserGetUsersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/common/users/",
    operationId: "apiSuperuserGetUsers",
    variables,
  });

/**
 * Uses the viewset to serve this request until we port it to Ninja
 * We have to wrap the output in SecodaNinjaPaginationOutput schema as
 * thats what the viewset returns.
 *
 * Having search_term in the args list means OpenAPI spec uses that as a parameter
 * for our codegen process. It is used in the viewset call.
 */
export const useApiSuperuserGetUsers = <
  TData = Schemas.SecodaNinjaPaginationOutputLiteUserOut,
>(
  variables: ApiSuperuserGetUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputLiteUserOut,
      ApiSuperuserGetUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/common/users/",
    operationId: "apiSuperuserGetUsers",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SecodaNinjaPaginationOutputLiteUserOut,
    ApiSuperuserGetUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Uses the viewset to serve this request until we port it to Ninja
 * We have to wrap the output in SecodaNinjaPaginationOutput schema as
 * thats what the viewset returns.
 *
 * Having search_term in the args list means OpenAPI spec uses that as a parameter
 * for our codegen process. It is used in the viewset call.
 */
export const useSuspenseApiSuperuserGetUsers = <
  TData = Schemas.SecodaNinjaPaginationOutputLiteUserOut,
>(
  variables: ApiSuperuserGetUsersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputLiteUserOut,
      ApiSuperuserGetUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/common/users/",
    operationId: "apiSuperuserGetUsers",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SecodaNinjaPaginationOutputLiteUserOut,
    ApiSuperuserGetUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetComputeCostMetricsQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  workspace_id?: string | null;
};

export type ApiGetComputeCostMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetComputeCostMetricsVariables = {
  queryParams?: ApiGetComputeCostMetricsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get compute cost metrics across all workspaces (superuser only).
 *
 * By default returns metrics for all workspaces. Optionally filter by workspace_id.
 */
export const fetchApiGetComputeCostMetrics = (
  variables: ApiGetComputeCostMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ComputeCostMetrics,
    ApiGetComputeCostMetricsError,
    undefined,
    {},
    ApiGetComputeCostMetricsQueryParams,
    {}
  >({
    url: "/admin/compute-cost/metrics/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetComputeCostMetricsQueryKey = (
  variables: ApiGetComputeCostMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/compute-cost/metrics/",
    operationId: "apiGetComputeCostMetrics",
    variables,
  });

/**
 * Get compute cost metrics across all workspaces (superuser only).
 *
 * By default returns metrics for all workspaces. Optionally filter by workspace_id.
 */
export const useApiGetComputeCostMetrics = <
  TData = Schemas.ComputeCostMetrics,
>(
  variables: ApiGetComputeCostMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ComputeCostMetrics,
      ApiGetComputeCostMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/compute-cost/metrics/",
    operationId: "apiGetComputeCostMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ComputeCostMetrics,
    ApiGetComputeCostMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetComputeCostMetrics(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get compute cost metrics across all workspaces (superuser only).
 *
 * By default returns metrics for all workspaces. Optionally filter by workspace_id.
 */
export const useSuspenseApiGetComputeCostMetrics = <
  TData = Schemas.ComputeCostMetrics,
>(
  variables: ApiGetComputeCostMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ComputeCostMetrics,
      ApiGetComputeCostMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/compute-cost/metrics/",
    operationId: "apiGetComputeCostMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ComputeCostMetrics,
    ApiGetComputeCostMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetComputeCostMetrics(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetComputeCostTimeseriesQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  start_date?: string | null;
  end_date?: string | null;
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
  /**
   * @default job_type
   */
  group_by?: "job_type" | "execution_type" | "workspace";
  workspace_id?: string | null;
};

export type ApiGetComputeCostTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetComputeCostTimeseriesVariables = {
  queryParams?: ApiGetComputeCostTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get compute cost timeseries data across all workspaces (superuser only).
 *
 * By default returns data for all workspaces. Optionally filter by workspace_id.
 */
export const fetchApiGetComputeCostTimeseries = (
  variables: ApiGetComputeCostTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ComputeCostTimeSeries,
    ApiGetComputeCostTimeseriesError,
    undefined,
    {},
    ApiGetComputeCostTimeseriesQueryParams,
    {}
  >({
    url: "/admin/compute-cost/timeseries/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetComputeCostTimeseriesQueryKey = (
  variables: ApiGetComputeCostTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/compute-cost/timeseries/",
    operationId: "apiGetComputeCostTimeseries",
    variables,
  });

/**
 * Get compute cost timeseries data across all workspaces (superuser only).
 *
 * By default returns data for all workspaces. Optionally filter by workspace_id.
 */
export const useApiGetComputeCostTimeseries = <
  TData = Schemas.ComputeCostTimeSeries,
>(
  variables: ApiGetComputeCostTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ComputeCostTimeSeries,
      ApiGetComputeCostTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/compute-cost/timeseries/",
    operationId: "apiGetComputeCostTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ComputeCostTimeSeries,
    ApiGetComputeCostTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetComputeCostTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get compute cost timeseries data across all workspaces (superuser only).
 *
 * By default returns data for all workspaces. Optionally filter by workspace_id.
 */
export const useSuspenseApiGetComputeCostTimeseries = <
  TData = Schemas.ComputeCostTimeSeries,
>(
  variables: ApiGetComputeCostTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ComputeCostTimeSeries,
      ApiGetComputeCostTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/compute-cost/timeseries/",
    operationId: "apiGetComputeCostTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ComputeCostTimeSeries,
    ApiGetComputeCostTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetComputeCostTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetLatestGitInfoError = Fetcher.ErrorWrapper<undefined>;

export type GetLatestGitInfoVariables = ApiContext["fetcherOptions"];

export const fetchGetLatestGitInfo = (
  variables: GetLatestGitInfoVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.CommitData, GetLatestGitInfoError, undefined, {}, {}, {}>({
    url: "/admin/github/latest_git_info/",
    method: "get",
    ...variables,
    signal,
  });

export const getLatestGitInfoQueryKey = (
  variables: GetLatestGitInfoVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/github/latest_git_info/",
    operationId: "getLatestGitInfo",
    variables,
  });

export const useGetLatestGitInfo = <TData = Schemas.CommitData,>(
  variables: GetLatestGitInfoVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CommitData,
      GetLatestGitInfoError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/github/latest_git_info/",
    operationId: "getLatestGitInfo",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CommitData,
    GetLatestGitInfoError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetLatestGitInfo({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetLatestGitInfo = <TData = Schemas.CommitData,>(
  variables: GetLatestGitInfoVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CommitData,
      GetLatestGitInfoError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/github/latest_git_info/",
    operationId: "getLatestGitInfo",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CommitData,
    GetLatestGitInfoError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetLatestGitInfo({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetCommitInfoPathParams = {
  databuilderJobId: string;
};

export type GetCommitInfoError = Fetcher.ErrorWrapper<undefined>;

export type GetCommitInfoVariables = {
  pathParams: GetCommitInfoPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetCommitInfo = (
  variables: GetCommitInfoVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CommitData,
    GetCommitInfoError,
    undefined,
    {},
    {},
    GetCommitInfoPathParams
  >({
    url: "/admin/github/commit_info/{databuilderJobId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getCommitInfoQueryKey = (
  variables: GetCommitInfoVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/github/commit_info/{databuilderJobId}/",
    operationId: "getCommitInfo",
    variables,
  });

export const useGetCommitInfo = <TData = Schemas.CommitData,>(
  variables: GetCommitInfoVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CommitData, GetCommitInfoError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/github/commit_info/{databuilderJobId}/",
    operationId: "getCommitInfo",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CommitData,
    GetCommitInfoError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCommitInfo({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetCommitInfo = <TData = Schemas.CommitData,>(
  variables: GetCommitInfoVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CommitData,
      GetCommitInfoError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/github/commit_info/{databuilderJobId}/",
    operationId: "getCommitInfo",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CommitData,
    GetCommitInfoError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCommitInfo({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetIntegrationApiSpecPathParams = {
  integrationId: string;
};

export type ApiGetIntegrationApiSpecError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetIntegrationApiSpecVariables = {
  pathParams: ApiGetIntegrationApiSpecPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetIntegrationApiSpec = (
  variables: ApiGetIntegrationApiSpecVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IntegrationApiSpec,
    ApiGetIntegrationApiSpecError,
    undefined,
    {},
    {},
    ApiGetIntegrationApiSpecPathParams
  >({
    url: "/admin/inspect_api/{integrationId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIntegrationApiSpecQueryKey = (
  variables: ApiGetIntegrationApiSpecVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/inspect_api/{integrationId}/",
    operationId: "apiGetIntegrationApiSpec",
    variables,
  });

export const useApiGetIntegrationApiSpec = <
  TData = Schemas.IntegrationApiSpec,
>(
  variables: ApiGetIntegrationApiSpecVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IntegrationApiSpec,
      ApiGetIntegrationApiSpecError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/inspect_api/{integrationId}/",
    operationId: "apiGetIntegrationApiSpec",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.IntegrationApiSpec,
    ApiGetIntegrationApiSpecError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationApiSpec(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetIntegrationApiSpec = <
  TData = Schemas.IntegrationApiSpec,
>(
  variables: ApiGetIntegrationApiSpecVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.IntegrationApiSpec,
      ApiGetIntegrationApiSpecError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/inspect_api/{integrationId}/",
    operationId: "apiGetIntegrationApiSpec",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.IntegrationApiSpec,
    ApiGetIntegrationApiSpecError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationApiSpec(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiRunIntegrationApiMethodPathParams = {
  integrationId: string;
  methodName: string;
};

export type ApiRunIntegrationApiMethodQueryParams = {
  /**
   * @default false
   */
  show_original?: boolean;
  /**
   * @default false
   */
  run_as_background_job?: boolean;
};

export type ApiRunIntegrationApiMethodError = Fetcher.ErrorWrapper<undefined>;

export type ApiRunIntegrationApiMethodRequestBody = {
  [key: string]: any;
};

export type ApiRunIntegrationApiMethodVariables = {
  body?: ApiRunIntegrationApiMethodRequestBody;
  pathParams: ApiRunIntegrationApiMethodPathParams;
  queryParams?: ApiRunIntegrationApiMethodQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRunIntegrationApiMethod = (
  variables: ApiRunIntegrationApiMethodVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    void,
    ApiRunIntegrationApiMethodError,
    ApiRunIntegrationApiMethodRequestBody,
    {},
    ApiRunIntegrationApiMethodQueryParams,
    ApiRunIntegrationApiMethodPathParams
  >({
    url: "/admin/inspect_api/{integrationId}/{methodName}/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiRunIntegrationApiMethod = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ApiRunIntegrationApiMethodError,
      ApiRunIntegrationApiMethodVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    void,
    ApiRunIntegrationApiMethodError,
    ApiRunIntegrationApiMethodVariables
  >({
    mutationFn: (variables: ApiRunIntegrationApiMethodVariables) =>
      fetchApiRunIntegrationApiMethod({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetCeleryWorkersError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetCeleryWorkersResponse = Schemas.CeleryWorker[];

export type ApiGetCeleryWorkersVariables = ApiContext["fetcherOptions"];

/**
 * Get all Celery workers.
 */
export const fetchApiGetCeleryWorkers = (
  variables: ApiGetCeleryWorkersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetCeleryWorkersResponse,
    ApiGetCeleryWorkersError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/admin/inspect_celery/worker/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetCeleryWorkersQueryKey = (
  variables: ApiGetCeleryWorkersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/inspect_celery/worker/",
    operationId: "apiGetCeleryWorkers",
    variables,
  });

/**
 * Get all Celery workers.
 */
export const useApiGetCeleryWorkers = <TData = ApiGetCeleryWorkersResponse,>(
  variables: ApiGetCeleryWorkersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetCeleryWorkersResponse,
      ApiGetCeleryWorkersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/inspect_celery/worker/",
    operationId: "apiGetCeleryWorkers",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetCeleryWorkersResponse,
    ApiGetCeleryWorkersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCeleryWorkers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all Celery workers.
 */
export const useSuspenseApiGetCeleryWorkers = <
  TData = ApiGetCeleryWorkersResponse,
>(
  variables: ApiGetCeleryWorkersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetCeleryWorkersResponse,
      ApiGetCeleryWorkersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/inspect_celery/worker/",
    operationId: "apiGetCeleryWorkers",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetCeleryWorkersResponse,
    ApiGetCeleryWorkersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCeleryWorkers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetCeleryQueuesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetCeleryQueuesResponse = Schemas.CeleryQueue[];

export type ApiGetCeleryQueuesVariables = ApiContext["fetcherOptions"];

/**
 * Get all active queues.
 */
export const fetchApiGetCeleryQueues = (
  variables: ApiGetCeleryQueuesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetCeleryQueuesResponse,
    ApiGetCeleryQueuesError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/admin/inspect_celery/queue/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetCeleryQueuesQueryKey = (
  variables: ApiGetCeleryQueuesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/inspect_celery/queue/",
    operationId: "apiGetCeleryQueues",
    variables,
  });

/**
 * Get all active queues.
 */
export const useApiGetCeleryQueues = <TData = ApiGetCeleryQueuesResponse,>(
  variables: ApiGetCeleryQueuesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetCeleryQueuesResponse,
      ApiGetCeleryQueuesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/inspect_celery/queue/",
    operationId: "apiGetCeleryQueues",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetCeleryQueuesResponse,
    ApiGetCeleryQueuesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCeleryQueues({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all active queues.
 */
export const useSuspenseApiGetCeleryQueues = <
  TData = ApiGetCeleryQueuesResponse,
>(
  variables: ApiGetCeleryQueuesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetCeleryQueuesResponse,
      ApiGetCeleryQueuesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/inspect_celery/queue/",
    operationId: "apiGetCeleryQueues",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetCeleryQueuesResponse,
    ApiGetCeleryQueuesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCeleryQueues({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetCeleryTasksError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetCeleryTasksResponse = Schemas.CeleryTask[];

export type ApiGetCeleryTasksVariables = ApiContext["fetcherOptions"];

/**
 * Get all Celery tasks from all queues.
 */
export const fetchApiGetCeleryTasks = (
  variables: ApiGetCeleryTasksVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetCeleryTasksResponse,
    ApiGetCeleryTasksError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/admin/inspect_celery/task/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetCeleryTasksQueryKey = (
  variables: ApiGetCeleryTasksVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/inspect_celery/task/",
    operationId: "apiGetCeleryTasks",
    variables,
  });

/**
 * Get all Celery tasks from all queues.
 */
export const useApiGetCeleryTasks = <TData = ApiGetCeleryTasksResponse,>(
  variables: ApiGetCeleryTasksVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetCeleryTasksResponse,
      ApiGetCeleryTasksError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/inspect_celery/task/",
    operationId: "apiGetCeleryTasks",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetCeleryTasksResponse,
    ApiGetCeleryTasksError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCeleryTasks({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all Celery tasks from all queues.
 */
export const useSuspenseApiGetCeleryTasks = <
  TData = ApiGetCeleryTasksResponse,
>(
  variables: ApiGetCeleryTasksVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetCeleryTasksResponse,
      ApiGetCeleryTasksError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/inspect_celery/task/",
    operationId: "apiGetCeleryTasks",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetCeleryTasksResponse,
    ApiGetCeleryTasksError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCeleryTasks({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetDatabaseObjectsError = Fetcher.ErrorWrapper<undefined>;

export type GetDatabaseObjectsResponse = Schemas.DatabaseObject[];

export type GetDatabaseObjectsVariables = ApiContext["fetcherOptions"];

/**
 * Get a consolidated list of all database objects (schemas, tables, columns) with their fully qualified names.
 * Used for autocomplete in the SQL editor.
 */
export const fetchGetDatabaseObjects = (
  variables: GetDatabaseObjectsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetDatabaseObjectsResponse,
    GetDatabaseObjectsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/admin/metric/internal_database_objects/",
    method: "get",
    ...variables,
    signal,
  });

export const getDatabaseObjectsQueryKey = (
  variables: GetDatabaseObjectsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/metric/internal_database_objects/",
    operationId: "getDatabaseObjects",
    variables,
  });

/**
 * Get a consolidated list of all database objects (schemas, tables, columns) with their fully qualified names.
 * Used for autocomplete in the SQL editor.
 */
export const useGetDatabaseObjects = <TData = GetDatabaseObjectsResponse,>(
  variables: GetDatabaseObjectsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetDatabaseObjectsResponse,
      GetDatabaseObjectsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/metric/internal_database_objects/",
    operationId: "getDatabaseObjects",
    variables,
  });
  const result = reactQuery.useQuery<
    GetDatabaseObjectsResponse,
    GetDatabaseObjectsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetDatabaseObjects({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a consolidated list of all database objects (schemas, tables, columns) with their fully qualified names.
 * Used for autocomplete in the SQL editor.
 */
export const useSuspenseGetDatabaseObjects = <
  TData = GetDatabaseObjectsResponse,
>(
  variables: GetDatabaseObjectsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetDatabaseObjectsResponse,
      GetDatabaseObjectsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/metric/internal_database_objects/",
    operationId: "getDatabaseObjects",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetDatabaseObjectsResponse,
    GetDatabaseObjectsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetDatabaseObjects({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSuperuserExecuteQueryError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApiSuperuserExecuteQueryResponse = {
  [key: string]: any;
};

export type ApiSuperuserExecuteQueryVariables = {
  body: Schemas.ExecuteQueryIn;
} & ApiContext["fetcherOptions"];

export const fetchApiSuperuserExecuteQuery = (
  variables: ApiSuperuserExecuteQueryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiSuperuserExecuteQueryResponse,
    ApiSuperuserExecuteQueryError,
    Schemas.ExecuteQueryIn,
    {},
    {},
    {}
  >({ url: "/admin/metric/execute/", method: "post", ...variables, signal });

export const useApiSuperuserExecuteQuery = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiSuperuserExecuteQueryResponse,
      ApiSuperuserExecuteQueryError,
      ApiSuperuserExecuteQueryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiSuperuserExecuteQueryResponse,
    ApiSuperuserExecuteQueryError,
    ApiSuperuserExecuteQueryVariables
  >({
    mutationFn: (variables: ApiSuperuserExecuteQueryVariables) =>
      fetchApiSuperuserExecuteQuery({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetInternalIntegrationStatusQueryParams = {
  /**
   * @default 10
   */
  latest_k?: number;
};

export type ApiGetInternalIntegrationStatusError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetInternalIntegrationStatusResponse =
  Schemas.InternalIntegrationStatus[];

export type ApiGetInternalIntegrationStatusVariables = {
  queryParams?: ApiGetInternalIntegrationStatusQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetInternalIntegrationStatus = (
  variables: ApiGetInternalIntegrationStatusVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetInternalIntegrationStatusResponse,
    ApiGetInternalIntegrationStatusError,
    undefined,
    {},
    ApiGetInternalIntegrationStatusQueryParams,
    {}
  >({
    url: "/admin/internal_integration_status/status/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetInternalIntegrationStatusQueryKey = (
  variables: ApiGetInternalIntegrationStatusVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/internal_integration_status/status/",
    operationId: "apiGetInternalIntegrationStatus",
    variables,
  });

export const useApiGetInternalIntegrationStatus = <
  TData = ApiGetInternalIntegrationStatusResponse,
>(
  variables: ApiGetInternalIntegrationStatusVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetInternalIntegrationStatusResponse,
      ApiGetInternalIntegrationStatusError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/status/",
    operationId: "apiGetInternalIntegrationStatus",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetInternalIntegrationStatusResponse,
    ApiGetInternalIntegrationStatusError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetInternalIntegrationStatus(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetInternalIntegrationStatus = <
  TData = ApiGetInternalIntegrationStatusResponse,
>(
  variables: ApiGetInternalIntegrationStatusVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetInternalIntegrationStatusResponse,
      ApiGetInternalIntegrationStatusError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/status/",
    operationId: "apiGetInternalIntegrationStatus",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetInternalIntegrationStatusResponse,
    ApiGetInternalIntegrationStatusError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetInternalIntegrationStatus(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetAwsBatchJobDetailPathParams = {
  awsBatchJobId: string;
};

export type GetAwsBatchJobDetailError = Fetcher.ErrorWrapper<undefined>;

export type GetAwsBatchJobDetailResponse = {
  [key: string]: any;
};

export type GetAwsBatchJobDetailVariables = {
  pathParams: GetAwsBatchJobDetailPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetAwsBatchJobDetail = (
  variables: GetAwsBatchJobDetailVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetAwsBatchJobDetailResponse,
    GetAwsBatchJobDetailError,
    undefined,
    {},
    {},
    GetAwsBatchJobDetailPathParams
  >({
    url: "/admin/internal_integration_status/aws_batch_job/{awsBatchJobId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getAwsBatchJobDetailQueryKey = (
  variables: GetAwsBatchJobDetailVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/internal_integration_status/aws_batch_job/{awsBatchJobId}/",
    operationId: "getAwsBatchJobDetail",
    variables,
  });

export const useGetAwsBatchJobDetail = <TData = GetAwsBatchJobDetailResponse,>(
  variables: GetAwsBatchJobDetailVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAwsBatchJobDetailResponse,
      GetAwsBatchJobDetailError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/aws_batch_job/{awsBatchJobId}/",
    operationId: "getAwsBatchJobDetail",
    variables,
  });
  const result = reactQuery.useQuery<
    GetAwsBatchJobDetailResponse,
    GetAwsBatchJobDetailError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAwsBatchJobDetail({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetAwsBatchJobDetail = <
  TData = GetAwsBatchJobDetailResponse,
>(
  variables: GetAwsBatchJobDetailVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetAwsBatchJobDetailResponse,
      GetAwsBatchJobDetailError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/aws_batch_job/{awsBatchJobId}/",
    operationId: "getAwsBatchJobDetail",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetAwsBatchJobDetailResponse,
    GetAwsBatchJobDetailError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAwsBatchJobDetail({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type RemoveDanglingJobsPathParams = {
  integrationId: string;
};

export type RemoveDanglingJobsError = Fetcher.ErrorWrapper<undefined>;

export type RemoveDanglingJobsVariables = {
  pathParams: RemoveDanglingJobsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchRemoveDanglingJobs = (
  variables: RemoveDanglingJobsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    RemoveDanglingJobsError,
    undefined,
    {},
    {},
    RemoveDanglingJobsPathParams
  >({
    url: "/admin/internal_integration_status/remove_dangling_jobs/{integrationId}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useRemoveDanglingJobs = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveDanglingJobsError,
      RemoveDanglingJobsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveDanglingJobsError,
    RemoveDanglingJobsVariables
  >({
    mutationFn: (variables: RemoveDanglingJobsVariables) =>
      fetchRemoveDanglingJobs({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveReservedJobPathParams = {
  databuilderJobId: string;
};

export type RemoveReservedJobError = Fetcher.ErrorWrapper<undefined>;

export type RemoveReservedJobVariables = {
  pathParams: RemoveReservedJobPathParams;
} & ApiContext["fetcherOptions"];

export const fetchRemoveReservedJob = (
  variables: RemoveReservedJobVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    RemoveReservedJobError,
    undefined,
    {},
    {},
    RemoveReservedJobPathParams
  >({
    url: "/admin/internal_integration_status/remove_reserved_job/{databuilderJobId}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useRemoveReservedJob = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveReservedJobError,
      RemoveReservedJobVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveReservedJobError,
    RemoveReservedJobVariables
  >({
    mutationFn: (variables: RemoveReservedJobVariables) =>
      fetchRemoveReservedJob({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RetryDatabuilderJobPathParams = {
  databuilderJobId: string;
};

export type RetryDatabuilderJobError = Fetcher.ErrorWrapper<undefined>;

export type RetryDatabuilderJobVariables = {
  pathParams: RetryDatabuilderJobPathParams;
} & ApiContext["fetcherOptions"];

export const fetchRetryDatabuilderJob = (
  variables: RetryDatabuilderJobVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    RetryDatabuilderJobError,
    undefined,
    {},
    {},
    RetryDatabuilderJobPathParams
  >({
    url: "/admin/internal_integration_status/retry_databuilder_job/{databuilderJobId}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useRetryDatabuilderJob = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RetryDatabuilderJobError,
      RetryDatabuilderJobVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    RetryDatabuilderJobError,
    RetryDatabuilderJobVariables
  >({
    mutationFn: (variables: RetryDatabuilderJobVariables) =>
      fetchRetryDatabuilderJob({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GenerateWorkspaceLineagePathParams = {
  workspaceId: string;
};

export type GenerateWorkspaceLineageError = Fetcher.ErrorWrapper<undefined>;

export type GenerateWorkspaceLineageVariables = {
  pathParams: GenerateWorkspaceLineagePathParams;
} & ApiContext["fetcherOptions"];

export const fetchGenerateWorkspaceLineage = (
  variables: GenerateWorkspaceLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    GenerateWorkspaceLineageError,
    undefined,
    {},
    {},
    GenerateWorkspaceLineagePathParams
  >({
    url: "/admin/internal_integration_status/generate_workspace_lineage/{workspaceId}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useGenerateWorkspaceLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      GenerateWorkspaceLineageError,
      GenerateWorkspaceLineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    GenerateWorkspaceLineageError,
    GenerateWorkspaceLineageVariables
  >({
    mutationFn: (variables: GenerateWorkspaceLineageVariables) =>
      fetchGenerateWorkspaceLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetInTrialWorkspacesError = Fetcher.ErrorWrapper<undefined>;

export type GetInTrialWorkspacesResponse = string[];

export type GetInTrialWorkspacesVariables = ApiContext["fetcherOptions"];

export const fetchGetInTrialWorkspaces = (
  variables: GetInTrialWorkspacesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetInTrialWorkspacesResponse,
    GetInTrialWorkspacesError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/admin/internal_integration_status/in_trial_workspaces/",
    method: "get",
    ...variables,
    signal,
  });

export const getInTrialWorkspacesQueryKey = (
  variables: GetInTrialWorkspacesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/internal_integration_status/in_trial_workspaces/",
    operationId: "getInTrialWorkspaces",
    variables,
  });

export const useGetInTrialWorkspaces = <TData = GetInTrialWorkspacesResponse,>(
  variables: GetInTrialWorkspacesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetInTrialWorkspacesResponse,
      GetInTrialWorkspacesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/in_trial_workspaces/",
    operationId: "getInTrialWorkspaces",
    variables,
  });
  const result = reactQuery.useQuery<
    GetInTrialWorkspacesResponse,
    GetInTrialWorkspacesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetInTrialWorkspaces({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetInTrialWorkspaces = <
  TData = GetInTrialWorkspacesResponse,
>(
  variables: GetInTrialWorkspacesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetInTrialWorkspacesResponse,
      GetInTrialWorkspacesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/in_trial_workspaces/",
    operationId: "getInTrialWorkspaces",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetInTrialWorkspacesResponse,
    GetInTrialWorkspacesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetInTrialWorkspaces({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetDebugLogsPathParams = {
  databuilderJobId: string;
};

export type GetDebugLogsError = Fetcher.ErrorWrapper<undefined>;

export type GetDebugLogsResponse = Schemas.DebugLogItem[];

export type GetDebugLogsVariables = {
  pathParams: GetDebugLogsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Gets the latest 500 log items
 */
export const fetchGetDebugLogs = (
  variables: GetDebugLogsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetDebugLogsResponse,
    GetDebugLogsError,
    undefined,
    {},
    {},
    GetDebugLogsPathParams
  >({
    url: "/admin/internal_integration_status/debug/{databuilderJobId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getDebugLogsQueryKey = (
  variables: GetDebugLogsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/internal_integration_status/debug/{databuilderJobId}/",
    operationId: "getDebugLogs",
    variables,
  });

/**
 * Gets the latest 500 log items
 */
export const useGetDebugLogs = <TData = GetDebugLogsResponse,>(
  variables: GetDebugLogsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetDebugLogsResponse, GetDebugLogsError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/debug/{databuilderJobId}/",
    operationId: "getDebugLogs",
    variables,
  });
  const result = reactQuery.useQuery<
    GetDebugLogsResponse,
    GetDebugLogsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetDebugLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Gets the latest 500 log items
 */
export const useSuspenseGetDebugLogs = <TData = GetDebugLogsResponse,>(
  variables: GetDebugLogsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetDebugLogsResponse,
      GetDebugLogsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/debug/{databuilderJobId}/",
    operationId: "getDebugLogs",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetDebugLogsResponse,
    GetDebugLogsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetDebugLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetDebugLogPathParams = {
  databuilderJobId: string;
  index: number;
};

export type GetDebugLogError = Fetcher.ErrorWrapper<undefined>;

export type GetDebugLogVariables = {
  pathParams: GetDebugLogPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Gets a single debug log item with the entire content
 */
export const fetchGetDebugLog = (
  variables: GetDebugLogVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DebugLogItem,
    GetDebugLogError,
    undefined,
    {},
    {},
    GetDebugLogPathParams
  >({
    url: "/admin/internal_integration_status/debug/{databuilderJobId}/{index}/",
    method: "get",
    ...variables,
    signal,
  });

export const getDebugLogQueryKey = (
  variables: GetDebugLogVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/internal_integration_status/debug/{databuilderJobId}/{index}/",
    operationId: "getDebugLog",
    variables,
  });

/**
 * Gets a single debug log item with the entire content
 */
export const useGetDebugLog = <TData = Schemas.DebugLogItem,>(
  variables: GetDebugLogVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DebugLogItem, GetDebugLogError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/debug/{databuilderJobId}/{index}/",
    operationId: "getDebugLog",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DebugLogItem,
    GetDebugLogError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetDebugLog({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Gets a single debug log item with the entire content
 */
export const useSuspenseGetDebugLog = <TData = Schemas.DebugLogItem,>(
  variables: GetDebugLogVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DebugLogItem,
      GetDebugLogError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_integration_status/debug/{databuilderJobId}/{index}/",
    operationId: "getDebugLog",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DebugLogItem,
    GetDebugLogError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetDebugLog({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type IsSuperadminError = Fetcher.ErrorWrapper<undefined>;

export type IsSuperadminVariables = ApiContext["fetcherOptions"];

export const fetchIsSuperadmin = (
  variables: IsSuperadminVariables,
  signal?: AbortSignal,
) =>
  apiFetch<boolean, IsSuperadminError, undefined, {}, {}, {}>({
    url: "/admin/internal_query_actions/is_superadmin/",
    method: "get",
    ...variables,
    signal,
  });

export const isSuperadminQueryKey = (
  variables: IsSuperadminVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/internal_query_actions/is_superadmin/",
    operationId: "isSuperadmin",
    variables,
  });

export const useIsSuperadmin = <TData = boolean,>(
  variables: IsSuperadminVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<boolean, IsSuperadminError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_query_actions/is_superadmin/",
    operationId: "isSuperadmin",
    variables,
  });
  const result = reactQuery.useQuery<boolean, IsSuperadminError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchIsSuperadmin({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseIsSuperadmin = <TData = boolean,>(
  variables: IsSuperadminVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<boolean, IsSuperadminError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_query_actions/is_superadmin/",
    operationId: "isSuperadmin",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<boolean, IsSuperadminError, TData>(
    {
      queryKey: queryKey,
      queryFn: ({ signal }) =>
        fetchIsSuperadmin({ ...fetcherOptions, ...variables }, signal),
      ...options,
      ...queryOptions,
    },
  );
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type LineageQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type LineageError = Fetcher.ErrorWrapper<undefined>;

export type LineageVariables = {
  body: Schemas.LineageIn;
  queryParams?: LineageQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchLineage = (
  variables: LineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedLineageOut2,
    LineageError,
    Schemas.LineageIn,
    {},
    LineageQueryParams,
    {}
  >({
    url: "/admin/internal_query_actions/lineage/",
    method: "post",
    ...variables,
    signal,
  });

export const useLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PagedLineageOut2,
      LineageError,
      LineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PagedLineageOut2,
    LineageError,
    LineageVariables
  >({
    mutationFn: (variables: LineageVariables) =>
      fetchLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type LineageCountError = Fetcher.ErrorWrapper<undefined>;

export type LineageCountVariables = {
  body: Schemas.LineageIn;
} & ApiContext["fetcherOptions"];

export const fetchLineageCount = (
  variables: LineageCountVariables,
  signal?: AbortSignal,
) =>
  apiFetch<number, LineageCountError, Schemas.LineageIn, {}, {}, {}>({
    url: "/admin/internal_query_actions/lineage_count/",
    method: "post",
    ...variables,
    signal,
  });

export const useLineageCount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      number,
      LineageCountError,
      LineageCountVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    number,
    LineageCountError,
    LineageCountVariables
  >({
    mutationFn: (variables: LineageCountVariables) =>
      fetchLineageCount({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ResourceQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ResourceError = Fetcher.ErrorWrapper<undefined>;

export type ResourceVariables = {
  body: Schemas.ResourceIn;
  queryParams?: ResourceQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchResource = (
  variables: ResourceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedResourceOut,
    ResourceError,
    Schemas.ResourceIn,
    {},
    ResourceQueryParams,
    {}
  >({
    url: "/admin/internal_query_actions/resource/",
    method: "post",
    ...variables,
    signal,
  });

export const useResource = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PagedResourceOut,
      ResourceError,
      ResourceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PagedResourceOut,
    ResourceError,
    ResourceVariables
  >({
    mutationFn: (variables: ResourceVariables) =>
      fetchResource({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ResourceCountError = Fetcher.ErrorWrapper<undefined>;

export type ResourceCountVariables = {
  body: Schemas.ResourceIn;
} & ApiContext["fetcherOptions"];

export const fetchResourceCount = (
  variables: ResourceCountVariables,
  signal?: AbortSignal,
) =>
  apiFetch<number, ResourceCountError, Schemas.ResourceIn, {}, {}, {}>({
    url: "/admin/internal_query_actions/resource_count/",
    method: "post",
    ...variables,
    signal,
  });

export const useResourceCount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      number,
      ResourceCountError,
      ResourceCountVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    number,
    ResourceCountError,
    ResourceCountVariables
  >({
    mutationFn: (variables: ResourceCountVariables) =>
      fetchResourceCount({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdminQuerySecodaDocumentsError = Fetcher.ErrorWrapper<undefined>;

export type AdminQuerySecodaDocumentsResponse = {
  [key: string]: any;
}[];

export type AdminQuerySecodaDocumentsVariables = {
  body: Schemas.SecodaDocumentQueryIn;
} & ApiContext["fetcherOptions"];

export const fetchAdminQuerySecodaDocuments = (
  variables: AdminQuerySecodaDocumentsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    AdminQuerySecodaDocumentsResponse,
    AdminQuerySecodaDocumentsError,
    Schemas.SecodaDocumentQueryIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/secoda_document/",
    method: "post",
    ...variables,
    signal,
  });

export const useAdminQuerySecodaDocuments = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      AdminQuerySecodaDocumentsResponse,
      AdminQuerySecodaDocumentsError,
      AdminQuerySecodaDocumentsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    AdminQuerySecodaDocumentsResponse,
    AdminQuerySecodaDocumentsError,
    AdminQuerySecodaDocumentsVariables
  >({
    mutationFn: (variables: AdminQuerySecodaDocumentsVariables) =>
      fetchAdminQuerySecodaDocuments({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AdminDownloadS3FileQueryParams = {
  file_path: string;
  bucket?: string | null;
};

export type AdminDownloadS3FileError = Fetcher.ErrorWrapper<undefined>;

export type AdminDownloadS3FileResponse = {
  [key: string]: any;
}[];

export type AdminDownloadS3FileVariables = {
  queryParams: AdminDownloadS3FileQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get contents of a file from S3 bucket as a downloadable file
 */
export const fetchAdminDownloadS3File = (
  variables: AdminDownloadS3FileVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    AdminDownloadS3FileResponse,
    AdminDownloadS3FileError,
    undefined,
    {},
    AdminDownloadS3FileQueryParams,
    {}
  >({
    url: "/admin/internal_query_actions/download_s3_file/",
    method: "get",
    ...variables,
    signal,
  });

export const adminDownloadS3FileQueryKey = (
  variables: AdminDownloadS3FileVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/internal_query_actions/download_s3_file/",
    operationId: "adminDownloadS3File",
    variables,
  });

/**
 * Get contents of a file from S3 bucket as a downloadable file
 */
export const useAdminDownloadS3File = <TData = AdminDownloadS3FileResponse,>(
  variables: AdminDownloadS3FileVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      AdminDownloadS3FileResponse,
      AdminDownloadS3FileError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_query_actions/download_s3_file/",
    operationId: "adminDownloadS3File",
    variables,
  });
  const result = reactQuery.useQuery<
    AdminDownloadS3FileResponse,
    AdminDownloadS3FileError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchAdminDownloadS3File({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get contents of a file from S3 bucket as a downloadable file
 */
export const useSuspenseAdminDownloadS3File = <
  TData = AdminDownloadS3FileResponse,
>(
  variables: AdminDownloadS3FileVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      AdminDownloadS3FileResponse,
      AdminDownloadS3FileError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_query_actions/download_s3_file/",
    operationId: "adminDownloadS3File",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    AdminDownloadS3FileResponse,
    AdminDownloadS3FileError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchAdminDownloadS3File({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type InspectCachePathParams = {
  cacheKey: string;
};

export type InspectCacheError = Fetcher.ErrorWrapper<undefined>;

export type InspectCacheResponse = any[];

export type InspectCacheVariables = {
  pathParams: InspectCachePathParams;
} & ApiContext["fetcherOptions"];

export const fetchInspectCache = (
  variables: InspectCacheVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    InspectCacheResponse,
    InspectCacheError,
    undefined,
    {},
    {},
    InspectCachePathParams
  >({
    url: "/admin/internal_query_actions/inspect_cache/{cacheKey}/",
    method: "get",
    ...variables,
    signal,
  });

export const inspectCacheQueryKey = (
  variables: InspectCacheVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/internal_query_actions/inspect_cache/{cacheKey}/",
    operationId: "inspectCache",
    variables,
  });

export const useInspectCache = <TData = InspectCacheResponse,>(
  variables: InspectCacheVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<InspectCacheResponse, InspectCacheError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_query_actions/inspect_cache/{cacheKey}/",
    operationId: "inspectCache",
    variables,
  });
  const result = reactQuery.useQuery<
    InspectCacheResponse,
    InspectCacheError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchInspectCache({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseInspectCache = <TData = InspectCacheResponse,>(
  variables: InspectCacheVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      InspectCacheResponse,
      InspectCacheError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/internal_query_actions/inspect_cache/{cacheKey}/",
    operationId: "inspectCache",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    InspectCacheResponse,
    InspectCacheError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchInspectCache({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type DeleteFromCachePathParams = {
  cacheKey: string;
};

export type DeleteFromCacheError = Fetcher.ErrorWrapper<undefined>;

export type DeleteFromCacheResponse = any[];

export type DeleteFromCacheVariables = {
  pathParams: DeleteFromCachePathParams;
} & ApiContext["fetcherOptions"];

export const fetchDeleteFromCache = (
  variables: DeleteFromCacheVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    DeleteFromCacheResponse,
    DeleteFromCacheError,
    undefined,
    {},
    {},
    DeleteFromCachePathParams
  >({
    url: "/admin/internal_query_actions/delete_from_cache/{cacheKey}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteFromCache = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      DeleteFromCacheResponse,
      DeleteFromCacheError,
      DeleteFromCacheVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    DeleteFromCacheResponse,
    DeleteFromCacheError,
    DeleteFromCacheVariables
  >({
    mutationFn: (variables: DeleteFromCacheVariables) =>
      fetchDeleteFromCache({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ClearQueryParseResultsPathParams = {
  integrationId: string;
};

export type ClearQueryParseResultsQueryParams = {
  databuilder_prefix?: string | null;
};

export type ClearQueryParseResultsError = Fetcher.ErrorWrapper<undefined>;

export type ClearQueryParseResultsResponse = {
  [key: string]: any;
};

export type ClearQueryParseResultsVariables = {
  pathParams: ClearQueryParseResultsPathParams;
  queryParams?: ClearQueryParseResultsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchClearQueryParseResults = (
  variables: ClearQueryParseResultsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ClearQueryParseResultsResponse,
    ClearQueryParseResultsError,
    undefined,
    {},
    ClearQueryParseResultsQueryParams,
    ClearQueryParseResultsPathParams
  >({
    url: "/admin/internal_query_actions/clear_query_parse_results/{integrationId}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useClearQueryParseResults = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ClearQueryParseResultsResponse,
      ClearQueryParseResultsError,
      ClearQueryParseResultsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ClearQueryParseResultsResponse,
    ClearQueryParseResultsError,
    ClearQueryParseResultsVariables
  >({
    mutationFn: (variables: ClearQueryParseResultsVariables) =>
      fetchClearQueryParseResults({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateAllowedDomainsError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type UpdateAllowedDomainsVariables = {
  body: Schemas.WorkspaceAllowedDomainsIn;
} & ApiContext["fetcherOptions"];

/**
 * Update the allowed domains for a workspace
 */
export const fetchUpdateAllowedDomains = (
  variables: UpdateAllowedDomainsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LiteWorkspace,
    UpdateAllowedDomainsError,
    Schemas.WorkspaceAllowedDomainsIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/update_allowed_domains/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Update the allowed domains for a workspace
 */
export const useUpdateAllowedDomains = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LiteWorkspace,
      UpdateAllowedDomainsError,
      UpdateAllowedDomainsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LiteWorkspace,
    UpdateAllowedDomainsError,
    UpdateAllowedDomainsVariables
  >({
    mutationFn: (variables: UpdateAllowedDomainsVariables) =>
      fetchUpdateAllowedDomains({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateDisabledError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type UpdateDisabledVariables = {
  body: Schemas.WorkspaceDisabledIn;
} & ApiContext["fetcherOptions"];

/**
 * Update the disabled status of a workspace
 */
export const fetchUpdateDisabled = (
  variables: UpdateDisabledVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LiteWorkspace,
    UpdateDisabledError,
    Schemas.WorkspaceDisabledIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/update_disabled/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Update the disabled status of a workspace
 */
export const useUpdateDisabled = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LiteWorkspace,
      UpdateDisabledError,
      UpdateDisabledVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LiteWorkspace,
    UpdateDisabledError,
    UpdateDisabledVariables
  >({
    mutationFn: (variables: UpdateDisabledVariables) =>
      fetchUpdateDisabled({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RegenerateWorkspacePoliciesError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type RegenerateWorkspacePoliciesResponse = {
  [key: string]: any;
};

export type RegenerateWorkspacePoliciesVariables = {
  body: Schemas.WorkspacePolicyRegenerationIn;
} & ApiContext["fetcherOptions"];

/**
 * Regenerate policies for a specific workspace.
 * Supports both partial (fast) and complete (slow) rebuilds.
 */
export const fetchRegenerateWorkspacePolicies = (
  variables: RegenerateWorkspacePoliciesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    RegenerateWorkspacePoliciesResponse,
    RegenerateWorkspacePoliciesError,
    Schemas.WorkspacePolicyRegenerationIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/regenerate_workspace_policies/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Regenerate policies for a specific workspace.
 * Supports both partial (fast) and complete (slow) rebuilds.
 */
export const useRegenerateWorkspacePolicies = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      RegenerateWorkspacePoliciesResponse,
      RegenerateWorkspacePoliciesError,
      RegenerateWorkspacePoliciesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    RegenerateWorkspacePoliciesResponse,
    RegenerateWorkspacePoliciesError,
    RegenerateWorkspacePoliciesVariables
  >({
    mutationFn: (variables: RegenerateWorkspacePoliciesVariables) =>
      fetchRegenerateWorkspacePolicies({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateWorkspaceQualityFlagsEndpointError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type UpdateWorkspaceQualityFlagsEndpointResponse = {
  [key: string]: any;
};

export type UpdateWorkspaceQualityFlagsEndpointVariables = {
  body: Schemas.WorkspaceQualityFlagUpdateIn;
} & ApiContext["fetcherOptions"];

/**
 * Queue a quality flag refresh for a workspace.
 */
export const fetchUpdateWorkspaceQualityFlagsEndpoint = (
  variables: UpdateWorkspaceQualityFlagsEndpointVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    UpdateWorkspaceQualityFlagsEndpointResponse,
    UpdateWorkspaceQualityFlagsEndpointError,
    Schemas.WorkspaceQualityFlagUpdateIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/update_workspace_quality_flags/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Queue a quality flag refresh for a workspace.
 */
export const useUpdateWorkspaceQualityFlagsEndpoint = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      UpdateWorkspaceQualityFlagsEndpointResponse,
      UpdateWorkspaceQualityFlagsEndpointError,
      UpdateWorkspaceQualityFlagsEndpointVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    UpdateWorkspaceQualityFlagsEndpointResponse,
    UpdateWorkspaceQualityFlagsEndpointError,
    UpdateWorkspaceQualityFlagsEndpointVariables
  >({
    mutationFn: (variables: UpdateWorkspaceQualityFlagsEndpointVariables) =>
      fetchUpdateWorkspaceQualityFlagsEndpoint({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ResetDqs2PoliciesError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type ResetDqs2PoliciesResponse = {
  [key: string]: any;
};

export type ResetDqs2PoliciesVariables = {
  body: Schemas.WorkspaceDqs2ResetIn;
} & ApiContext["fetcherOptions"];

/**
 * Reset default DQS2 policies for a workspace and queue policy processing.
 */
export const fetchResetDqs2Policies = (
  variables: ResetDqs2PoliciesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ResetDqs2PoliciesResponse,
    ResetDqs2PoliciesError,
    Schemas.WorkspaceDqs2ResetIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/reset_dqs2_policies/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Reset default DQS2 policies for a workspace and queue policy processing.
 */
export const useResetDqs2Policies = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ResetDqs2PoliciesResponse,
      ResetDqs2PoliciesError,
      ResetDqs2PoliciesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ResetDqs2PoliciesResponse,
    ResetDqs2PoliciesError,
    ResetDqs2PoliciesVariables
  >({
    mutationFn: (variables: ResetDqs2PoliciesVariables) =>
      fetchResetDqs2Policies({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type BulkExportError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: {
    [key: string]: any;
  };
}>;

export type BulkExportResponse = {
  [key: string]: any;
};

export type BulkExportVariables = {
  body: Schemas.BulkExportIn;
} & ApiContext["fetcherOptions"];

/**
 * Start a bulk export job for the current admin user's workspace.
 *
 * Ensures the job runs as a background task and is attributed to the
 * authenticated admin user triggering it.
 */
export const fetchBulkExport = (
  variables: BulkExportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    BulkExportResponse,
    BulkExportError,
    Schemas.BulkExportIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/bulk_export/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Start a bulk export job for the current admin user's workspace.
 *
 * Ensures the job runs as a background task and is attributed to the
 * authenticated admin user triggering it.
 */
export const useBulkExport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      BulkExportResponse,
      BulkExportError,
      BulkExportVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    BulkExportResponse,
    BulkExportError,
    BulkExportVariables
  >({
    mutationFn: (variables: BulkExportVariables) =>
      fetchBulkExport({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type TestTunnelConnectivityError = Fetcher.ErrorWrapper<undefined>;

export type TestTunnelConnectivityVariables = {
  body: Schemas.TunnelConnectivityTestIn;
} & ApiContext["fetcherOptions"];

/**
 * Spawn a background task to test tunnel connectivity with results logged to Grafana.
 */
export const fetchTestTunnelConnectivity = (
  variables: TestTunnelConnectivityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TunnelConnectivityTestOut,
    TestTunnelConnectivityError,
    Schemas.TunnelConnectivityTestIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/test_tunnel_connectivity/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Spawn a background task to test tunnel connectivity with results logged to Grafana.
 */
export const useTestTunnelConnectivity = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TunnelConnectivityTestOut,
      TestTunnelConnectivityError,
      TestTunnelConnectivityVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.TunnelConnectivityTestOut,
    TestTunnelConnectivityError,
    TestTunnelConnectivityVariables
  >({
    mutationFn: (variables: TestTunnelConnectivityVariables) =>
      fetchTestTunnelConnectivity({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type TestConnectivityError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: {
    [key: string]: any;
  };
}>;

export type TestConnectivityResponse = {
  [key: string]: any;
};

export type TestConnectivityVariables = {
  body: Schemas.IntegrationConnectivityTestIn;
} & ApiContext["fetcherOptions"];

export const fetchTestConnectivity = (
  variables: TestConnectivityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    TestConnectivityResponse,
    TestConnectivityError,
    Schemas.IntegrationConnectivityTestIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/test_connectivity/",
    method: "post",
    ...variables,
    signal,
  });

export const useTestConnectivity = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      TestConnectivityResponse,
      TestConnectivityError,
      TestConnectivityVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    TestConnectivityResponse,
    TestConnectivityError,
    TestConnectivityVariables
  >({
    mutationFn: (variables: TestConnectivityVariables) =>
      fetchTestConnectivity({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RegenerateTeamsPermissionsError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: {
    [key: string]: any;
  };
}>;

export type RegenerateTeamsPermissionsResponse = {
  [key: string]: any;
};

export type RegenerateTeamsPermissionsVariables = {
  body: Schemas.RegenerateTeamsPermissionsIn;
} & ApiContext["fetcherOptions"];

export const fetchRegenerateTeamsPermissions = (
  variables: RegenerateTeamsPermissionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    RegenerateTeamsPermissionsResponse,
    RegenerateTeamsPermissionsError,
    Schemas.RegenerateTeamsPermissionsIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/regenerate_teams_permissions/",
    method: "post",
    ...variables,
    signal,
  });

export const useRegenerateTeamsPermissions = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      RegenerateTeamsPermissionsResponse,
      RegenerateTeamsPermissionsError,
      RegenerateTeamsPermissionsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    RegenerateTeamsPermissionsResponse,
    RegenerateTeamsPermissionsError,
    RegenerateTeamsPermissionsVariables
  >({
    mutationFn: (variables: RegenerateTeamsPermissionsVariables) =>
      fetchRegenerateTeamsPermissions({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveDisabledUsersFromTeamsError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type RemoveDisabledUsersFromTeamsResponse = {
  [key: string]: any;
};

export type RemoveDisabledUsersFromTeamsVariables = {
  body: Schemas.RemoveDisabledUsersFromTeamsIn;
} & ApiContext["fetcherOptions"];

/**
 * Delete all TeamMembership records where the user is disabled, scoped to a workspace.
 */
export const fetchRemoveDisabledUsersFromTeams = (
  variables: RemoveDisabledUsersFromTeamsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    RemoveDisabledUsersFromTeamsResponse,
    RemoveDisabledUsersFromTeamsError,
    Schemas.RemoveDisabledUsersFromTeamsIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/remove_disabled_users_from_teams/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Delete all TeamMembership records where the user is disabled, scoped to a workspace.
 */
export const useRemoveDisabledUsersFromTeams = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      RemoveDisabledUsersFromTeamsResponse,
      RemoveDisabledUsersFromTeamsError,
      RemoveDisabledUsersFromTeamsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    RemoveDisabledUsersFromTeamsResponse,
    RemoveDisabledUsersFromTeamsError,
    RemoveDisabledUsersFromTeamsVariables
  >({
    mutationFn: (variables: RemoveDisabledUsersFromTeamsVariables) =>
      fetchRemoveDisabledUsersFromTeams({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGenerateWorkspaceLineageError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type ApiGenerateWorkspaceLineageResponse = {
  [key: string]: any;
};

export type ApiGenerateWorkspaceLineageVariables = {
  body: Schemas.GenerateWorkspaceLineageIn;
} & ApiContext["fetcherOptions"];

/**
 * Generate workspace lineage for a specific workspace.
 * Runs synchronously and returns any errors immediately.
 */
export const fetchApiGenerateWorkspaceLineage = (
  variables: ApiGenerateWorkspaceLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGenerateWorkspaceLineageResponse,
    ApiGenerateWorkspaceLineageError,
    Schemas.GenerateWorkspaceLineageIn,
    {},
    {},
    {}
  >({
    url: "/admin/internal_query_actions/generate_workspace_lineage/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Generate workspace lineage for a specific workspace.
 * Runs synchronously and returns any errors immediately.
 */
export const useApiGenerateWorkspaceLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiGenerateWorkspaceLineageResponse,
      ApiGenerateWorkspaceLineageError,
      ApiGenerateWorkspaceLineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiGenerateWorkspaceLineageResponse,
    ApiGenerateWorkspaceLineageError,
    ApiGenerateWorkspaceLineageVariables
  >({
    mutationFn: (variables: ApiGenerateWorkspaceLineageVariables) =>
      fetchApiGenerateWorkspaceLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateLinearTicketError = Fetcher.ErrorWrapper<undefined>;

export type CreateLinearTicketVariables = {
  body: Schemas.TicketIn;
} & ApiContext["fetcherOptions"];

export const fetchCreateLinearTicket = (
  variables: CreateLinearTicketVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TicketCreateOut,
    CreateLinearTicketError,
    Schemas.TicketIn,
    {},
    {},
    {}
  >({
    url: "/admin/linear/create_linear_ticket/",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateLinearTicket = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TicketCreateOut,
      CreateLinearTicketError,
      CreateLinearTicketVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.TicketCreateOut,
    CreateLinearTicketError,
    CreateLinearTicketVariables
  >({
    mutationFn: (variables: CreateLinearTicketVariables) =>
      fetchCreateLinearTicket({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetLinearTicketsPathParams = {
  title: string;
};

export type GetLinearTicketsError = Fetcher.ErrorWrapper<undefined>;

export type GetLinearTicketsResponse = Schemas.LinearTicket[];

export type GetLinearTicketsVariables = {
  pathParams: GetLinearTicketsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetLinearTickets = (
  variables: GetLinearTicketsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetLinearTicketsResponse,
    GetLinearTicketsError,
    undefined,
    {},
    {},
    GetLinearTicketsPathParams
  >({
    url: "/admin/linear/get_linear_tickets/{title}/",
    method: "get",
    ...variables,
    signal,
  });

export const getLinearTicketsQueryKey = (
  variables: GetLinearTicketsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/linear/get_linear_tickets/{title}/",
    operationId: "getLinearTickets",
    variables,
  });

export const useGetLinearTickets = <TData = GetLinearTicketsResponse,>(
  variables: GetLinearTicketsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetLinearTicketsResponse,
      GetLinearTicketsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/linear/get_linear_tickets/{title}/",
    operationId: "getLinearTickets",
    variables,
  });
  const result = reactQuery.useQuery<
    GetLinearTicketsResponse,
    GetLinearTicketsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetLinearTickets({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetLinearTickets = <TData = GetLinearTicketsResponse,>(
  variables: GetLinearTicketsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetLinearTicketsResponse,
      GetLinearTicketsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/linear/get_linear_tickets/{title}/",
    operationId: "getLinearTickets",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetLinearTicketsResponse,
    GetLinearTicketsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetLinearTickets({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type LinkLinearTicketError = Fetcher.ErrorWrapper<undefined>;

export type LinkLinearTicketVariables = {
  body: Schemas.LinkTicketIn;
} & ApiContext["fetcherOptions"];

export const fetchLinkLinearTicket = (
  variables: LinkLinearTicketVariables,
  signal?: AbortSignal,
) =>
  apiFetch<undefined, LinkLinearTicketError, Schemas.LinkTicketIn, {}, {}, {}>({
    url: "/admin/linear/link_linear_ticket/",
    method: "post",
    ...variables,
    signal,
  });

export const useLinkLinearTicket = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      LinkLinearTicketError,
      LinkLinearTicketVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    LinkLinearTicketError,
    LinkLinearTicketVariables
  >({
    mutationFn: (variables: LinkLinearTicketVariables) =>
      fetchLinkLinearTicket({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveLinearTicketError = Fetcher.ErrorWrapper<undefined>;

export type RemoveLinearTicketVariables = {
  body: Schemas.RemoveTicketIn;
} & ApiContext["fetcherOptions"];

export const fetchRemoveLinearTicket = (
  variables: RemoveLinearTicketVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    RemoveLinearTicketError,
    Schemas.RemoveTicketIn,
    {},
    {},
    {}
  >({
    url: "/admin/linear/remove_linear_ticket/",
    method: "post",
    ...variables,
    signal,
  });

export const useRemoveLinearTicket = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveLinearTicketError,
      RemoveLinearTicketVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveLinearTicketError,
    RemoveLinearTicketVariables
  >({
    mutationFn: (variables: RemoveLinearTicketVariables) =>
      fetchRemoveLinearTicket({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiInspectLineageFromSqlError = Fetcher.ErrorWrapper<undefined>;

export type ApiInspectLineageFromSqlVariables = {
  body: Schemas.InspectLineageRequest;
} & ApiContext["fetcherOptions"];

/**
 * Inspect lineage from SQL query.
 */
export const fetchApiInspectLineageFromSql = (
  variables: ApiInspectLineageFromSqlVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.InspectLineageResponse,
    ApiInspectLineageFromSqlError,
    Schemas.InspectLineageRequest,
    {},
    {},
    {}
  >({ url: "/admin/sql_query/inspect/", method: "post", ...variables, signal });

/**
 * Inspect lineage from SQL query.
 */
export const useApiInspectLineageFromSql = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.InspectLineageResponse,
      ApiInspectLineageFromSqlError,
      ApiInspectLineageFromSqlVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.InspectLineageResponse,
    ApiInspectLineageFromSqlError,
    ApiInspectLineageFromSqlVariables
  >({
    mutationFn: (variables: ApiInspectLineageFromSqlVariables) =>
      fetchApiInspectLineageFromSql({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiSubmitFixLineageRequestError = Fetcher.ErrorWrapper<undefined>;

export type ApiSubmitFixLineageRequestVariables = {
  body: Schemas.FixLineageRequest;
} & ApiContext["fetcherOptions"];

/**
 * Submit a request to fix the lineage of given target entity.
 */
export const fetchApiSubmitFixLineageRequest = (
  variables: ApiSubmitFixLineageRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PendingLineageFixOut,
    ApiSubmitFixLineageRequestError,
    Schemas.FixLineageRequest,
    {},
    {},
    {}
  >({ url: "/admin/sql_query/fix/", method: "post", ...variables, signal });

/**
 * Submit a request to fix the lineage of given target entity.
 */
export const useApiSubmitFixLineageRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PendingLineageFixOut,
      ApiSubmitFixLineageRequestError,
      ApiSubmitFixLineageRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PendingLineageFixOut,
    ApiSubmitFixLineageRequestError,
    ApiSubmitFixLineageRequestVariables
  >({
    mutationFn: (variables: ApiSubmitFixLineageRequestVariables) =>
      fetchApiSubmitFixLineageRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetEntityLineageGraphQueryParams = {
  entity_id: string;
  /**
   * @default false
   */
  include_archived?: boolean;
};

export type GetEntityLineageGraphError = Fetcher.ErrorWrapper<undefined>;

export type GetEntityLineageGraphVariables = {
  queryParams: GetEntityLineageGraphQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get lineage data for a given entity ID in LineageGraphData format.
 * This queries the Lineage Django objects directly and returns the data
 * in the format expected by the frontend LineageGraph component.
 */
export const fetchGetEntityLineageGraph = (
  variables: GetEntityLineageGraphVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    GetEntityLineageGraphError,
    undefined,
    {},
    GetEntityLineageGraphQueryParams,
    {}
  >({
    url: "/admin/entity_lineage/lineage_graph/",
    method: "get",
    ...variables,
    signal,
  });

export const getEntityLineageGraphQueryKey = (
  variables: GetEntityLineageGraphVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/entity_lineage/lineage_graph/",
    operationId: "getEntityLineageGraph",
    variables,
  });

/**
 * Get lineage data for a given entity ID in LineageGraphData format.
 * This queries the Lineage Django objects directly and returns the data
 * in the format expected by the frontend LineageGraph component.
 */
export const useGetEntityLineageGraph = <TData = undefined,>(
  variables: GetEntityLineageGraphVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetEntityLineageGraphError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/entity_lineage/lineage_graph/",
    operationId: "getEntityLineageGraph",
    variables,
  });
  const result = reactQuery.useQuery<
    undefined,
    GetEntityLineageGraphError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetEntityLineageGraph({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get lineage data for a given entity ID in LineageGraphData format.
 * This queries the Lineage Django objects directly and returns the data
 * in the format expected by the frontend LineageGraph component.
 */
export const useSuspenseGetEntityLineageGraph = <TData = undefined,>(
  variables: GetEntityLineageGraphVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      undefined,
      GetEntityLineageGraphError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/entity_lineage/lineage_graph/",
    operationId: "getEntityLineageGraph",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    undefined,
    GetEntityLineageGraphError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetEntityLineageGraph({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ForceStaleLineagePathParams = {
  lineageId: string;
};

export type ForceStaleLineageError = Fetcher.ErrorWrapper<undefined>;

export type ForceStaleLineageVariables = {
  pathParams: ForceStaleLineagePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Force a lineage to be stale.
 */
export const fetchForceStaleLineage = (
  variables: ForceStaleLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ForceStaleLineageError,
    undefined,
    {},
    {},
    ForceStaleLineagePathParams
  >({
    url: "/admin/entity_lineage/force_stale_lineage/{lineageId}/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Force a lineage to be stale.
 */
export const useForceStaleLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ForceStaleLineageError,
      ForceStaleLineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ForceStaleLineageError,
    ForceStaleLineageVariables
  >({
    mutationFn: (variables: ForceStaleLineageVariables) =>
      fetchForceStaleLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ForceUnstaleLineagePathParams = {
  lineageId: string;
};

export type ForceUnstaleLineageError = Fetcher.ErrorWrapper<undefined>;

export type ForceUnstaleLineageVariables = {
  pathParams: ForceUnstaleLineagePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Force a lineage to be unstale.
 */
export const fetchForceUnstaleLineage = (
  variables: ForceUnstaleLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ForceUnstaleLineageError,
    undefined,
    {},
    {},
    ForceUnstaleLineagePathParams
  >({
    url: "/admin/entity_lineage/force_unstale_lineage/{lineageId}/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Force a lineage to be unstale.
 */
export const useForceUnstaleLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ForceUnstaleLineageError,
      ForceUnstaleLineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ForceUnstaleLineageError,
    ForceUnstaleLineageVariables
  >({
    mutationFn: (variables: ForceUnstaleLineageVariables) =>
      fetchForceUnstaleLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetLineageDebugInfoPathParams = {
  lineageId: string;
};

export type GetLineageDebugInfoError = Fetcher.ErrorWrapper<undefined>;

export type GetLineageDebugInfoVariables = {
  pathParams: GetLineageDebugInfoPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get debug info for a given lineage ID.
 */
export const fetchGetLineageDebugInfo = (
  variables: GetLineageDebugInfoVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    GetLineageDebugInfoError,
    undefined,
    {},
    {},
    GetLineageDebugInfoPathParams
  >({
    url: "/admin/entity_lineage/lineage_debug_info/{lineageId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getLineageDebugInfoQueryKey = (
  variables: GetLineageDebugInfoVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/entity_lineage/lineage_debug_info/{lineageId}/",
    operationId: "getLineageDebugInfo",
    variables,
  });

/**
 * Get debug info for a given lineage ID.
 */
export const useGetLineageDebugInfo = <TData = undefined,>(
  variables: GetLineageDebugInfoVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetLineageDebugInfoError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/entity_lineage/lineage_debug_info/{lineageId}/",
    operationId: "getLineageDebugInfo",
    variables,
  });
  const result = reactQuery.useQuery<
    undefined,
    GetLineageDebugInfoError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetLineageDebugInfo({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get debug info for a given lineage ID.
 */
export const useSuspenseGetLineageDebugInfo = <TData = undefined,>(
  variables: GetLineageDebugInfoVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      undefined,
      GetLineageDebugInfoError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/entity_lineage/lineage_debug_info/{lineageId}/",
    operationId: "getLineageDebugInfo",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    undefined,
    GetLineageDebugInfoError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetLineageDebugInfo({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSuperuserGetAiChatPathParams = {
  promptId: string;
};

export type ApiSuperuserGetAiChatError = Fetcher.ErrorWrapper<undefined>;

export type ApiSuperuserGetAiChatResponse = Schemas.EmbeddedPromptAdminOut[];

export type ApiSuperuserGetAiChatVariables = {
  pathParams: ApiSuperuserGetAiChatPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the AI chat for the given prompt id
 */
export const fetchApiSuperuserGetAiChat = (
  variables: ApiSuperuserGetAiChatVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiSuperuserGetAiChatResponse,
    ApiSuperuserGetAiChatError,
    undefined,
    {},
    {},
    ApiSuperuserGetAiChatPathParams
  >({
    url: "/admin/ai_chats/chat/{promptId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiSuperuserGetAiChatQueryKey = (
  variables: ApiSuperuserGetAiChatVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/ai_chats/chat/{promptId}/",
    operationId: "apiSuperuserGetAiChat",
    variables,
  });

/**
 * Get the AI chat for the given prompt id
 */
export const useApiSuperuserGetAiChat = <
  TData = ApiSuperuserGetAiChatResponse,
>(
  variables: ApiSuperuserGetAiChatVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiSuperuserGetAiChatResponse,
      ApiSuperuserGetAiChatError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/ai_chats/chat/{promptId}/",
    operationId: "apiSuperuserGetAiChat",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiSuperuserGetAiChatResponse,
    ApiSuperuserGetAiChatError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetAiChat({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the AI chat for the given prompt id
 */
export const useSuspenseApiSuperuserGetAiChat = <
  TData = ApiSuperuserGetAiChatResponse,
>(
  variables: ApiSuperuserGetAiChatVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiSuperuserGetAiChatResponse,
      ApiSuperuserGetAiChatError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/ai_chats/chat/{promptId}/",
    operationId: "apiSuperuserGetAiChat",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiSuperuserGetAiChatResponse,
    ApiSuperuserGetAiChatError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetAiChat({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSuperuserGetAiChatsForUserPathParams = {
  userId: string;
};

export type ApiSuperuserGetAiChatsForUserQueryParams = {
  user_generated?: boolean | null;
};

export type ApiSuperuserGetAiChatsForUserError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiSuperuserGetAiChatsForUserResponse =
  Schemas.LiteEmbeddedPromptOut[];

export type ApiSuperuserGetAiChatsForUserVariables = {
  pathParams: ApiSuperuserGetAiChatsForUserPathParams;
  queryParams?: ApiSuperuserGetAiChatsForUserQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the AI chat for the given prompt id
 */
export const fetchApiSuperuserGetAiChatsForUser = (
  variables: ApiSuperuserGetAiChatsForUserVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiSuperuserGetAiChatsForUserResponse,
    ApiSuperuserGetAiChatsForUserError,
    undefined,
    {},
    ApiSuperuserGetAiChatsForUserQueryParams,
    ApiSuperuserGetAiChatsForUserPathParams
  >({
    url: "/admin/ai_chats/for_user/{userId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiSuperuserGetAiChatsForUserQueryKey = (
  variables: ApiSuperuserGetAiChatsForUserVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/ai_chats/for_user/{userId}/",
    operationId: "apiSuperuserGetAiChatsForUser",
    variables,
  });

/**
 * Get the AI chat for the given prompt id
 */
export const useApiSuperuserGetAiChatsForUser = <
  TData = ApiSuperuserGetAiChatsForUserResponse,
>(
  variables: ApiSuperuserGetAiChatsForUserVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiSuperuserGetAiChatsForUserResponse,
      ApiSuperuserGetAiChatsForUserError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/ai_chats/for_user/{userId}/",
    operationId: "apiSuperuserGetAiChatsForUser",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiSuperuserGetAiChatsForUserResponse,
    ApiSuperuserGetAiChatsForUserError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetAiChatsForUser(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the AI chat for the given prompt id
 */
export const useSuspenseApiSuperuserGetAiChatsForUser = <
  TData = ApiSuperuserGetAiChatsForUserResponse,
>(
  variables: ApiSuperuserGetAiChatsForUserVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiSuperuserGetAiChatsForUserResponse,
      ApiSuperuserGetAiChatsForUserError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/ai_chats/for_user/{userId}/",
    operationId: "apiSuperuserGetAiChatsForUser",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiSuperuserGetAiChatsForUserResponse,
    ApiSuperuserGetAiChatsForUserError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetAiChatsForUser(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiAdminGetRunningAutomationsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiAdminGetRunningAutomationsVariables =
  ApiContext["fetcherOptions"];

export const fetchApiAdminGetRunningAutomations = (
  variables: ApiAdminGetRunningAutomationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RunningAutomationsOut,
    ApiAdminGetRunningAutomationsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/admin/automations/", method: "get", ...variables, signal });

export const apiAdminGetRunningAutomationsQueryKey = (
  variables: ApiAdminGetRunningAutomationsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/automations/",
    operationId: "apiAdminGetRunningAutomations",
    variables,
  });

export const useApiAdminGetRunningAutomations = <
  TData = Schemas.RunningAutomationsOut,
>(
  variables: ApiAdminGetRunningAutomationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RunningAutomationsOut,
      ApiAdminGetRunningAutomationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/automations/",
    operationId: "apiAdminGetRunningAutomations",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.RunningAutomationsOut,
    ApiAdminGetRunningAutomationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiAdminGetRunningAutomations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiAdminGetRunningAutomations = <
  TData = Schemas.RunningAutomationsOut,
>(
  variables: ApiAdminGetRunningAutomationsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.RunningAutomationsOut,
      ApiAdminGetRunningAutomationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/automations/",
    operationId: "apiAdminGetRunningAutomations",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.RunningAutomationsOut,
    ApiAdminGetRunningAutomationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiAdminGetRunningAutomations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiAdminRemoveAutomationFromQueueQueryParams = {
  automation_id: string;
};

export type ApiAdminRemoveAutomationFromQueueError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiAdminRemoveAutomationFromQueueVariables = {
  queryParams: ApiAdminRemoveAutomationFromQueueQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiAdminRemoveAutomationFromQueue = (
  variables: ApiAdminRemoveAutomationFromQueueVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    ApiAdminRemoveAutomationFromQueueError,
    undefined,
    {},
    ApiAdminRemoveAutomationFromQueueQueryParams,
    {}
  >({
    url: "/admin/automations/remove_from_queue/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiAdminRemoveAutomationFromQueue = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      ApiAdminRemoveAutomationFromQueueError,
      ApiAdminRemoveAutomationFromQueueVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    string,
    ApiAdminRemoveAutomationFromQueueError,
    ApiAdminRemoveAutomationFromQueueVariables
  >({
    mutationFn: (variables: ApiAdminRemoveAutomationFromQueueVariables) =>
      fetchApiAdminRemoveAutomationFromQueue({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type GetWorkspaceFlagsPathParams = {
  workspaceId: string;
};

export type GetWorkspaceFlagsError = Fetcher.ErrorWrapper<undefined>;

export type GetWorkspaceFlagsVariables = {
  pathParams: GetWorkspaceFlagsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve all Boolean fields from a workspace.
 */
export const fetchGetWorkspaceFlags = (
  variables: GetWorkspaceFlagsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.WorkspaceFlags,
    GetWorkspaceFlagsError,
    undefined,
    {},
    {},
    GetWorkspaceFlagsPathParams
  >({
    url: "/admin/workspace_flags/{workspaceId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getWorkspaceFlagsQueryKey = (
  variables: GetWorkspaceFlagsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/workspace_flags/{workspaceId}/",
    operationId: "getWorkspaceFlags",
    variables,
  });

/**
 * Retrieve all Boolean fields from a workspace.
 */
export const useGetWorkspaceFlags = <TData = Schemas.WorkspaceFlags,>(
  variables: GetWorkspaceFlagsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.WorkspaceFlags,
      GetWorkspaceFlagsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/workspace_flags/{workspaceId}/",
    operationId: "getWorkspaceFlags",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.WorkspaceFlags,
    GetWorkspaceFlagsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceFlags({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve all Boolean fields from a workspace.
 */
export const useSuspenseGetWorkspaceFlags = <TData = Schemas.WorkspaceFlags,>(
  variables: GetWorkspaceFlagsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.WorkspaceFlags,
      GetWorkspaceFlagsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/workspace_flags/{workspaceId}/",
    operationId: "getWorkspaceFlags",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.WorkspaceFlags,
    GetWorkspaceFlagsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceFlags({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type UpdateWorkspaceFlagsPathParams = {
  workspaceId: string;
};

export type UpdateWorkspaceFlagsError = Fetcher.ErrorWrapper<undefined>;

export type UpdateWorkspaceFlagsVariables = {
  body: Schemas.WorkspaceFlagsInPatch;
  pathParams: UpdateWorkspaceFlagsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update Boolean fields on a workspace.
 */
export const fetchUpdateWorkspaceFlags = (
  variables: UpdateWorkspaceFlagsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    UpdateWorkspaceFlagsError,
    Schemas.WorkspaceFlagsInPatch,
    {},
    {},
    UpdateWorkspaceFlagsPathParams
  >({
    url: "/admin/workspace_flags/{workspaceId}/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update Boolean fields on a workspace.
 */
export const useUpdateWorkspaceFlags = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateWorkspaceFlagsError,
      UpdateWorkspaceFlagsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateWorkspaceFlagsError,
    UpdateWorkspaceFlagsVariables
  >({
    mutationFn: (variables: UpdateWorkspaceFlagsVariables) =>
      fetchUpdateWorkspaceFlags({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetWorkspaceMemoryPathParams = {
  workspaceId: string;
};

export type GetWorkspaceMemoryError = Fetcher.ErrorWrapper<undefined>;

export type GetWorkspaceMemoryVariables = {
  pathParams: GetWorkspaceMemoryPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get workspace memory content for any workspace.
 *
 * Args:
 *     request: The incoming HTTP request.
 *     workspace_id: The workspace identifier.
 *
 * Returns:
 *     Workspace memory content and size metadata.
 */
export const fetchGetWorkspaceMemory = (
  variables: GetWorkspaceMemoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.WorkspaceMemoryOut,
    GetWorkspaceMemoryError,
    undefined,
    {},
    {},
    GetWorkspaceMemoryPathParams
  >({
    url: "/admin/workspace_memory/{workspaceId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getWorkspaceMemoryQueryKey = (
  variables: GetWorkspaceMemoryVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/workspace_memory/{workspaceId}/",
    operationId: "getWorkspaceMemory",
    variables,
  });

/**
 * Get workspace memory content for any workspace.
 *
 * Args:
 *     request: The incoming HTTP request.
 *     workspace_id: The workspace identifier.
 *
 * Returns:
 *     Workspace memory content and size metadata.
 */
export const useGetWorkspaceMemory = <TData = Schemas.WorkspaceMemoryOut,>(
  variables: GetWorkspaceMemoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.WorkspaceMemoryOut,
      GetWorkspaceMemoryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/workspace_memory/{workspaceId}/",
    operationId: "getWorkspaceMemory",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.WorkspaceMemoryOut,
    GetWorkspaceMemoryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceMemory({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get workspace memory content for any workspace.
 *
 * Args:
 *     request: The incoming HTTP request.
 *     workspace_id: The workspace identifier.
 *
 * Returns:
 *     Workspace memory content and size metadata.
 */
export const useSuspenseGetWorkspaceMemory = <
  TData = Schemas.WorkspaceMemoryOut,
>(
  variables: GetWorkspaceMemoryVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.WorkspaceMemoryOut,
      GetWorkspaceMemoryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/workspace_memory/{workspaceId}/",
    operationId: "getWorkspaceMemory",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.WorkspaceMemoryOut,
    GetWorkspaceMemoryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceMemory({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type PreviewCondensedWorkspaceMemoryPathParams = {
  workspaceId: string;
};

export type PreviewCondensedWorkspaceMemoryError =
  Fetcher.ErrorWrapper<undefined>;

export type PreviewCondensedWorkspaceMemoryVariables = {
  body: Schemas.WorkspaceMemoryCondensePreviewIn;
  pathParams: PreviewCondensedWorkspaceMemoryPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Start a background job that previews condensed workspace memory.
 *
 * Args:
 *     request: The incoming HTTP request.
 *     workspace_id: The workspace identifier.
 *     body: Condensation effort settings.
 *
 * Returns:
 *     Background job for the condensation preview.
 */
export const fetchPreviewCondensedWorkspaceMemory = (
  variables: PreviewCondensedWorkspaceMemoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    PreviewCondensedWorkspaceMemoryError,
    Schemas.WorkspaceMemoryCondensePreviewIn,
    {},
    {},
    PreviewCondensedWorkspaceMemoryPathParams
  >({
    url: "/admin/workspace_memory/{workspaceId}/condense/preview/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Start a background job that previews condensed workspace memory.
 *
 * Args:
 *     request: The incoming HTTP request.
 *     workspace_id: The workspace identifier.
 *     body: Condensation effort settings.
 *
 * Returns:
 *     Background job for the condensation preview.
 */
export const usePreviewCondensedWorkspaceMemory = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BackgroundJobOut,
      PreviewCondensedWorkspaceMemoryError,
      PreviewCondensedWorkspaceMemoryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BackgroundJobOut,
    PreviewCondensedWorkspaceMemoryError,
    PreviewCondensedWorkspaceMemoryVariables
  >({
    mutationFn: (variables: PreviewCondensedWorkspaceMemoryVariables) =>
      fetchPreviewCondensedWorkspaceMemory({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetCondensedWorkspaceMemoryPreviewPathParams = {
  workspaceId: string;
  jobId: string;
};

export type GetCondensedWorkspaceMemoryPreviewError =
  Fetcher.ErrorWrapper<undefined>;

export type GetCondensedWorkspaceMemoryPreviewVariables = {
  pathParams: GetCondensedWorkspaceMemoryPreviewPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a workspace memory condensation preview background job.
 */
export const fetchGetCondensedWorkspaceMemoryPreview = (
  variables: GetCondensedWorkspaceMemoryPreviewVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.WorkspaceMemoryCondensePreviewJobOut,
    GetCondensedWorkspaceMemoryPreviewError,
    undefined,
    {},
    {},
    GetCondensedWorkspaceMemoryPreviewPathParams
  >({
    url: "/admin/workspace_memory/{workspaceId}/condense/preview/{jobId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getCondensedWorkspaceMemoryPreviewQueryKey = (
  variables: GetCondensedWorkspaceMemoryPreviewVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/admin/workspace_memory/{workspaceId}/condense/preview/{jobId}/",
    operationId: "getCondensedWorkspaceMemoryPreview",
    variables,
  });

/**
 * Get a workspace memory condensation preview background job.
 */
export const useGetCondensedWorkspaceMemoryPreview = <
  TData = Schemas.WorkspaceMemoryCondensePreviewJobOut,
>(
  variables: GetCondensedWorkspaceMemoryPreviewVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.WorkspaceMemoryCondensePreviewJobOut,
      GetCondensedWorkspaceMemoryPreviewError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/workspace_memory/{workspaceId}/condense/preview/{jobId}/",
    operationId: "getCondensedWorkspaceMemoryPreview",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.WorkspaceMemoryCondensePreviewJobOut,
    GetCondensedWorkspaceMemoryPreviewError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCondensedWorkspaceMemoryPreview(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a workspace memory condensation preview background job.
 */
export const useSuspenseGetCondensedWorkspaceMemoryPreview = <
  TData = Schemas.WorkspaceMemoryCondensePreviewJobOut,
>(
  variables: GetCondensedWorkspaceMemoryPreviewVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.WorkspaceMemoryCondensePreviewJobOut,
      GetCondensedWorkspaceMemoryPreviewError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/admin/workspace_memory/{workspaceId}/condense/preview/{jobId}/",
    operationId: "getCondensedWorkspaceMemoryPreview",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.WorkspaceMemoryCondensePreviewJobOut,
    GetCondensedWorkspaceMemoryPreviewError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCondensedWorkspaceMemoryPreview(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApplyCondensedWorkspaceMemoryPathParams = {
  workspaceId: string;
};

export type ApplyCondensedWorkspaceMemoryError =
  Fetcher.ErrorWrapper<undefined>;

export type ApplyCondensedWorkspaceMemoryVariables = {
  body: Schemas.WorkspaceMemoryCondenseApplyIn;
  pathParams: ApplyCondensedWorkspaceMemoryPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Persist a previously generated condensed workspace memory preview.
 *
 * Args:
 *     request: The incoming HTTP request.
 *     workspace_id: The workspace identifier.
 *     body: Condensed memory content and effort used to generate it.
 *
 * Returns:
 *     Updated workspace memory content and size metadata.
 */
export const fetchApplyCondensedWorkspaceMemory = (
  variables: ApplyCondensedWorkspaceMemoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.WorkspaceMemoryOut,
    ApplyCondensedWorkspaceMemoryError,
    Schemas.WorkspaceMemoryCondenseApplyIn,
    {},
    {},
    ApplyCondensedWorkspaceMemoryPathParams
  >({
    url: "/admin/workspace_memory/{workspaceId}/condense/apply/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Persist a previously generated condensed workspace memory preview.
 *
 * Args:
 *     request: The incoming HTTP request.
 *     workspace_id: The workspace identifier.
 *     body: Condensed memory content and effort used to generate it.
 *
 * Returns:
 *     Updated workspace memory content and size metadata.
 */
export const useApplyCondensedWorkspaceMemory = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.WorkspaceMemoryOut,
      ApplyCondensedWorkspaceMemoryError,
      ApplyCondensedWorkspaceMemoryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.WorkspaceMemoryOut,
    ApplyCondensedWorkspaceMemoryError,
    ApplyCondensedWorkspaceMemoryVariables
  >({
    mutationFn: (variables: ApplyCondensedWorkspaceMemoryVariables) =>
      fetchApplyCondensedWorkspaceMemory({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type MigrateGlossaryTermsEndpointError = Fetcher.ErrorWrapper<undefined>;

export type MigrateGlossaryTermsEndpointVariables =
  ApiContext["fetcherOptions"];

/**
 * Migrate glossary terms
 */
export const fetchMigrateGlossaryTermsEndpoint = (
  variables: MigrateGlossaryTermsEndpointVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    MigrateGlossaryTermsEndpointError,
    undefined,
    {},
    {},
    {}
  >({ url: "/glossary/migrate/", method: "post", ...variables, signal });

/**
 * Migrate glossary terms
 */
export const useMigrateGlossaryTermsEndpoint = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BackgroundJobOut,
      MigrateGlossaryTermsEndpointError,
      MigrateGlossaryTermsEndpointVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BackgroundJobOut,
    MigrateGlossaryTermsEndpointError,
    MigrateGlossaryTermsEndpointVariables
  >({
    mutationFn: (variables: MigrateGlossaryTermsEndpointVariables) =>
      fetchMigrateGlossaryTermsEndpoint({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetCollectionEntitiesCountPathParams = {
  entityId: string;
};

export type ApiGetCollectionEntitiesCountError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetCollectionEntitiesCountResponse = {
  [key: string]: number;
};

export type ApiGetCollectionEntitiesCountVariables = {
  pathParams: ApiGetCollectionEntitiesCountPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the count of entities within a collection grouped by entity type.
 */
export const fetchApiGetCollectionEntitiesCount = (
  variables: ApiGetCollectionEntitiesCountVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetCollectionEntitiesCountResponse,
    ApiGetCollectionEntitiesCountError,
    undefined,
    {},
    {},
    ApiGetCollectionEntitiesCountPathParams
  >({
    url: "/collection/collections/{entityId}/entities_count/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetCollectionEntitiesCountQueryKey = (
  variables: ApiGetCollectionEntitiesCountVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/collection/collections/{entityId}/entities_count/",
    operationId: "apiGetCollectionEntitiesCount",
    variables,
  });

/**
 * Get the count of entities within a collection grouped by entity type.
 */
export const useApiGetCollectionEntitiesCount = <
  TData = ApiGetCollectionEntitiesCountResponse,
>(
  variables: ApiGetCollectionEntitiesCountVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetCollectionEntitiesCountResponse,
      ApiGetCollectionEntitiesCountError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/collection/collections/{entityId}/entities_count/",
    operationId: "apiGetCollectionEntitiesCount",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetCollectionEntitiesCountResponse,
    ApiGetCollectionEntitiesCountError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCollectionEntitiesCount(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the count of entities within a collection grouped by entity type.
 */
export const useSuspenseApiGetCollectionEntitiesCount = <
  TData = ApiGetCollectionEntitiesCountResponse,
>(
  variables: ApiGetCollectionEntitiesCountVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetCollectionEntitiesCountResponse,
      ApiGetCollectionEntitiesCountError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/collection/collections/{entityId}/entities_count/",
    operationId: "apiGetCollectionEntitiesCount",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetCollectionEntitiesCountResponse,
    ApiGetCollectionEntitiesCountError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCollectionEntitiesCount(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetSearchMetaError = Fetcher.ErrorWrapper<undefined>;

export type GetSearchMetaVariables = ApiContext["fetcherOptions"];

export const fetchGetSearchMeta = (
  variables: GetSearchMetaVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.MetaOut, GetSearchMetaError, undefined, {}, {}, {}>({
    url: "/search/v2/meta/",
    method: "get",
    ...variables,
    signal,
  });

export const getSearchMetaQueryKey = (
  variables: GetSearchMetaVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/search/v2/meta/",
    operationId: "getSearchMeta",
    variables,
  });

export const useGetSearchMeta = <TData = Schemas.MetaOut,>(
  variables: GetSearchMetaVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.MetaOut, GetSearchMetaError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/search/v2/meta/",
    operationId: "getSearchMeta",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.MetaOut,
    GetSearchMetaError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSearchMeta({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetSearchMeta = <TData = Schemas.MetaOut,>(
  variables: GetSearchMetaVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.MetaOut,
      GetSearchMetaError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/search/v2/meta/",
    operationId: "getSearchMeta",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.MetaOut,
    GetSearchMetaError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSearchMeta({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type AutocompleteQueryParams = {
  /**
   * @default
   */
  term?: string | null;
};

export type AutocompleteError = Fetcher.ErrorWrapper<undefined>;

export type AutocompleteVariables = {
  queryParams?: AutocompleteQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchAutocomplete = (
  variables: AutocompleteVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    AutocompleteError,
    undefined,
    {},
    AutocompleteQueryParams,
    {}
  >({ url: "/search/v2/autocomplete/", method: "get", ...variables, signal });

export const autocompleteQueryKey = (
  variables: AutocompleteVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/search/v2/autocomplete/",
    operationId: "autocomplete",
    variables,
  });

export const useAutocomplete = <TData = undefined,>(
  variables: AutocompleteVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, AutocompleteError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/search/v2/autocomplete/",
    operationId: "autocomplete",
    variables,
  });
  const result = reactQuery.useQuery<undefined, AutocompleteError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchAutocomplete({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseAutocomplete = <TData = undefined,>(
  variables: AutocompleteVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<undefined, AutocompleteError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/search/v2/autocomplete/",
    operationId: "autocomplete",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    undefined,
    AutocompleteError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchAutocomplete({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SuggestionsQueryParams = {
  /**
   * @default
   */
  term?: string | null;
};

export type SuggestionsError = Fetcher.ErrorWrapper<undefined>;

export type SuggestionsVariables = {
  queryParams?: SuggestionsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchSuggestions = (
  variables: SuggestionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SuggestionsOut,
    SuggestionsError,
    undefined,
    {},
    SuggestionsQueryParams,
    {}
  >({ url: "/search/v2/suggestions/", method: "get", ...variables, signal });

export const suggestionsQueryKey = (
  variables: SuggestionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/search/v2/suggestions/",
    operationId: "suggestions",
    variables,
  });

export const useSuggestions = <TData = Schemas.SuggestionsOut,>(
  variables: SuggestionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SuggestionsOut, SuggestionsError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/search/v2/suggestions/",
    operationId: "suggestions",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SuggestionsOut,
    SuggestionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchSuggestions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseSuggestions = <TData = Schemas.SuggestionsOut,>(
  variables: SuggestionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SuggestionsOut,
      SuggestionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/search/v2/suggestions/",
    operationId: "suggestions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SuggestionsOut,
    SuggestionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchSuggestions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetDefaultSearchViewPathParams = {
  viewId: string;
};

export type SetDefaultSearchViewQueryParams = {
  team_id?: string | null;
};

export type SetDefaultSearchViewError = Fetcher.ErrorWrapper<undefined>;

export type SetDefaultSearchViewVariables = {
  pathParams: SetDefaultSearchViewPathParams;
  queryParams?: SetDefaultSearchViewQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Set or unset a SearchView as default for a specific team.
 */
export const fetchSetDefaultSearchView = (
  variables: SetDefaultSearchViewVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefaultSearchViewOut,
    SetDefaultSearchViewError,
    undefined,
    {},
    SetDefaultSearchViewQueryParams,
    SetDefaultSearchViewPathParams
  >({
    url: "/search/v2/view/default/{viewId}/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Set or unset a SearchView as default for a specific team.
 */
export const useSetDefaultSearchView = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DefaultSearchViewOut,
      SetDefaultSearchViewError,
      SetDefaultSearchViewVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DefaultSearchViewOut,
    SetDefaultSearchViewError,
    SetDefaultSearchViewVariables
  >({
    mutationFn: (variables: SetDefaultSearchViewVariables) =>
      fetchSetDefaultSearchView({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetSearchFiltersEntityTypeQueryParams = {
  integration_id?: string | null;
};

export type GetSearchFiltersEntityTypeError = Fetcher.ErrorWrapper<undefined>;

export type GetSearchFiltersEntityTypeVariables = {
  queryParams?: GetSearchFiltersEntityTypeQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the available entity types and native types for search filters.
 *
 * Args:
 *     integration_id (Optional[str]): Optional integration ID to filter by
 *
 * Returns:
 *     Dict containing:
 *         - entity_type: List of available entity types
 *         - native_type: List of available native types
 */
export const fetchGetSearchFiltersEntityType = (
  variables: GetSearchFiltersEntityTypeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SearchFiltersEntityTypeOut,
    GetSearchFiltersEntityTypeError,
    undefined,
    {},
    GetSearchFiltersEntityTypeQueryParams,
    {}
  >({
    url: "/search/v2/filters/entity_type/",
    method: "get",
    ...variables,
    signal,
  });

export const getSearchFiltersEntityTypeQueryKey = (
  variables: GetSearchFiltersEntityTypeVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/search/v2/filters/entity_type/",
    operationId: "getSearchFiltersEntityType",
    variables,
  });

/**
 * Get the available entity types and native types for search filters.
 *
 * Args:
 *     integration_id (Optional[str]): Optional integration ID to filter by
 *
 * Returns:
 *     Dict containing:
 *         - entity_type: List of available entity types
 *         - native_type: List of available native types
 */
export const useGetSearchFiltersEntityType = <
  TData = Schemas.SearchFiltersEntityTypeOut,
>(
  variables: GetSearchFiltersEntityTypeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SearchFiltersEntityTypeOut,
      GetSearchFiltersEntityTypeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/search/v2/filters/entity_type/",
    operationId: "getSearchFiltersEntityType",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SearchFiltersEntityTypeOut,
    GetSearchFiltersEntityTypeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSearchFiltersEntityType(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the available entity types and native types for search filters.
 *
 * Args:
 *     integration_id (Optional[str]): Optional integration ID to filter by
 *
 * Returns:
 *     Dict containing:
 *         - entity_type: List of available entity types
 *         - native_type: List of available native types
 */
export const useSuspenseGetSearchFiltersEntityType = <
  TData = Schemas.SearchFiltersEntityTypeOut,
>(
  variables: GetSearchFiltersEntityTypeVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SearchFiltersEntityTypeOut,
      GetSearchFiltersEntityTypeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/search/v2/filters/entity_type/",
    operationId: "getSearchFiltersEntityType",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SearchFiltersEntityTypeOut,
    GetSearchFiltersEntityTypeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSearchFiltersEntityType(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CreateCustomerPortalSessionError = Fetcher.ErrorWrapper<undefined>;

export type CreateCustomerPortalSessionVariables = {
  body: Schemas.CustomerPortalIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a Stripe customer portal session for the workspace.
 * This endpoint creates a customer portal session that allows customers to manage their billing.
 */
export const fetchCreateCustomerPortalSession = (
  variables: CreateCustomerPortalSessionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomerPortalOut,
    CreateCustomerPortalSessionError,
    Schemas.CustomerPortalIn,
    {},
    {},
    {}
  >({ url: "/stripe/customer-portal/", method: "post", ...variables, signal });

/**
 * Create a Stripe customer portal session for the workspace.
 * This endpoint creates a customer portal session that allows customers to manage their billing.
 */
export const useCreateCustomerPortalSession = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CustomerPortalOut,
      CreateCustomerPortalSessionError,
      CreateCustomerPortalSessionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CustomerPortalOut,
    CreateCustomerPortalSessionError,
    CreateCustomerPortalSessionVariables
  >({
    mutationFn: (variables: CreateCustomerPortalSessionVariables) =>
      fetchCreateCustomerPortalSession({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ReactivateOrCreateSecodaLiteSubscriptionError =
  Fetcher.ErrorWrapper<undefined>;

export type ReactivateOrCreateSecodaLiteSubscriptionVariables =
  ApiContext["fetcherOptions"];

/**
 * Reactivate or resume a subscription based on its current status.
 * - Paused subscriptions: Resume existing subscription
 * - Canceled/Ended/Unpaid subscriptions: Create new subscription
 * - Active/Trialing subscriptions: Return current status
 */
export const fetchReactivateOrCreateSecodaLiteSubscription = (
  variables: ReactivateOrCreateSecodaLiteSubscriptionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ReactivateSubscriptionOut,
    ReactivateOrCreateSecodaLiteSubscriptionError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/stripe/reactivate-subscription/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Reactivate or resume a subscription based on its current status.
 * - Paused subscriptions: Resume existing subscription
 * - Canceled/Ended/Unpaid subscriptions: Create new subscription
 * - Active/Trialing subscriptions: Return current status
 */
export const useReactivateOrCreateSecodaLiteSubscription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ReactivateSubscriptionOut,
      ReactivateOrCreateSecodaLiteSubscriptionError,
      ReactivateOrCreateSecodaLiteSubscriptionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ReactivateSubscriptionOut,
    ReactivateOrCreateSecodaLiteSubscriptionError,
    ReactivateOrCreateSecodaLiteSubscriptionVariables
  >({
    mutationFn: (
      variables: ReactivateOrCreateSecodaLiteSubscriptionVariables,
    ) =>
      fetchReactivateOrCreateSecodaLiteSubscription({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type CreateCheckoutSessionError = Fetcher.ErrorWrapper<undefined>;

export type CreateCheckoutSessionVariables = {
  body: Schemas.CheckoutSessionIn;
} & ApiContext["fetcherOptions"];

export const fetchCreateCheckoutSession = (
  variables: CreateCheckoutSessionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CheckoutSessionOut,
    CreateCheckoutSessionError,
    Schemas.CheckoutSessionIn,
    {},
    {},
    {}
  >({ url: "/stripe/create-checkout/", method: "post", ...variables, signal });

export const useCreateCheckoutSession = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CheckoutSessionOut,
      CreateCheckoutSessionError,
      CreateCheckoutSessionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CheckoutSessionOut,
    CreateCheckoutSessionError,
    CreateCheckoutSessionVariables
  >({
    mutationFn: (variables: CreateCheckoutSessionVariables) =>
      fetchCreateCheckoutSession({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateIntentError = Fetcher.ErrorWrapper<undefined>;

export type CreateIntentVariables = {
  body: Schemas.IntentRequestIn;
} & ApiContext["fetcherOptions"];

export const fetchCreateIntent = (
  variables: CreateIntentVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IntentOut,
    CreateIntentError,
    Schemas.IntentRequestIn,
    {},
    {},
    {}
  >({ url: "/stripe/create-intent/", method: "post", ...variables, signal });

export const useCreateIntent = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.IntentOut,
      CreateIntentError,
      CreateIntentVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.IntentOut,
    CreateIntentError,
    CreateIntentVariables
  >({
    mutationFn: (variables: CreateIntentVariables) =>
      fetchCreateIntent({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateInvoiceError = Fetcher.ErrorWrapper<undefined>;

export type CreateInvoiceVariables = {
  body: Schemas.CreateInvoiceIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a Stripe invoice for account credits.
 * This endpoint creates an invoice that can be paid to add credits to the workspace.
 */
export const fetchCreateInvoice = (
  variables: CreateInvoiceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CreateInvoiceOut,
    CreateInvoiceError,
    Schemas.CreateInvoiceIn,
    {},
    {},
    {}
  >({ url: "/stripe/create-invoice/", method: "post", ...variables, signal });

/**
 * Create a Stripe invoice for account credits.
 * This endpoint creates an invoice that can be paid to add credits to the workspace.
 */
export const useCreateInvoice = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CreateInvoiceOut,
      CreateInvoiceError,
      CreateInvoiceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CreateInvoiceOut,
    CreateInvoiceError,
    CreateInvoiceVariables
  >({
    mutationFn: (variables: CreateInvoiceVariables) =>
      fetchCreateInvoice({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListTeamsV1QueryParams = {
  /**
   * @default false
   */
  include_archived?: boolean;
  /**
   * @default false
   */
  only_joined?: boolean;
  /**
   * @default false
   */
  only_write?: boolean;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListTeamsV1Error = Fetcher.ErrorWrapper<undefined>;

export type ApiListTeamsV1Variables = {
  queryParams?: ApiListTeamsV1QueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a paginated list of teams in the workspace.
 */
export const fetchApiListTeamsV1 = (
  variables: ApiListTeamsV1Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedTeamOut,
    ApiListTeamsV1Error,
    undefined,
    {},
    ApiListTeamsV1QueryParams,
    {}
  >({ url: "/auth/teams/", method: "get", ...variables, signal });

export const apiListTeamsV1QueryKey = (
  variables: ApiListTeamsV1Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/teams/",
    operationId: "apiListTeamsV1",
    variables,
  });

/**
 * Get a paginated list of teams in the workspace.
 */
export const useApiListTeamsV1 = <TData = Schemas.PagedTeamOut,>(
  variables: ApiListTeamsV1Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedTeamOut,
      ApiListTeamsV1Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/",
    operationId: "apiListTeamsV1",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedTeamOut,
    ApiListTeamsV1Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListTeamsV1({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a paginated list of teams in the workspace.
 */
export const useSuspenseApiListTeamsV1 = <TData = Schemas.PagedTeamOut,>(
  variables: ApiListTeamsV1Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedTeamOut,
      ApiListTeamsV1Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/",
    operationId: "apiListTeamsV1",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedTeamOut,
    ApiListTeamsV1Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListTeamsV1({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateTeamError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateTeamVariables = {
  body: Schemas.TeamIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a new team in the workspace.
 */
export const fetchApiCreateTeam = (
  variables: ApiCreateTeamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.TeamOut, ApiCreateTeamError, Schemas.TeamIn, {}, {}, {}>({
    url: "/auth/teams/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create a new team in the workspace.
 */
export const useApiCreateTeam = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TeamOut,
      ApiCreateTeamError,
      ApiCreateTeamVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.TeamOut,
    ApiCreateTeamError,
    ApiCreateTeamVariables
  >({
    mutationFn: (variables: ApiCreateTeamVariables) =>
      fetchApiCreateTeam({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetTeamPathParams = {
  teamId: string;
};

export type ApiGetTeamError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetTeamVariables = {
  pathParams: ApiGetTeamPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a team by their ID.
 */
export const fetchApiGetTeam = (
  variables: ApiGetTeamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TeamOut,
    ApiGetTeamError,
    undefined,
    {},
    {},
    ApiGetTeamPathParams
  >({ url: "/auth/teams/{teamId}/", method: "get", ...variables, signal });

export const apiGetTeamQueryKey = (
  variables: ApiGetTeamVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/teams/{teamId}/",
    operationId: "apiGetTeam",
    variables,
  });

/**
 * Get a team by their ID.
 */
export const useApiGetTeam = <TData = Schemas.TeamOut,>(
  variables: ApiGetTeamVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.TeamOut, ApiGetTeamError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/",
    operationId: "apiGetTeam",
    variables,
  });
  const result = reactQuery.useQuery<Schemas.TeamOut, ApiGetTeamError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetTeam({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a team by their ID.
 */
export const useSuspenseApiGetTeam = <TData = Schemas.TeamOut,>(
  variables: ApiGetTeamVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<Schemas.TeamOut, ApiGetTeamError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/",
    operationId: "apiGetTeam",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.TeamOut,
    ApiGetTeamError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetTeam({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateTeamPathParams = {
  teamId: string;
};

export type ApiUpdateTeamError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateTeamVariables = {
  body: Schemas.PartialTeamIn;
  pathParams: ApiUpdateTeamPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Use this endpoint to update the Team. Editable fields include the name, description, icon, type, and sidebar settings.
 */
export const fetchApiUpdateTeam = (
  variables: ApiUpdateTeamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TeamOut,
    ApiUpdateTeamError,
    Schemas.PartialTeamIn,
    {},
    {},
    ApiUpdateTeamPathParams
  >({ url: "/auth/teams/{teamId}/", method: "patch", ...variables, signal });

/**
 * Use this endpoint to update the Team. Editable fields include the name, description, icon, type, and sidebar settings.
 */
export const useApiUpdateTeam = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TeamOut,
      ApiUpdateTeamError,
      ApiUpdateTeamVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.TeamOut,
    ApiUpdateTeamError,
    ApiUpdateTeamVariables
  >({
    mutationFn: (variables: ApiUpdateTeamVariables) =>
      fetchApiUpdateTeam({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetTeamEmptyStatePathParams = {
  teamId: string;
};

export type ApiGetTeamEmptyStateError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetTeamEmptyStateVariables = {
  pathParams: ApiGetTeamEmptyStatePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the empty state for a team by their ID.
 */
export const fetchApiGetTeamEmptyState = (
  variables: ApiGetTeamEmptyStateVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ExistDictOut,
    ApiGetTeamEmptyStateError,
    undefined,
    {},
    {},
    ApiGetTeamEmptyStatePathParams
  >({
    url: "/auth/teams/{teamId}/empty_state/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetTeamEmptyStateQueryKey = (
  variables: ApiGetTeamEmptyStateVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/teams/{teamId}/empty_state/",
    operationId: "apiGetTeamEmptyState",
    variables,
  });

/**
 * Get the empty state for a team by their ID.
 */
export const useApiGetTeamEmptyState = <TData = Schemas.ExistDictOut,>(
  variables: ApiGetTeamEmptyStateVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ExistDictOut,
      ApiGetTeamEmptyStateError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/empty_state/",
    operationId: "apiGetTeamEmptyState",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ExistDictOut,
    ApiGetTeamEmptyStateError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetTeamEmptyState({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the empty state for a team by their ID.
 */
export const useSuspenseApiGetTeamEmptyState = <TData = Schemas.ExistDictOut,>(
  variables: ApiGetTeamEmptyStateVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ExistDictOut,
      ApiGetTeamEmptyStateError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/empty_state/",
    operationId: "apiGetTeamEmptyState",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ExistDictOut,
    ApiGetTeamEmptyStateError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetTeamEmptyState({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMyMembershipsPathParams = {
  teamId: string;
};

export type ApiGetMyMembershipsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetMyMembershipsResponse = Schemas.TeamMembershipOut[];

export type ApiGetMyMembershipsVariables = {
  pathParams: ApiGetMyMembershipsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the current user's memberships for a team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *
 * Returns:
 *     Tuple of status code and list of TeamMembershipOut objects.
 */
export const fetchApiGetMyMemberships = (
  variables: ApiGetMyMembershipsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetMyMembershipsResponse,
    ApiGetMyMembershipsError,
    undefined,
    {},
    {},
    ApiGetMyMembershipsPathParams
  >({
    url: "/auth/teams/{teamId}/my_memberships/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetMyMembershipsQueryKey = (
  variables: ApiGetMyMembershipsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/teams/{teamId}/my_memberships/",
    operationId: "apiGetMyMemberships",
    variables,
  });

/**
 * Get the current user's memberships for a team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *
 * Returns:
 *     Tuple of status code and list of TeamMembershipOut objects.
 */
export const useApiGetMyMemberships = <TData = ApiGetMyMembershipsResponse,>(
  variables: ApiGetMyMembershipsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetMyMembershipsResponse,
      ApiGetMyMembershipsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/my_memberships/",
    operationId: "apiGetMyMemberships",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetMyMembershipsResponse,
    ApiGetMyMembershipsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMyMemberships({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the current user's memberships for a team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *
 * Returns:
 *     Tuple of status code and list of TeamMembershipOut objects.
 */
export const useSuspenseApiGetMyMemberships = <
  TData = ApiGetMyMembershipsResponse,
>(
  variables: ApiGetMyMembershipsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetMyMembershipsResponse,
      ApiGetMyMembershipsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/my_memberships/",
    operationId: "apiGetMyMemberships",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetMyMembershipsResponse,
    ApiGetMyMembershipsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMyMemberships({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiJoinTeamPathParams = {
  teamId: string;
};

export type ApiJoinTeamError = Fetcher.ErrorWrapper<undefined>;

export type ApiJoinTeamVariables = {
  pathParams: ApiJoinTeamPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Join an open team.
 *
 * Allows a user to join a team if it is open or if the user is an admin.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team to join.
 *
 * Returns:
 *     Tuple of status code and created TeamMembershipOut object.
 *
 * Raises:
 *     HttpError: If the team is invalid, user lacks permission, or team is not open.
 */
export const fetchApiJoinTeam = (
  variables: ApiJoinTeamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TeamMembershipOut,
    ApiJoinTeamError,
    undefined,
    {},
    {},
    ApiJoinTeamPathParams
  >({
    url: "/auth/teams/{teamId}/join/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Join an open team.
 *
 * Allows a user to join a team if it is open or if the user is an admin.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team to join.
 *
 * Returns:
 *     Tuple of status code and created TeamMembershipOut object.
 *
 * Raises:
 *     HttpError: If the team is invalid, user lacks permission, or team is not open.
 */
export const useApiJoinTeam = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TeamMembershipOut,
      ApiJoinTeamError,
      ApiJoinTeamVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.TeamMembershipOut,
    ApiJoinTeamError,
    ApiJoinTeamVariables
  >({
    mutationFn: (variables: ApiJoinTeamVariables) =>
      fetchApiJoinTeam({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiLeaveTeamPathParams = {
  teamId: string;
};

export type ApiLeaveTeamError = Fetcher.ErrorWrapper<undefined>;

export type ApiLeaveTeamVariables = {
  pathParams: ApiLeaveTeamPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Leave a team.
 *
 * Removes the current user's membership from the specified team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team to leave.
 *
 * Returns:
 *     Tuple of status code (204) and None.
 */
export const fetchApiLeaveTeam = (
  variables: ApiLeaveTeamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiLeaveTeamError,
    undefined,
    {},
    {},
    ApiLeaveTeamPathParams
  >({
    url: "/auth/teams/{teamId}/leave/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Leave a team.
 *
 * Removes the current user's membership from the specified team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team to leave.
 *
 * Returns:
 *     Tuple of status code (204) and None.
 */
export const useApiLeaveTeam = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiLeaveTeamError,
      ApiLeaveTeamVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiLeaveTeamError,
    ApiLeaveTeamVariables
  >({
    mutationFn: (variables: ApiLeaveTeamVariables) =>
      fetchApiLeaveTeam({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetTeamListUsersPathParams = {
  teamId: string;
};

export type ApiGetTeamListUsersQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiGetTeamListUsersError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetTeamListUsersVariables = {
  pathParams: ApiGetTeamListUsersPathParams;
  queryParams?: ApiGetTeamListUsersQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List users in a team.
 *
 * Returns all users who are members of the team, either directly or via user groups.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *
 * Returns:
 *     Tuple of status code and QuerySet of users.
 */
export const fetchApiGetTeamListUsers = (
  variables: ApiGetTeamListUsersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedLiteUserOut,
    ApiGetTeamListUsersError,
    undefined,
    {},
    ApiGetTeamListUsersQueryParams,
    ApiGetTeamListUsersPathParams
  >({
    url: "/auth/teams/{teamId}/users/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetTeamListUsersQueryKey = (
  variables: ApiGetTeamListUsersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/teams/{teamId}/users/",
    operationId: "apiGetTeamListUsers",
    variables,
  });

/**
 * List users in a team.
 *
 * Returns all users who are members of the team, either directly or via user groups.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *
 * Returns:
 *     Tuple of status code and QuerySet of users.
 */
export const useApiGetTeamListUsers = <TData = Schemas.PagedLiteUserOut,>(
  variables: ApiGetTeamListUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedLiteUserOut,
      ApiGetTeamListUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/users/",
    operationId: "apiGetTeamListUsers",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedLiteUserOut,
    ApiGetTeamListUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetTeamListUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List users in a team.
 *
 * Returns all users who are members of the team, either directly or via user groups.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *
 * Returns:
 *     Tuple of status code and QuerySet of users.
 */
export const useSuspenseApiGetTeamListUsers = <
  TData = Schemas.PagedLiteUserOut,
>(
  variables: ApiGetTeamListUsersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedLiteUserOut,
      ApiGetTeamListUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/users/",
    operationId: "apiGetTeamListUsers",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedLiteUserOut,
    ApiGetTeamListUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetTeamListUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiBulkCreateMembershipsPathParams = {
  teamId: string;
};

export type ApiBulkCreateMembershipsError = Fetcher.ErrorWrapper<undefined>;

export type ApiBulkCreateMembershipsResponse = Schemas.TeamMembershipOut[];

export type ApiBulkCreateMembershipsRequestBody = Schemas.TeamMembershipIn[];

export type ApiBulkCreateMembershipsVariables = {
  body?: ApiBulkCreateMembershipsRequestBody;
  pathParams: ApiBulkCreateMembershipsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Bulk create or update team memberships.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     body: List of membership data to create or update.
 *
 * Returns:
 *     Tuple of status code and list of created TeamMembershipOut objects.
 */
export const fetchApiBulkCreateMemberships = (
  variables: ApiBulkCreateMembershipsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiBulkCreateMembershipsResponse,
    ApiBulkCreateMembershipsError,
    ApiBulkCreateMembershipsRequestBody,
    {},
    {},
    ApiBulkCreateMembershipsPathParams
  >({
    url: "/auth/teams/{teamId}/memberships/bulk/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Bulk create or update team memberships.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     body: List of membership data to create or update.
 *
 * Returns:
 *     Tuple of status code and list of created TeamMembershipOut objects.
 */
export const useApiBulkCreateMemberships = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiBulkCreateMembershipsResponse,
      ApiBulkCreateMembershipsError,
      ApiBulkCreateMembershipsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiBulkCreateMembershipsResponse,
    ApiBulkCreateMembershipsError,
    ApiBulkCreateMembershipsVariables
  >({
    mutationFn: (variables: ApiBulkCreateMembershipsVariables) =>
      fetchApiBulkCreateMemberships({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListMembershipsPathParams = {
  teamId: string;
};

export type ApiListMembershipsQueryParams = {
  /**
   * @default
   */
  search_term?: string;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListMembershipsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListMembershipsVariables = {
  pathParams: ApiListMembershipsPathParams;
  queryParams?: ApiListMembershipsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List memberships for a team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     search_term: Optional search term to filter by user name/email or group name.
 *
 * Returns:
 *     Tuple of status code and QuerySet of TeamMembership objects.
 */
export const fetchApiListMemberships = (
  variables: ApiListMembershipsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedTeamMembershipOut,
    ApiListMembershipsError,
    undefined,
    {},
    ApiListMembershipsQueryParams,
    ApiListMembershipsPathParams
  >({
    url: "/auth/teams/{teamId}/memberships/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListMembershipsQueryKey = (
  variables: ApiListMembershipsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/teams/{teamId}/memberships/",
    operationId: "apiListMemberships",
    variables,
  });

/**
 * List memberships for a team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     search_term: Optional search term to filter by user name/email or group name.
 *
 * Returns:
 *     Tuple of status code and QuerySet of TeamMembership objects.
 */
export const useApiListMemberships = <TData = Schemas.PagedTeamMembershipOut,>(
  variables: ApiListMembershipsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedTeamMembershipOut,
      ApiListMembershipsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/memberships/",
    operationId: "apiListMemberships",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedTeamMembershipOut,
    ApiListMembershipsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListMemberships({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List memberships for a team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     search_term: Optional search term to filter by user name/email or group name.
 *
 * Returns:
 *     Tuple of status code and QuerySet of TeamMembership objects.
 */
export const useSuspenseApiListMemberships = <
  TData = Schemas.PagedTeamMembershipOut,
>(
  variables: ApiListMembershipsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedTeamMembershipOut,
      ApiListMembershipsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/teams/{teamId}/memberships/",
    operationId: "apiListMemberships",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedTeamMembershipOut,
    ApiListMembershipsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListMemberships({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiApproveTeamAccessRequestPathParams = {
  teamId: string;
  membershipId: string;
};

export type ApiApproveTeamAccessRequestError = Fetcher.ErrorWrapper<undefined>;

export type ApiApproveTeamAccessRequestVariables = {
  pathParams: ApiApproveTeamAccessRequestPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiApproveTeamAccessRequest = (
  variables: ApiApproveTeamAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TeamMembershipOut,
    ApiApproveTeamAccessRequestError,
    undefined,
    {},
    {},
    ApiApproveTeamAccessRequestPathParams
  >({
    url: "/auth/teams/{teamId}/access_requests/{membershipId}/approve/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiApproveTeamAccessRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TeamMembershipOut,
      ApiApproveTeamAccessRequestError,
      ApiApproveTeamAccessRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.TeamMembershipOut,
    ApiApproveTeamAccessRequestError,
    ApiApproveTeamAccessRequestVariables
  >({
    mutationFn: (variables: ApiApproveTeamAccessRequestVariables) =>
      fetchApiApproveTeamAccessRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRejectTeamAccessRequestPathParams = {
  teamId: string;
  membershipId: string;
};

export type ApiRejectTeamAccessRequestError = Fetcher.ErrorWrapper<undefined>;

export type ApiRejectTeamAccessRequestVariables = {
  pathParams: ApiRejectTeamAccessRequestPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRejectTeamAccessRequest = (
  variables: ApiRejectTeamAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiRejectTeamAccessRequestError,
    undefined,
    {},
    {},
    ApiRejectTeamAccessRequestPathParams
  >({
    url: "/auth/teams/{teamId}/access_requests/{membershipId}/reject/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiRejectTeamAccessRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiRejectTeamAccessRequestError,
      ApiRejectTeamAccessRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiRejectTeamAccessRequestError,
    ApiRejectTeamAccessRequestVariables
  >({
    mutationFn: (variables: ApiRejectTeamAccessRequestVariables) =>
      fetchApiRejectTeamAccessRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateMembershipPathParams = {
  teamId: string;
  membershipId: string;
};

export type ApiUpdateMembershipError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateMembershipVariables = {
  body: Schemas.UpdateMembershipRequest;
  pathParams: ApiUpdateMembershipPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update a team membership.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     membership_id: The unique identifier of the membership to update.
 *     body: The membership permissions to update.
 *
 * Returns:
 *     Tuple of status code and updated TeamMembershipOut object.
 *
 * Raises:
 *     HttpError: If attempting to grant write access to a user without proper permissions.
 */
export const fetchApiUpdateMembership = (
  variables: ApiUpdateMembershipVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TeamMembershipOut,
    ApiUpdateMembershipError,
    Schemas.UpdateMembershipRequest,
    {},
    {},
    ApiUpdateMembershipPathParams
  >({
    url: "/auth/teams/{teamId}/memberships/{membershipId}/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update a team membership.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     membership_id: The unique identifier of the membership to update.
 *     body: The membership permissions to update.
 *
 * Returns:
 *     Tuple of status code and updated TeamMembershipOut object.
 *
 * Raises:
 *     HttpError: If attempting to grant write access to a user without proper permissions.
 */
export const useApiUpdateMembership = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TeamMembershipOut,
      ApiUpdateMembershipError,
      ApiUpdateMembershipVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.TeamMembershipOut,
    ApiUpdateMembershipError,
    ApiUpdateMembershipVariables
  >({
    mutationFn: (variables: ApiUpdateMembershipVariables) =>
      fetchApiUpdateMembership({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDeleteMembershipPathParams = {
  teamId: string;
  membershipId: string;
};

export type ApiDeleteMembershipError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteMembershipVariables = {
  pathParams: ApiDeleteMembershipPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete a team membership.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     membership_id: The unique identifier of the membership to delete.
 *
 * Returns:
 *     Tuple of status code (204) and None.
 */
export const fetchApiDeleteMembership = (
  variables: ApiDeleteMembershipVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteMembershipError,
    undefined,
    {},
    {},
    ApiDeleteMembershipPathParams
  >({
    url: "/auth/teams/{teamId}/memberships/{membershipId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete a team membership.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team.
 *     membership_id: The unique identifier of the membership to delete.
 *
 * Returns:
 *     Tuple of status code (204) and None.
 */
export const useApiDeleteMembership = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteMembershipError,
      ApiDeleteMembershipVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteMembershipError,
    ApiDeleteMembershipVariables
  >({
    mutationFn: (variables: ApiDeleteMembershipVariables) =>
      fetchApiDeleteMembership({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiSetDefaultTeamPathParams = {
  teamId: string;
};

export type ApiSetDefaultTeamError = Fetcher.ErrorWrapper<undefined>;

export type ApiSetDefaultTeamVariables = {
  pathParams: ApiSetDefaultTeamPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Set a team as the default team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team to set as default.
 *
 * Returns:
 *     Tuple of status code and updated TeamOut object.
 */
export const fetchApiSetDefaultTeam = (
  variables: ApiSetDefaultTeamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiSetDefaultTeamError,
    undefined,
    {},
    {},
    ApiSetDefaultTeamPathParams
  >({
    url: "/auth/teams/{teamId}/set_default/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Set a team as the default team.
 *
 * Args:
 *     request: The authenticated request containing user context.
 *     team_id: The unique identifier of the team to set as default.
 *
 * Returns:
 *     Tuple of status code and updated TeamOut object.
 */
export const useApiSetDefaultTeam = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiSetDefaultTeamError,
      ApiSetDefaultTeamVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiSetDefaultTeamError,
    ApiSetDefaultTeamVariables
  >({
    mutationFn: (variables: ApiSetDefaultTeamVariables) =>
      fetchApiSetDefaultTeam({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListApiKeysV1QueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListApiKeysV1Error = Fetcher.ErrorWrapper<undefined>;

export type ApiListApiKeysV1Variables = {
  queryParams?: ApiListApiKeysV1QueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Lists API keys for the current workspace (v1).
 *
 * Returns basic information about API keys.
 */
export const fetchApiListApiKeysV1 = (
  variables: ApiListApiKeysV1Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedApiKeyOut,
    ApiListApiKeysV1Error,
    undefined,
    {},
    ApiListApiKeysV1QueryParams,
    {}
  >({ url: "/auth/api_keys/", method: "get", ...variables, signal });

export const apiListApiKeysV1QueryKey = (
  variables: ApiListApiKeysV1Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/api_keys/",
    operationId: "apiListApiKeysV1",
    variables,
  });

/**
 * Lists API keys for the current workspace (v1).
 *
 * Returns basic information about API keys.
 */
export const useApiListApiKeysV1 = <TData = Schemas.PagedApiKeyOut,>(
  variables: ApiListApiKeysV1Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedApiKeyOut,
      ApiListApiKeysV1Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/api_keys/",
    operationId: "apiListApiKeysV1",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedApiKeyOut,
    ApiListApiKeysV1Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListApiKeysV1({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Lists API keys for the current workspace (v1).
 *
 * Returns basic information about API keys.
 */
export const useSuspenseApiListApiKeysV1 = <TData = Schemas.PagedApiKeyOut,>(
  variables: ApiListApiKeysV1Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedApiKeyOut,
      ApiListApiKeysV1Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/api_keys/",
    operationId: "apiListApiKeysV1",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedApiKeyOut,
    ApiListApiKeysV1Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListApiKeysV1({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateApiKeyError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateApiKeyVariables = {
  body: Schemas.APIKeyIn;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateApiKey = (
  variables: ApiCreateApiKeyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ApiKeyOut,
    ApiCreateApiKeyError,
    Schemas.APIKeyIn,
    {},
    {},
    {}
  >({ url: "/auth/api_keys/", method: "post", ...variables, signal });

export const useApiCreateApiKey = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApiKeyOut,
      ApiCreateApiKeyError,
      ApiCreateApiKeyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ApiKeyOut,
    ApiCreateApiKeyError,
    ApiCreateApiKeyVariables
  >({
    mutationFn: (variables: ApiCreateApiKeyVariables) =>
      fetchApiCreateApiKey({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateApiKeyPathParams = {
  apiKeyId: string;
};

export type ApiUpdateApiKeyError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateApiKeyVariables = {
  body: Schemas.APIKeyIn;
  pathParams: ApiUpdateApiKeyPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateApiKey = (
  variables: ApiUpdateApiKeyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ApiKeyOut,
    ApiUpdateApiKeyError,
    Schemas.APIKeyIn,
    {},
    {},
    ApiUpdateApiKeyPathParams
  >({
    url: "/auth/api_keys/{apiKeyId}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiUpdateApiKey = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ApiKeyOut,
      ApiUpdateApiKeyError,
      ApiUpdateApiKeyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ApiKeyOut,
    ApiUpdateApiKeyError,
    ApiUpdateApiKeyVariables
  >({
    mutationFn: (variables: ApiUpdateApiKeyVariables) =>
      fetchApiUpdateApiKey({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDeleteApiKeyPathParams = {
  apiKeyId: string;
};

export type ApiDeleteApiKeyError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteApiKeyVariables = {
  pathParams: ApiDeleteApiKeyPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiDeleteApiKey = (
  variables: ApiDeleteApiKeyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteApiKeyError,
    undefined,
    {},
    {},
    ApiDeleteApiKeyPathParams
  >({
    url: "/auth/api_keys/{apiKeyId}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiDeleteApiKey = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteApiKeyError,
      ApiDeleteApiKeyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteApiKeyError,
    ApiDeleteApiKeyVariables
  >({
    mutationFn: (variables: ApiDeleteApiKeyVariables) =>
      fetchApiDeleteApiKey({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SwitchRegionPathParams = {
  regionName: string;
};

export type SwitchRegionError = Fetcher.ErrorWrapper<undefined>;

export type SwitchRegionVariables = {
  pathParams: SwitchRegionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSwitchRegion = (
  variables: SwitchRegionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    SwitchRegionError,
    undefined,
    {},
    {},
    SwitchRegionPathParams
  >({
    url: "/auth/region/{regionName}/",
    method: "post",
    ...variables,
    signal,
  });

export const useSwitchRegion = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      SwitchRegionError,
      SwitchRegionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    string,
    SwitchRegionError,
    SwitchRegionVariables
  >({
    mutationFn: (variables: SwitchRegionVariables) =>
      fetchSwitchRegion({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type VerifyDomainError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Schemas.ErrorResponse;
    }
  | {
      status: 404;
      payload: Schemas.ErrorResponse;
    }
>;

export type VerifyDomainVariables = {
  body: Schemas.DomainVerificationRequest;
} & ApiContext["fetcherOptions"];

/**
 * Send a verification email to verify domain ownership.
 */
export const fetchVerifyDomain = (
  variables: VerifyDomainVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MessageResponse,
    VerifyDomainError,
    Schemas.DomainVerificationRequest,
    {},
    {},
    {}
  >({
    url: "/auth/domain/verify_domain/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Send a verification email to verify domain ownership.
 */
export const useVerifyDomain = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MessageResponse,
      VerifyDomainError,
      VerifyDomainVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MessageResponse,
    VerifyDomainError,
    VerifyDomainVariables
  >({
    mutationFn: (variables: VerifyDomainVariables) =>
      fetchVerifyDomain({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type VerifyDomainCodeError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Schemas.ErrorResponse;
    }
  | {
      status: 404;
      payload: Schemas.ErrorResponse;
    }
>;

export type VerifyDomainCodeVariables = {
  body: Schemas.DomainVerificationCodeRequest;
} & ApiContext["fetcherOptions"];

/**
 * Verify a domain using verification codes.
 *
 * NOTE: This endpoint verifies SAML domains to ensure a workspace has
 * legitimate access to a domain. This check is critical because SAML is a
 * federated system that trusts the Identity Provider (IdP) to confirm the
 * user's email, which the customer may control. Skipping the allowed_domains
 * verification would undermine a key security feature of the SAML
 * implementation.
 */
export const fetchVerifyDomainCode = (
  variables: VerifyDomainCodeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MessageResponse,
    VerifyDomainCodeError,
    Schemas.DomainVerificationCodeRequest,
    {},
    {},
    {}
  >({
    url: "/auth/domain/verify_domain_code/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Verify a domain using verification codes.
 *
 * NOTE: This endpoint verifies SAML domains to ensure a workspace has
 * legitimate access to a domain. This check is critical because SAML is a
 * federated system that trusts the Identity Provider (IdP) to confirm the
 * user's email, which the customer may control. Skipping the allowed_domains
 * verification would undermine a key security feature of the SAML
 * implementation.
 */
export const useVerifyDomainCode = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MessageResponse,
      VerifyDomainCodeError,
      VerifyDomainCodeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MessageResponse,
    VerifyDomainCodeError,
    VerifyDomainCodeVariables
  >({
    mutationFn: (variables: VerifyDomainCodeVariables) =>
      fetchVerifyDomainCode({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListAllowedDomainsError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: Schemas.ErrorResponse;
}>;

export type ApiListAllowedDomainsVariables = ApiContext["fetcherOptions"];

/**
 * List all allowed domains for the current workspace.
 */
export const fetchApiListAllowedDomains = (
  variables: ApiListAllowedDomainsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AllowedDomainsResponse,
    ApiListAllowedDomainsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/auth/domain/allowed_domains/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListAllowedDomainsQueryKey = (
  variables: ApiListAllowedDomainsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/domain/allowed_domains/",
    operationId: "apiListAllowedDomains",
    variables,
  });

/**
 * List all allowed domains for the current workspace.
 */
export const useApiListAllowedDomains = <
  TData = Schemas.AllowedDomainsResponse,
>(
  variables: ApiListAllowedDomainsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AllowedDomainsResponse,
      ApiListAllowedDomainsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/domain/allowed_domains/",
    operationId: "apiListAllowedDomains",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AllowedDomainsResponse,
    ApiListAllowedDomainsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListAllowedDomains({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List all allowed domains for the current workspace.
 */
export const useSuspenseApiListAllowedDomains = <
  TData = Schemas.AllowedDomainsResponse,
>(
  variables: ApiListAllowedDomainsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AllowedDomainsResponse,
      ApiListAllowedDomainsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/domain/allowed_domains/",
    operationId: "apiListAllowedDomains",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AllowedDomainsResponse,
    ApiListAllowedDomainsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListAllowedDomains({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiDeleteAllowedDomainError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Schemas.ErrorResponse;
    }
  | {
      status: 404;
      payload: Schemas.ErrorResponse;
    }
>;

export type ApiDeleteAllowedDomainVariables = {
  body: Schemas.DeleteDomainRequest;
} & ApiContext["fetcherOptions"];

/**
 * Delete a domain from the allowed domains list.
 */
export const fetchApiDeleteAllowedDomain = (
  variables: ApiDeleteAllowedDomainVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MessageResponse,
    ApiDeleteAllowedDomainError,
    Schemas.DeleteDomainRequest,
    {},
    {},
    {}
  >({
    url: "/auth/domain/delete_domain/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Delete a domain from the allowed domains list.
 */
export const useApiDeleteAllowedDomain = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MessageResponse,
      ApiDeleteAllowedDomainError,
      ApiDeleteAllowedDomainVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MessageResponse,
    ApiDeleteAllowedDomainError,
    ApiDeleteAllowedDomainVariables
  >({
    mutationFn: (variables: ApiDeleteAllowedDomainVariables) =>
      fetchApiDeleteAllowedDomain({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiCreateSamlConfigurationError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateSamlConfigurationVariables = {
  body: Schemas.SAMLConfigurationSchemaIn;
} & ApiContext["fetcherOptions"];

/**
 * Creates a new SAML configuration for the user's workspace.
 * Note: acs_path and entity_id must be globally unique based on the current model definition.
 */
export const fetchApiCreateSamlConfiguration = (
  variables: ApiCreateSamlConfigurationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SAMLConfigurationSchemaOut,
    ApiCreateSamlConfigurationError,
    Schemas.SAMLConfigurationSchemaIn,
    {},
    {},
    {}
  >({ url: "/auth/saml/v2/", method: "post", ...variables, signal });

/**
 * Creates a new SAML configuration for the user's workspace.
 * Note: acs_path and entity_id must be globally unique based on the current model definition.
 */
export const useApiCreateSamlConfiguration = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SAMLConfigurationSchemaOut,
      ApiCreateSamlConfigurationError,
      ApiCreateSamlConfigurationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SAMLConfigurationSchemaOut,
    ApiCreateSamlConfigurationError,
    ApiCreateSamlConfigurationVariables
  >({
    mutationFn: (variables: ApiCreateSamlConfigurationVariables) =>
      fetchApiCreateSamlConfiguration({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListSamlConfigurationsQueryParams = {
  /**
   * @default 1
   * @minimum 1
   */
  page?: number;
};

export type ApiListSamlConfigurationsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListSamlConfigurationsVariables = {
  queryParams?: ApiListSamlConfigurationsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Lists SAML configurations for the user's workspace.
 * Requires READ permission on SAMLConfiguration.
 */
export const fetchApiListSamlConfigurations = (
  variables: ApiListSamlConfigurationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedSAMLConfigurationSchemaOut,
    ApiListSamlConfigurationsError,
    undefined,
    {},
    ApiListSamlConfigurationsQueryParams,
    {}
  >({ url: "/auth/saml/v2/", method: "get", ...variables, signal });

export const apiListSamlConfigurationsQueryKey = (
  variables: ApiListSamlConfigurationsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/saml/v2/",
    operationId: "apiListSamlConfigurations",
    variables,
  });

/**
 * Lists SAML configurations for the user's workspace.
 * Requires READ permission on SAMLConfiguration.
 */
export const useApiListSamlConfigurations = <
  TData = Schemas.PagedSAMLConfigurationSchemaOut,
>(
  variables: ApiListSamlConfigurationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedSAMLConfigurationSchemaOut,
      ApiListSamlConfigurationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/saml/v2/",
    operationId: "apiListSamlConfigurations",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedSAMLConfigurationSchemaOut,
    ApiListSamlConfigurationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListSamlConfigurations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Lists SAML configurations for the user's workspace.
 * Requires READ permission on SAMLConfiguration.
 */
export const useSuspenseApiListSamlConfigurations = <
  TData = Schemas.PagedSAMLConfigurationSchemaOut,
>(
  variables: ApiListSamlConfigurationsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedSAMLConfigurationSchemaOut,
      ApiListSamlConfigurationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/saml/v2/",
    operationId: "apiListSamlConfigurations",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedSAMLConfigurationSchemaOut,
    ApiListSamlConfigurationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListSamlConfigurations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiRetrieveSamlConfigurationPathParams = {
  /**
   * @format uuid
   */
  samlConfigId: string;
};

export type ApiRetrieveSamlConfigurationError = Fetcher.ErrorWrapper<undefined>;

export type ApiRetrieveSamlConfigurationVariables = {
  pathParams: ApiRetrieveSamlConfigurationPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieves a specific SAML configuration by its ID.
 * Requires READ permission on the specific SAMLConfiguration object.
 */
export const fetchApiRetrieveSamlConfiguration = (
  variables: ApiRetrieveSamlConfigurationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SAMLConfigurationSchemaOut,
    ApiRetrieveSamlConfigurationError,
    undefined,
    {},
    {},
    ApiRetrieveSamlConfigurationPathParams
  >({
    url: "/auth/saml/v2/{samlConfigId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiRetrieveSamlConfigurationQueryKey = (
  variables: ApiRetrieveSamlConfigurationVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/saml/v2/{samlConfigId}/",
    operationId: "apiRetrieveSamlConfiguration",
    variables,
  });

/**
 * Retrieves a specific SAML configuration by its ID.
 * Requires READ permission on the specific SAMLConfiguration object.
 */
export const useApiRetrieveSamlConfiguration = <
  TData = Schemas.SAMLConfigurationSchemaOut,
>(
  variables: ApiRetrieveSamlConfigurationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SAMLConfigurationSchemaOut,
      ApiRetrieveSamlConfigurationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/saml/v2/{samlConfigId}/",
    operationId: "apiRetrieveSamlConfiguration",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SAMLConfigurationSchemaOut,
    ApiRetrieveSamlConfigurationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveSamlConfiguration(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieves a specific SAML configuration by its ID.
 * Requires READ permission on the specific SAMLConfiguration object.
 */
export const useSuspenseApiRetrieveSamlConfiguration = <
  TData = Schemas.SAMLConfigurationSchemaOut,
>(
  variables: ApiRetrieveSamlConfigurationVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SAMLConfigurationSchemaOut,
      ApiRetrieveSamlConfigurationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/saml/v2/{samlConfigId}/",
    operationId: "apiRetrieveSamlConfiguration",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SAMLConfigurationSchemaOut,
    ApiRetrieveSamlConfigurationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveSamlConfiguration(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateSamlConfigurationPathParams = {
  /**
   * @format uuid
   */
  samlConfigId: string;
};

export type ApiUpdateSamlConfigurationError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateSamlConfigurationVariables = {
  body: Schemas.SAMLConfigurationSchemaIn;
  pathParams: ApiUpdateSamlConfigurationPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Updates an existing SAML configuration.
 * Requires UPDATE permission on the specific SAMLConfiguration object.
 */
export const fetchApiUpdateSamlConfiguration = (
  variables: ApiUpdateSamlConfigurationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SAMLConfigurationSchemaOut,
    ApiUpdateSamlConfigurationError,
    Schemas.SAMLConfigurationSchemaIn,
    {},
    {},
    ApiUpdateSamlConfigurationPathParams
  >({
    url: "/auth/saml/v2/{samlConfigId}/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Updates an existing SAML configuration.
 * Requires UPDATE permission on the specific SAMLConfiguration object.
 */
export const useApiUpdateSamlConfiguration = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SAMLConfigurationSchemaOut,
      ApiUpdateSamlConfigurationError,
      ApiUpdateSamlConfigurationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SAMLConfigurationSchemaOut,
    ApiUpdateSamlConfigurationError,
    ApiUpdateSamlConfigurationVariables
  >({
    mutationFn: (variables: ApiUpdateSamlConfigurationVariables) =>
      fetchApiUpdateSamlConfiguration({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDeleteSamlConfigurationPathParams = {
  /**
   * @format uuid
   */
  samlConfigId: string;
};

export type ApiDeleteSamlConfigurationError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteSamlConfigurationVariables = {
  pathParams: ApiDeleteSamlConfigurationPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Deletes a specific SAML configuration.
 * Requires DELETE permission on the specific SAMLConfiguration object.
 */
export const fetchApiDeleteSamlConfiguration = (
  variables: ApiDeleteSamlConfigurationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteSamlConfigurationError,
    undefined,
    {},
    {},
    ApiDeleteSamlConfigurationPathParams
  >({
    url: "/auth/saml/v2/{samlConfigId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Deletes a specific SAML configuration.
 * Requires DELETE permission on the specific SAMLConfiguration object.
 */
export const useApiDeleteSamlConfiguration = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteSamlConfigurationError,
      ApiDeleteSamlConfigurationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteSamlConfigurationError,
    ApiDeleteSamlConfigurationVariables
  >({
    mutationFn: (variables: ApiDeleteSamlConfigurationVariables) =>
      fetchApiDeleteSamlConfiguration({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ExchangeJwtPathParams = {
  provider: string;
};

export type ExchangeJwtError = Fetcher.ErrorWrapper<undefined>;

export type ExchangeJwtResponse = {
  [key: string]: any;
};

export type ExchangeJwtVariables = {
  body: Schemas.JWTExchangeIn;
  pathParams: ExchangeJwtPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Validate JWT token from auth worker and exchange for properly signed token.
 *
 * Args:
 *     request: Django request object
 *     data: JWTExchangeIn containing the JWT token
 *
 * Returns:
 *     JsonResponse: Response with token and identity or error
 */
export const fetchExchangeJwt = (
  variables: ExchangeJwtVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ExchangeJwtResponse,
    ExchangeJwtError,
    Schemas.JWTExchangeIn,
    {},
    {},
    ExchangeJwtPathParams
  >({
    url: "/auth/jwt/exchange/{provider}/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Validate JWT token from auth worker and exchange for properly signed token.
 *
 * Args:
 *     request: Django request object
 *     data: JWTExchangeIn containing the JWT token
 *
 * Returns:
 *     JsonResponse: Response with token and identity or error
 */
export const useExchangeJwt = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ExchangeJwtResponse,
      ExchangeJwtError,
      ExchangeJwtVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ExchangeJwtResponse,
    ExchangeJwtError,
    ExchangeJwtVariables
  >({
    mutationFn: (variables: ExchangeJwtVariables) =>
      fetchExchangeJwt({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SetWorkspacePanPathParams = {
  workspaceId: string;
};

export type SetWorkspacePanError = Fetcher.ErrorWrapper<undefined>;

export type SetWorkspacePanVariables = {
  body: Schemas.WorkspacePlanIn;
  pathParams: SetWorkspacePanPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSetWorkspacePan = (
  variables: SetWorkspacePanVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.WorkspacePlanOut,
    SetWorkspacePanError,
    Schemas.WorkspacePlanIn,
    {},
    {},
    SetWorkspacePanPathParams
  >({
    url: "/superuser/workspace/{workspaceId}/plan/",
    method: "put",
    ...variables,
    signal,
  });

export const useSetWorkspacePan = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.WorkspacePlanOut,
      SetWorkspacePanError,
      SetWorkspacePanVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.WorkspacePlanOut,
    SetWorkspacePanError,
    SetWorkspacePanVariables
  >({
    mutationFn: (variables: SetWorkspacePanVariables) =>
      fetchSetWorkspacePan({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DisableWorkspacePathParams = {
  workspaceId: string;
};

export type DisableWorkspaceError = Fetcher.ErrorWrapper<undefined>;

export type DisableWorkspaceVariables = {
  pathParams: DisableWorkspacePathParams;
} & ApiContext["fetcherOptions"];

export const fetchDisableWorkspace = (
  variables: DisableWorkspaceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DisableWorkspaceError,
    undefined,
    {},
    {},
    DisableWorkspacePathParams
  >({
    url: "/superuser/workspace/{workspaceId}/disable/",
    method: "post",
    ...variables,
    signal,
  });

export const useDisableWorkspace = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DisableWorkspaceError,
      DisableWorkspaceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DisableWorkspaceError,
    DisableWorkspaceVariables
  >({
    mutationFn: (variables: DisableWorkspaceVariables) =>
      fetchDisableWorkspace({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type EnableWorkspacePathParams = {
  workspaceId: string;
};

export type EnableWorkspaceError = Fetcher.ErrorWrapper<undefined>;

export type EnableWorkspaceVariables = {
  pathParams: EnableWorkspacePathParams;
} & ApiContext["fetcherOptions"];

export const fetchEnableWorkspace = (
  variables: EnableWorkspaceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    EnableWorkspaceError,
    undefined,
    {},
    {},
    EnableWorkspacePathParams
  >({
    url: "/superuser/workspace/{workspaceId}/enable/",
    method: "post",
    ...variables,
    signal,
  });

export const useEnableWorkspace = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      EnableWorkspaceError,
      EnableWorkspaceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    EnableWorkspaceError,
    EnableWorkspaceVariables
  >({
    mutationFn: (variables: EnableWorkspaceVariables) =>
      fetchEnableWorkspace({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SetWorkspaceLogoPathParams = {
  workspaceId: string;
};

export type SetWorkspaceLogoError = Fetcher.ErrorWrapper<undefined>;

export type SetWorkspaceLogoRequestBody = {
  /**
   * @format binary
   */
  file: Blob;
};

export type SetWorkspaceLogoVariables = {
  body: SetWorkspaceLogoRequestBody;
  pathParams: SetWorkspaceLogoPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSetWorkspaceLogo = (
  variables: SetWorkspaceLogoVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.WorkspaceSetLogoOut,
    SetWorkspaceLogoError,
    SetWorkspaceLogoRequestBody,
    {},
    {},
    SetWorkspaceLogoPathParams
  >({
    url: "/workspace/image/{workspaceId}/upload/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetWorkspaceLogo = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.WorkspaceSetLogoOut,
      SetWorkspaceLogoError,
      SetWorkspaceLogoVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.WorkspaceSetLogoOut,
    SetWorkspaceLogoError,
    SetWorkspaceLogoVariables
  >({
    mutationFn: (variables: SetWorkspaceLogoVariables) =>
      fetchSetWorkspaceLogo({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetWorkspaceFeatureAccessError = Fetcher.ErrorWrapper<undefined>;

export type GetWorkspaceFeatureAccessVariables = ApiContext["fetcherOptions"];

/**
 * Feature access for the workspace. This endpoint is used by the frontend to
 * determine if the workspace has access to certain features.
 *
 * This endpoint manually handles authentication using CookieAuth to derive the workspace.
 */
export const fetchGetWorkspaceFeatureAccess = (
  variables: GetWorkspaceFeatureAccessVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.FeatureAccess,
    GetWorkspaceFeatureAccessError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/",
    method: "get",
    ...variables,
    signal,
  });

export const getWorkspaceFeatureAccessQueryKey = (
  variables: GetWorkspaceFeatureAccessVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/feature_access/v2/",
    operationId: "getWorkspaceFeatureAccess",
    variables,
  });

/**
 * Feature access for the workspace. This endpoint is used by the frontend to
 * determine if the workspace has access to certain features.
 *
 * This endpoint manually handles authentication using CookieAuth to derive the workspace.
 */
export const useGetWorkspaceFeatureAccess = <TData = Schemas.FeatureAccess,>(
  variables: GetWorkspaceFeatureAccessVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FeatureAccess,
      GetWorkspaceFeatureAccessError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/",
    operationId: "getWorkspaceFeatureAccess",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.FeatureAccess,
    GetWorkspaceFeatureAccessError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceFeatureAccess(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Feature access for the workspace. This endpoint is used by the frontend to
 * determine if the workspace has access to certain features.
 *
 * This endpoint manually handles authentication using CookieAuth to derive the workspace.
 */
export const useSuspenseGetWorkspaceFeatureAccess = <
  TData = Schemas.FeatureAccess,
>(
  variables: GetWorkspaceFeatureAccessVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.FeatureAccess,
      GetWorkspaceFeatureAccessError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/",
    operationId: "getWorkspaceFeatureAccess",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.FeatureAccess,
    GetWorkspaceFeatureAccessError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceFeatureAccess(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetRunningTotalAiTokenCostError = Fetcher.ErrorWrapper<undefined>;

export type GetRunningTotalAiTokenCostVariables = ApiContext["fetcherOptions"];

/**
 * Get AI token credit balance for the workspace.
 * Returns cost, paid credits, unpaid credits, balance, and allowed overdraft.
 */
export const fetchGetRunningTotalAiTokenCost = (
  variables: GetRunningTotalAiTokenCostVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiTokenCreditBalanceOut,
    GetRunningTotalAiTokenCostError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/ai-balance/",
    method: "get",
    ...variables,
    signal,
  });

export const getRunningTotalAiTokenCostQueryKey = (
  variables: GetRunningTotalAiTokenCostVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/feature_access/v2/ai-balance/",
    operationId: "getRunningTotalAiTokenCost",
    variables,
  });

/**
 * Get AI token credit balance for the workspace.
 * Returns cost, paid credits, unpaid credits, balance, and allowed overdraft.
 */
export const useGetRunningTotalAiTokenCost = <
  TData = Schemas.AiTokenCreditBalanceOut,
>(
  variables: GetRunningTotalAiTokenCostVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiTokenCreditBalanceOut,
      GetRunningTotalAiTokenCostError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/ai-balance/",
    operationId: "getRunningTotalAiTokenCost",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiTokenCreditBalanceOut,
    GetRunningTotalAiTokenCostError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetRunningTotalAiTokenCost(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get AI token credit balance for the workspace.
 * Returns cost, paid credits, unpaid credits, balance, and allowed overdraft.
 */
export const useSuspenseGetRunningTotalAiTokenCost = <
  TData = Schemas.AiTokenCreditBalanceOut,
>(
  variables: GetRunningTotalAiTokenCostVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiTokenCreditBalanceOut,
      GetRunningTotalAiTokenCostError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/ai-balance/",
    operationId: "getRunningTotalAiTokenCost",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiTokenCreditBalanceOut,
    GetRunningTotalAiTokenCostError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetRunningTotalAiTokenCost(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetAiTokenAutoTopupSettingsError = Fetcher.ErrorWrapper<undefined>;

export type GetAiTokenAutoTopupSettingsResponse = {
  [key: string]: any;
};

export type GetAiTokenAutoTopupSettingsVariables = ApiContext["fetcherOptions"];

/**
 * Get AI token auto top-up settings for the workspace.
 *
 * Returns the current auto top-up configuration including enabled flag, threshold, and amount.
 */
export const fetchGetAiTokenAutoTopupSettings = (
  variables: GetAiTokenAutoTopupSettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetAiTokenAutoTopupSettingsResponse,
    GetAiTokenAutoTopupSettingsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/ai-auto-topup/",
    method: "get",
    ...variables,
    signal,
  });

export const getAiTokenAutoTopupSettingsQueryKey = (
  variables: GetAiTokenAutoTopupSettingsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/feature_access/v2/ai-auto-topup/",
    operationId: "getAiTokenAutoTopupSettings",
    variables,
  });

/**
 * Get AI token auto top-up settings for the workspace.
 *
 * Returns the current auto top-up configuration including enabled flag, threshold, and amount.
 */
export const useGetAiTokenAutoTopupSettings = <
  TData = GetAiTokenAutoTopupSettingsResponse,
>(
  variables: GetAiTokenAutoTopupSettingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAiTokenAutoTopupSettingsResponse,
      GetAiTokenAutoTopupSettingsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/ai-auto-topup/",
    operationId: "getAiTokenAutoTopupSettings",
    variables,
  });
  const result = reactQuery.useQuery<
    GetAiTokenAutoTopupSettingsResponse,
    GetAiTokenAutoTopupSettingsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiTokenAutoTopupSettings(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get AI token auto top-up settings for the workspace.
 *
 * Returns the current auto top-up configuration including enabled flag, threshold, and amount.
 */
export const useSuspenseGetAiTokenAutoTopupSettings = <
  TData = GetAiTokenAutoTopupSettingsResponse,
>(
  variables: GetAiTokenAutoTopupSettingsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetAiTokenAutoTopupSettingsResponse,
      GetAiTokenAutoTopupSettingsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/ai-auto-topup/",
    operationId: "getAiTokenAutoTopupSettings",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetAiTokenAutoTopupSettingsResponse,
    GetAiTokenAutoTopupSettingsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiTokenAutoTopupSettings(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetAiTokenAutoTopupSettingsError = Fetcher.ErrorWrapper<undefined>;

export type SetAiTokenAutoTopupSettingsResponse = {
  [key: string]: any;
};

export type SetAiTokenAutoTopupSettingsVariables = {
  body: Schemas.AiTokenAutoTopupIn;
} & ApiContext["fetcherOptions"];

/**
 * Set AI token auto top-up settings for the workspace.
 *
 * Args:
 *     settings: Auto top-up configuration including enabled flag, threshold, and amount
 */
export const fetchSetAiTokenAutoTopupSettings = (
  variables: SetAiTokenAutoTopupSettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    SetAiTokenAutoTopupSettingsResponse,
    SetAiTokenAutoTopupSettingsError,
    Schemas.AiTokenAutoTopupIn,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/ai-auto-topup/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Set AI token auto top-up settings for the workspace.
 *
 * Args:
 *     settings: Auto top-up configuration including enabled flag, threshold, and amount
 */
export const useSetAiTokenAutoTopupSettings = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SetAiTokenAutoTopupSettingsResponse,
      SetAiTokenAutoTopupSettingsError,
      SetAiTokenAutoTopupSettingsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    SetAiTokenAutoTopupSettingsResponse,
    SetAiTokenAutoTopupSettingsError,
    SetAiTokenAutoTopupSettingsVariables
  >({
    mutationFn: (variables: SetAiTokenAutoTopupSettingsVariables) =>
      fetchSetAiTokenAutoTopupSettings({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAiTokenCreditsQueryParams = {
  status?: string | null;
  /**
   * @default 1
   */
  page?: number | null;
};

export type GetAiTokenCreditsError = Fetcher.ErrorWrapper<undefined>;

export type GetAiTokenCreditsVariables = {
  queryParams?: GetAiTokenCreditsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get paginated list of AI token credits for the workspace.
 *
 * Args:
 *     status: Filter by status (completed, pending, failed, refunded)
 */
export const fetchGetAiTokenCredits = (
  variables: GetAiTokenCreditsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedAiTokenCreditModelOut,
    GetAiTokenCreditsError,
    undefined,
    {},
    GetAiTokenCreditsQueryParams,
    {}
  >({
    url: "/workspace/feature_access/v2/ai-credits/",
    method: "get",
    ...variables,
    signal,
  });

export const getAiTokenCreditsQueryKey = (
  variables: GetAiTokenCreditsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/feature_access/v2/ai-credits/",
    operationId: "getAiTokenCredits",
    variables,
  });

/**
 * Get paginated list of AI token credits for the workspace.
 *
 * Args:
 *     status: Filter by status (completed, pending, failed, refunded)
 */
export const useGetAiTokenCredits = <
  TData = Schemas.PagedAiTokenCreditModelOut,
>(
  variables: GetAiTokenCreditsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedAiTokenCreditModelOut,
      GetAiTokenCreditsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/ai-credits/",
    operationId: "getAiTokenCredits",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedAiTokenCreditModelOut,
    GetAiTokenCreditsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiTokenCredits({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get paginated list of AI token credits for the workspace.
 *
 * Args:
 *     status: Filter by status (completed, pending, failed, refunded)
 */
export const useSuspenseGetAiTokenCredits = <
  TData = Schemas.PagedAiTokenCreditModelOut,
>(
  variables: GetAiTokenCreditsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedAiTokenCreditModelOut,
      GetAiTokenCreditsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/ai-credits/",
    operationId: "getAiTokenCredits",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedAiTokenCreditModelOut,
    GetAiTokenCreditsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiTokenCredits({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetWorkspaceCardDetailsError = Fetcher.ErrorWrapper<undefined>;

export type GetWorkspaceCardDetailsVariables = ApiContext["fetcherOptions"];

/**
 * Get card details for the workspace.
 * Returns the encrypted card information if available.
 */
export const fetchGetWorkspaceCardDetails = (
  variables: GetWorkspaceCardDetailsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CardDetailsOut,
    GetWorkspaceCardDetailsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/card-details/",
    method: "get",
    ...variables,
    signal,
  });

export const getWorkspaceCardDetailsQueryKey = (
  variables: GetWorkspaceCardDetailsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/feature_access/v2/card-details/",
    operationId: "getWorkspaceCardDetails",
    variables,
  });

/**
 * Get card details for the workspace.
 * Returns the encrypted card information if available.
 */
export const useGetWorkspaceCardDetails = <TData = Schemas.CardDetailsOut,>(
  variables: GetWorkspaceCardDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CardDetailsOut,
      GetWorkspaceCardDetailsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/card-details/",
    operationId: "getWorkspaceCardDetails",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CardDetailsOut,
    GetWorkspaceCardDetailsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceCardDetails({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get card details for the workspace.
 * Returns the encrypted card information if available.
 */
export const useSuspenseGetWorkspaceCardDetails = <
  TData = Schemas.CardDetailsOut,
>(
  variables: GetWorkspaceCardDetailsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CardDetailsOut,
      GetWorkspaceCardDetailsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/card-details/",
    operationId: "getWorkspaceCardDetails",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CardDetailsOut,
    GetWorkspaceCardDetailsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceCardDetails({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetWorkspaceSubscriptionDetailsError =
  Fetcher.ErrorWrapper<undefined>;

export type GetWorkspaceSubscriptionDetailsVariables =
  ApiContext["fetcherOptions"];

/**
 * Get subscription details for the workspace.
 * Returns the subscription details if available.
 */
export const fetchGetWorkspaceSubscriptionDetails = (
  variables: GetWorkspaceSubscriptionDetailsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SubscriptionDetailsOut,
    GetWorkspaceSubscriptionDetailsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/subscription-details/",
    method: "get",
    ...variables,
    signal,
  });

export const getWorkspaceSubscriptionDetailsQueryKey = (
  variables: GetWorkspaceSubscriptionDetailsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/feature_access/v2/subscription-details/",
    operationId: "getWorkspaceSubscriptionDetails",
    variables,
  });

/**
 * Get subscription details for the workspace.
 * Returns the subscription details if available.
 */
export const useGetWorkspaceSubscriptionDetails = <
  TData = Schemas.SubscriptionDetailsOut,
>(
  variables: GetWorkspaceSubscriptionDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SubscriptionDetailsOut,
      GetWorkspaceSubscriptionDetailsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/subscription-details/",
    operationId: "getWorkspaceSubscriptionDetails",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SubscriptionDetailsOut,
    GetWorkspaceSubscriptionDetailsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceSubscriptionDetails(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get subscription details for the workspace.
 * Returns the subscription details if available.
 */
export const useSuspenseGetWorkspaceSubscriptionDetails = <
  TData = Schemas.SubscriptionDetailsOut,
>(
  variables: GetWorkspaceSubscriptionDetailsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SubscriptionDetailsOut,
      GetWorkspaceSubscriptionDetailsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/subscription-details/",
    operationId: "getWorkspaceSubscriptionDetails",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SubscriptionDetailsOut,
    GetWorkspaceSubscriptionDetailsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceSubscriptionDetails(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetWorkspaceBudgetSettingsError = Fetcher.ErrorWrapper<undefined>;

export type GetWorkspaceBudgetSettingsResponse = {
  [key: string]: any;
};

export type GetWorkspaceBudgetSettingsVariables = ApiContext["fetcherOptions"];

/**
 * Get workspace budget settings.
 *
 * Returns the current monthly budget configuration.
 */
export const fetchGetWorkspaceBudgetSettings = (
  variables: GetWorkspaceBudgetSettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetWorkspaceBudgetSettingsResponse,
    GetWorkspaceBudgetSettingsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/budget/",
    method: "get",
    ...variables,
    signal,
  });

export const getWorkspaceBudgetSettingsQueryKey = (
  variables: GetWorkspaceBudgetSettingsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/feature_access/v2/budget/",
    operationId: "getWorkspaceBudgetSettings",
    variables,
  });

/**
 * Get workspace budget settings.
 *
 * Returns the current monthly budget configuration.
 */
export const useGetWorkspaceBudgetSettings = <
  TData = GetWorkspaceBudgetSettingsResponse,
>(
  variables: GetWorkspaceBudgetSettingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetWorkspaceBudgetSettingsResponse,
      GetWorkspaceBudgetSettingsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/budget/",
    operationId: "getWorkspaceBudgetSettings",
    variables,
  });
  const result = reactQuery.useQuery<
    GetWorkspaceBudgetSettingsResponse,
    GetWorkspaceBudgetSettingsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceBudgetSettings(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get workspace budget settings.
 *
 * Returns the current monthly budget configuration.
 */
export const useSuspenseGetWorkspaceBudgetSettings = <
  TData = GetWorkspaceBudgetSettingsResponse,
>(
  variables: GetWorkspaceBudgetSettingsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetWorkspaceBudgetSettingsResponse,
      GetWorkspaceBudgetSettingsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/budget/",
    operationId: "getWorkspaceBudgetSettings",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetWorkspaceBudgetSettingsResponse,
    GetWorkspaceBudgetSettingsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceBudgetSettings(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetWorkspaceBudgetSettingsError = Fetcher.ErrorWrapper<undefined>;

export type SetWorkspaceBudgetSettingsResponse = {
  [key: string]: any;
};

export type SetWorkspaceBudgetSettingsVariables = {
  body: Schemas.WorkspaceBudgetIn;
} & ApiContext["fetcherOptions"];

/**
 * Set workspace budget settings.
 *
 * Args:
 *     settings: Budget configuration including monthly budget amount and enabled status
 */
export const fetchSetWorkspaceBudgetSettings = (
  variables: SetWorkspaceBudgetSettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    SetWorkspaceBudgetSettingsResponse,
    SetWorkspaceBudgetSettingsError,
    Schemas.WorkspaceBudgetIn,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/budget/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Set workspace budget settings.
 *
 * Args:
 *     settings: Budget configuration including monthly budget amount and enabled status
 */
export const useSetWorkspaceBudgetSettings = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SetWorkspaceBudgetSettingsResponse,
      SetWorkspaceBudgetSettingsError,
      SetWorkspaceBudgetSettingsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    SetWorkspaceBudgetSettingsResponse,
    SetWorkspaceBudgetSettingsError,
    SetWorkspaceBudgetSettingsVariables
  >({
    mutationFn: (variables: SetWorkspaceBudgetSettingsVariables) =>
      fetchSetWorkspaceBudgetSettings({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAiAccessStatusError = Fetcher.ErrorWrapper<undefined>;

export type GetAiAccessStatusVariables = ApiContext["fetcherOptions"];

/**
 * Get AI access status including credit balance restrictions.
 * Returns detailed information about access restrictions and credit balance.
 */
export const fetchGetAiAccessStatus = (
  variables: GetAiAccessStatusVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AIAccessStatusOut,
    GetAiAccessStatusError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/workspace/feature_access/v2/ai-access-status/",
    method: "get",
    ...variables,
    signal,
  });

export const getAiAccessStatusQueryKey = (
  variables: GetAiAccessStatusVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/feature_access/v2/ai-access-status/",
    operationId: "getAiAccessStatus",
    variables,
  });

/**
 * Get AI access status including credit balance restrictions.
 * Returns detailed information about access restrictions and credit balance.
 */
export const useGetAiAccessStatus = <TData = Schemas.AIAccessStatusOut,>(
  variables: GetAiAccessStatusVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AIAccessStatusOut,
      GetAiAccessStatusError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/ai-access-status/",
    operationId: "getAiAccessStatus",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AIAccessStatusOut,
    GetAiAccessStatusError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiAccessStatus({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get AI access status including credit balance restrictions.
 * Returns detailed information about access restrictions and credit balance.
 */
export const useSuspenseGetAiAccessStatus = <
  TData = Schemas.AIAccessStatusOut,
>(
  variables: GetAiAccessStatusVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AIAccessStatusOut,
      GetAiAccessStatusError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/feature_access/v2/ai-access-status/",
    operationId: "getAiAccessStatus",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AIAccessStatusOut,
    GetAiAccessStatusError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiAccessStatus({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetUserProfileImageError = Fetcher.ErrorWrapper<undefined>;

export type SetUserProfileImageRequestBody = {
  /**
   * @format binary
   */
  file: Blob;
};

export type SetUserProfileImageVariables = {
  body: SetUserProfileImageRequestBody;
} & ApiContext["fetcherOptions"];

export const fetchSetUserProfileImage = (
  variables: SetUserProfileImageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    SetUserProfileImageError,
    SetUserProfileImageRequestBody,
    {},
    {},
    {}
  >({
    url: "/user/profile_picture/upload/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetUserProfileImage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      SetUserProfileImageError,
      SetUserProfileImageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    string,
    SetUserProfileImageError,
    SetUserProfileImageVariables
  >({
    mutationFn: (variables: SetUserProfileImageVariables) =>
      fetchSetUserProfileImage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetGroupPathParams = {
  groupId: string;
};

export type ApiGetGroupError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetGroupVariables = {
  pathParams: ApiGetGroupPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a user group by their ID.
 */
export const fetchApiGetGroup = (
  variables: ApiGetGroupVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LiteUserGroupOut,
    ApiGetGroupError,
    undefined,
    {},
    {},
    ApiGetGroupPathParams
  >({ url: "/user/group/{groupId}/", method: "get", ...variables, signal });

export const apiGetGroupQueryKey = (
  variables: ApiGetGroupVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/user/group/{groupId}/",
    operationId: "apiGetGroup",
    variables,
  });

/**
 * Get a user group by their ID.
 */
export const useApiGetGroup = <TData = Schemas.LiteUserGroupOut,>(
  variables: ApiGetGroupVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LiteUserGroupOut,
      ApiGetGroupError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/user/group/{groupId}/",
    operationId: "apiGetGroup",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LiteUserGroupOut,
    ApiGetGroupError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetGroup({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a user group by their ID.
 */
export const useSuspenseApiGetGroup = <TData = Schemas.LiteUserGroupOut,>(
  variables: ApiGetGroupVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LiteUserGroupOut,
      ApiGetGroupError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/user/group/{groupId}/",
    operationId: "apiGetGroup",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LiteUserGroupOut,
    ApiGetGroupError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetGroup({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiImpersonateUserError = Fetcher.ErrorWrapper<undefined>;

export type ApiImpersonateUserVariables = {
  body: Schemas.ImpersonateUserRequest;
} & ApiContext["fetcherOptions"];

/**
 * Endpoint for admin users to impersonate another user in their workspace
 */
export const fetchApiImpersonateUser = (
  variables: ApiImpersonateUserVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiImpersonateUserError,
    Schemas.ImpersonateUserRequest,
    {},
    {},
    {}
  >({ url: "/auth/user/impersonate/", method: "post", ...variables, signal });

/**
 * Endpoint for admin users to impersonate another user in their workspace
 */
export const useApiImpersonateUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiImpersonateUserError,
      ApiImpersonateUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiImpersonateUserError,
    ApiImpersonateUserVariables
  >({
    mutationFn: (variables: ApiImpersonateUserVariables) =>
      fetchApiImpersonateUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetPreferencesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPreferencesVariables = ApiContext["fetcherOptions"];

/**
 * Get all user preferences.
 */
export const fetchApiGetPreferences = (
  variables: ApiGetPreferencesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PreferencesOut,
    ApiGetPreferencesError,
    undefined,
    {},
    {},
    {}
  >({ url: "/auth/preferences/", method: "get", ...variables, signal });

export const apiGetPreferencesQueryKey = (
  variables: ApiGetPreferencesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/preferences/",
    operationId: "apiGetPreferences",
    variables,
  });

/**
 * Get all user preferences.
 */
export const useApiGetPreferences = <TData = Schemas.PreferencesOut,>(
  variables: ApiGetPreferencesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PreferencesOut,
      ApiGetPreferencesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/preferences/",
    operationId: "apiGetPreferences",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PreferencesOut,
    ApiGetPreferencesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPreferences({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all user preferences.
 */
export const useSuspenseApiGetPreferences = <TData = Schemas.PreferencesOut,>(
  variables: ApiGetPreferencesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PreferencesOut,
      ApiGetPreferencesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/preferences/",
    operationId: "apiGetPreferences",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PreferencesOut,
    ApiGetPreferencesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPreferences({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdatePreferencesError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdatePreferencesVariables = {
  body: Schemas.PreferencesIn;
} & ApiContext["fetcherOptions"];

/**
 * Update user preferences. This endpoint can handle any key-value pairs.
 */
export const fetchApiUpdatePreferences = (
  variables: ApiUpdatePreferencesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PreferencesOut,
    ApiUpdatePreferencesError,
    Schemas.PreferencesIn,
    {},
    {},
    {}
  >({ url: "/auth/preferences/", method: "patch", ...variables, signal });

/**
 * Update user preferences. This endpoint can handle any key-value pairs.
 */
export const useApiUpdatePreferences = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PreferencesOut,
      ApiUpdatePreferencesError,
      ApiUpdatePreferencesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PreferencesOut,
    ApiUpdatePreferencesError,
    ApiUpdatePreferencesVariables
  >({
    mutationFn: (variables: ApiUpdatePreferencesVariables) =>
      fetchApiUpdatePreferences({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetUsedWorkspaceSeatsError = Fetcher.ErrorWrapper<undefined>;

export type GetUsedWorkspaceSeatsVariables = ApiContext["fetcherOptions"];

/**
 * Get the number of used seats in the workspace.
 *
 * Returns:
 *     WorkspaceUsedSeatsOut: Object containing the number of used editor, viewer, integration, extension, and exempt editor seats.
 */
export const fetchGetUsedWorkspaceSeats = (
  variables: GetUsedWorkspaceSeatsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.WorkspaceUsedSeatsOut,
    GetUsedWorkspaceSeatsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/workspace/seats/used/", method: "get", ...variables, signal });

export const getUsedWorkspaceSeatsQueryKey = (
  variables: GetUsedWorkspaceSeatsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/seats/used/",
    operationId: "getUsedWorkspaceSeats",
    variables,
  });

/**
 * Get the number of used seats in the workspace.
 *
 * Returns:
 *     WorkspaceUsedSeatsOut: Object containing the number of used editor, viewer, integration, extension, and exempt editor seats.
 */
export const useGetUsedWorkspaceSeats = <
  TData = Schemas.WorkspaceUsedSeatsOut,
>(
  variables: GetUsedWorkspaceSeatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.WorkspaceUsedSeatsOut,
      GetUsedWorkspaceSeatsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/seats/used/",
    operationId: "getUsedWorkspaceSeats",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.WorkspaceUsedSeatsOut,
    GetUsedWorkspaceSeatsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetUsedWorkspaceSeats({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the number of used seats in the workspace.
 *
 * Returns:
 *     WorkspaceUsedSeatsOut: Object containing the number of used editor, viewer, integration, extension, and exempt editor seats.
 */
export const useSuspenseGetUsedWorkspaceSeats = <
  TData = Schemas.WorkspaceUsedSeatsOut,
>(
  variables: GetUsedWorkspaceSeatsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.WorkspaceUsedSeatsOut,
      GetUsedWorkspaceSeatsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/seats/used/",
    operationId: "getUsedWorkspaceSeats",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.WorkspaceUsedSeatsOut,
    GetUsedWorkspaceSeatsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetUsedWorkspaceSeats({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetWorkspaceLimitsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetWorkspaceLimitsVariables = ApiContext["fetcherOptions"];

/**
 * Get billing limits for the workspace.
 *
 * This endpoint is used by the frontend to determine if the user has reached
 * their limits for editors, viewers, and integrations.
 *
 * The request is forwarded to a CloudFlare worker that processes billing telemetry.
 *
 * Performance note: This makes an external HTTP call to the telemetry service,
 * which may take ~100-300ms depending on network latency.
 *
 * Returns:
 *     dict: Billing limits data from the telemetry service
 */
export const fetchApiGetWorkspaceLimits = (
  variables: ApiGetWorkspaceLimitsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LimitsOut,
    ApiGetWorkspaceLimitsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/workspace/seats/limits/", method: "get", ...variables, signal });

export const apiGetWorkspaceLimitsQueryKey = (
  variables: ApiGetWorkspaceLimitsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/workspace/seats/limits/",
    operationId: "apiGetWorkspaceLimits",
    variables,
  });

/**
 * Get billing limits for the workspace.
 *
 * This endpoint is used by the frontend to determine if the user has reached
 * their limits for editors, viewers, and integrations.
 *
 * The request is forwarded to a CloudFlare worker that processes billing telemetry.
 *
 * Performance note: This makes an external HTTP call to the telemetry service,
 * which may take ~100-300ms depending on network latency.
 *
 * Returns:
 *     dict: Billing limits data from the telemetry service
 */
export const useApiGetWorkspaceLimits = <TData = Schemas.LimitsOut,>(
  variables: ApiGetWorkspaceLimitsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LimitsOut,
      ApiGetWorkspaceLimitsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/seats/limits/",
    operationId: "apiGetWorkspaceLimits",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LimitsOut,
    ApiGetWorkspaceLimitsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetWorkspaceLimits({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get billing limits for the workspace.
 *
 * This endpoint is used by the frontend to determine if the user has reached
 * their limits for editors, viewers, and integrations.
 *
 * The request is forwarded to a CloudFlare worker that processes billing telemetry.
 *
 * Performance note: This makes an external HTTP call to the telemetry service,
 * which may take ~100-300ms depending on network latency.
 *
 * Returns:
 *     dict: Billing limits data from the telemetry service
 */
export const useSuspenseApiGetWorkspaceLimits = <TData = Schemas.LimitsOut,>(
  variables: ApiGetWorkspaceLimitsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LimitsOut,
      ApiGetWorkspaceLimitsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/workspace/seats/limits/",
    operationId: "apiGetWorkspaceLimits",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LimitsOut,
    ApiGetWorkspaceLimitsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetWorkspaceLimits({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAllowedAuthMethodsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAllowedAuthMethodsVariables = ApiContext["fetcherOptions"];

/**
 * Returns the allowed authentication methods based on deployment type and configuration.
 *
 * For cloud deployments: Returns standard SSO options
 * For managed/on-premise: Checks workspace SSO enforcement and SAML configuration
 */
export const fetchApiGetAllowedAuthMethods = (
  variables: ApiGetAllowedAuthMethodsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AllowedAuthMethodsResponse,
    ApiGetAllowedAuthMethodsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/auth/methods/allowed-auth-methods/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAllowedAuthMethodsQueryKey = (
  variables: ApiGetAllowedAuthMethodsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/auth/methods/allowed-auth-methods/",
    operationId: "apiGetAllowedAuthMethods",
    variables,
  });

/**
 * Returns the allowed authentication methods based on deployment type and configuration.
 *
 * For cloud deployments: Returns standard SSO options
 * For managed/on-premise: Checks workspace SSO enforcement and SAML configuration
 */
export const useApiGetAllowedAuthMethods = <
  TData = Schemas.AllowedAuthMethodsResponse,
>(
  variables: ApiGetAllowedAuthMethodsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AllowedAuthMethodsResponse,
      ApiGetAllowedAuthMethodsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/methods/allowed-auth-methods/",
    operationId: "apiGetAllowedAuthMethods",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AllowedAuthMethodsResponse,
    ApiGetAllowedAuthMethodsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAllowedAuthMethods(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Returns the allowed authentication methods based on deployment type and configuration.
 *
 * For cloud deployments: Returns standard SSO options
 * For managed/on-premise: Checks workspace SSO enforcement and SAML configuration
 */
export const useSuspenseApiGetAllowedAuthMethods = <
  TData = Schemas.AllowedAuthMethodsResponse,
>(
  variables: ApiGetAllowedAuthMethodsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AllowedAuthMethodsResponse,
      ApiGetAllowedAuthMethodsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/auth/methods/allowed-auth-methods/",
    operationId: "apiGetAllowedAuthMethods",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AllowedAuthMethodsResponse,
    ApiGetAllowedAuthMethodsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAllowedAuthMethods(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiAuthStartError = Fetcher.ErrorWrapper<undefined>;

export type ApiAuthStartVariables = {
  body: Schemas.AuthStartRequest;
} & ApiContext["fetcherOptions"];

/**
 * Start the authentication process for an email address.
 *
 * Determines the appropriate authentication method based on:
 * - Domain authorization
 * - SSO enforcement settings
 * - Email validation
 */
export const fetchApiAuthStart = (
  variables: ApiAuthStartVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AuthStartResponse,
    ApiAuthStartError,
    Schemas.AuthStartRequest,
    {},
    {},
    {}
  >({ url: "/auth/start/", method: "post", ...variables, signal });

/**
 * Start the authentication process for an email address.
 *
 * Determines the appropriate authentication method based on:
 * - Domain authorization
 * - SSO enforcement settings
 * - Email validation
 */
export const useApiAuthStart = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AuthStartResponse,
      ApiAuthStartError,
      ApiAuthStartVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AuthStartResponse,
    ApiAuthStartError,
    ApiAuthStartVariables
  >({
    mutationFn: (variables: ApiAuthStartVariables) =>
      fetchApiAuthStart({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiAuthVerifyError = Fetcher.ErrorWrapper<undefined>;

export type ApiAuthVerifyVariables = {
  body: Schemas.AuthVerifyRequest;
} & ApiContext["fetcherOptions"];

/**
 * Verify email verification code and create user account.
 *
 * Rate-limited to prevent brute-force attacks on verification codes.
 */
export const fetchApiAuthVerify = (
  variables: ApiAuthVerifyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AuthVerifyResponse,
    ApiAuthVerifyError,
    Schemas.AuthVerifyRequest,
    {},
    {},
    {}
  >({ url: "/auth/verify/", method: "post", ...variables, signal });

/**
 * Verify email verification code and create user account.
 *
 * Rate-limited to prevent brute-force attacks on verification codes.
 */
export const useApiAuthVerify = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AuthVerifyResponse,
      ApiAuthVerifyError,
      ApiAuthVerifyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AuthVerifyResponse,
    ApiAuthVerifyError,
    ApiAuthVerifyVariables
  >({
    mutationFn: (variables: ApiAuthVerifyVariables) =>
      fetchApiAuthVerify({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetColumnTypesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetColumnTypesResponse = string[];

export type ApiGetColumnTypesVariables = ApiContext["fetcherOptions"];

/**
 * Get all column types within the workspace.
 */
export const fetchApiGetColumnTypes = (
  variables: ApiGetColumnTypesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetColumnTypesResponse,
    ApiGetColumnTypesError,
    undefined,
    {},
    {},
    {}
  >({ url: "/table/columns_v2/types/", method: "get", ...variables, signal });

export const apiGetColumnTypesQueryKey = (
  variables: ApiGetColumnTypesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/table/columns_v2/types/",
    operationId: "apiGetColumnTypes",
    variables,
  });

/**
 * Get all column types within the workspace.
 */
export const useApiGetColumnTypes = <TData = ApiGetColumnTypesResponse,>(
  variables: ApiGetColumnTypesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetColumnTypesResponse,
      ApiGetColumnTypesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/table/columns_v2/types/",
    operationId: "apiGetColumnTypes",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetColumnTypesResponse,
    ApiGetColumnTypesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetColumnTypes({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all column types within the workspace.
 */
export const useSuspenseApiGetColumnTypes = <
  TData = ApiGetColumnTypesResponse,
>(
  variables: ApiGetColumnTypesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetColumnTypesResponse,
      ApiGetColumnTypesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/table/columns_v2/types/",
    operationId: "apiGetColumnTypes",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetColumnTypesResponse,
    ApiGetColumnTypesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetColumnTypes({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPiiWordListError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPiiWordListVariables = ApiContext["fetcherOptions"];

export const fetchApiGetPiiWordList = (
  variables: ApiGetPiiWordListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PiiWordListResponse,
    ApiGetPiiWordListError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/table/columns_v2/pii_word_list/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetPiiWordListQueryKey = (
  variables: ApiGetPiiWordListVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/table/columns_v2/pii_word_list/",
    operationId: "apiGetPiiWordList",
    variables,
  });

export const useApiGetPiiWordList = <TData = Schemas.PiiWordListResponse,>(
  variables: ApiGetPiiWordListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PiiWordListResponse,
      ApiGetPiiWordListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/table/columns_v2/pii_word_list/",
    operationId: "apiGetPiiWordList",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PiiWordListResponse,
    ApiGetPiiWordListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPiiWordList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetPiiWordList = <
  TData = Schemas.PiiWordListResponse,
>(
  variables: ApiGetPiiWordListVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PiiWordListResponse,
      ApiGetPiiWordListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/table/columns_v2/pii_word_list/",
    operationId: "apiGetPiiWordList",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PiiWordListResponse,
    ApiGetPiiWordListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPiiWordList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdatePiiWordListError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdatePiiWordListVariables = {
  body: Schemas.PiiWordListRequest;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdatePiiWordList = (
  variables: ApiUpdatePiiWordListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PiiWordListResponse,
    ApiUpdatePiiWordListError,
    Schemas.PiiWordListRequest,
    {},
    {},
    {}
  >({
    url: "/table/columns_v2/pii_word_list/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdatePiiWordList = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PiiWordListResponse,
      ApiUpdatePiiWordListError,
      ApiUpdatePiiWordListVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PiiWordListResponse,
    ApiUpdatePiiWordListError,
    ApiUpdatePiiWordListVariables
  >({
    mutationFn: (variables: ApiUpdatePiiWordListVariables) =>
      fetchApiUpdatePiiWordList({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetPiiColumnsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPiiColumnsResponse = Schemas.PiiColumn[];

export type ApiGetPiiColumnsVariables = ApiContext["fetcherOptions"];

export const fetchApiGetPiiColumns = (
  variables: ApiGetPiiColumnsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetPiiColumnsResponse,
    ApiGetPiiColumnsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/table/columns_v2/pii/", method: "get", ...variables, signal });

export const apiGetPiiColumnsQueryKey = (
  variables: ApiGetPiiColumnsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/table/columns_v2/pii/",
    operationId: "apiGetPiiColumns",
    variables,
  });

export const useApiGetPiiColumns = <TData = ApiGetPiiColumnsResponse,>(
  variables: ApiGetPiiColumnsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetPiiColumnsResponse,
      ApiGetPiiColumnsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/table/columns_v2/pii/",
    operationId: "apiGetPiiColumns",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetPiiColumnsResponse,
    ApiGetPiiColumnsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPiiColumns({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetPiiColumns = <TData = ApiGetPiiColumnsResponse,>(
  variables: ApiGetPiiColumnsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetPiiColumnsResponse,
      ApiGetPiiColumnsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/table/columns_v2/pii/",
    operationId: "apiGetPiiColumns",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetPiiColumnsResponse,
    ApiGetPiiColumnsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPiiColumns({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiColumnUpdatePiiQueryParams = {
  column_id: string;
  /**
   * @default false
   */
  column_only?: boolean;
};

export type ApiColumnUpdatePiiError = Fetcher.ErrorWrapper<undefined>;

export type ApiColumnUpdatePiiVariables = {
  queryParams: ApiColumnUpdatePiiQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Update PII flag for column and optionally its parent table.
 *
 * Args:
 *     column_id: ID of the column to mark as PII
 *     column_only: If True, only mark the column as PII
 *                 If False, mark both column and parent table as PII
 */
export const fetchApiColumnUpdatePii = (
  variables: ApiColumnUpdatePiiVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiColumnUpdatePiiError,
    undefined,
    {},
    ApiColumnUpdatePiiQueryParams,
    {}
  >({
    url: "/table/columns_v2/update_pii/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update PII flag for column and optionally its parent table.
 *
 * Args:
 *     column_id: ID of the column to mark as PII
 *     column_only: If True, only mark the column as PII
 *                 If False, mark both column and parent table as PII
 */
export const useApiColumnUpdatePii = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiColumnUpdatePiiError,
      ApiColumnUpdatePiiVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiColumnUpdatePiiError,
    ApiColumnUpdatePiiVariables
  >({
    mutationFn: (variables: ApiColumnUpdatePiiVariables) =>
      fetchApiColumnUpdatePii({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetIntegrationGroupItemsPathParams = {
  integrationId: string;
};

export type ApiGetIntegrationGroupItemsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetIntegrationGroupItemsResponse =
  Schemas.GroupItemSettingSchema[];

export type ApiGetIntegrationGroupItemsVariables = {
  pathParams: ApiGetIntegrationGroupItemsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetIntegrationGroupItems = (
  variables: ApiGetIntegrationGroupItemsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetIntegrationGroupItemsResponse,
    ApiGetIntegrationGroupItemsError,
    undefined,
    {},
    {},
    ApiGetIntegrationGroupItemsPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/group_items/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIntegrationGroupItemsQueryKey = (
  variables: ApiGetIntegrationGroupItemsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/group_items/",
    operationId: "apiGetIntegrationGroupItems",
    variables,
  });

export const useApiGetIntegrationGroupItems = <
  TData = ApiGetIntegrationGroupItemsResponse,
>(
  variables: ApiGetIntegrationGroupItemsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetIntegrationGroupItemsResponse,
      ApiGetIntegrationGroupItemsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/group_items/",
    operationId: "apiGetIntegrationGroupItems",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetIntegrationGroupItemsResponse,
    ApiGetIntegrationGroupItemsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationGroupItems(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetIntegrationGroupItems = <
  TData = ApiGetIntegrationGroupItemsResponse,
>(
  variables: ApiGetIntegrationGroupItemsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetIntegrationGroupItemsResponse,
      ApiGetIntegrationGroupItemsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/group_items/",
    operationId: "apiGetIntegrationGroupItems",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetIntegrationGroupItemsResponse,
    ApiGetIntegrationGroupItemsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationGroupItems(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGroupItemsRefreshSupportQueryParams = {
  integration_type: string;
};

export type ApiGroupItemsRefreshSupportError = Fetcher.ErrorWrapper<undefined>;

export type ApiGroupItemsRefreshSupportVariables = {
  queryParams: ApiGroupItemsRefreshSupportQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGroupItemsRefreshSupport = (
  variables: ApiGroupItemsRefreshSupportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    boolean,
    ApiGroupItemsRefreshSupportError,
    undefined,
    {},
    ApiGroupItemsRefreshSupportQueryParams,
    {}
  >({
    url: "/integration_v2/integrations/group_items/refresh_support/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGroupItemsRefreshSupportQueryKey = (
  variables: ApiGroupItemsRefreshSupportVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/group_items/refresh_support/",
    operationId: "apiGroupItemsRefreshSupport",
    variables,
  });

export const useApiGroupItemsRefreshSupport = <TData = boolean,>(
  variables: ApiGroupItemsRefreshSupportVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      boolean,
      ApiGroupItemsRefreshSupportError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/group_items/refresh_support/",
    operationId: "apiGroupItemsRefreshSupport",
    variables,
  });
  const result = reactQuery.useQuery<
    boolean,
    ApiGroupItemsRefreshSupportError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGroupItemsRefreshSupport(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGroupItemsRefreshSupport = <TData = boolean,>(
  variables: ApiGroupItemsRefreshSupportVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      boolean,
      ApiGroupItemsRefreshSupportError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/group_items/refresh_support/",
    operationId: "apiGroupItemsRefreshSupport",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    boolean,
    ApiGroupItemsRefreshSupportError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGroupItemsRefreshSupport(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiRefreshIntegrationGroupItemsPathParams = {
  integrationId: string;
};

export type ApiRefreshIntegrationGroupItemsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiRefreshIntegrationGroupItemsVariables = {
  pathParams: ApiRefreshIntegrationGroupItemsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRefreshIntegrationGroupItems = (
  variables: ApiRefreshIntegrationGroupItemsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    ApiRefreshIntegrationGroupItemsError,
    undefined,
    {},
    {},
    ApiRefreshIntegrationGroupItemsPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/group_items/refresh/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiRefreshIntegrationGroupItems = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BackgroundJobOut,
      ApiRefreshIntegrationGroupItemsError,
      ApiRefreshIntegrationGroupItemsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BackgroundJobOut,
    ApiRefreshIntegrationGroupItemsError,
    ApiRefreshIntegrationGroupItemsVariables
  >({
    mutationFn: (variables: ApiRefreshIntegrationGroupItemsVariables) =>
      fetchApiRefreshIntegrationGroupItems({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateIntegrationGroupSettingsPathParams = {
  integrationId: string;
};

export type ApiUpdateIntegrationGroupSettingsError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiUpdateIntegrationGroupSettingsResponse =
  Schemas.GroupItemSettingSchema[];

export type ApiUpdateIntegrationGroupSettingsVariables = {
  body: Schemas.UpdateGroupSettingsRequest;
  pathParams: ApiUpdateIntegrationGroupSettingsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * This endpoint is deprecated. Use the v2 PATCH request below
 */
export const fetchApiUpdateIntegrationGroupSettings = (
  variables: ApiUpdateIntegrationGroupSettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiUpdateIntegrationGroupSettingsResponse,
    ApiUpdateIntegrationGroupSettingsError,
    Schemas.UpdateGroupSettingsRequest,
    {},
    {},
    ApiUpdateIntegrationGroupSettingsPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/group_settings/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * This endpoint is deprecated. Use the v2 PATCH request below
 */
export const useApiUpdateIntegrationGroupSettings = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiUpdateIntegrationGroupSettingsResponse,
      ApiUpdateIntegrationGroupSettingsError,
      ApiUpdateIntegrationGroupSettingsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiUpdateIntegrationGroupSettingsResponse,
    ApiUpdateIntegrationGroupSettingsError,
    ApiUpdateIntegrationGroupSettingsVariables
  >({
    mutationFn: (variables: ApiUpdateIntegrationGroupSettingsVariables) =>
      fetchApiUpdateIntegrationGroupSettings({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type SetIntegrationWhitelistFiltersPathParams = {
  integrationId: string;
};

export type SetIntegrationWhitelistFiltersError =
  Fetcher.ErrorWrapper<undefined>;

export type SetIntegrationWhitelistFiltersResponse = {
  [key: string]: any;
};

export type SetIntegrationWhitelistFiltersRequestBody = {
  [key: string]: (string | string[])[];
};

export type SetIntegrationWhitelistFiltersVariables = {
  body?: SetIntegrationWhitelistFiltersRequestBody;
  pathParams: SetIntegrationWhitelistFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSetIntegrationWhitelistFilters = (
  variables: SetIntegrationWhitelistFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    SetIntegrationWhitelistFiltersResponse,
    SetIntegrationWhitelistFiltersError,
    SetIntegrationWhitelistFiltersRequestBody,
    {},
    {},
    SetIntegrationWhitelistFiltersPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/whitelist-filters/",
    method: "patch",
    ...variables,
    signal,
  });

export const useSetIntegrationWhitelistFilters = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SetIntegrationWhitelistFiltersResponse,
      SetIntegrationWhitelistFiltersError,
      SetIntegrationWhitelistFiltersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    SetIntegrationWhitelistFiltersResponse,
    SetIntegrationWhitelistFiltersError,
    SetIntegrationWhitelistFiltersVariables
  >({
    mutationFn: (variables: SetIntegrationWhitelistFiltersVariables) =>
      fetchSetIntegrationWhitelistFilters({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SetIntegrationExclusionFiltersPathParams = {
  integrationId: string;
};

export type SetIntegrationExclusionFiltersError =
  Fetcher.ErrorWrapper<undefined>;

export type SetIntegrationExclusionFiltersResponse = {
  [key: string]: any;
};

export type SetIntegrationExclusionFiltersRequestBody = {
  [key: string]: (string | string[])[];
};

export type SetIntegrationExclusionFiltersVariables = {
  body?: SetIntegrationExclusionFiltersRequestBody;
  pathParams: SetIntegrationExclusionFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSetIntegrationExclusionFilters = (
  variables: SetIntegrationExclusionFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    SetIntegrationExclusionFiltersResponse,
    SetIntegrationExclusionFiltersError,
    SetIntegrationExclusionFiltersRequestBody,
    {},
    {},
    SetIntegrationExclusionFiltersPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/exclusion-filters/",
    method: "patch",
    ...variables,
    signal,
  });

export const useSetIntegrationExclusionFilters = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SetIntegrationExclusionFiltersResponse,
      SetIntegrationExclusionFiltersError,
      SetIntegrationExclusionFiltersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    SetIntegrationExclusionFiltersResponse,
    SetIntegrationExclusionFiltersError,
    SetIntegrationExclusionFiltersVariables
  >({
    mutationFn: (variables: SetIntegrationExclusionFiltersVariables) =>
      fetchSetIntegrationExclusionFilters({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetIntegrationLineageSpecsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetIntegrationLineageSpecsResponse = {
  [key: string]: Schemas.LineageNodeSpec;
};

export type ApiGetIntegrationLineageSpecsVariables =
  ApiContext["fetcherOptions"];

export const fetchApiGetIntegrationLineageSpecs = (
  variables: ApiGetIntegrationLineageSpecsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetIntegrationLineageSpecsResponse,
    ApiGetIntegrationLineageSpecsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/integration_v2/integrations/lineage/node-specs/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIntegrationLineageSpecsQueryKey = (
  variables: ApiGetIntegrationLineageSpecsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/lineage/node-specs/",
    operationId: "apiGetIntegrationLineageSpecs",
    variables,
  });

export const useApiGetIntegrationLineageSpecs = <
  TData = ApiGetIntegrationLineageSpecsResponse,
>(
  variables: ApiGetIntegrationLineageSpecsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetIntegrationLineageSpecsResponse,
      ApiGetIntegrationLineageSpecsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/lineage/node-specs/",
    operationId: "apiGetIntegrationLineageSpecs",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetIntegrationLineageSpecsResponse,
    ApiGetIntegrationLineageSpecsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationLineageSpecs(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetIntegrationLineageSpecs = <
  TData = ApiGetIntegrationLineageSpecsResponse,
>(
  variables: ApiGetIntegrationLineageSpecsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetIntegrationLineageSpecsResponse,
      ApiGetIntegrationLineageSpecsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/lineage/node-specs/",
    operationId: "apiGetIntegrationLineageSpecs",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetIntegrationLineageSpecsResponse,
    ApiGetIntegrationLineageSpecsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationLineageSpecs(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiHasPreviewAccessPathParams = {
  integrationId: string;
};

export type ApiHasPreviewAccessError = Fetcher.ErrorWrapper<undefined>;

export type ApiHasPreviewAccessVariables = {
  pathParams: ApiHasPreviewAccessPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiHasPreviewAccess = (
  variables: ApiHasPreviewAccessVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    boolean,
    ApiHasPreviewAccessError,
    undefined,
    {},
    {},
    ApiHasPreviewAccessPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/has-preview-access/",
    method: "get",
    ...variables,
    signal,
  });

export const apiHasPreviewAccessQueryKey = (
  variables: ApiHasPreviewAccessVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/has-preview-access/",
    operationId: "apiHasPreviewAccess",
    variables,
  });

export const useApiHasPreviewAccess = <TData = boolean,>(
  variables: ApiHasPreviewAccessVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<boolean, ApiHasPreviewAccessError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/has-preview-access/",
    operationId: "apiHasPreviewAccess",
    variables,
  });
  const result = reactQuery.useQuery<boolean, ApiHasPreviewAccessError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiHasPreviewAccess({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiHasPreviewAccess = <TData = boolean,>(
  variables: ApiHasPreviewAccessVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      boolean,
      ApiHasPreviewAccessError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/has-preview-access/",
    operationId: "apiHasPreviewAccess",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    boolean,
    ApiHasPreviewAccessError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiHasPreviewAccess({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetCatalogTreeIntegrationsQueryParams = {
  team_id: string;
};

export type ApiGetCatalogTreeIntegrationsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetCatalogTreeIntegrationsResponse =
  Schemas.LiteIntegrationOut[];

export type ApiGetCatalogTreeIntegrationsVariables = {
  queryParams: ApiGetCatalogTreeIntegrationsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get integrations for catalog tree display. This endpoint is deprecated and will be removed in a future version.
 */
export const fetchApiGetCatalogTreeIntegrations = (
  variables: ApiGetCatalogTreeIntegrationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetCatalogTreeIntegrationsResponse,
    ApiGetCatalogTreeIntegrationsError,
    undefined,
    {},
    ApiGetCatalogTreeIntegrationsQueryParams,
    {}
  >({
    url: "/integration_v2/integrations/catalogtree/list/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetCatalogTreeIntegrationsQueryKey = (
  variables: ApiGetCatalogTreeIntegrationsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/catalogtree/list/",
    operationId: "apiGetCatalogTreeIntegrations",
    variables,
  });

/**
 * Get integrations for catalog tree display. This endpoint is deprecated and will be removed in a future version.
 */
export const useApiGetCatalogTreeIntegrations = <
  TData = ApiGetCatalogTreeIntegrationsResponse,
>(
  variables: ApiGetCatalogTreeIntegrationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetCatalogTreeIntegrationsResponse,
      ApiGetCatalogTreeIntegrationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/catalogtree/list/",
    operationId: "apiGetCatalogTreeIntegrations",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetCatalogTreeIntegrationsResponse,
    ApiGetCatalogTreeIntegrationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCatalogTreeIntegrations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get integrations for catalog tree display. This endpoint is deprecated and will be removed in a future version.
 */
export const useSuspenseApiGetCatalogTreeIntegrations = <
  TData = ApiGetCatalogTreeIntegrationsResponse,
>(
  variables: ApiGetCatalogTreeIntegrationsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetCatalogTreeIntegrationsResponse,
      ApiGetCatalogTreeIntegrationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/catalogtree/list/",
    operationId: "apiGetCatalogTreeIntegrations",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetCatalogTreeIntegrationsResponse,
    ApiGetCatalogTreeIntegrationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCatalogTreeIntegrations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiAggregateEntityKeysForIntegrationPathParams = {
  integrationId: string;
};

export type ApiAggregateEntityKeysForIntegrationQueryParams = {
  entity_keys: string[];
};

export type ApiAggregateEntityKeysForIntegrationError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiAggregateEntityKeysForIntegrationResponse = {
  [key: string]: string[];
};

export type ApiAggregateEntityKeysForIntegrationVariables = {
  pathParams: ApiAggregateEntityKeysForIntegrationPathParams;
  queryParams: ApiAggregateEntityKeysForIntegrationQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiAggregateEntityKeysForIntegration = (
  variables: ApiAggregateEntityKeysForIntegrationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiAggregateEntityKeysForIntegrationResponse,
    ApiAggregateEntityKeysForIntegrationError,
    undefined,
    {},
    ApiAggregateEntityKeysForIntegrationQueryParams,
    ApiAggregateEntityKeysForIntegrationPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/aggregate-entity-keys/",
    method: "get",
    ...variables,
    signal,
  });

export const apiAggregateEntityKeysForIntegrationQueryKey = (
  variables: ApiAggregateEntityKeysForIntegrationVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/aggregate-entity-keys/",
    operationId: "apiAggregateEntityKeysForIntegration",
    variables,
  });

export const useApiAggregateEntityKeysForIntegration = <
  TData = ApiAggregateEntityKeysForIntegrationResponse,
>(
  variables: ApiAggregateEntityKeysForIntegrationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiAggregateEntityKeysForIntegrationResponse,
      ApiAggregateEntityKeysForIntegrationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/aggregate-entity-keys/",
    operationId: "apiAggregateEntityKeysForIntegration",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiAggregateEntityKeysForIntegrationResponse,
    ApiAggregateEntityKeysForIntegrationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiAggregateEntityKeysForIntegration(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiAggregateEntityKeysForIntegration = <
  TData = ApiAggregateEntityKeysForIntegrationResponse,
>(
  variables: ApiAggregateEntityKeysForIntegrationVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiAggregateEntityKeysForIntegrationResponse,
      ApiAggregateEntityKeysForIntegrationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/aggregate-entity-keys/",
    operationId: "apiAggregateEntityKeysForIntegration",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiAggregateEntityKeysForIntegrationResponse,
    ApiAggregateEntityKeysForIntegrationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiAggregateEntityKeysForIntegration(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetIntegrationQueryExecuteAccessPathParams = {
  integrationId: string;
};

export type ApiGetIntegrationQueryExecuteAccessError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetIntegrationQueryExecuteAccessVariables = {
  pathParams: ApiGetIntegrationQueryExecuteAccessPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the query execute access settings for an integration.
 */
export const fetchApiGetIntegrationQueryExecuteAccess = (
  variables: ApiGetIntegrationQueryExecuteAccessVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QueryExecuteAccessOut,
    ApiGetIntegrationQueryExecuteAccessError,
    undefined,
    {},
    {},
    ApiGetIntegrationQueryExecuteAccessPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/query-execute-access/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIntegrationQueryExecuteAccessQueryKey = (
  variables: ApiGetIntegrationQueryExecuteAccessVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/query-execute-access/",
    operationId: "apiGetIntegrationQueryExecuteAccess",
    variables,
  });

/**
 * Get the query execute access settings for an integration.
 */
export const useApiGetIntegrationQueryExecuteAccess = <
  TData = Schemas.QueryExecuteAccessOut,
>(
  variables: ApiGetIntegrationQueryExecuteAccessVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QueryExecuteAccessOut,
      ApiGetIntegrationQueryExecuteAccessError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/query-execute-access/",
    operationId: "apiGetIntegrationQueryExecuteAccess",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QueryExecuteAccessOut,
    ApiGetIntegrationQueryExecuteAccessError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationQueryExecuteAccess(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the query execute access settings for an integration.
 */
export const useSuspenseApiGetIntegrationQueryExecuteAccess = <
  TData = Schemas.QueryExecuteAccessOut,
>(
  variables: ApiGetIntegrationQueryExecuteAccessVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QueryExecuteAccessOut,
      ApiGetIntegrationQueryExecuteAccessError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/query-execute-access/",
    operationId: "apiGetIntegrationQueryExecuteAccess",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QueryExecuteAccessOut,
    ApiGetIntegrationQueryExecuteAccessError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationQueryExecuteAccess(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSetIntegrationQueryExecuteAccessPathParams = {
  integrationId: string;
};

export type ApiSetIntegrationQueryExecuteAccessError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiSetIntegrationQueryExecuteAccessVariables = {
  body: Schemas.QueryExecuteAccessIn;
  pathParams: ApiSetIntegrationQueryExecuteAccessPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Set the query execute access settings for an integration.
 */
export const fetchApiSetIntegrationQueryExecuteAccess = (
  variables: ApiSetIntegrationQueryExecuteAccessVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QueryExecuteAccessOut,
    ApiSetIntegrationQueryExecuteAccessError,
    Schemas.QueryExecuteAccessIn,
    {},
    {},
    ApiSetIntegrationQueryExecuteAccessPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/query-execute-access/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Set the query execute access settings for an integration.
 */
export const useApiSetIntegrationQueryExecuteAccess = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.QueryExecuteAccessOut,
      ApiSetIntegrationQueryExecuteAccessError,
      ApiSetIntegrationQueryExecuteAccessVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.QueryExecuteAccessOut,
    ApiSetIntegrationQueryExecuteAccessError,
    ApiSetIntegrationQueryExecuteAccessVariables
  >({
    mutationFn: (variables: ApiSetIntegrationQueryExecuteAccessVariables) =>
      fetchApiSetIntegrationQueryExecuteAccess({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiGetIntegrationUserCredentialsPathParams = {
  integrationId: string;
};

export type ApiGetIntegrationUserCredentialsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetIntegrationUserCredentialsVariables = {
  pathParams: ApiGetIntegrationUserCredentialsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetIntegrationUserCredentials = (
  variables: ApiGetIntegrationUserCredentialsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.UserIntegrationCredentialsOut,
    ApiGetIntegrationUserCredentialsError,
    undefined,
    {},
    {},
    ApiGetIntegrationUserCredentialsPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/user-credentials/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIntegrationUserCredentialsQueryKey = (
  variables: ApiGetIntegrationUserCredentialsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/user-credentials/",
    operationId: "apiGetIntegrationUserCredentials",
    variables,
  });

export const useApiGetIntegrationUserCredentials = <
  TData = Schemas.UserIntegrationCredentialsOut,
>(
  variables: ApiGetIntegrationUserCredentialsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserIntegrationCredentialsOut,
      ApiGetIntegrationUserCredentialsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/user-credentials/",
    operationId: "apiGetIntegrationUserCredentials",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.UserIntegrationCredentialsOut,
    ApiGetIntegrationUserCredentialsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationUserCredentials(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetIntegrationUserCredentials = <
  TData = Schemas.UserIntegrationCredentialsOut,
>(
  variables: ApiGetIntegrationUserCredentialsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.UserIntegrationCredentialsOut,
      ApiGetIntegrationUserCredentialsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/user-credentials/",
    operationId: "apiGetIntegrationUserCredentials",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.UserIntegrationCredentialsOut,
    ApiGetIntegrationUserCredentialsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationUserCredentials(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSetIntegrationUserCredentialsPathParams = {
  integrationId: string;
};

export type ApiSetIntegrationUserCredentialsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiSetIntegrationUserCredentialsVariables = {
  body: Schemas.UserIntegrationCredentialsIn;
  pathParams: ApiSetIntegrationUserCredentialsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiSetIntegrationUserCredentials = (
  variables: ApiSetIntegrationUserCredentialsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    ApiSetIntegrationUserCredentialsError,
    Schemas.UserIntegrationCredentialsIn,
    {},
    {},
    ApiSetIntegrationUserCredentialsPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/user-credentials/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiSetIntegrationUserCredentials = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      ApiSetIntegrationUserCredentialsError,
      ApiSetIntegrationUserCredentialsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    string,
    ApiSetIntegrationUserCredentialsError,
    ApiSetIntegrationUserCredentialsVariables
  >({
    mutationFn: (variables: ApiSetIntegrationUserCredentialsVariables) =>
      fetchApiSetIntegrationUserCredentials({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiInitiateIntegrationOauthPathParams = {
  integrationId: string;
  integrationType: string;
};

export type ApiInitiateIntegrationOauthQueryParams = {
  return_url?: string | null;
};

export type ApiInitiateIntegrationOauthError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiInitiateIntegrationOauthVariables = {
  pathParams: ApiInitiateIntegrationOauthPathParams;
  queryParams?: ApiInitiateIntegrationOauthQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Initiate OAuth flow for an integration.
 */
export const fetchApiInitiateIntegrationOauth = (
  variables: ApiInitiateIntegrationOauthVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IntegrationOauthInitiateOut,
    ApiInitiateIntegrationOauthError,
    undefined,
    {},
    ApiInitiateIntegrationOauthQueryParams,
    ApiInitiateIntegrationOauthPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/initiate/",
    method: "get",
    ...variables,
    signal,
  });

export const apiInitiateIntegrationOauthQueryKey = (
  variables: ApiInitiateIntegrationOauthVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/initiate/",
    operationId: "apiInitiateIntegrationOauth",
    variables,
  });

/**
 * Initiate OAuth flow for an integration.
 */
export const useApiInitiateIntegrationOauth = <
  TData = Schemas.IntegrationOauthInitiateOut,
>(
  variables: ApiInitiateIntegrationOauthVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IntegrationOauthInitiateOut,
      ApiInitiateIntegrationOauthError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/initiate/",
    operationId: "apiInitiateIntegrationOauth",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.IntegrationOauthInitiateOut,
    ApiInitiateIntegrationOauthError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiInitiateIntegrationOauth(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Initiate OAuth flow for an integration.
 */
export const useSuspenseApiInitiateIntegrationOauth = <
  TData = Schemas.IntegrationOauthInitiateOut,
>(
  variables: ApiInitiateIntegrationOauthVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.IntegrationOauthInitiateOut,
      ApiInitiateIntegrationOauthError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/initiate/",
    operationId: "apiInitiateIntegrationOauth",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.IntegrationOauthInitiateOut,
    ApiInitiateIntegrationOauthError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiInitiateIntegrationOauth(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiIntegrationOauthCallbackPathParams = {
  integrationType: string;
};

export type ApiIntegrationOauthCallbackQueryParams = {
  code: string;
  state: string;
};

export type ApiIntegrationOauthCallbackError = Fetcher.ErrorWrapper<undefined>;

export type ApiIntegrationOauthCallbackVariables = {
  pathParams: ApiIntegrationOauthCallbackPathParams;
  queryParams: ApiIntegrationOauthCallbackQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Handle OAuth callback.
 */
export const fetchApiIntegrationOauthCallback = (
  variables: ApiIntegrationOauthCallbackVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiIntegrationOauthCallbackError,
    undefined,
    {},
    ApiIntegrationOauthCallbackQueryParams,
    ApiIntegrationOauthCallbackPathParams
  >({
    url: "/integration_v2/integrations/{integrationType}/oauth/callback/",
    method: "get",
    ...variables,
    signal,
  });

export const apiIntegrationOauthCallbackQueryKey = (
  variables: ApiIntegrationOauthCallbackVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/{integrationType}/oauth/callback/",
    operationId: "apiIntegrationOauthCallback",
    variables,
  });

/**
 * Handle OAuth callback.
 */
export const useApiIntegrationOauthCallback = <TData = undefined,>(
  variables: ApiIntegrationOauthCallbackVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      ApiIntegrationOauthCallbackError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationType}/oauth/callback/",
    operationId: "apiIntegrationOauthCallback",
    variables,
  });
  const result = reactQuery.useQuery<
    undefined,
    ApiIntegrationOauthCallbackError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationOauthCallback(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Handle OAuth callback.
 */
export const useSuspenseApiIntegrationOauthCallback = <TData = undefined,>(
  variables: ApiIntegrationOauthCallbackVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      undefined,
      ApiIntegrationOauthCallbackError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationType}/oauth/callback/",
    operationId: "apiIntegrationOauthCallback",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    undefined,
    ApiIntegrationOauthCallbackError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationOauthCallback(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiIntegrationOauthStatusPathParams = {
  integrationId: string;
  integrationType: string;
};

export type ApiIntegrationOauthStatusError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiIntegrationOauthStatusVariables = {
  pathParams: ApiIntegrationOauthStatusPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Check whether user has connected OAuth for this integration.
 */
export const fetchApiIntegrationOauthStatus = (
  variables: ApiIntegrationOauthStatusVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IntegrationOauthStatusOut,
    ApiIntegrationOauthStatusError,
    undefined,
    {},
    {},
    ApiIntegrationOauthStatusPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/status/",
    method: "get",
    ...variables,
    signal,
  });

export const apiIntegrationOauthStatusQueryKey = (
  variables: ApiIntegrationOauthStatusVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/status/",
    operationId: "apiIntegrationOauthStatus",
    variables,
  });

/**
 * Check whether user has connected OAuth for this integration.
 */
export const useApiIntegrationOauthStatus = <
  TData = Schemas.IntegrationOauthStatusOut,
>(
  variables: ApiIntegrationOauthStatusVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IntegrationOauthStatusOut,
      ApiIntegrationOauthStatusError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/status/",
    operationId: "apiIntegrationOauthStatus",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.IntegrationOauthStatusOut,
    ApiIntegrationOauthStatusError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationOauthStatus(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Check whether user has connected OAuth for this integration.
 */
export const useSuspenseApiIntegrationOauthStatus = <
  TData = Schemas.IntegrationOauthStatusOut,
>(
  variables: ApiIntegrationOauthStatusVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.IntegrationOauthStatusOut,
      ApiIntegrationOauthStatusError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/status/",
    operationId: "apiIntegrationOauthStatus",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.IntegrationOauthStatusOut,
    ApiIntegrationOauthStatusError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationOauthStatus(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiIntegrationOauthDisconnectPathParams = {
  integrationId: string;
  integrationType: string;
};

export type ApiIntegrationOauthDisconnectError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiIntegrationOauthDisconnectVariables = {
  pathParams: ApiIntegrationOauthDisconnectPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Disconnect user's OAuth connection.
 */
export const fetchApiIntegrationOauthDisconnect = (
  variables: ApiIntegrationOauthDisconnectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    ApiIntegrationOauthDisconnectError,
    undefined,
    {},
    {},
    ApiIntegrationOauthDisconnectPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/disconnect/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Disconnect user's OAuth connection.
 */
export const useApiIntegrationOauthDisconnect = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      ApiIntegrationOauthDisconnectError,
      ApiIntegrationOauthDisconnectVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    string,
    ApiIntegrationOauthDisconnectError,
    ApiIntegrationOauthDisconnectVariables
  >({
    mutationFn: (variables: ApiIntegrationOauthDisconnectVariables) =>
      fetchApiIntegrationOauthDisconnect({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiTestUserCredentialsConnectionPathParams = {
  integrationId: string;
};

export type ApiTestUserCredentialsConnectionError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiTestUserCredentialsConnectionVariables = {
  pathParams: ApiTestUserCredentialsConnectionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiTestUserCredentialsConnection = (
  variables: ApiTestUserCredentialsConnectionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.TestConnectionOut,
    ApiTestUserCredentialsConnectionError,
    undefined,
    {},
    {},
    ApiTestUserCredentialsConnectionPathParams
  >({
    url: "/integration_v2/integrations/{integrationId}/test-user-credentials-connection/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiTestUserCredentialsConnection = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.TestConnectionOut,
      ApiTestUserCredentialsConnectionError,
      ApiTestUserCredentialsConnectionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.TestConnectionOut,
    ApiTestUserCredentialsConnectionError,
    ApiTestUserCredentialsConnectionVariables
  >({
    mutationFn: (variables: ApiTestUserCredentialsConnectionVariables) =>
      fetchApiTestUserCredentialsConnection({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type CheckSlackOauthScopesError = Fetcher.ErrorWrapper<undefined>;

export type CheckSlackOauthScopesVariables = ApiContext["fetcherOptions"];

/**
 * Check if the Slack integration has all required OAuth scopes.
 * Returns information about granted and missing scopes.
 */
export const fetchCheckSlackOauthScopes = (
  variables: CheckSlackOauthScopesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SlackOAuthScopesOut,
    CheckSlackOauthScopesError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/integration_v2/slack/channel/oauth-scopes/",
    method: "get",
    ...variables,
    signal,
  });

export const checkSlackOauthScopesQueryKey = (
  variables: CheckSlackOauthScopesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/slack/channel/oauth-scopes/",
    operationId: "checkSlackOauthScopes",
    variables,
  });

/**
 * Check if the Slack integration has all required OAuth scopes.
 * Returns information about granted and missing scopes.
 */
export const useCheckSlackOauthScopes = <TData = Schemas.SlackOAuthScopesOut,>(
  variables: CheckSlackOauthScopesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SlackOAuthScopesOut,
      CheckSlackOauthScopesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/slack/channel/oauth-scopes/",
    operationId: "checkSlackOauthScopes",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SlackOAuthScopesOut,
    CheckSlackOauthScopesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchCheckSlackOauthScopes({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Check if the Slack integration has all required OAuth scopes.
 * Returns information about granted and missing scopes.
 */
export const useSuspenseCheckSlackOauthScopes = <
  TData = Schemas.SlackOAuthScopesOut,
>(
  variables: CheckSlackOauthScopesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SlackOAuthScopesOut,
      CheckSlackOauthScopesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/slack/channel/oauth-scopes/",
    operationId: "checkSlackOauthScopes",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SlackOAuthScopesOut,
    CheckSlackOauthScopesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchCheckSlackOauthScopes({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetSlackConversationsQueryParams = {
  /**
   * @default false
   */
  refresh?: boolean | null;
};

export type GetSlackConversationsError = Fetcher.ErrorWrapper<undefined>;

export type GetSlackConversationsResponse = Schemas.SlackConverstationOut[];

export type GetSlackConversationsVariables = {
  queryParams?: GetSlackConversationsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get all channels in a Slack team
 */
export const fetchGetSlackConversations = (
  variables: GetSlackConversationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetSlackConversationsResponse,
    GetSlackConversationsError,
    undefined,
    {},
    GetSlackConversationsQueryParams,
    {}
  >({
    url: "/integration_v2/slack/channel/conversations/",
    method: "get",
    ...variables,
    signal,
  });

export const getSlackConversationsQueryKey = (
  variables: GetSlackConversationsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/slack/channel/conversations/",
    operationId: "getSlackConversations",
    variables,
  });

/**
 * Get all channels in a Slack team
 */
export const useGetSlackConversations = <
  TData = GetSlackConversationsResponse,
>(
  variables: GetSlackConversationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetSlackConversationsResponse,
      GetSlackConversationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/slack/channel/conversations/",
    operationId: "getSlackConversations",
    variables,
  });
  const result = reactQuery.useQuery<
    GetSlackConversationsResponse,
    GetSlackConversationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSlackConversations({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all channels in a Slack team
 */
export const useSuspenseGetSlackConversations = <
  TData = GetSlackConversationsResponse,
>(
  variables: GetSlackConversationsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetSlackConversationsResponse,
      GetSlackConversationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/slack/channel/conversations/",
    operationId: "getSlackConversations",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetSlackConversationsResponse,
    GetSlackConversationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSlackConversations({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetSlackConversationFromIdPathParams = {
  channelId: string;
};

export type GetSlackConversationFromIdError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type GetSlackConversationFromIdVariables = {
  pathParams: GetSlackConversationFromIdPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a single channel in a Slack team from the channel ID
 */
export const fetchGetSlackConversationFromId = (
  variables: GetSlackConversationFromIdVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SlackConverstationOut,
    GetSlackConversationFromIdError,
    undefined,
    {},
    {},
    GetSlackConversationFromIdPathParams
  >({
    url: "/integration_v2/slack/channel/conversation/{channelId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getSlackConversationFromIdQueryKey = (
  variables: GetSlackConversationFromIdVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/slack/channel/conversation/{channelId}/",
    operationId: "getSlackConversationFromId",
    variables,
  });

/**
 * Get a single channel in a Slack team from the channel ID
 */
export const useGetSlackConversationFromId = <
  TData = Schemas.SlackConverstationOut,
>(
  variables: GetSlackConversationFromIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SlackConverstationOut,
      GetSlackConversationFromIdError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/slack/channel/conversation/{channelId}/",
    operationId: "getSlackConversationFromId",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SlackConverstationOut,
    GetSlackConversationFromIdError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSlackConversationFromId(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a single channel in a Slack team from the channel ID
 */
export const useSuspenseGetSlackConversationFromId = <
  TData = Schemas.SlackConverstationOut,
>(
  variables: GetSlackConversationFromIdVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SlackConverstationOut,
      GetSlackConversationFromIdError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/slack/channel/conversation/{channelId}/",
    operationId: "getSlackConversationFromId",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SlackConverstationOut,
    GetSlackConversationFromIdError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSlackConversationFromId(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetSlackChannelsError = Fetcher.ErrorWrapper<undefined>;

export type GetSlackChannelsVariables = ApiContext["fetcherOptions"];

/**
 * Get all slack channels
 */
export const fetchGetSlackChannels = (
  variables: GetSlackChannelsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ChannelListOut,
    GetSlackChannelsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/integration_v2/slack/channel/",
    method: "get",
    ...variables,
    signal,
  });

export const getSlackChannelsQueryKey = (
  variables: GetSlackChannelsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/slack/channel/",
    operationId: "getSlackChannels",
    variables,
  });

/**
 * Get all slack channels
 */
export const useGetSlackChannels = <TData = Schemas.ChannelListOut,>(
  variables: GetSlackChannelsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ChannelListOut,
      GetSlackChannelsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/slack/channel/",
    operationId: "getSlackChannels",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ChannelListOut,
    GetSlackChannelsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSlackChannels({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all slack channels
 */
export const useSuspenseGetSlackChannels = <TData = Schemas.ChannelListOut,>(
  variables: GetSlackChannelsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ChannelListOut,
      GetSlackChannelsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/slack/channel/",
    operationId: "getSlackChannels",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ChannelListOut,
    GetSlackChannelsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSlackChannels({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CreateSlackChannelError = Fetcher.ErrorWrapper<undefined>;

export type CreateSlackChannelVariables = {
  body: Schemas.SlackChannelIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a slack channel
 */
export const fetchCreateSlackChannel = (
  variables: CreateSlackChannelVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    CreateSlackChannelError,
    Schemas.SlackChannelIn,
    {},
    {},
    {}
  >({
    url: "/integration_v2/slack/channel/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create a slack channel
 */
export const useCreateSlackChannel = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CreateSlackChannelError,
      CreateSlackChannelVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    CreateSlackChannelError,
    CreateSlackChannelVariables
  >({
    mutationFn: (variables: CreateSlackChannelVariables) =>
      fetchCreateSlackChannel({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateSlackChannelPathParams = {
  channelId: string;
};

export type UpdateSlackChannelError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: string;
}>;

export type UpdateSlackChannelResponse = {
  [key: string]: any;
};

export type UpdateSlackChannelVariables = {
  body: Schemas.SlackChannelIn;
  pathParams: UpdateSlackChannelPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update a slack channel
 */
export const fetchUpdateSlackChannel = (
  variables: UpdateSlackChannelVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    UpdateSlackChannelResponse,
    UpdateSlackChannelError,
    Schemas.SlackChannelIn,
    {},
    {},
    UpdateSlackChannelPathParams
  >({
    url: "/integration_v2/slack/channel/{channelId}/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update a slack channel
 */
export const useUpdateSlackChannel = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      UpdateSlackChannelResponse,
      UpdateSlackChannelError,
      UpdateSlackChannelVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    UpdateSlackChannelResponse,
    UpdateSlackChannelError,
    UpdateSlackChannelVariables
  >({
    mutationFn: (variables: UpdateSlackChannelVariables) =>
      fetchUpdateSlackChannel({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteSlackChannelPathParams = {
  channelId: string;
};

export type DeleteSlackChannelError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: string;
}>;

export type DeleteSlackChannelResponse = {
  [key: string]: any;
};

export type DeleteSlackChannelVariables = {
  pathParams: DeleteSlackChannelPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete a slack channel
 */
export const fetchDeleteSlackChannel = (
  variables: DeleteSlackChannelVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    DeleteSlackChannelResponse,
    DeleteSlackChannelError,
    undefined,
    {},
    {},
    DeleteSlackChannelPathParams
  >({
    url: "/integration_v2/slack/channel/delete/{channelId}/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Delete a slack channel
 */
export const useDeleteSlackChannel = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      DeleteSlackChannelResponse,
      DeleteSlackChannelError,
      DeleteSlackChannelVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    DeleteSlackChannelResponse,
    DeleteSlackChannelError,
    DeleteSlackChannelVariables
  >({
    mutationFn: (variables: DeleteSlackChannelVariables) =>
      fetchDeleteSlackChannel({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiIntegrationShowRolesPathParams = {
  integrationId: string;
};

export type ApiIntegrationShowRolesError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApiIntegrationShowRolesVariables = {
  pathParams: ApiIntegrationShowRolesPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get all available roles in the external system
 */
export const fetchApiIntegrationShowRoles = (
  variables: ApiIntegrationShowRolesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GrantResultRoleSchema,
    ApiIntegrationShowRolesError,
    undefined,
    {},
    {},
    ApiIntegrationShowRolesPathParams
  >({
    url: "/integration_v2/data-access-management/{integrationId}/roles/",
    method: "get",
    ...variables,
    signal,
  });

export const apiIntegrationShowRolesQueryKey = (
  variables: ApiIntegrationShowRolesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/roles/",
    operationId: "apiIntegrationShowRoles",
    variables,
  });

/**
 * Get all available roles in the external system
 */
export const useApiIntegrationShowRoles = <
  TData = Schemas.GrantResultRoleSchema,
>(
  variables: ApiIntegrationShowRolesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GrantResultRoleSchema,
      ApiIntegrationShowRolesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/roles/",
    operationId: "apiIntegrationShowRoles",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.GrantResultRoleSchema,
    ApiIntegrationShowRolesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationShowRoles({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all available roles in the external system
 */
export const useSuspenseApiIntegrationShowRoles = <
  TData = Schemas.GrantResultRoleSchema,
>(
  variables: ApiIntegrationShowRolesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.GrantResultRoleSchema,
      ApiIntegrationShowRolesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/roles/",
    operationId: "apiIntegrationShowRoles",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.GrantResultRoleSchema,
    ApiIntegrationShowRolesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationShowRoles({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiIntegrationShowUsersPathParams = {
  integrationId: string;
};

export type ApiIntegrationShowUsersError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApiIntegrationShowUsersVariables = {
  pathParams: ApiIntegrationShowUsersPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get all users and their associated roles
 */
export const fetchApiIntegrationShowUsers = (
  variables: ApiIntegrationShowUsersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GrantResultUserSchema,
    ApiIntegrationShowUsersError,
    undefined,
    {},
    {},
    ApiIntegrationShowUsersPathParams
  >({
    url: "/integration_v2/data-access-management/{integrationId}/users/",
    method: "get",
    ...variables,
    signal,
  });

export const apiIntegrationShowUsersQueryKey = (
  variables: ApiIntegrationShowUsersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/users/",
    operationId: "apiIntegrationShowUsers",
    variables,
  });

/**
 * Get all users and their associated roles
 */
export const useApiIntegrationShowUsers = <
  TData = Schemas.GrantResultUserSchema,
>(
  variables: ApiIntegrationShowUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GrantResultUserSchema,
      ApiIntegrationShowUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/users/",
    operationId: "apiIntegrationShowUsers",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.GrantResultUserSchema,
    ApiIntegrationShowUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationShowUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all users and their associated roles
 */
export const useSuspenseApiIntegrationShowUsers = <
  TData = Schemas.GrantResultUserSchema,
>(
  variables: ApiIntegrationShowUsersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.GrantResultUserSchema,
      ApiIntegrationShowUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/users/",
    operationId: "apiIntegrationShowUsers",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.GrantResultUserSchema,
    ApiIntegrationShowUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationShowUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiIntegrationShowGrantsToSingleUserPathParams = {
  integrationId: string;
};

export type ApiIntegrationShowGrantsToSingleUserQueryParams = {
  username: string;
};

export type ApiIntegrationShowGrantsToSingleUserError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApiIntegrationShowGrantsToSingleUserVariables = {
  pathParams: ApiIntegrationShowGrantsToSingleUserPathParams;
  queryParams: ApiIntegrationShowGrantsToSingleUserQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get all roles assigned to a specific user
 */
export const fetchApiIntegrationShowGrantsToSingleUser = (
  variables: ApiIntegrationShowGrantsToSingleUserVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GrantResultGrantToUserSchema,
    ApiIntegrationShowGrantsToSingleUserError,
    undefined,
    {},
    ApiIntegrationShowGrantsToSingleUserQueryParams,
    ApiIntegrationShowGrantsToSingleUserPathParams
  >({
    url: "/integration_v2/data-access-management/{integrationId}/user-roles/",
    method: "get",
    ...variables,
    signal,
  });

export const apiIntegrationShowGrantsToSingleUserQueryKey = (
  variables: ApiIntegrationShowGrantsToSingleUserVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/user-roles/",
    operationId: "apiIntegrationShowGrantsToSingleUser",
    variables,
  });

/**
 * Get all roles assigned to a specific user
 */
export const useApiIntegrationShowGrantsToSingleUser = <
  TData = Schemas.GrantResultGrantToUserSchema,
>(
  variables: ApiIntegrationShowGrantsToSingleUserVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GrantResultGrantToUserSchema,
      ApiIntegrationShowGrantsToSingleUserError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/user-roles/",
    operationId: "apiIntegrationShowGrantsToSingleUser",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.GrantResultGrantToUserSchema,
    ApiIntegrationShowGrantsToSingleUserError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationShowGrantsToSingleUser(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all roles assigned to a specific user
 */
export const useSuspenseApiIntegrationShowGrantsToSingleUser = <
  TData = Schemas.GrantResultGrantToUserSchema,
>(
  variables: ApiIntegrationShowGrantsToSingleUserVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.GrantResultGrantToUserSchema,
      ApiIntegrationShowGrantsToSingleUserError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/user-roles/",
    operationId: "apiIntegrationShowGrantsToSingleUser",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.GrantResultGrantToUserSchema,
    ApiIntegrationShowGrantsToSingleUserError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationShowGrantsToSingleUser(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiIntegrationShowGrantsToRoleForResourcePathParams = {
  integrationId: string;
};

export type ApiIntegrationShowGrantsToRoleForResourceQueryParams = {
  database_name: string;
  schema_name: string | null;
  table_name: string | null;
};

export type ApiIntegrationShowGrantsToRoleForResourceError =
  Fetcher.ErrorWrapper<{
    status: 403;
    payload: string;
  }>;

export type ApiIntegrationShowGrantsToRoleForResourceVariables = {
  pathParams: ApiIntegrationShowGrantsToRoleForResourcePathParams;
  queryParams: ApiIntegrationShowGrantsToRoleForResourceQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get all roles that have a specific privilege
 */
export const fetchApiIntegrationShowGrantsToRoleForResource = (
  variables: ApiIntegrationShowGrantsToRoleForResourceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GrantResultGrantToRoleSchema,
    ApiIntegrationShowGrantsToRoleForResourceError,
    undefined,
    {},
    ApiIntegrationShowGrantsToRoleForResourceQueryParams,
    ApiIntegrationShowGrantsToRoleForResourcePathParams
  >({
    url: "/integration_v2/data-access-management/{integrationId}/roles-with-privilege/",
    method: "get",
    ...variables,
    signal,
  });

export const apiIntegrationShowGrantsToRoleForResourceQueryKey = (
  variables: ApiIntegrationShowGrantsToRoleForResourceVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/roles-with-privilege/",
    operationId: "apiIntegrationShowGrantsToRoleForResource",
    variables,
  });

/**
 * Get all roles that have a specific privilege
 */
export const useApiIntegrationShowGrantsToRoleForResource = <
  TData = Schemas.GrantResultGrantToRoleSchema,
>(
  variables: ApiIntegrationShowGrantsToRoleForResourceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GrantResultGrantToRoleSchema,
      ApiIntegrationShowGrantsToRoleForResourceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/roles-with-privilege/",
    operationId: "apiIntegrationShowGrantsToRoleForResource",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.GrantResultGrantToRoleSchema,
    ApiIntegrationShowGrantsToRoleForResourceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationShowGrantsToRoleForResource(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all roles that have a specific privilege
 */
export const useSuspenseApiIntegrationShowGrantsToRoleForResource = <
  TData = Schemas.GrantResultGrantToRoleSchema,
>(
  variables: ApiIntegrationShowGrantsToRoleForResourceVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.GrantResultGrantToRoleSchema,
      ApiIntegrationShowGrantsToRoleForResourceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-management/{integrationId}/roles-with-privilege/",
    operationId: "apiIntegrationShowGrantsToRoleForResource",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.GrantResultGrantToRoleSchema,
    ApiIntegrationShowGrantsToRoleForResourceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiIntegrationShowGrantsToRoleForResource(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiIntegrationGrantRolePathParams = {
  integrationId: string;
};

export type ApiIntegrationGrantRoleError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApiIntegrationGrantRoleVariables = {
  body: Schemas.GrantRoleSchema;
  pathParams: ApiIntegrationGrantRolePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Grant a role to a user
 */
export const fetchApiIntegrationGrantRole = (
  variables: ApiIntegrationGrantRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    boolean,
    ApiIntegrationGrantRoleError,
    Schemas.GrantRoleSchema,
    {},
    {},
    ApiIntegrationGrantRolePathParams
  >({
    url: "/integration_v2/data-access-management/{integrationId}/grant-role/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Grant a role to a user
 */
export const useApiIntegrationGrantRole = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      boolean,
      ApiIntegrationGrantRoleError,
      ApiIntegrationGrantRoleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    boolean,
    ApiIntegrationGrantRoleError,
    ApiIntegrationGrantRoleVariables
  >({
    mutationFn: (variables: ApiIntegrationGrantRoleVariables) =>
      fetchApiIntegrationGrantRole({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiIntegrationGrantPrivilegesPathParams = {
  integrationId: string;
};

export type ApiIntegrationGrantPrivilegesError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApiIntegrationGrantPrivilegesVariables = {
  body: Schemas.GrantPrivilegesSchema;
  pathParams: ApiIntegrationGrantPrivilegesPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Grant privileges to a role
 */
export const fetchApiIntegrationGrantPrivileges = (
  variables: ApiIntegrationGrantPrivilegesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    boolean,
    ApiIntegrationGrantPrivilegesError,
    Schemas.GrantPrivilegesSchema,
    {},
    {},
    ApiIntegrationGrantPrivilegesPathParams
  >({
    url: "/integration_v2/data-access-management/{integrationId}/grant-privileges/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Grant privileges to a role
 */
export const useApiIntegrationGrantPrivileges = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      boolean,
      ApiIntegrationGrantPrivilegesError,
      ApiIntegrationGrantPrivilegesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    boolean,
    ApiIntegrationGrantPrivilegesError,
    ApiIntegrationGrantPrivilegesVariables
  >({
    mutationFn: (variables: ApiIntegrationGrantPrivilegesVariables) =>
      fetchApiIntegrationGrantPrivileges({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateAccessRequestError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type CreateAccessRequestVariables = {
  body: Schemas.DataAccessRequestCreateIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a new data access request
 */
export const fetchCreateAccessRequest = (
  variables: CreateAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestOut,
    CreateAccessRequestError,
    Schemas.DataAccessRequestCreateIn,
    {},
    {},
    {}
  >({
    url: "/integration_v2/data-access-requests/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create a new data access request
 */
export const useCreateAccessRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DataAccessRequestOut,
      CreateAccessRequestError,
      CreateAccessRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DataAccessRequestOut,
    CreateAccessRequestError,
    CreateAccessRequestVariables
  >({
    mutationFn: (variables: CreateAccessRequestVariables) =>
      fetchCreateAccessRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListAccessRequestsQueryParams = {
  status?: Schemas.DataAccessRequestStatus | null;
  integration_id?: string | null;
  created_by?: string | null;
  sort?: string | null;
  filter?: string | null;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ListAccessRequestsError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ListAccessRequestsVariables = {
  queryParams?: ListAccessRequestsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List data access requests with optional filters
 */
export const fetchListAccessRequests = (
  variables: ListAccessRequestsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedDataAccessRequestOut,
    ListAccessRequestsError,
    undefined,
    {},
    ListAccessRequestsQueryParams,
    {}
  >({
    url: "/integration_v2/data-access-requests/",
    method: "get",
    ...variables,
    signal,
  });

export const listAccessRequestsQueryKey = (
  variables: ListAccessRequestsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access-requests/",
    operationId: "listAccessRequests",
    variables,
  });

/**
 * List data access requests with optional filters
 */
export const useListAccessRequests = <
  TData = Schemas.PagedDataAccessRequestOut,
>(
  variables: ListAccessRequestsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedDataAccessRequestOut,
      ListAccessRequestsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-requests/",
    operationId: "listAccessRequests",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedDataAccessRequestOut,
    ListAccessRequestsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListAccessRequests({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List data access requests with optional filters
 */
export const useSuspenseListAccessRequests = <
  TData = Schemas.PagedDataAccessRequestOut,
>(
  variables: ListAccessRequestsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedDataAccessRequestOut,
      ListAccessRequestsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-requests/",
    operationId: "listAccessRequests",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedDataAccessRequestOut,
    ListAccessRequestsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListAccessRequests({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CountPendingRequestsError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type CountPendingRequestsVariables = ApiContext["fetcherOptions"];

/**
 * Get the count of pending data access requests in the workspace
 */
export const fetchCountPendingRequests = (
  variables: CountPendingRequestsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<number, CountPendingRequestsError, undefined, {}, {}, {}>({
    url: "/integration_v2/data-access-requests/pending-count/",
    method: "get",
    ...variables,
    signal,
  });

export const countPendingRequestsQueryKey = (
  variables: CountPendingRequestsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access-requests/pending-count/",
    operationId: "countPendingRequests",
    variables,
  });

/**
 * Get the count of pending data access requests in the workspace
 */
export const useCountPendingRequests = <TData = number,>(
  variables: CountPendingRequestsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<number, CountPendingRequestsError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-requests/pending-count/",
    operationId: "countPendingRequests",
    variables,
  });
  const result = reactQuery.useQuery<number, CountPendingRequestsError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchCountPendingRequests({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the count of pending data access requests in the workspace
 */
export const useSuspenseCountPendingRequests = <TData = number,>(
  variables: CountPendingRequestsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      number,
      CountPendingRequestsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-requests/pending-count/",
    operationId: "countPendingRequests",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    number,
    CountPendingRequestsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchCountPendingRequests({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApproveAccessRequestPathParams = {
  requestId: string;
};

export type ApproveAccessRequestError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApproveAccessRequestVariables = {
  body: Schemas.DataAccessRequestApproveSchema;
  pathParams: ApproveAccessRequestPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Approve a data access request
 */
export const fetchApproveAccessRequest = (
  variables: ApproveAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestOut,
    ApproveAccessRequestError,
    Schemas.DataAccessRequestApproveSchema,
    {},
    {},
    ApproveAccessRequestPathParams
  >({
    url: "/integration_v2/data-access-requests/{requestId}/approve/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Approve a data access request
 */
export const useApproveAccessRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DataAccessRequestOut,
      ApproveAccessRequestError,
      ApproveAccessRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DataAccessRequestOut,
    ApproveAccessRequestError,
    ApproveAccessRequestVariables
  >({
    mutationFn: (variables: ApproveAccessRequestVariables) =>
      fetchApproveAccessRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RejectAccessRequestPathParams = {
  requestId: string;
};

export type RejectAccessRequestError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type RejectAccessRequestVariables = {
  body: Schemas.DataAccessRequestRejectSchema;
  pathParams: RejectAccessRequestPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Reject a data access request
 */
export const fetchRejectAccessRequest = (
  variables: RejectAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestOut,
    RejectAccessRequestError,
    Schemas.DataAccessRequestRejectSchema,
    {},
    {},
    RejectAccessRequestPathParams
  >({
    url: "/integration_v2/data-access-requests/{requestId}/reject/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Reject a data access request
 */
export const useRejectAccessRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DataAccessRequestOut,
      RejectAccessRequestError,
      RejectAccessRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DataAccessRequestOut,
    RejectAccessRequestError,
    RejectAccessRequestVariables
  >({
    mutationFn: (variables: RejectAccessRequestVariables) =>
      fetchRejectAccessRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateAccessRequestPathParams = {
  requestId: string;
};

export type UpdateAccessRequestError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type UpdateAccessRequestVariables = {
  body: Schemas.DataAccessRequestUpdateSchema;
  pathParams: UpdateAccessRequestPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update specific fields of a pending access request
 */
export const fetchUpdateAccessRequest = (
  variables: UpdateAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestOut,
    UpdateAccessRequestError,
    Schemas.DataAccessRequestUpdateSchema,
    {},
    {},
    UpdateAccessRequestPathParams
  >({
    url: "/integration_v2/data-access-requests/{requestId}/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update specific fields of a pending access request
 */
export const useUpdateAccessRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DataAccessRequestOut,
      UpdateAccessRequestError,
      UpdateAccessRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DataAccessRequestOut,
    UpdateAccessRequestError,
    UpdateAccessRequestVariables
  >({
    mutationFn: (variables: UpdateAccessRequestVariables) =>
      fetchUpdateAccessRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteAccessRequestPathParams = {
  requestId: string;
};

export type DeleteAccessRequestError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type DeleteAccessRequestVariables = {
  pathParams: DeleteAccessRequestPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete a data access request
 */
export const fetchDeleteAccessRequest = (
  variables: DeleteAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DeleteAccessRequestError,
    undefined,
    {},
    {},
    DeleteAccessRequestPathParams
  >({
    url: "/integration_v2/data-access-requests/{requestId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete a data access request
 */
export const useDeleteAccessRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteAccessRequestError,
      DeleteAccessRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteAccessRequestError,
    DeleteAccessRequestVariables
  >({
    mutationFn: (variables: DeleteAccessRequestVariables) =>
      fetchDeleteAccessRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAccessRequestPathParams = {
  requestId: string;
};

export type GetAccessRequestError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type GetAccessRequestVariables = {
  pathParams: GetAccessRequestPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a specific data access request
 */
export const fetchGetAccessRequest = (
  variables: GetAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestOut,
    GetAccessRequestError,
    undefined,
    {},
    {},
    GetAccessRequestPathParams
  >({
    url: "/integration_v2/data-access-requests/{requestId}/",
    method: "get",
    ...variables,
    signal,
  });

export const getAccessRequestQueryKey = (
  variables: GetAccessRequestVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access-requests/{requestId}/",
    operationId: "getAccessRequest",
    variables,
  });

/**
 * Get a specific data access request
 */
export const useGetAccessRequest = <TData = Schemas.DataAccessRequestOut,>(
  variables: GetAccessRequestVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DataAccessRequestOut,
      GetAccessRequestError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-requests/{requestId}/",
    operationId: "getAccessRequest",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DataAccessRequestOut,
    GetAccessRequestError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAccessRequest({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a specific data access request
 */
export const useSuspenseGetAccessRequest = <
  TData = Schemas.DataAccessRequestOut,
>(
  variables: GetAccessRequestVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DataAccessRequestOut,
      GetAccessRequestError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access-requests/{requestId}/",
    operationId: "getAccessRequest",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DataAccessRequestOut,
    GetAccessRequestError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAccessRequest({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetAccessRequestCredentialsPathParams = {
  requestId: string;
};

export type GetAccessRequestCredentialsError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type GetAccessRequestCredentialsVariables = {
  pathParams: GetAccessRequestCredentialsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a specific data access request credentials
 */
export const fetchGetAccessRequestCredentials = (
  variables: GetAccessRequestCredentialsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestOut,
    GetAccessRequestCredentialsError,
    undefined,
    {},
    {},
    GetAccessRequestCredentialsPathParams
  >({
    url: "/integration_v2/data-access-requests/{requestId}/credentials/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Get a specific data access request credentials
 */
export const useGetAccessRequestCredentials = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DataAccessRequestOut,
      GetAccessRequestCredentialsError,
      GetAccessRequestCredentialsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DataAccessRequestOut,
    GetAccessRequestCredentialsError,
    GetAccessRequestCredentialsVariables
  >({
    mutationFn: (variables: GetAccessRequestCredentialsVariables) =>
      fetchGetAccessRequestCredentials({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CancelAccessRequestPathParams = {
  requestId: string;
};

export type CancelAccessRequestError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type CancelAccessRequestVariables = {
  body: Schemas.DataAccessRequestCancelSchema;
  pathParams: CancelAccessRequestPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Cancel a data access request and revert any granted permissions
 */
export const fetchCancelAccessRequest = (
  variables: CancelAccessRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestOut,
    CancelAccessRequestError,
    Schemas.DataAccessRequestCancelSchema,
    {},
    {},
    CancelAccessRequestPathParams
  >({
    url: "/integration_v2/data-access-requests/{requestId}/cancel/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Cancel a data access request and revert any granted permissions
 */
export const useCancelAccessRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DataAccessRequestOut,
      CancelAccessRequestError,
      CancelAccessRequestVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DataAccessRequestOut,
    CancelAccessRequestError,
    CancelAccessRequestVariables
  >({
    mutationFn: (variables: CancelAccessRequestVariables) =>
      fetchCancelAccessRequest({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetDataAccessRequestMetricsQueryParams = {
  workspace_id: string;
  /**
   * @default all
   */
  filter_type?: "all" | "created" | "assigned";
  user_id?: string | null;
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * @default false
   */
  current_state_only?: boolean;
};

export type ApiGetDataAccessRequestMetricsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetDataAccessRequestMetricsVariables = {
  queryParams: ApiGetDataAccessRequestMetricsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get metrics for data access requests in a workspace
 */
export const fetchApiGetDataAccessRequestMetrics = (
  variables: ApiGetDataAccessRequestMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestMetrics,
    ApiGetDataAccessRequestMetricsError,
    undefined,
    {},
    ApiGetDataAccessRequestMetricsQueryParams,
    {}
  >({
    url: "/integration_v2/data-access/metrics/metrics/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetDataAccessRequestMetricsQueryKey = (
  variables: ApiGetDataAccessRequestMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access/metrics/metrics/",
    operationId: "apiGetDataAccessRequestMetrics",
    variables,
  });

/**
 * Get metrics for data access requests in a workspace
 */
export const useApiGetDataAccessRequestMetrics = <
  TData = Schemas.DataAccessRequestMetrics,
>(
  variables: ApiGetDataAccessRequestMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DataAccessRequestMetrics,
      ApiGetDataAccessRequestMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access/metrics/metrics/",
    operationId: "apiGetDataAccessRequestMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DataAccessRequestMetrics,
    ApiGetDataAccessRequestMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetDataAccessRequestMetrics(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get metrics for data access requests in a workspace
 */
export const useSuspenseApiGetDataAccessRequestMetrics = <
  TData = Schemas.DataAccessRequestMetrics,
>(
  variables: ApiGetDataAccessRequestMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DataAccessRequestMetrics,
      ApiGetDataAccessRequestMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access/metrics/metrics/",
    operationId: "apiGetDataAccessRequestMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DataAccessRequestMetrics,
    ApiGetDataAccessRequestMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetDataAccessRequestMetrics(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetDataAccessRequestTimeseriesQueryParams = {
  workspace_id: string;
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * @default all
   */
  filter_type?: "all" | "created" | "assigned";
  user_id?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
};

export type ApiGetDataAccessRequestTimeseriesError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetDataAccessRequestTimeseriesVariables = {
  queryParams: ApiGetDataAccessRequestTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get timeseries data for data access requests in a workspace
 */
export const fetchApiGetDataAccessRequestTimeseries = (
  variables: ApiGetDataAccessRequestTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataAccessRequestTimeSeries,
    ApiGetDataAccessRequestTimeseriesError,
    undefined,
    {},
    ApiGetDataAccessRequestTimeseriesQueryParams,
    {}
  >({
    url: "/integration_v2/data-access/metrics/timeseries/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetDataAccessRequestTimeseriesQueryKey = (
  variables: ApiGetDataAccessRequestTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/data-access/metrics/timeseries/",
    operationId: "apiGetDataAccessRequestTimeseries",
    variables,
  });

/**
 * Get timeseries data for data access requests in a workspace
 */
export const useApiGetDataAccessRequestTimeseries = <
  TData = Schemas.DataAccessRequestTimeSeries,
>(
  variables: ApiGetDataAccessRequestTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DataAccessRequestTimeSeries,
      ApiGetDataAccessRequestTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access/metrics/timeseries/",
    operationId: "apiGetDataAccessRequestTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DataAccessRequestTimeSeries,
    ApiGetDataAccessRequestTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetDataAccessRequestTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get timeseries data for data access requests in a workspace
 */
export const useSuspenseApiGetDataAccessRequestTimeseries = <
  TData = Schemas.DataAccessRequestTimeSeries,
>(
  variables: ApiGetDataAccessRequestTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DataAccessRequestTimeSeries,
      ApiGetDataAccessRequestTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/data-access/metrics/timeseries/",
    operationId: "apiGetDataAccessRequestTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DataAccessRequestTimeSeries,
    ApiGetDataAccessRequestTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetDataAccessRequestTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetIntegrationTimeseriesQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  integration_id?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
};

export type ApiGetIntegrationTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetIntegrationTimeseriesVariables = {
  queryParams?: ApiGetIntegrationTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get timeseries data for integrations in a workspace
 */
export const fetchApiGetIntegrationTimeseries = (
  variables: ApiGetIntegrationTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IntegrationTimeSeries,
    ApiGetIntegrationTimeseriesError,
    undefined,
    {},
    ApiGetIntegrationTimeseriesQueryParams,
    {}
  >({
    url: "/integration_v2/metrics/timeseries/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIntegrationTimeseriesQueryKey = (
  variables: ApiGetIntegrationTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/metrics/timeseries/",
    operationId: "apiGetIntegrationTimeseries",
    variables,
  });

/**
 * Get timeseries data for integrations in a workspace
 */
export const useApiGetIntegrationTimeseries = <
  TData = Schemas.IntegrationTimeSeries,
>(
  variables: ApiGetIntegrationTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IntegrationTimeSeries,
      ApiGetIntegrationTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/metrics/timeseries/",
    operationId: "apiGetIntegrationTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.IntegrationTimeSeries,
    ApiGetIntegrationTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get timeseries data for integrations in a workspace
 */
export const useSuspenseApiGetIntegrationTimeseries = <
  TData = Schemas.IntegrationTimeSeries,
>(
  variables: ApiGetIntegrationTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.IntegrationTimeSeries,
      ApiGetIntegrationTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/metrics/timeseries/",
    operationId: "apiGetIntegrationTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.IntegrationTimeSeries,
    ApiGetIntegrationTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntegrationTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetIncludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetIncludedFiltersVariables = ApiContext["fetcherOptions"];

/**
 * Get included filters for Glean push.
 */
export const fetchApiGetIncludedFilters = (
  variables: ApiGetIncludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CatalogRule,
    ApiGetIncludedFiltersError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/integration_v2/glean-preferences/included/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIncludedFiltersQueryKey = (
  variables: ApiGetIncludedFiltersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration_v2/glean-preferences/included/",
    operationId: "apiGetIncludedFilters",
    variables,
  });

/**
 * Get included filters for Glean push.
 */
export const useApiGetIncludedFilters = <TData = Schemas.CatalogRule,>(
  variables: ApiGetIncludedFiltersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CatalogRule,
      ApiGetIncludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/glean-preferences/included/",
    operationId: "apiGetIncludedFilters",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CatalogRule,
    ApiGetIncludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIncludedFilters({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get included filters for Glean push.
 */
export const useSuspenseApiGetIncludedFilters = <TData = Schemas.CatalogRule,>(
  variables: ApiGetIncludedFiltersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CatalogRule,
      ApiGetIncludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration_v2/glean-preferences/included/",
    operationId: "apiGetIncludedFilters",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CatalogRule,
    ApiGetIncludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIncludedFilters({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSetIncludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type ApiSetIncludedFiltersVariables = {
  body: Schemas.CatalogRule;
} & ApiContext["fetcherOptions"];

/**
 * Set included filters for Glean push.
 */
export const fetchApiSetIncludedFilters = (
  variables: ApiSetIncludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiSetIncludedFiltersError,
    Schemas.CatalogRule,
    {},
    {},
    {}
  >({
    url: "/integration_v2/glean-preferences/included/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Set included filters for Glean push.
 */
export const useApiSetIncludedFilters = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiSetIncludedFiltersError,
      ApiSetIncludedFiltersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiSetIncludedFiltersError,
    ApiSetIncludedFiltersVariables
  >({
    mutationFn: (variables: ApiSetIncludedFiltersVariables) =>
      fetchApiSetIncludedFilters({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPostIntegrationRunLogsPathParams = {
  integrationId: string;
};

export type ApiPostIntegrationRunLogsQueryParams = {
  type?: string | null;
};

export type ApiPostIntegrationRunLogsError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApiPostIntegrationRunLogsRequestBody = {
  [key: string]: any;
};

export type ApiPostIntegrationRunLogsVariables = {
  body?: ApiPostIntegrationRunLogsRequestBody;
  pathParams: ApiPostIntegrationRunLogsPathParams;
  queryParams?: ApiPostIntegrationRunLogsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiPostIntegrationRunLogs = (
  variables: ApiPostIntegrationRunLogsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiPostIntegrationRunLogsError,
    ApiPostIntegrationRunLogsRequestBody,
    {},
    ApiPostIntegrationRunLogsQueryParams,
    ApiPostIntegrationRunLogsPathParams
  >({
    url: "/integration/run_logs/{integrationId}/ingest/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiPostIntegrationRunLogs = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPostIntegrationRunLogsError,
      ApiPostIntegrationRunLogsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiPostIntegrationRunLogsError,
    ApiPostIntegrationRunLogsVariables
  >({
    mutationFn: (variables: ApiPostIntegrationRunLogsVariables) =>
      fetchApiPostIntegrationRunLogs({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUploadDbtArtifactsPathParams = {
  integrationId: string;
};

export type ApiUploadDbtArtifactsError = Fetcher.ErrorWrapper<undefined>;

export type ApiUploadDbtArtifactsRequestBody = {
  /**
   * @format binary
   */
  run_results: Blob;
  /**
   * @format binary
   */
  manifest: Blob;
};

export type ApiUploadDbtArtifactsVariables = {
  body: ApiUploadDbtArtifactsRequestBody;
  pathParams: ApiUploadDbtArtifactsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Upload dbt Core artifacts including run results and manifest files.
 */
export const fetchApiUploadDbtArtifacts = (
  variables: ApiUploadDbtArtifactsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiUploadDbtArtifactsError,
    ApiUploadDbtArtifactsRequestBody,
    {},
    {},
    ApiUploadDbtArtifactsPathParams
  >({
    url: "/integration/dbt/{integrationId}/upload_artifacts/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Upload dbt Core artifacts including run results and manifest files.
 */
export const useApiUploadDbtArtifacts = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiUploadDbtArtifactsError,
      ApiUploadDbtArtifactsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiUploadDbtArtifactsError,
    ApiUploadDbtArtifactsVariables
  >({
    mutationFn: (variables: ApiUploadDbtArtifactsVariables) =>
      fetchApiUploadDbtArtifacts({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiTriggerDbtRunPathParams = {
  integrationId: string;
};

export type ApiTriggerDbtRunError = Fetcher.ErrorWrapper<{
  status: 409;
  payload: string;
}>;

export type ApiTriggerDbtRunVariables = {
  pathParams: ApiTriggerDbtRunPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Trigger a dbt Core synchronization for the integration.
 */
export const fetchApiTriggerDbtRun = (
  variables: ApiTriggerDbtRunVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiTriggerDbtRunError,
    undefined,
    {},
    {},
    ApiTriggerDbtRunPathParams
  >({
    url: "/integration/dbt/{integrationId}/trigger/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Trigger a dbt Core synchronization for the integration.
 */
export const useApiTriggerDbtRun = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiTriggerDbtRunError,
      ApiTriggerDbtRunVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiTriggerDbtRunError,
    ApiTriggerDbtRunVariables
  >({
    mutationFn: (variables: ApiTriggerDbtRunVariables) =>
      fetchApiTriggerDbtRun({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetFailingTestsPathParams = {
  integrationId: string;
};

export type ApiGetFailingTestsError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiGetFailingTestsVariables = {
  pathParams: ApiGetFailingTestsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get entities with tests that are failing or have a warning.
 */
export const fetchApiGetFailingTests = (
  variables: ApiGetFailingTestsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DBTTestResultsOut,
    ApiGetFailingTestsError,
    undefined,
    {},
    {},
    ApiGetFailingTestsPathParams
  >({
    url: "/integration/dbt/{integrationId}/failing_tests/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetFailingTestsQueryKey = (
  variables: ApiGetFailingTestsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/dbt/{integrationId}/failing_tests/",
    operationId: "apiGetFailingTests",
    variables,
  });

/**
 * Get entities with tests that are failing or have a warning.
 */
export const useApiGetFailingTests = <TData = Schemas.DBTTestResultsOut,>(
  variables: ApiGetFailingTestsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DBTTestResultsOut,
      ApiGetFailingTestsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/dbt/{integrationId}/failing_tests/",
    operationId: "apiGetFailingTests",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DBTTestResultsOut,
    ApiGetFailingTestsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetFailingTests({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get entities with tests that are failing or have a warning.
 */
export const useSuspenseApiGetFailingTests = <
  TData = Schemas.DBTTestResultsOut,
>(
  variables: ApiGetFailingTestsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DBTTestResultsOut,
      ApiGetFailingTestsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/dbt/{integrationId}/failing_tests/",
    operationId: "apiGetFailingTests",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DBTTestResultsOut,
    ApiGetFailingTestsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetFailingTests({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type JiraWebhookError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: string;
    }
  | {
      status: 401;
      payload: string;
    }
>;

export type JiraWebhookVariables = ApiContext["fetcherOptions"];

export const fetchJiraWebhook = (
  variables: JiraWebhookVariables,
  signal?: AbortSignal,
) =>
  apiFetch<string, JiraWebhookError, undefined, {}, {}, {}>({
    url: "/integration/jira/jira-webhook/",
    method: "post",
    ...variables,
    signal,
  });

export const useJiraWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      JiraWebhookError,
      JiraWebhookVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<string, JiraWebhookError, JiraWebhookVariables>(
    {
      mutationFn: (variables: JiraWebhookVariables) =>
        fetchJiraWebhook({ ...fetcherOptions, ...variables }),
      ...options,
    },
  );
};

export type ApiGithubWebhookError = Fetcher.ErrorWrapper<{
  status: 403;
  payload: string;
}>;

export type ApiGithubWebhookVariables = {
  body: Schemas.GithubWebhookIn;
} & ApiContext["fetcherOptions"];

/**
 * Handle GitHub webhook events for pull requests.
 *
 * Args:
 *     request: The HTTP request object containing headers and body
 *     body: The parsed webhook payload
 *
 * Returns:
 *     tuple: (status_code, message)
 *         - 204: Event ignored (non-PR or disabled integration)
 *         - 403: Invalid request signature or stale event
 *         - 200: Event processed successfully
 */
export const fetchApiGithubWebhook = (
  variables: ApiGithubWebhookVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiGithubWebhookError,
    Schemas.GithubWebhookIn,
    {},
    {},
    {}
  >({
    url: "/integration/github/webhook/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Handle GitHub webhook events for pull requests.
 *
 * Args:
 *     request: The HTTP request object containing headers and body
 *     body: The parsed webhook payload
 *
 * Returns:
 *     tuple: (status_code, message)
 *         - 204: Event ignored (non-PR or disabled integration)
 *         - 403: Invalid request signature or stale event
 *         - 200: Event processed successfully
 */
export const useApiGithubWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiGithubWebhookError,
      ApiGithubWebhookVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiGithubWebhookError,
    ApiGithubWebhookVariables
  >({
    mutationFn: (variables: ApiGithubWebhookVariables) =>
      fetchApiGithubWebhook({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGithubPullRequestPathParams = {
  integrationId: string;
  pullRequestId: string;
};

export type ApiGithubPullRequestQueryParams = {
  search_term?: string | null;
  filter?: string | null;
  page?: number | null;
};

export type ApiGithubPullRequestError = Fetcher.ErrorWrapper<undefined>;

export type ApiGithubPullRequestVariables = {
  pathParams: ApiGithubPullRequestPathParams;
  queryParams?: ApiGithubPullRequestQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGithubPullRequest = (
  variables: ApiGithubPullRequestVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GithubPullRequestDownstreamEntitiesOutPaginated,
    ApiGithubPullRequestError,
    undefined,
    {},
    ApiGithubPullRequestQueryParams,
    ApiGithubPullRequestPathParams
  >({
    url: "/integration/github/{integrationId}/pull-requests/{pullRequestId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGithubPullRequestQueryKey = (
  variables: ApiGithubPullRequestVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/github/{integrationId}/pull-requests/{pullRequestId}/",
    operationId: "apiGithubPullRequest",
    variables,
  });

export const useApiGithubPullRequest = <
  TData = Schemas.GithubPullRequestDownstreamEntitiesOutPaginated,
>(
  variables: ApiGithubPullRequestVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GithubPullRequestDownstreamEntitiesOutPaginated,
      ApiGithubPullRequestError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/github/{integrationId}/pull-requests/{pullRequestId}/",
    operationId: "apiGithubPullRequest",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.GithubPullRequestDownstreamEntitiesOutPaginated,
    ApiGithubPullRequestError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGithubPullRequest({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGithubPullRequest = <
  TData = Schemas.GithubPullRequestDownstreamEntitiesOutPaginated,
>(
  variables: ApiGithubPullRequestVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.GithubPullRequestDownstreamEntitiesOutPaginated,
      ApiGithubPullRequestError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/github/{integrationId}/pull-requests/{pullRequestId}/",
    operationId: "apiGithubPullRequest",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.GithubPullRequestDownstreamEntitiesOutPaginated,
    ApiGithubPullRequestError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGithubPullRequest({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGithubPullRequestsPathParams = {
  integrationId: string;
};

export type ApiGithubPullRequestsQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiGithubPullRequestsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGithubPullRequestsVariables = {
  pathParams: ApiGithubPullRequestsPathParams;
  queryParams?: ApiGithubPullRequestsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGithubPullRequests = (
  variables: ApiGithubPullRequestsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedGithubPullRequestOut,
    ApiGithubPullRequestsError,
    undefined,
    {},
    ApiGithubPullRequestsQueryParams,
    ApiGithubPullRequestsPathParams
  >({
    url: "/integration/github/{integrationId}/pull-requests/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGithubPullRequestsQueryKey = (
  variables: ApiGithubPullRequestsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/github/{integrationId}/pull-requests/",
    operationId: "apiGithubPullRequests",
    variables,
  });

export const useApiGithubPullRequests = <
  TData = Schemas.PagedGithubPullRequestOut,
>(
  variables: ApiGithubPullRequestsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedGithubPullRequestOut,
      ApiGithubPullRequestsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/github/{integrationId}/pull-requests/",
    operationId: "apiGithubPullRequests",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedGithubPullRequestOut,
    ApiGithubPullRequestsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGithubPullRequests({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGithubPullRequests = <
  TData = Schemas.PagedGithubPullRequestOut,
>(
  variables: ApiGithubPullRequestsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedGithubPullRequestOut,
      ApiGithubPullRequestsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/github/{integrationId}/pull-requests/",
    operationId: "apiGithubPullRequests",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedGithubPullRequestOut,
    ApiGithubPullRequestsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGithubPullRequests({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ServicenowWebhookError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: string;
      };
    }
  | {
      status: 401;
      payload: {
        [key: string]: string;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: string;
      };
    }
>;

export type ServicenowWebhookResponse = {
  [key: string]: string;
};

export type ServicenowWebhookVariables = ApiContext["fetcherOptions"];

/**
 * Webhook endpoint for receiving updates from ServiceNow.
 *
 * This endpoint processes status updates from ServiceNow and synchronizes them
 * with Secoda's data access requests.
 */
export const fetchServicenowWebhook = (
  variables: ServicenowWebhookVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ServicenowWebhookResponse,
    ServicenowWebhookError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/integration/servicenow/webhook/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Webhook endpoint for receiving updates from ServiceNow.
 *
 * This endpoint processes status updates from ServiceNow and synchronizes them
 * with Secoda's data access requests.
 */
export const useServicenowWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ServicenowWebhookResponse,
      ServicenowWebhookError,
      ServicenowWebhookVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ServicenowWebhookResponse,
    ServicenowWebhookError,
    ServicenowWebhookVariables
  >({
    mutationFn: (variables: ServicenowWebhookVariables) =>
      fetchServicenowWebhook({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRestoreEntityFromActivityLogQueryParams = {
  entity_snapshot_key: string;
};

export type ApiRestoreEntityFromActivityLogError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiRestoreEntityFromActivityLogVariables = {
  queryParams: ApiRestoreEntityFromActivityLogQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Restore an entity to a previous state from activity log snapshot.
 */
export const fetchApiRestoreEntityFromActivityLog = (
  variables: ApiRestoreEntityFromActivityLogVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    boolean,
    ApiRestoreEntityFromActivityLogError,
    undefined,
    {},
    ApiRestoreEntityFromActivityLogQueryParams,
    {}
  >({
    url: "/notification/activity_log/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Restore an entity to a previous state from activity log snapshot.
 */
export const useApiRestoreEntityFromActivityLog = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      boolean,
      ApiRestoreEntityFromActivityLogError,
      ApiRestoreEntityFromActivityLogVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    boolean,
    ApiRestoreEntityFromActivityLogError,
    ApiRestoreEntityFromActivityLogVariables
  >({
    mutationFn: (variables: ApiRestoreEntityFromActivityLogVariables) =>
      fetchApiRestoreEntityFromActivityLog({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetQuestionMetricsQueryParams = {
  team_id: string;
  /**
   * @default all
   */
  filter_type?: "all" | "created" | "assigned";
  user_id?: string | null;
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * @default false
   */
  current_state_only?: boolean;
};

export type ApiGetQuestionMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetQuestionMetricsVariables = {
  queryParams: ApiGetQuestionMetricsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get metrics for questions in a workspace
 */
export const fetchApiGetQuestionMetrics = (
  variables: ApiGetQuestionMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QuestionMetrics,
    ApiGetQuestionMetricsError,
    undefined,
    {},
    ApiGetQuestionMetricsQueryParams,
    {}
  >({ url: "/question/metrics/metrics/", method: "get", ...variables, signal });

export const apiGetQuestionMetricsQueryKey = (
  variables: ApiGetQuestionMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/question/metrics/metrics/",
    operationId: "apiGetQuestionMetrics",
    variables,
  });

/**
 * Get metrics for questions in a workspace
 */
export const useApiGetQuestionMetrics = <TData = Schemas.QuestionMetrics,>(
  variables: ApiGetQuestionMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QuestionMetrics,
      ApiGetQuestionMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/question/metrics/metrics/",
    operationId: "apiGetQuestionMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QuestionMetrics,
    ApiGetQuestionMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQuestionMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get metrics for questions in a workspace
 */
export const useSuspenseApiGetQuestionMetrics = <
  TData = Schemas.QuestionMetrics,
>(
  variables: ApiGetQuestionMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QuestionMetrics,
      ApiGetQuestionMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/question/metrics/metrics/",
    operationId: "apiGetQuestionMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QuestionMetrics,
    ApiGetQuestionMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQuestionMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetQuestionTimeseriesQueryParams = {
  team_id: string;
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * @default all
   */
  filter_type?: "all" | "created" | "assigned";
  user_id?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
};

export type ApiGetQuestionTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetQuestionTimeseriesVariables = {
  queryParams: ApiGetQuestionTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get timeseries data for questions in a workspace
 */
export const fetchApiGetQuestionTimeseries = (
  variables: ApiGetQuestionTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QuestionTimeSeries,
    ApiGetQuestionTimeseriesError,
    undefined,
    {},
    ApiGetQuestionTimeseriesQueryParams,
    {}
  >({
    url: "/question/metrics/timeseries/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetQuestionTimeseriesQueryKey = (
  variables: ApiGetQuestionTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/question/metrics/timeseries/",
    operationId: "apiGetQuestionTimeseries",
    variables,
  });

/**
 * Get timeseries data for questions in a workspace
 */
export const useApiGetQuestionTimeseries = <
  TData = Schemas.QuestionTimeSeries,
>(
  variables: ApiGetQuestionTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QuestionTimeSeries,
      ApiGetQuestionTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/question/metrics/timeseries/",
    operationId: "apiGetQuestionTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QuestionTimeSeries,
    ApiGetQuestionTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQuestionTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get timeseries data for questions in a workspace
 */
export const useSuspenseApiGetQuestionTimeseries = <
  TData = Schemas.QuestionTimeSeries,
>(
  variables: ApiGetQuestionTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QuestionTimeSeries,
      ApiGetQuestionTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/question/metrics/timeseries/",
    operationId: "apiGetQuestionTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QuestionTimeSeries,
    ApiGetQuestionTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQuestionTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetLineageFlowQueryParams = {
  id: string;
  root_node_id?: string | null;
  direction?: Schemas.LineageDirection | null;
  filter?: string | null;
  /**
   * @default 1
   */
  upstream_depth?: number | null;
  /**
   * @default 1
   */
  downstream_depth?: number | null;
};

export type ApiGetLineageFlowError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetLineageFlowVariables = {
  queryParams: ApiGetLineageFlowQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetLineageFlow = (
  variables: ApiGetLineageFlowVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowOut,
    ApiGetLineageFlowError,
    undefined,
    {},
    ApiGetLineageFlowQueryParams,
    {}
  >({ url: "/lineage/flow/", method: "get", ...variables, signal });

export const apiGetLineageFlowQueryKey = (
  variables: ApiGetLineageFlowVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/flow/",
    operationId: "apiGetLineageFlow",
    variables,
  });

export const useApiGetLineageFlow = <TData = Schemas.LineageFlowOut,>(
  variables: ApiGetLineageFlowVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageFlowOut,
      ApiGetLineageFlowError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/",
    operationId: "apiGetLineageFlow",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageFlowOut,
    ApiGetLineageFlowError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlow({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetLineageFlow = <TData = Schemas.LineageFlowOut,>(
  variables: ApiGetLineageFlowVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageFlowOut,
      ApiGetLineageFlowError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/",
    operationId: "apiGetLineageFlow",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageFlowOut,
    ApiGetLineageFlowError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlow({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetLineageFlowV2QueryParams = {
  id: string;
  root_node_id?: string | null;
  direction?: Schemas.LineageDirection | null;
  filter?: string | null;
  /**
   * @default 1
   */
  upstream_depth?: number | null;
  /**
   * @default 1
   */
  downstream_depth?: number | null;
};

export type ApiGetLineageFlowV2Error = Fetcher.ErrorWrapper<undefined>;

export type ApiGetLineageFlowV2Variables = {
  queryParams: ApiGetLineageFlowV2QueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetLineageFlowV2 = (
  variables: ApiGetLineageFlowV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowOutV2,
    ApiGetLineageFlowV2Error,
    undefined,
    {},
    ApiGetLineageFlowV2QueryParams,
    {}
  >({ url: "/lineage/flow/v2/", method: "get", ...variables, signal });

export const apiGetLineageFlowV2QueryKey = (
  variables: ApiGetLineageFlowV2Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/flow/v2/",
    operationId: "apiGetLineageFlowV2",
    variables,
  });

export const useApiGetLineageFlowV2 = <TData = Schemas.LineageFlowOutV2,>(
  variables: ApiGetLineageFlowV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageFlowOutV2,
      ApiGetLineageFlowV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/v2/",
    operationId: "apiGetLineageFlowV2",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageFlowOutV2,
    ApiGetLineageFlowV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlowV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetLineageFlowV2 = <
  TData = Schemas.LineageFlowOutV2,
>(
  variables: ApiGetLineageFlowV2Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageFlowOutV2,
      ApiGetLineageFlowV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/v2/",
    operationId: "apiGetLineageFlowV2",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageFlowOutV2,
    ApiGetLineageFlowV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlowV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMultipleLineageFlowQueryParams = {
  root_node_id?: string | null;
  upstream_ids?: string | null;
  downstream_ids?: string | null;
  filter?: string | null;
  /**
   * @default 1
   */
  upstream_depth?: number | null;
  /**
   * @default 1
   */
  downstream_depth?: number | null;
};

export type ApiGetMultipleLineageFlowError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetMultipleLineageFlowVariables = {
  queryParams?: ApiGetMultipleLineageFlowQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMultipleLineageFlow = (
  variables: ApiGetMultipleLineageFlowVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowOut,
    ApiGetMultipleLineageFlowError,
    undefined,
    {},
    ApiGetMultipleLineageFlowQueryParams,
    {}
  >({ url: "/lineage/flow/multiple/", method: "get", ...variables, signal });

export const apiGetMultipleLineageFlowQueryKey = (
  variables: ApiGetMultipleLineageFlowVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/flow/multiple/",
    operationId: "apiGetMultipleLineageFlow",
    variables,
  });

export const useApiGetMultipleLineageFlow = <TData = Schemas.LineageFlowOut,>(
  variables: ApiGetMultipleLineageFlowVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageFlowOut,
      ApiGetMultipleLineageFlowError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/multiple/",
    operationId: "apiGetMultipleLineageFlow",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageFlowOut,
    ApiGetMultipleLineageFlowError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMultipleLineageFlow(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMultipleLineageFlow = <
  TData = Schemas.LineageFlowOut,
>(
  variables: ApiGetMultipleLineageFlowVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageFlowOut,
      ApiGetMultipleLineageFlowError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/multiple/",
    operationId: "apiGetMultipleLineageFlow",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageFlowOut,
    ApiGetMultipleLineageFlowError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMultipleLineageFlow(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMultipleLineageFlowV2QueryParams = {
  root_node_id?: string | null;
  upstream_ids?: string | null;
  downstream_ids?: string | null;
  filter?: string | null;
  /**
   * @default 1
   */
  upstream_depth?: number | null;
  /**
   * @default 1
   */
  downstream_depth?: number | null;
};

export type ApiGetMultipleLineageFlowV2Error = Fetcher.ErrorWrapper<undefined>;

export type ApiGetMultipleLineageFlowV2Variables = {
  queryParams?: ApiGetMultipleLineageFlowV2QueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMultipleLineageFlowV2 = (
  variables: ApiGetMultipleLineageFlowV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowOutV2,
    ApiGetMultipleLineageFlowV2Error,
    undefined,
    {},
    ApiGetMultipleLineageFlowV2QueryParams,
    {}
  >({ url: "/lineage/flow/multiple/v2/", method: "get", ...variables, signal });

export const apiGetMultipleLineageFlowV2QueryKey = (
  variables: ApiGetMultipleLineageFlowV2Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/flow/multiple/v2/",
    operationId: "apiGetMultipleLineageFlowV2",
    variables,
  });

export const useApiGetMultipleLineageFlowV2 = <
  TData = Schemas.LineageFlowOutV2,
>(
  variables: ApiGetMultipleLineageFlowV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageFlowOutV2,
      ApiGetMultipleLineageFlowV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/multiple/v2/",
    operationId: "apiGetMultipleLineageFlowV2",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageFlowOutV2,
    ApiGetMultipleLineageFlowV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMultipleLineageFlowV2(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMultipleLineageFlowV2 = <
  TData = Schemas.LineageFlowOutV2,
>(
  variables: ApiGetMultipleLineageFlowV2Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageFlowOutV2,
      ApiGetMultipleLineageFlowV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/multiple/v2/",
    operationId: "apiGetMultipleLineageFlowV2",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageFlowOutV2,
    ApiGetMultipleLineageFlowV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMultipleLineageFlowV2(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetLineageFlowMetadataError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetLineageFlowMetadataVariables = {
  body: Schemas.LineageFlowMetadataIn;
} & ApiContext["fetcherOptions"];

export const fetchApiGetLineageFlowMetadata = (
  variables: ApiGetLineageFlowMetadataVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowMetadataOut,
    ApiGetLineageFlowMetadataError,
    Schemas.LineageFlowMetadataIn,
    {},
    {},
    {}
  >({ url: "/lineage/flow/metadata/", method: "post", ...variables, signal });

export const useApiGetLineageFlowMetadata = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LineageFlowMetadataOut,
      ApiGetLineageFlowMetadataError,
      ApiGetLineageFlowMetadataVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LineageFlowMetadataOut,
    ApiGetLineageFlowMetadataError,
    ApiGetLineageFlowMetadataVariables
  >({
    mutationFn: (variables: ApiGetLineageFlowMetadataVariables) =>
      fetchApiGetLineageFlowMetadata({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetLineageFlowChildrenQueryParams = {
  id: string;
};

export type ApiGetLineageFlowChildrenError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetLineageFlowChildrenVariables = {
  queryParams: ApiGetLineageFlowChildrenQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetLineageFlowChildren = (
  variables: ApiGetLineageFlowChildrenVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowChildrenOut,
    ApiGetLineageFlowChildrenError,
    undefined,
    {},
    ApiGetLineageFlowChildrenQueryParams,
    {}
  >({ url: "/lineage/flow/children/", method: "get", ...variables, signal });

export const apiGetLineageFlowChildrenQueryKey = (
  variables: ApiGetLineageFlowChildrenVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/flow/children/",
    operationId: "apiGetLineageFlowChildren",
    variables,
  });

export const useApiGetLineageFlowChildren = <
  TData = Schemas.LineageFlowChildrenOut,
>(
  variables: ApiGetLineageFlowChildrenVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageFlowChildrenOut,
      ApiGetLineageFlowChildrenError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/children/",
    operationId: "apiGetLineageFlowChildren",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageFlowChildrenOut,
    ApiGetLineageFlowChildrenError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlowChildren(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetLineageFlowChildren = <
  TData = Schemas.LineageFlowChildrenOut,
>(
  variables: ApiGetLineageFlowChildrenVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageFlowChildrenOut,
      ApiGetLineageFlowChildrenError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/children/",
    operationId: "apiGetLineageFlowChildren",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageFlowChildrenOut,
    ApiGetLineageFlowChildrenError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlowChildren(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetLineageFlowImpactedChildrenQueryParams = {
  id: string;
  filter?: string | null;
};

export type ApiGetLineageFlowImpactedChildrenError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetLineageFlowImpactedChildrenVariables = {
  queryParams: ApiGetLineageFlowImpactedChildrenQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetLineageFlowImpactedChildren = (
  variables: ApiGetLineageFlowImpactedChildrenVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowImpactedChildrenOut,
    ApiGetLineageFlowImpactedChildrenError,
    undefined,
    {},
    ApiGetLineageFlowImpactedChildrenQueryParams,
    {}
  >({
    url: "/lineage/flow/impacted-children/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetLineageFlowImpactedChildrenQueryKey = (
  variables: ApiGetLineageFlowImpactedChildrenVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/flow/impacted-children/",
    operationId: "apiGetLineageFlowImpactedChildren",
    variables,
  });

export const useApiGetLineageFlowImpactedChildren = <
  TData = Schemas.LineageFlowImpactedChildrenOut,
>(
  variables: ApiGetLineageFlowImpactedChildrenVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageFlowImpactedChildrenOut,
      ApiGetLineageFlowImpactedChildrenError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/impacted-children/",
    operationId: "apiGetLineageFlowImpactedChildren",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageFlowImpactedChildrenOut,
    ApiGetLineageFlowImpactedChildrenError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlowImpactedChildren(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetLineageFlowImpactedChildren = <
  TData = Schemas.LineageFlowImpactedChildrenOut,
>(
  variables: ApiGetLineageFlowImpactedChildrenVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageFlowImpactedChildrenOut,
      ApiGetLineageFlowImpactedChildrenError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/impacted-children/",
    operationId: "apiGetLineageFlowImpactedChildren",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageFlowImpactedChildrenOut,
    ApiGetLineageFlowImpactedChildrenError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlowImpactedChildren(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetLineageFlowQueryDagPathParams = {
  queryId: string;
};

export type ApiGetLineageFlowQueryDagError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetLineageFlowQueryDagVariables = {
  pathParams: ApiGetLineageFlowQueryDagPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetLineageFlowQueryDag = (
  variables: ApiGetLineageFlowQueryDagVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowQueryDagOut,
    ApiGetLineageFlowQueryDagError,
    undefined,
    {},
    {},
    ApiGetLineageFlowQueryDagPathParams
  >({
    url: "/lineage/flow/query/{queryId}/dag/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetLineageFlowQueryDagQueryKey = (
  variables: ApiGetLineageFlowQueryDagVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/flow/query/{queryId}/dag/",
    operationId: "apiGetLineageFlowQueryDag",
    variables,
  });

export const useApiGetLineageFlowQueryDag = <
  TData = Schemas.LineageFlowQueryDagOut,
>(
  variables: ApiGetLineageFlowQueryDagVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageFlowQueryDagOut,
      ApiGetLineageFlowQueryDagError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/query/{queryId}/dag/",
    operationId: "apiGetLineageFlowQueryDag",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageFlowQueryDagOut,
    ApiGetLineageFlowQueryDagError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlowQueryDag(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetLineageFlowQueryDag = <
  TData = Schemas.LineageFlowQueryDagOut,
>(
  variables: ApiGetLineageFlowQueryDagVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageFlowQueryDagOut,
      ApiGetLineageFlowQueryDagError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/flow/query/{queryId}/dag/",
    operationId: "apiGetLineageFlowQueryDag",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageFlowQueryDagOut,
    ApiGetLineageFlowQueryDagError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFlowQueryDag(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiEntityHasLineageQueryParams = {
  id: string;
};

export type ApiEntityHasLineageError = Fetcher.ErrorWrapper<undefined>;

export type ApiEntityHasLineageVariables = {
  queryParams: ApiEntityHasLineageQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiEntityHasLineage = (
  variables: ApiEntityHasLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    boolean,
    ApiEntityHasLineageError,
    undefined,
    {},
    ApiEntityHasLineageQueryParams,
    {}
  >({ url: "/lineage/has_lineage/", method: "get", ...variables, signal });

export const apiEntityHasLineageQueryKey = (
  variables: ApiEntityHasLineageVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/has_lineage/",
    operationId: "apiEntityHasLineage",
    variables,
  });

export const useApiEntityHasLineage = <TData = boolean,>(
  variables: ApiEntityHasLineageVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<boolean, ApiEntityHasLineageError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/has_lineage/",
    operationId: "apiEntityHasLineage",
    variables,
  });
  const result = reactQuery.useQuery<boolean, ApiEntityHasLineageError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiEntityHasLineage({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiEntityHasLineage = <TData = boolean,>(
  variables: ApiEntityHasLineageVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      boolean,
      ApiEntityHasLineageError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/has_lineage/",
    operationId: "apiEntityHasLineage",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    boolean,
    ApiEntityHasLineageError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiEntityHasLineage({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateLineageError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateLineageVariables = {
  body: Schemas.LineageIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a new lineage object manually. Only one direction of the relationship needs to be created. The opposite direction of the lineage is automatically generated.
 */
export const fetchApiCreateLineage = (
  variables: ApiCreateLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageOut,
    ApiCreateLineageError,
    Schemas.LineageIn,
    {},
    {},
    {}
  >({ url: "/lineage/", method: "post", ...variables, signal });

/**
 * Create a new lineage object manually. Only one direction of the relationship needs to be created. The opposite direction of the lineage is automatically generated.
 */
export const useApiCreateLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LineageOut,
      ApiCreateLineageError,
      ApiCreateLineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LineageOut,
    ApiCreateLineageError,
    ApiCreateLineageVariables
  >({
    mutationFn: (variables: ApiCreateLineageVariables) =>
      fetchApiCreateLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListLineageQueryParams = {
  id: string;
  direction: "UPSTREAM" | "DOWNSTREAM";
  filter?: string | null;
  /**
   * @default 1
   */
  depth?: number | null;
  entity_type?: string | null;
  include_columns?: string | null;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListLineageError = Fetcher.ErrorWrapper<undefined>;

export type ApiListLineageVariables = {
  queryParams: ApiListLineageQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListLineage = (
  variables: ApiListLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PaginatedLineageListOut,
    ApiListLineageError,
    undefined,
    {},
    ApiListLineageQueryParams,
    {}
  >({ url: "/lineage/", method: "get", ...variables, signal });

export const apiListLineageQueryKey = (
  variables: ApiListLineageVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/",
    operationId: "apiListLineage",
    variables,
  });

export const useApiListLineage = <TData = Schemas.PaginatedLineageListOut,>(
  variables: ApiListLineageVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PaginatedLineageListOut,
      ApiListLineageError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/",
    operationId: "apiListLineage",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PaginatedLineageListOut,
    ApiListLineageError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListLineage({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListLineage = <
  TData = Schemas.PaginatedLineageListOut,
>(
  variables: ApiListLineageVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PaginatedLineageListOut,
      ApiListLineageError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/",
    operationId: "apiListLineage",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PaginatedLineageListOut,
    ApiListLineageError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListLineage({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListChildrenByParentIdsQueryParams = {
  search_after?: string | null;
};

export type ApiListChildrenByParentIdsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListChildrenByParentIdsVariables = {
  body: Schemas.ChildrenBodyIn;
  queryParams?: ApiListChildrenByParentIdsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListChildrenByParentIds = (
  variables: ApiListChildrenByParentIdsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PaginatedChildrenOut,
    ApiListChildrenByParentIdsError,
    Schemas.ChildrenBodyIn,
    {},
    ApiListChildrenByParentIdsQueryParams,
    {}
  >({ url: "/lineage/children/", method: "post", ...variables, signal });

export const useApiListChildrenByParentIds = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PaginatedChildrenOut,
      ApiListChildrenByParentIdsError,
      ApiListChildrenByParentIdsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PaginatedChildrenOut,
    ApiListChildrenByParentIdsError,
    ApiListChildrenByParentIdsVariables
  >({
    mutationFn: (variables: ApiListChildrenByParentIdsVariables) =>
      fetchApiListChildrenByParentIds({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListTestsByTableIdsQueryParams = {
  /**
   * @default 1
   */
  page?: number;
};

export type ApiListTestsByTableIdsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListTestsByTableIdsVariables = {
  body: Schemas.ChildrenBodyIn;
  queryParams?: ApiListTestsByTableIdsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListTestsByTableIds = (
  variables: ApiListTestsByTableIdsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedTestsOut,
    ApiListTestsByTableIdsError,
    Schemas.ChildrenBodyIn,
    {},
    ApiListTestsByTableIdsQueryParams,
    {}
  >({ url: "/lineage/table-tests/", method: "post", ...variables, signal });

export const useApiListTestsByTableIds = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PagedTestsOut,
      ApiListTestsByTableIdsError,
      ApiListTestsByTableIdsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PagedTestsOut,
    ApiListTestsByTableIdsError,
    ApiListTestsByTableIdsVariables
  >({
    mutationFn: (variables: ApiListTestsByTableIdsVariables) =>
      fetchApiListTestsByTableIds({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListTableMonitorsByTableIdsQueryParams = {
  /**
   * @default 1
   */
  page?: number;
};

export type ApiListTableMonitorsByTableIdsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiListTableMonitorsByTableIdsVariables = {
  body: Schemas.ChildrenBodyIn;
  queryParams?: ApiListTableMonitorsByTableIdsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListTableMonitorsByTableIds = (
  variables: ApiListTableMonitorsByTableIdsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedMonitorsOut,
    ApiListTableMonitorsByTableIdsError,
    Schemas.ChildrenBodyIn,
    {},
    ApiListTableMonitorsByTableIdsQueryParams,
    {}
  >({ url: "/lineage/table-monitors/", method: "post", ...variables, signal });

export const useApiListTableMonitorsByTableIds = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PagedMonitorsOut,
      ApiListTableMonitorsByTableIdsError,
      ApiListTableMonitorsByTableIdsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PagedMonitorsOut,
    ApiListTableMonitorsByTableIdsError,
    ApiListTableMonitorsByTableIdsVariables
  >({
    mutationFn: (variables: ApiListTableMonitorsByTableIdsVariables) =>
      fetchApiListTableMonitorsByTableIds({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListTableCreationQueriesByTableIdsQueryParams = {
  /**
   * @default 1
   */
  page?: number;
};

export type ApiListTableCreationQueriesByTableIdsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiListTableCreationQueriesByTableIdsVariables = {
  body: Schemas.ChildrenBodyIn;
  queryParams?: ApiListTableCreationQueriesByTableIdsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListTableCreationQueriesByTableIds = (
  variables: ApiListTableCreationQueriesByTableIdsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedQueriesOut,
    ApiListTableCreationQueriesByTableIdsError,
    Schemas.ChildrenBodyIn,
    {},
    ApiListTableCreationQueriesByTableIdsQueryParams,
    {}
  >({
    url: "/lineage/table-creation-queries/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiListTableCreationQueriesByTableIds = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PagedQueriesOut,
      ApiListTableCreationQueriesByTableIdsError,
      ApiListTableCreationQueriesByTableIdsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PagedQueriesOut,
    ApiListTableCreationQueriesByTableIdsError,
    ApiListTableCreationQueriesByTableIdsVariables
  >({
    mutationFn: (variables: ApiListTableCreationQueriesByTableIdsVariables) =>
      fetchApiListTableCreationQueriesByTableIds({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiRetrieveImpactedIdsPathParams = {
  fromId: string;
};

export type ApiRetrieveImpactedIdsError = Fetcher.ErrorWrapper<undefined>;

export type ApiRetrieveImpactedIdsVariables = {
  pathParams: ApiRetrieveImpactedIdsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRetrieveImpactedIds = (
  variables: ApiRetrieveImpactedIdsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ImpactedIdsOut,
    ApiRetrieveImpactedIdsError,
    undefined,
    {},
    {},
    ApiRetrieveImpactedIdsPathParams
  >({
    url: "/lineage/impacted/{fromId}/ids/",
    method: "get",
    ...variables,
    signal,
  });

export const apiRetrieveImpactedIdsQueryKey = (
  variables: ApiRetrieveImpactedIdsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/impacted/{fromId}/ids/",
    operationId: "apiRetrieveImpactedIds",
    variables,
  });

export const useApiRetrieveImpactedIds = <TData = Schemas.ImpactedIdsOut,>(
  variables: ApiRetrieveImpactedIdsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ImpactedIdsOut,
      ApiRetrieveImpactedIdsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/impacted/{fromId}/ids/",
    operationId: "apiRetrieveImpactedIds",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ImpactedIdsOut,
    ApiRetrieveImpactedIdsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveImpactedIds({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiRetrieveImpactedIds = <
  TData = Schemas.ImpactedIdsOut,
>(
  variables: ApiRetrieveImpactedIdsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ImpactedIdsOut,
      ApiRetrieveImpactedIdsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/impacted/{fromId}/ids/",
    operationId: "apiRetrieveImpactedIds",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ImpactedIdsOut,
    ApiRetrieveImpactedIdsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveImpactedIds({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiRetrieveImpactedPathsPathParams = {
  fromId: string;
};

export type ApiRetrieveImpactedPathsQueryParams = {
  /**
   * @default DOWNSTREAM
   */
  direction?: Schemas.LineageDirection | null;
};

export type ApiRetrieveImpactedPathsError = Fetcher.ErrorWrapper<undefined>;

export type ApiRetrieveImpactedPathsResponse = {
  [key: string]: Schemas.ImpactedPathsOut;
};

export type ApiRetrieveImpactedPathsVariables = {
  pathParams: ApiRetrieveImpactedPathsPathParams;
  queryParams?: ApiRetrieveImpactedPathsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRetrieveImpactedPaths = (
  variables: ApiRetrieveImpactedPathsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiRetrieveImpactedPathsResponse,
    ApiRetrieveImpactedPathsError,
    undefined,
    {},
    ApiRetrieveImpactedPathsQueryParams,
    ApiRetrieveImpactedPathsPathParams
  >({
    url: "/lineage/impacted/{fromId}/paths/",
    method: "get",
    ...variables,
    signal,
  });

export const apiRetrieveImpactedPathsQueryKey = (
  variables: ApiRetrieveImpactedPathsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/impacted/{fromId}/paths/",
    operationId: "apiRetrieveImpactedPaths",
    variables,
  });

export const useApiRetrieveImpactedPaths = <
  TData = ApiRetrieveImpactedPathsResponse,
>(
  variables: ApiRetrieveImpactedPathsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiRetrieveImpactedPathsResponse,
      ApiRetrieveImpactedPathsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/impacted/{fromId}/paths/",
    operationId: "apiRetrieveImpactedPaths",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiRetrieveImpactedPathsResponse,
    ApiRetrieveImpactedPathsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveImpactedPaths(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiRetrieveImpactedPaths = <
  TData = ApiRetrieveImpactedPathsResponse,
>(
  variables: ApiRetrieveImpactedPathsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiRetrieveImpactedPathsResponse,
      ApiRetrieveImpactedPathsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/impacted/{fromId}/paths/",
    operationId: "apiRetrieveImpactedPaths",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiRetrieveImpactedPathsResponse,
    ApiRetrieveImpactedPathsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveImpactedPaths(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiExportImpactedCsvPathParams = {
  fromId: string;
};

export type ApiExportImpactedCsvError = Fetcher.ErrorWrapper<undefined>;

export type ApiExportImpactedCsvVariables = {
  pathParams: ApiExportImpactedCsvPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiExportImpactedCsv = (
  variables: ApiExportImpactedCsvVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    ApiExportImpactedCsvError,
    undefined,
    {},
    {},
    ApiExportImpactedCsvPathParams
  >({
    url: "/lineage/impacted/{fromId}/csv/",
    method: "get",
    ...variables,
    signal,
  });

export const apiExportImpactedCsvQueryKey = (
  variables: ApiExportImpactedCsvVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/impacted/{fromId}/csv/",
    operationId: "apiExportImpactedCsv",
    variables,
  });

export const useApiExportImpactedCsv = <TData = Schemas.BackgroundJobOut,>(
  variables: ApiExportImpactedCsvVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BackgroundJobOut,
      ApiExportImpactedCsvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/impacted/{fromId}/csv/",
    operationId: "apiExportImpactedCsv",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.BackgroundJobOut,
    ApiExportImpactedCsvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiExportImpactedCsv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiExportImpactedCsv = <
  TData = Schemas.BackgroundJobOut,
>(
  variables: ApiExportImpactedCsvVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.BackgroundJobOut,
      ApiExportImpactedCsvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/impacted/{fromId}/csv/",
    operationId: "apiExportImpactedCsv",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.BackgroundJobOut,
    ApiExportImpactedCsvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiExportImpactedCsv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiBulkUpdateResourceRelationsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiBulkUpdateResourceRelationsVariables = {
  body: Schemas.ResourceRelationBulkIn;
} & ApiContext["fetcherOptions"];

export const fetchApiBulkUpdateResourceRelations = (
  variables: ApiBulkUpdateResourceRelationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiBulkUpdateResourceRelationsError,
    Schemas.ResourceRelationBulkIn,
    {},
    {},
    {}
  >({ url: "/lineage/bulk_relations/", method: "post", ...variables, signal });

export const useApiBulkUpdateResourceRelations = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiBulkUpdateResourceRelationsError,
      ApiBulkUpdateResourceRelationsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiBulkUpdateResourceRelationsError,
    ApiBulkUpdateResourceRelationsVariables
  >({
    mutationFn: (variables: ApiBulkUpdateResourceRelationsVariables) =>
      fetchApiBulkUpdateResourceRelations({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiCreateResourceRelationError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateResourceRelationVariables = {
  body: Schemas.ResourceRelationIn;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateResourceRelation = (
  variables: ApiCreateResourceRelationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ResourceRelationOut,
    ApiCreateResourceRelationError,
    Schemas.ResourceRelationIn,
    {},
    {},
    {}
  >({ url: "/lineage/relations/", method: "post", ...variables, signal });

export const useApiCreateResourceRelation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ResourceRelationOut,
      ApiCreateResourceRelationError,
      ApiCreateResourceRelationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ResourceRelationOut,
    ApiCreateResourceRelationError,
    ApiCreateResourceRelationVariables
  >({
    mutationFn: (variables: ApiCreateResourceRelationVariables) =>
      fetchApiCreateResourceRelation({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListResourceRelationsQueryParams = {
  resource_id: string;
  /**
   * @default 1
   */
  page?: number;
};

export type ApiListResourceRelationsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListResourceRelationsVariables = {
  queryParams: ApiListResourceRelationsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListResourceRelations = (
  variables: ApiListResourceRelationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedResourceRelationOut,
    ApiListResourceRelationsError,
    undefined,
    {},
    ApiListResourceRelationsQueryParams,
    {}
  >({ url: "/lineage/relations/", method: "get", ...variables, signal });

export const apiListResourceRelationsQueryKey = (
  variables: ApiListResourceRelationsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/relations/",
    operationId: "apiListResourceRelations",
    variables,
  });

export const useApiListResourceRelations = <
  TData = Schemas.PagedResourceRelationOut,
>(
  variables: ApiListResourceRelationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedResourceRelationOut,
      ApiListResourceRelationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/relations/",
    operationId: "apiListResourceRelations",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedResourceRelationOut,
    ApiListResourceRelationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListResourceRelations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListResourceRelations = <
  TData = Schemas.PagedResourceRelationOut,
>(
  variables: ApiListResourceRelationsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedResourceRelationOut,
      ApiListResourceRelationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/relations/",
    operationId: "apiListResourceRelations",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedResourceRelationOut,
    ApiListResourceRelationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListResourceRelations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiDeleteResourceRelationError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteResourceRelationVariables = {
  body: Schemas.ResourceRelationIn;
} & ApiContext["fetcherOptions"];

export const fetchApiDeleteResourceRelation = (
  variables: ApiDeleteResourceRelationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteResourceRelationError,
    Schemas.ResourceRelationIn,
    {},
    {},
    {}
  >({ url: "/lineage/relations/", method: "delete", ...variables, signal });

export const useApiDeleteResourceRelation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteResourceRelationError,
      ApiDeleteResourceRelationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteResourceRelationError,
    ApiDeleteResourceRelationVariables
  >({
    mutationFn: (variables: ApiDeleteResourceRelationVariables) =>
      fetchApiDeleteResourceRelation({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiCreateResourceRelationQuestionError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiCreateResourceRelationQuestionVariables = {
  body: Schemas.ResourceRelationIn;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateResourceRelationQuestion = (
  variables: ApiCreateResourceRelationQuestionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ResourceRelationOut,
    ApiCreateResourceRelationQuestionError,
    Schemas.ResourceRelationIn,
    {},
    {},
    {}
  >({
    url: "/lineage/relations/question/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCreateResourceRelationQuestion = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ResourceRelationOut,
      ApiCreateResourceRelationQuestionError,
      ApiCreateResourceRelationQuestionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ResourceRelationOut,
    ApiCreateResourceRelationQuestionError,
    ApiCreateResourceRelationQuestionVariables
  >({
    mutationFn: (variables: ApiCreateResourceRelationQuestionVariables) =>
      fetchApiCreateResourceRelationQuestion({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiRetrieveResourceRelationPathParams = {
  relationId: string;
};

export type ApiRetrieveResourceRelationError = Fetcher.ErrorWrapper<undefined>;

export type ApiRetrieveResourceRelationVariables = {
  pathParams: ApiRetrieveResourceRelationPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRetrieveResourceRelation = (
  variables: ApiRetrieveResourceRelationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ResourceRelationOut,
    ApiRetrieveResourceRelationError,
    undefined,
    {},
    {},
    ApiRetrieveResourceRelationPathParams
  >({
    url: "/lineage/relations/{relationId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiRetrieveResourceRelationQueryKey = (
  variables: ApiRetrieveResourceRelationVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/relations/{relationId}/",
    operationId: "apiRetrieveResourceRelation",
    variables,
  });

export const useApiRetrieveResourceRelation = <
  TData = Schemas.ResourceRelationOut,
>(
  variables: ApiRetrieveResourceRelationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ResourceRelationOut,
      ApiRetrieveResourceRelationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/relations/{relationId}/",
    operationId: "apiRetrieveResourceRelation",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ResourceRelationOut,
    ApiRetrieveResourceRelationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveResourceRelation(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiRetrieveResourceRelation = <
  TData = Schemas.ResourceRelationOut,
>(
  variables: ApiRetrieveResourceRelationVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ResourceRelationOut,
      ApiRetrieveResourceRelationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/relations/{relationId}/",
    operationId: "apiRetrieveResourceRelation",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ResourceRelationOut,
    ApiRetrieveResourceRelationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveResourceRelation(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateManualLineageError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateManualLineageVariables = {
  body: Schemas.LineageIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a new lineage object manually. Only one direction of the relationship needs to be created. The opposite direction of the lineage is automatically generated.
 */
export const fetchApiCreateManualLineage = (
  variables: ApiCreateManualLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageOut,
    ApiCreateManualLineageError,
    Schemas.LineageIn,
    {},
    {},
    {}
  >({ url: "/lineage/manual/", method: "post", ...variables, signal });

/**
 * Create a new lineage object manually. Only one direction of the relationship needs to be created. The opposite direction of the lineage is automatically generated.
 */
export const useApiCreateManualLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LineageOut,
      ApiCreateManualLineageError,
      ApiCreateManualLineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LineageOut,
    ApiCreateManualLineageError,
    ApiCreateManualLineageVariables
  >({
    mutationFn: (variables: ApiCreateManualLineageVariables) =>
      fetchApiCreateManualLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListManualLineagesQueryParams = {
  from_entity?: string | null;
  from_entity_id?: string | null;
  from_entity__in?: string | null;
  to_entity?: string | null;
  to_entity_id?: string | null;
  to_entity__in?: string | null;
  integration_type?: string | null;
  integration__type?: string | null;
  /**
   * @default 1
   */
  page?: number;
};

export type ApiListManualLineagesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListManualLineagesVariables = {
  queryParams?: ApiListManualLineagesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get lineage objects with optional filtering by source and destination entity.
 */
export const fetchApiListManualLineages = (
  variables: ApiListManualLineagesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedLineageOut,
    ApiListManualLineagesError,
    undefined,
    {},
    ApiListManualLineagesQueryParams,
    {}
  >({ url: "/lineage/manual/", method: "get", ...variables, signal });

export const apiListManualLineagesQueryKey = (
  variables: ApiListManualLineagesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/manual/",
    operationId: "apiListManualLineages",
    variables,
  });

/**
 * Get lineage objects with optional filtering by source and destination entity.
 */
export const useApiListManualLineages = <TData = Schemas.PagedLineageOut,>(
  variables: ApiListManualLineagesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedLineageOut,
      ApiListManualLineagesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/manual/",
    operationId: "apiListManualLineages",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedLineageOut,
    ApiListManualLineagesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListManualLineages({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get lineage objects with optional filtering by source and destination entity.
 */
export const useSuspenseApiListManualLineages = <
  TData = Schemas.PagedLineageOut,
>(
  variables: ApiListManualLineagesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedLineageOut,
      ApiListManualLineagesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/manual/",
    operationId: "apiListManualLineages",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedLineageOut,
    ApiListManualLineagesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListManualLineages({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetLineageFromQueryQueryParams = {
  /**
   * @example SELECT a.customer_id, b.order_id FROM customers a JOIN orders b ON a.customer_id = b.customer_id
   */
  sql: string;
  /**
   * @example postgresql
   */
  dialect: string;
  /**
   * @example 550e8400-e29b-41d4-a716-446655440000
   */
  table_id?: string;
  /**
   * @example production
   */
  default_database?: string;
  /**
   * @example public
   */
  default_schema?: string;
};

export type ApiGetLineageFromQueryError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetLineageFromQueryVariables = {
  queryParams: ApiGetLineageFromQueryQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Preview Lineage from a Query.
 */
export const fetchApiGetLineageFromQuery = (
  variables: ApiGetLineageFromQueryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFromQueryOut,
    ApiGetLineageFromQueryError,
    undefined,
    {},
    ApiGetLineageFromQueryQueryParams,
    {}
  >({
    url: "/lineage/lineage_from_query/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetLineageFromQueryQueryKey = (
  variables: ApiGetLineageFromQueryVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/lineage_from_query/",
    operationId: "apiGetLineageFromQuery",
    variables,
  });

/**
 * Preview Lineage from a Query.
 */
export const useApiGetLineageFromQuery = <TData = Schemas.LineageFromQueryOut,>(
  variables: ApiGetLineageFromQueryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageFromQueryOut,
      ApiGetLineageFromQueryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/lineage_from_query/",
    operationId: "apiGetLineageFromQuery",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageFromQueryOut,
    ApiGetLineageFromQueryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFromQuery({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Preview Lineage from a Query.
 */
export const useSuspenseApiGetLineageFromQuery = <
  TData = Schemas.LineageFromQueryOut,
>(
  variables: ApiGetLineageFromQueryVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageFromQueryOut,
      ApiGetLineageFromQueryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/lineage_from_query/",
    operationId: "apiGetLineageFromQuery",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageFromQueryOut,
    ApiGetLineageFromQueryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetLineageFromQuery({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiPostLineageFromQueryError = Fetcher.ErrorWrapper<undefined>;

export type ApiPostLineageFromQueryVariables = {
  body: Schemas.LineageFromQueryIn;
} & ApiContext["fetcherOptions"];

/**
 * Create Lineage from a Query.
 */
export const fetchApiPostLineageFromQuery = (
  variables: ApiPostLineageFromQueryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiPostLineageFromQueryError,
    Schemas.LineageFromQueryIn,
    {},
    {},
    {}
  >({
    url: "/lineage/lineage_from_query/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Create Lineage from a Query.
 */
export const useApiPostLineageFromQuery = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPostLineageFromQueryError,
      ApiPostLineageFromQueryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiPostLineageFromQueryError,
    ApiPostLineageFromQueryVariables
  >({
    mutationFn: (variables: ApiPostLineageFromQueryVariables) =>
      fetchApiPostLineageFromQuery({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPatchLineageFromQueryError = Fetcher.ErrorWrapper<undefined>;

export type ApiPatchLineageFromQueryVariables = {
  body: Schemas.LineageFromQueryIn;
} & ApiContext["fetcherOptions"];

/**
 * Create Lineage from Query and Removes Existing Upstream Non-Manual Lineage from Target Table.
 */
export const fetchApiPatchLineageFromQuery = (
  variables: ApiPatchLineageFromQueryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiPatchLineageFromQueryError,
    Schemas.LineageFromQueryIn,
    {},
    {},
    {}
  >({
    url: "/lineage/lineage_from_query/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Create Lineage from Query and Removes Existing Upstream Non-Manual Lineage from Target Table.
 */
export const useApiPatchLineageFromQuery = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiPatchLineageFromQueryError,
      ApiPatchLineageFromQueryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiPatchLineageFromQueryError,
    ApiPatchLineageFromQueryVariables
  >({
    mutationFn: (variables: ApiPatchLineageFromQueryVariables) =>
      fetchApiPatchLineageFromQuery({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRetrieveManualLineagePathParams = {
  lineageId: string;
};

export type ApiRetrieveManualLineageError = Fetcher.ErrorWrapper<undefined>;

export type ApiRetrieveManualLineageVariables = {
  pathParams: ApiRetrieveManualLineagePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a lineage object by its ID.
 */
export const fetchApiRetrieveManualLineage = (
  variables: ApiRetrieveManualLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageOut,
    ApiRetrieveManualLineageError,
    undefined,
    {},
    {},
    ApiRetrieveManualLineagePathParams
  >({
    url: "/lineage/manual/{lineageId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiRetrieveManualLineageQueryKey = (
  variables: ApiRetrieveManualLineageVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/manual/{lineageId}/",
    operationId: "apiRetrieveManualLineage",
    variables,
  });

/**
 * Get a lineage object by its ID.
 */
export const useApiRetrieveManualLineage = <TData = Schemas.LineageOut,>(
  variables: ApiRetrieveManualLineageVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageOut,
      ApiRetrieveManualLineageError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/manual/{lineageId}/",
    operationId: "apiRetrieveManualLineage",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageOut,
    ApiRetrieveManualLineageError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveManualLineage(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a lineage object by its ID.
 */
export const useSuspenseApiRetrieveManualLineage = <
  TData = Schemas.LineageOut,
>(
  variables: ApiRetrieveManualLineageVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageOut,
      ApiRetrieveManualLineageError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/manual/{lineageId}/",
    operationId: "apiRetrieveManualLineage",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageOut,
    ApiRetrieveManualLineageError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveManualLineage(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiDeleteManualLineagePathParams = {
  lineageId: string;
};

export type ApiDeleteManualLineageError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteManualLineageVariables = {
  pathParams: ApiDeleteManualLineagePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete a lineage object by its ID.
 */
export const fetchApiDeleteManualLineage = (
  variables: ApiDeleteManualLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteManualLineageError,
    undefined,
    {},
    {},
    ApiDeleteManualLineagePathParams
  >({
    url: "/lineage/manual/{lineageId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete a lineage object by its ID.
 */
export const useApiDeleteManualLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteManualLineageError,
      ApiDeleteManualLineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteManualLineageError,
    ApiDeleteManualLineageVariables
  >({
    mutationFn: (variables: ApiDeleteManualLineageVariables) =>
      fetchApiDeleteManualLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRetrieveLineagePathParams = {
  lineageId: string;
};

export type ApiRetrieveLineageError = Fetcher.ErrorWrapper<undefined>;

export type ApiRetrieveLineageVariables = {
  pathParams: ApiRetrieveLineagePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRetrieveLineage = (
  variables: ApiRetrieveLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageOut,
    ApiRetrieveLineageError,
    undefined,
    {},
    {},
    ApiRetrieveLineagePathParams
  >({ url: "/lineage/{lineageId}/", method: "get", ...variables, signal });

export const apiRetrieveLineageQueryKey = (
  variables: ApiRetrieveLineageVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/lineage/{lineageId}/",
    operationId: "apiRetrieveLineage",
    variables,
  });

export const useApiRetrieveLineage = <TData = Schemas.LineageOut,>(
  variables: ApiRetrieveLineageVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LineageOut,
      ApiRetrieveLineageError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/{lineageId}/",
    operationId: "apiRetrieveLineage",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LineageOut,
    ApiRetrieveLineageError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveLineage({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiRetrieveLineage = <TData = Schemas.LineageOut,>(
  variables: ApiRetrieveLineageVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LineageOut,
      ApiRetrieveLineageError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/lineage/{lineageId}/",
    operationId: "apiRetrieveLineage",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LineageOut,
    ApiRetrieveLineageError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveLineage({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiDeleteLineagePathParams = {
  lineageId: string;
};

export type ApiDeleteLineageError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteLineageVariables = {
  pathParams: ApiDeleteLineagePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiDeleteLineage = (
  variables: ApiDeleteLineageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteLineageError,
    undefined,
    {},
    {},
    ApiDeleteLineagePathParams
  >({ url: "/lineage/{lineageId}/", method: "delete", ...variables, signal });

export const useApiDeleteLineage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteLineageError,
      ApiDeleteLineageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteLineageError,
    ApiDeleteLineageVariables
  >({
    mutationFn: (variables: ApiDeleteLineageVariables) =>
      fetchApiDeleteLineage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetErdFlowPathParams = {
  tableId: string;
};

export type ApiGetErdFlowQueryParams = {
  /**
   * @default true
   */
  key_relationships?: boolean;
  /**
   * @default true
   */
  join_relationships?: boolean;
};

export type ApiGetErdFlowError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetErdFlowVariables = {
  pathParams: ApiGetErdFlowPathParams;
  queryParams?: ApiGetErdFlowQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetErdFlow = (
  variables: ApiGetErdFlowVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ERDFlowOut,
    ApiGetErdFlowError,
    undefined,
    {},
    ApiGetErdFlowQueryParams,
    ApiGetErdFlowPathParams
  >({ url: "/erd_flow/{tableId}/", method: "get", ...variables, signal });

export const apiGetErdFlowQueryKey = (
  variables: ApiGetErdFlowVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/erd_flow/{tableId}/",
    operationId: "apiGetErdFlow",
    variables,
  });

export const useApiGetErdFlow = <TData = Schemas.ERDFlowOut,>(
  variables: ApiGetErdFlowVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ERDFlowOut, ApiGetErdFlowError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/erd_flow/{tableId}/",
    operationId: "apiGetErdFlow",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ERDFlowOut,
    ApiGetErdFlowError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetErdFlow({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetErdFlow = <TData = Schemas.ERDFlowOut,>(
  variables: ApiGetErdFlowVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ERDFlowOut,
      ApiGetErdFlowError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/erd_flow/{tableId}/",
    operationId: "apiGetErdFlow",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ERDFlowOut,
    ApiGetErdFlowError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetErdFlow({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateAnnouncementError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateAnnouncementVariables = {
  body: Schemas.AnnouncementIn;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateAnnouncement = (
  variables: ApiCreateAnnouncementVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AnnouncementOut,
    ApiCreateAnnouncementError,
    Schemas.AnnouncementIn,
    {},
    {},
    {}
  >({
    url: "/announcement/announcements/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCreateAnnouncement = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AnnouncementOut,
      ApiCreateAnnouncementError,
      ApiCreateAnnouncementVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AnnouncementOut,
    ApiCreateAnnouncementError,
    ApiCreateAnnouncementVariables
  >({
    mutationFn: (variables: ApiCreateAnnouncementVariables) =>
      fetchApiCreateAnnouncement({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateAnnouncementError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAnnouncementVariables = {
  body: Schemas.AnnouncementUpdateIn;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAnnouncement = (
  variables: ApiUpdateAnnouncementVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiUpdateAnnouncementError,
    Schemas.AnnouncementUpdateIn,
    {},
    {},
    {}
  >({
    url: "/announcement/announcements/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiUpdateAnnouncement = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiUpdateAnnouncementError,
      ApiUpdateAnnouncementVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiUpdateAnnouncementError,
    ApiUpdateAnnouncementVariables
  >({
    mutationFn: (variables: ApiUpdateAnnouncementVariables) =>
      fetchApiUpdateAnnouncement({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDeleteAnnouncementError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteAnnouncementVariables = {
  body: Schemas.AnnouncementDeleteIn;
} & ApiContext["fetcherOptions"];

export const fetchApiDeleteAnnouncement = (
  variables: ApiDeleteAnnouncementVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteAnnouncementError,
    Schemas.AnnouncementDeleteIn,
    {},
    {},
    {}
  >({
    url: "/announcement/announcements/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiDeleteAnnouncement = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteAnnouncementError,
      ApiDeleteAnnouncementVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteAnnouncementError,
    ApiDeleteAnnouncementVariables
  >({
    mutationFn: (variables: ApiDeleteAnnouncementVariables) =>
      fetchApiDeleteAnnouncement({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateCsvsPathParams = {
  reportId: string;
};

export type CreateCsvsError = Fetcher.ErrorWrapper<undefined>;

export type CreateCsvsResponse = {
  [key: string]: string;
};

export type CreateCsvsVariables = {
  pathParams: CreateCsvsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchCreateCsvs = (
  variables: CreateCsvsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    CreateCsvsResponse,
    CreateCsvsError,
    undefined,
    {},
    {},
    CreateCsvsPathParams
  >({
    url: "/report/{reportId}/create_csvs/",
    method: "get",
    ...variables,
    signal,
  });

export const createCsvsQueryKey = (
  variables: CreateCsvsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/report/{reportId}/create_csvs/",
    operationId: "createCsvs",
    variables,
  });

export const useCreateCsvs = <TData = CreateCsvsResponse,>(
  variables: CreateCsvsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<CreateCsvsResponse, CreateCsvsError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/report/{reportId}/create_csvs/",
    operationId: "createCsvs",
    variables,
  });
  const result = reactQuery.useQuery<
    CreateCsvsResponse,
    CreateCsvsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchCreateCsvs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseCreateCsvs = <TData = CreateCsvsResponse,>(
  variables: CreateCsvsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      CreateCsvsResponse,
      CreateCsvsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/report/{reportId}/create_csvs/",
    operationId: "createCsvs",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    CreateCsvsResponse,
    CreateCsvsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchCreateCsvs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ListPromptsQueryParams = {
  is_agent_run?: boolean | null;
  starting_point_entity_identifier?: string | null;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ListPromptsError = Fetcher.ErrorWrapper<undefined>;

export type ListPromptsVariables = {
  queryParams?: ListPromptsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List all top level prompts for the user
 */
export const fetchListPrompts = (
  variables: ListPromptsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedEmbeddedPromptParentOut,
    ListPromptsError,
    undefined,
    {},
    ListPromptsQueryParams,
    {}
  >({ url: "/ai/embedded_prompt/", method: "get", ...variables, signal });

export const listPromptsQueryKey = (
  variables: ListPromptsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/embedded_prompt/",
    operationId: "listPrompts",
    variables,
  });

/**
 * List all top level prompts for the user
 */
export const useListPrompts = <TData = Schemas.PagedEmbeddedPromptParentOut,>(
  variables: ListPromptsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedEmbeddedPromptParentOut,
      ListPromptsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/",
    operationId: "listPrompts",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedEmbeddedPromptParentOut,
    ListPromptsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListPrompts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List all top level prompts for the user
 */
export const useSuspenseListPrompts = <
  TData = Schemas.PagedEmbeddedPromptParentOut,
>(
  variables: ListPromptsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedEmbeddedPromptParentOut,
      ListPromptsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/",
    operationId: "listPrompts",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedEmbeddedPromptParentOut,
    ListPromptsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListPrompts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CreatePromptError = Fetcher.ErrorWrapper<undefined>;

export type CreatePromptVariables = {
  body: Schemas.EmbeddedPromptIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a new prompt
 */
export const fetchCreatePrompt = (
  variables: CreatePromptVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EmbeddedPromptParentOut,
    CreatePromptError,
    Schemas.EmbeddedPromptIn,
    {},
    {},
    {}
  >({ url: "/ai/embedded_prompt/", method: "post", ...variables, signal });

/**
 * Create a new prompt
 */
export const useCreatePrompt = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmbeddedPromptParentOut,
      CreatePromptError,
      CreatePromptVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EmbeddedPromptParentOut,
    CreatePromptError,
    CreatePromptVariables
  >({
    mutationFn: (variables: CreatePromptVariables) =>
      fetchCreatePrompt({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteAllPromptsError = Fetcher.ErrorWrapper<undefined>;

export type DeleteAllPromptsVariables = ApiContext["fetcherOptions"];

/**
 * Delete all prompts for the user
 */
export const fetchDeleteAllPrompts = (
  variables: DeleteAllPromptsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<undefined, DeleteAllPromptsError, undefined, {}, {}, {}>({
    url: "/ai/embedded_prompt/delete_all/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Delete all prompts for the user
 */
export const useDeleteAllPrompts = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteAllPromptsError,
      DeleteAllPromptsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteAllPromptsError,
    DeleteAllPromptsVariables
  >({
    mutationFn: (variables: DeleteAllPromptsVariables) =>
      fetchDeleteAllPrompts({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SuggestPromptsError = Fetcher.ErrorWrapper<undefined>;

export type SuggestPromptsVariables = {
  body: Schemas.SuggestedPromptsIn;
} & ApiContext["fetcherOptions"];

/**
 * Get personalized contextual prompts based on user's role, use_reason, and specified context.
 *
 * Args:
 *     data: Request body containing context, num_prompts, and optional element_id
 *         - context: The context type (e.g., PromptContextType.ONBOARDING, PromptContextType.BI_DASHBOARD, etc.)
 *         - num_prompts: Number of prompts to return (default: 4, max: 10)
 *         - element_id: Optional element ID for context-specific prompts (dashboard_id for bi_dashboard, metric_id for bi_metric/new_bi_metric)
 *
 * Returns:
 *     Suggested prompts tailored to the user and context
 */
export const fetchSuggestPrompts = (
  variables: SuggestPromptsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SuggestedPromptsOut,
    SuggestPromptsError,
    Schemas.SuggestedPromptsIn,
    {},
    {},
    {}
  >({
    url: "/ai/embedded_prompt/suggestions/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Get personalized contextual prompts based on user's role, use_reason, and specified context.
 *
 * Args:
 *     data: Request body containing context, num_prompts, and optional element_id
 *         - context: The context type (e.g., PromptContextType.ONBOARDING, PromptContextType.BI_DASHBOARD, etc.)
 *         - num_prompts: Number of prompts to return (default: 4, max: 10)
 *         - element_id: Optional element ID for context-specific prompts (dashboard_id for bi_dashboard, metric_id for bi_metric/new_bi_metric)
 *
 * Returns:
 *     Suggested prompts tailored to the user and context
 */
export const useSuggestPrompts = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SuggestedPromptsOut,
      SuggestPromptsError,
      SuggestPromptsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SuggestedPromptsOut,
    SuggestPromptsError,
    SuggestPromptsVariables
  >({
    mutationFn: (variables: SuggestPromptsVariables) =>
      fetchSuggestPrompts({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type WorkspaceAiFeedbackError = Fetcher.ErrorWrapper<undefined>;

export type WorkspaceAiFeedbackVariables = ApiContext["fetcherOptions"];

/**
 * Get AI feedback for the workspace
 */
export const fetchWorkspaceAiFeedback = (
  variables: WorkspaceAiFeedbackVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.WorkspaceAIFeedback | null,
    WorkspaceAiFeedbackError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/embedded_prompt/feedback/",
    method: "get",
    ...variables,
    signal,
  });

export const workspaceAiFeedbackQueryKey = (
  variables: WorkspaceAiFeedbackVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/embedded_prompt/feedback/",
    operationId: "workspaceAiFeedback",
    variables,
  });

/**
 * Get AI feedback for the workspace
 */
export const useWorkspaceAiFeedback = <
  TData = Schemas.WorkspaceAIFeedback | null,
>(
  variables: WorkspaceAiFeedbackVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.WorkspaceAIFeedback | null,
      WorkspaceAiFeedbackError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/feedback/",
    operationId: "workspaceAiFeedback",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.WorkspaceAIFeedback | null,
    WorkspaceAiFeedbackError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchWorkspaceAiFeedback({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get AI feedback for the workspace
 */
export const useSuspenseWorkspaceAiFeedback = <
  TData = Schemas.WorkspaceAIFeedback | null,
>(
  variables: WorkspaceAiFeedbackVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.WorkspaceAIFeedback | null,
      WorkspaceAiFeedbackError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/feedback/",
    operationId: "workspaceAiFeedback",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.WorkspaceAIFeedback | null,
    WorkspaceAiFeedbackError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchWorkspaceAiFeedback({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ListWorkspacePromptsQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ListWorkspacePromptsError = Fetcher.ErrorWrapper<undefined>;

export type ListWorkspacePromptsVariables = {
  queryParams?: ListWorkspacePromptsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchListWorkspacePrompts = (
  variables: ListWorkspacePromptsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedEmbeddedPromptOut,
    ListWorkspacePromptsError,
    undefined,
    {},
    ListWorkspacePromptsQueryParams,
    {}
  >({
    url: "/ai/embedded_prompt/workspace/",
    method: "get",
    ...variables,
    signal,
  });

export const listWorkspacePromptsQueryKey = (
  variables: ListWorkspacePromptsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/embedded_prompt/workspace/",
    operationId: "listWorkspacePrompts",
    variables,
  });

export const useListWorkspacePrompts = <
  TData = Schemas.PagedEmbeddedPromptOut,
>(
  variables: ListWorkspacePromptsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedEmbeddedPromptOut,
      ListWorkspacePromptsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/workspace/",
    operationId: "listWorkspacePrompts",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedEmbeddedPromptOut,
    ListWorkspacePromptsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListWorkspacePrompts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseListWorkspacePrompts = <
  TData = Schemas.PagedEmbeddedPromptOut,
>(
  variables: ListWorkspacePromptsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedEmbeddedPromptOut,
      ListWorkspacePromptsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/workspace/",
    operationId: "listWorkspacePrompts",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedEmbeddedPromptOut,
    ListWorkspacePromptsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListWorkspacePrompts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CreateMsteamsPromptError = Fetcher.ErrorWrapper<undefined>;

export type CreateMsteamsPromptVariables = {
  body: Schemas.MSTeamsPromptIn;
} & ApiContext["fetcherOptions"];

export const fetchCreateMsteamsPrompt = (
  variables: CreateMsteamsPromptVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    CreateMsteamsPromptError,
    Schemas.MSTeamsPromptIn,
    {},
    {},
    {}
  >({
    url: "/ai/embedded_prompt/msteams/",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateMsteamsPrompt = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      CreateMsteamsPromptError,
      CreateMsteamsPromptVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    string,
    CreateMsteamsPromptError,
    CreateMsteamsPromptVariables
  >({
    mutationFn: (variables: CreateMsteamsPromptVariables) =>
      fetchCreateMsteamsPrompt({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RetrievePromptPathParams = {
  promptId: string;
};

export type RetrievePromptError = Fetcher.ErrorWrapper<undefined>;

export type RetrievePromptVariables = {
  pathParams: RetrievePromptPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve a prompt by id
 */
export const fetchRetrievePrompt = (
  variables: RetrievePromptVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EmbeddedPromptParentOut,
    RetrievePromptError,
    undefined,
    {},
    {},
    RetrievePromptPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/",
    method: "get",
    ...variables,
    signal,
  });

export const retrievePromptQueryKey = (
  variables: RetrievePromptVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/",
    operationId: "retrievePrompt",
    variables,
  });

/**
 * Retrieve a prompt by id
 */
export const useRetrievePrompt = <TData = Schemas.EmbeddedPromptParentOut,>(
  variables: RetrievePromptVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EmbeddedPromptParentOut,
      RetrievePromptError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/",
    operationId: "retrievePrompt",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.EmbeddedPromptParentOut,
    RetrievePromptError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrievePrompt({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve a prompt by id
 */
export const useSuspenseRetrievePrompt = <
  TData = Schemas.EmbeddedPromptParentOut,
>(
  variables: RetrievePromptVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.EmbeddedPromptParentOut,
      RetrievePromptError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/",
    operationId: "retrievePrompt",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.EmbeddedPromptParentOut,
    RetrievePromptError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrievePrompt({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type UpdatePromptPathParams = {
  promptId: string;
};

export type UpdatePromptError = Fetcher.ErrorWrapper<undefined>;

export type UpdatePromptVariables = {
  body: Schemas.EmbeddedPromptEditIn;
  pathParams: UpdatePromptPathParams;
} & ApiContext["fetcherOptions"];

export const fetchUpdatePrompt = (
  variables: UpdatePromptVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EmbeddedPromptParentOut,
    UpdatePromptError,
    Schemas.EmbeddedPromptEditIn,
    {},
    {},
    UpdatePromptPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useUpdatePrompt = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmbeddedPromptParentOut,
      UpdatePromptError,
      UpdatePromptVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EmbeddedPromptParentOut,
    UpdatePromptError,
    UpdatePromptVariables
  >({
    mutationFn: (variables: UpdatePromptVariables) =>
      fetchUpdatePrompt({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeletePromptPathParams = {
  promptId: string;
};

export type DeletePromptError = Fetcher.ErrorWrapper<undefined>;

export type DeletePromptVariables = {
  pathParams: DeletePromptPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Only mark a prompt as archived (does not delete the prompt)
 *
 * This is useful to keep track of the billable usage of the prompt.
 */
export const fetchDeletePrompt = (
  variables: DeletePromptVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DeletePromptError,
    undefined,
    {},
    {},
    DeletePromptPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Only mark a prompt as archived (does not delete the prompt)
 *
 * This is useful to keep track of the billable usage of the prompt.
 */
export const useDeletePrompt = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeletePromptError,
      DeletePromptVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeletePromptError,
    DeletePromptVariables
  >({
    mutationFn: (variables: DeletePromptVariables) =>
      fetchDeletePrompt({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type TerminatePromptPathParams = {
  promptId: string;
};

export type TerminatePromptError = Fetcher.ErrorWrapper<undefined>;

export type TerminatePromptVariables = {
  pathParams: TerminatePromptPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Terminate a prompt
 */
export const fetchTerminatePrompt = (
  variables: TerminatePromptVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    TerminatePromptError,
    undefined,
    {},
    {},
    TerminatePromptPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/terminate/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Terminate a prompt
 */
export const useTerminatePrompt = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      TerminatePromptError,
      TerminatePromptVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    TerminatePromptError,
    TerminatePromptVariables
  >({
    mutationFn: (variables: TerminatePromptVariables) =>
      fetchTerminatePrompt({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RetryPromptPathParams = {
  promptId: string;
};

export type RetryPromptError = Fetcher.ErrorWrapper<undefined>;

export type RetryPromptVariables = {
  pathParams: RetryPromptPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Retry a prompt
 */
export const fetchRetryPrompt = (
  variables: RetryPromptVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EmbeddedPromptParentOut,
    RetryPromptError,
    undefined,
    {},
    {},
    RetryPromptPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/retry/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Retry a prompt
 */
export const useRetryPrompt = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmbeddedPromptParentOut,
      RetryPromptError,
      RetryPromptVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EmbeddedPromptParentOut,
    RetryPromptError,
    RetryPromptVariables
  >({
    mutationFn: (variables: RetryPromptVariables) =>
      fetchRetryPrompt({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type FeedbackPathParams = {
  promptId: string;
};

export type FeedbackError = Fetcher.ErrorWrapper<undefined>;

export type FeedbackVariables = {
  body: Schemas.EmbeddedPromptFeedbackIn;
  pathParams: FeedbackPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Post feedback to Slack
 */
export const fetchFeedback = (
  variables: FeedbackVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EmbeddedPromptParentOut,
    FeedbackError,
    Schemas.EmbeddedPromptFeedbackIn,
    {},
    {},
    FeedbackPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/feedback/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Post feedback to Slack
 */
export const useFeedback = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmbeddedPromptParentOut,
      FeedbackError,
      FeedbackVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EmbeddedPromptParentOut,
    FeedbackError,
    FeedbackVariables
  >({
    mutationFn: (variables: FeedbackVariables) =>
      fetchFeedback({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ContinuePromptPathParams = {
  promptId: string;
};

export type ContinuePromptError = Fetcher.ErrorWrapper<undefined>;

export type ContinuePromptVariables = {
  pathParams: ContinuePromptPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Continue processing the prompt
 */
export const fetchContinuePrompt = (
  variables: ContinuePromptVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ContinuePromptError,
    undefined,
    {},
    {},
    ContinuePromptPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/continue/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Continue processing the prompt
 */
export const useContinuePrompt = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ContinuePromptError,
      ContinuePromptVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ContinuePromptError,
    ContinuePromptVariables
  >({
    mutationFn: (variables: ContinuePromptVariables) =>
      fetchContinuePrompt({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SharePathParams = {
  promptId: string;
};

export type ShareError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ShareVariables = {
  body: Schemas.EmbeddedPromptShareIn;
  pathParams: SharePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Share a prompt
 */
export const fetchShare = (variables: ShareVariables, signal?: AbortSignal) =>
  apiFetch<
    undefined,
    ShareError,
    Schemas.EmbeddedPromptShareIn,
    {},
    {},
    SharePathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/share/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Share a prompt
 */
export const useShare = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, ShareError, ShareVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<undefined, ShareError, ShareVariables>({
    mutationFn: (variables: ShareVariables) =>
      fetchShare({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListReferencedObjectsPathParams = {
  promptId: string;
};

export type ApiListReferencedObjectsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListReferencedObjectsResponse =
  Schemas.SecodaAIReferencedObjectOut[];

export type ApiListReferencedObjectsVariables = {
  pathParams: ApiListReferencedObjectsPathParams;
} & ApiContext["fetcherOptions"];

/**
 * List all referenced objects for a prompt
 */
export const fetchApiListReferencedObjects = (
  variables: ApiListReferencedObjectsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiListReferencedObjectsResponse,
    ApiListReferencedObjectsError,
    undefined,
    {},
    {},
    ApiListReferencedObjectsPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/referenced-objects/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListReferencedObjectsQueryKey = (
  variables: ApiListReferencedObjectsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/referenced-objects/",
    operationId: "apiListReferencedObjects",
    variables,
  });

/**
 * List all referenced objects for a prompt
 */
export const useApiListReferencedObjects = <
  TData = ApiListReferencedObjectsResponse,
>(
  variables: ApiListReferencedObjectsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiListReferencedObjectsResponse,
      ApiListReferencedObjectsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/referenced-objects/",
    operationId: "apiListReferencedObjects",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiListReferencedObjectsResponse,
    ApiListReferencedObjectsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListReferencedObjects(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List all referenced objects for a prompt
 */
export const useSuspenseApiListReferencedObjects = <
  TData = ApiListReferencedObjectsResponse,
>(
  variables: ApiListReferencedObjectsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiListReferencedObjectsResponse,
      ApiListReferencedObjectsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/referenced-objects/",
    operationId: "apiListReferencedObjects",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiListReferencedObjectsResponse,
    ApiListReferencedObjectsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListReferencedObjects(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiRetrieveReferencedObjectDetailPathParams = {
  promptId: string;
  objectId: string;
};

export type ApiRetrieveReferencedObjectDetailError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiRetrieveReferencedObjectDetailVariables = {
  pathParams: ApiRetrieveReferencedObjectDetailPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve a referenced object for a prompt
 */
export const fetchApiRetrieveReferencedObjectDetail = (
  variables: ApiRetrieveReferencedObjectDetailVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaAIReferencedObjectDetailOut,
    ApiRetrieveReferencedObjectDetailError,
    undefined,
    {},
    {},
    ApiRetrieveReferencedObjectDetailPathParams
  >({
    url: "/ai/embedded_prompt/{promptId}/referenced-objects/{objectId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiRetrieveReferencedObjectDetailQueryKey = (
  variables: ApiRetrieveReferencedObjectDetailVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/referenced-objects/{objectId}/",
    operationId: "apiRetrieveReferencedObjectDetail",
    variables,
  });

/**
 * Retrieve a referenced object for a prompt
 */
export const useApiRetrieveReferencedObjectDetail = <
  TData = Schemas.SecodaAIReferencedObjectDetailOut,
>(
  variables: ApiRetrieveReferencedObjectDetailVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SecodaAIReferencedObjectDetailOut,
      ApiRetrieveReferencedObjectDetailError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/referenced-objects/{objectId}/",
    operationId: "apiRetrieveReferencedObjectDetail",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SecodaAIReferencedObjectDetailOut,
    ApiRetrieveReferencedObjectDetailError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveReferencedObjectDetail(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve a referenced object for a prompt
 */
export const useSuspenseApiRetrieveReferencedObjectDetail = <
  TData = Schemas.SecodaAIReferencedObjectDetailOut,
>(
  variables: ApiRetrieveReferencedObjectDetailVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SecodaAIReferencedObjectDetailOut,
      ApiRetrieveReferencedObjectDetailError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/embedded_prompt/{promptId}/referenced-objects/{objectId}/",
    operationId: "apiRetrieveReferencedObjectDetail",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SecodaAIReferencedObjectDetailOut,
    ApiRetrieveReferencedObjectDetailError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiRetrieveReferencedObjectDetail(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetCustomInstructionsError = Fetcher.ErrorWrapper<undefined>;

export type GetCustomInstructionsVariables = ApiContext["fetcherOptions"];

export const fetchGetCustomInstructions = (
  variables: GetCustomInstructionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomInstructionsOut,
    GetCustomInstructionsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/instructions/",
    method: "get",
    ...variables,
    signal,
  });

export const getCustomInstructionsQueryKey = (
  variables: GetCustomInstructionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/preferences/instructions/",
    operationId: "getCustomInstructions",
    variables,
  });

export const useGetCustomInstructions = <
  TData = Schemas.CustomInstructionsOut,
>(
  variables: GetCustomInstructionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CustomInstructionsOut,
      GetCustomInstructionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/instructions/",
    operationId: "getCustomInstructions",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CustomInstructionsOut,
    GetCustomInstructionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCustomInstructions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetCustomInstructions = <
  TData = Schemas.CustomInstructionsOut,
>(
  variables: GetCustomInstructionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CustomInstructionsOut,
      GetCustomInstructionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/instructions/",
    operationId: "getCustomInstructions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CustomInstructionsOut,
    GetCustomInstructionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCustomInstructions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetCustomInstructionsError = Fetcher.ErrorWrapper<undefined>;

export type SetCustomInstructionsVariables = {
  body: Schemas.CustomInstructionsIn;
} & ApiContext["fetcherOptions"];

export const fetchSetCustomInstructions = (
  variables: SetCustomInstructionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomInstructionsOut,
    SetCustomInstructionsError,
    Schemas.CustomInstructionsIn,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/instructions/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetCustomInstructions = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CustomInstructionsOut,
      SetCustomInstructionsError,
      SetCustomInstructionsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CustomInstructionsOut,
    SetCustomInstructionsError,
    SetCustomInstructionsVariables
  >({
    mutationFn: (variables: SetCustomInstructionsVariables) =>
      fetchSetCustomInstructions({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SetCustomDescriptionStyleError = Fetcher.ErrorWrapper<undefined>;

export type SetCustomDescriptionStyleVariables = {
  body: Schemas.CustomInstructionsIn;
} & ApiContext["fetcherOptions"];

export const fetchSetCustomDescriptionStyle = (
  variables: SetCustomDescriptionStyleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomInstructionsOut,
    SetCustomDescriptionStyleError,
    Schemas.CustomInstructionsIn,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/descriptions/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetCustomDescriptionStyle = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CustomInstructionsOut,
      SetCustomDescriptionStyleError,
      SetCustomDescriptionStyleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CustomInstructionsOut,
    SetCustomDescriptionStyleError,
    SetCustomDescriptionStyleVariables
  >({
    mutationFn: (variables: SetCustomDescriptionStyleVariables) =>
      fetchSetCustomDescriptionStyle({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetCustomDescriptionStyleError = Fetcher.ErrorWrapper<undefined>;

export type GetCustomDescriptionStyleVariables = ApiContext["fetcherOptions"];

export const fetchGetCustomDescriptionStyle = (
  variables: GetCustomDescriptionStyleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomInstructionsOut,
    GetCustomDescriptionStyleError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/descriptions/",
    method: "get",
    ...variables,
    signal,
  });

export const getCustomDescriptionStyleQueryKey = (
  variables: GetCustomDescriptionStyleVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/preferences/descriptions/",
    operationId: "getCustomDescriptionStyle",
    variables,
  });

export const useGetCustomDescriptionStyle = <
  TData = Schemas.CustomInstructionsOut,
>(
  variables: GetCustomDescriptionStyleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CustomInstructionsOut,
      GetCustomDescriptionStyleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/descriptions/",
    operationId: "getCustomDescriptionStyle",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CustomInstructionsOut,
    GetCustomDescriptionStyleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCustomDescriptionStyle(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetCustomDescriptionStyle = <
  TData = Schemas.CustomInstructionsOut,
>(
  variables: GetCustomDescriptionStyleVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CustomInstructionsOut,
      GetCustomDescriptionStyleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/descriptions/",
    operationId: "getCustomDescriptionStyle",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CustomInstructionsOut,
    GetCustomDescriptionStyleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetCustomDescriptionStyle(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetAiCustomModelError = Fetcher.ErrorWrapper<undefined>;

export type SetAiCustomModelResponse = {
  [key: string]: boolean;
};

export type SetAiCustomModelVariables = {
  body: Schemas.CustomModelIn;
} & ApiContext["fetcherOptions"];

export const fetchSetAiCustomModel = (
  variables: SetAiCustomModelVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    SetAiCustomModelResponse,
    SetAiCustomModelError,
    Schemas.CustomModelIn,
    {},
    {},
    {}
  >({ url: "/ai/preferences/model/", method: "post", ...variables, signal });

export const useSetAiCustomModel = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SetAiCustomModelResponse,
      SetAiCustomModelError,
      SetAiCustomModelVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    SetAiCustomModelResponse,
    SetAiCustomModelError,
    SetAiCustomModelVariables
  >({
    mutationFn: (variables: SetAiCustomModelVariables) =>
      fetchSetAiCustomModel({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAiCustomModelError = Fetcher.ErrorWrapper<undefined>;

export type GetAiCustomModelVariables = ApiContext["fetcherOptions"];

export const fetchGetAiCustomModel = (
  variables: GetAiCustomModelVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CustomModelOut,
    GetAiCustomModelError,
    undefined,
    {},
    {},
    {}
  >({ url: "/ai/preferences/model/", method: "get", ...variables, signal });

export const getAiCustomModelQueryKey = (
  variables: GetAiCustomModelVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/preferences/model/",
    operationId: "getAiCustomModel",
    variables,
  });

export const useGetAiCustomModel = <TData = Schemas.CustomModelOut,>(
  variables: GetAiCustomModelVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CustomModelOut,
      GetAiCustomModelError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/model/",
    operationId: "getAiCustomModel",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CustomModelOut,
    GetAiCustomModelError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiCustomModel({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetAiCustomModel = <TData = Schemas.CustomModelOut,>(
  variables: GetAiCustomModelVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CustomModelOut,
      GetAiCustomModelError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/model/",
    operationId: "getAiCustomModel",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CustomModelOut,
    GetAiCustomModelError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiCustomModel({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetAiPrivacySettingsError = Fetcher.ErrorWrapper<undefined>;

export type GetAiPrivacySettingsVariables = ApiContext["fetcherOptions"];

export const fetchGetAiPrivacySettings = (
  variables: GetAiPrivacySettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PrivacySettingsOut,
    GetAiPrivacySettingsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/ai/preferences/privacy/", method: "get", ...variables, signal });

export const getAiPrivacySettingsQueryKey = (
  variables: GetAiPrivacySettingsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/preferences/privacy/",
    operationId: "getAiPrivacySettings",
    variables,
  });

export const useGetAiPrivacySettings = <TData = Schemas.PrivacySettingsOut,>(
  variables: GetAiPrivacySettingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PrivacySettingsOut,
      GetAiPrivacySettingsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/privacy/",
    operationId: "getAiPrivacySettings",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PrivacySettingsOut,
    GetAiPrivacySettingsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiPrivacySettings({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetAiPrivacySettings = <
  TData = Schemas.PrivacySettingsOut,
>(
  variables: GetAiPrivacySettingsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PrivacySettingsOut,
      GetAiPrivacySettingsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/privacy/",
    operationId: "getAiPrivacySettings",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PrivacySettingsOut,
    GetAiPrivacySettingsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiPrivacySettings({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetAiPrivacySettingsError = Fetcher.ErrorWrapper<undefined>;

export type SetAiPrivacySettingsVariables = {
  body: Schemas.UpdatePrivacySettingsIn;
} & ApiContext["fetcherOptions"];

export const fetchSetAiPrivacySettings = (
  variables: SetAiPrivacySettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetAiPrivacySettingsError,
    Schemas.UpdatePrivacySettingsIn,
    {},
    {},
    {}
  >({ url: "/ai/preferences/privacy/", method: "patch", ...variables, signal });

export const useSetAiPrivacySettings = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetAiPrivacySettingsError,
      SetAiPrivacySettingsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetAiPrivacySettingsError,
    SetAiPrivacySettingsVariables
  >({
    mutationFn: (variables: SetAiPrivacySettingsVariables) =>
      fetchSetAiPrivacySettings({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetIntelligentLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type GetIntelligentLlmProviderVariables = ApiContext["fetcherOptions"];

export const fetchGetIntelligentLlmProvider = (
  variables: GetIntelligentLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderOut,
    GetIntelligentLlmProviderError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/intelligent-llm/",
    method: "get",
    ...variables,
    signal,
  });

export const getIntelligentLlmProviderQueryKey = (
  variables: GetIntelligentLlmProviderVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/preferences/intelligent-llm/",
    operationId: "getIntelligentLlmProvider",
    variables,
  });

export const useGetIntelligentLlmProvider = <TData = Schemas.LLMProviderOut,>(
  variables: GetIntelligentLlmProviderVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LLMProviderOut,
      GetIntelligentLlmProviderError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/intelligent-llm/",
    operationId: "getIntelligentLlmProvider",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LLMProviderOut,
    GetIntelligentLlmProviderError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetIntelligentLlmProvider(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetIntelligentLlmProvider = <
  TData = Schemas.LLMProviderOut,
>(
  variables: GetIntelligentLlmProviderVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LLMProviderOut,
      GetIntelligentLlmProviderError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/intelligent-llm/",
    operationId: "getIntelligentLlmProvider",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LLMProviderOut,
    GetIntelligentLlmProviderError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetIntelligentLlmProvider(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetIntelligentLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type SetIntelligentLlmProviderVariables = {
  body: Schemas.LLMProviderIn;
} & ApiContext["fetcherOptions"];

export const fetchSetIntelligentLlmProvider = (
  variables: SetIntelligentLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderSuccessOut,
    SetIntelligentLlmProviderError,
    Schemas.LLMProviderIn,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/intelligent-llm/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetIntelligentLlmProvider = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LLMProviderSuccessOut,
      SetIntelligentLlmProviderError,
      SetIntelligentLlmProviderVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LLMProviderSuccessOut,
    SetIntelligentLlmProviderError,
    SetIntelligentLlmProviderVariables
  >({
    mutationFn: (variables: SetIntelligentLlmProviderVariables) =>
      fetchSetIntelligentLlmProvider({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteIntelligentLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type DeleteIntelligentLlmProviderVariables =
  ApiContext["fetcherOptions"];

export const fetchDeleteIntelligentLlmProvider = (
  variables: DeleteIntelligentLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderSuccessOut,
    DeleteIntelligentLlmProviderError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/intelligent-llm/",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteIntelligentLlmProvider = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LLMProviderSuccessOut,
      DeleteIntelligentLlmProviderError,
      DeleteIntelligentLlmProviderVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LLMProviderSuccessOut,
    DeleteIntelligentLlmProviderError,
    DeleteIntelligentLlmProviderVariables
  >({
    mutationFn: (variables: DeleteIntelligentLlmProviderVariables) =>
      fetchDeleteIntelligentLlmProvider({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetEfficientLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type GetEfficientLlmProviderVariables = ApiContext["fetcherOptions"];

export const fetchGetEfficientLlmProvider = (
  variables: GetEfficientLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderOut,
    GetEfficientLlmProviderError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/efficient-llm/",
    method: "get",
    ...variables,
    signal,
  });

export const getEfficientLlmProviderQueryKey = (
  variables: GetEfficientLlmProviderVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/preferences/efficient-llm/",
    operationId: "getEfficientLlmProvider",
    variables,
  });

export const useGetEfficientLlmProvider = <TData = Schemas.LLMProviderOut,>(
  variables: GetEfficientLlmProviderVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LLMProviderOut,
      GetEfficientLlmProviderError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/efficient-llm/",
    operationId: "getEfficientLlmProvider",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LLMProviderOut,
    GetEfficientLlmProviderError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetEfficientLlmProvider({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetEfficientLlmProvider = <
  TData = Schemas.LLMProviderOut,
>(
  variables: GetEfficientLlmProviderVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LLMProviderOut,
      GetEfficientLlmProviderError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/efficient-llm/",
    operationId: "getEfficientLlmProvider",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LLMProviderOut,
    GetEfficientLlmProviderError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetEfficientLlmProvider({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetEfficientLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type SetEfficientLlmProviderVariables = {
  body: Schemas.LLMProviderIn;
} & ApiContext["fetcherOptions"];

export const fetchSetEfficientLlmProvider = (
  variables: SetEfficientLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderSuccessOut,
    SetEfficientLlmProviderError,
    Schemas.LLMProviderIn,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/efficient-llm/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetEfficientLlmProvider = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LLMProviderSuccessOut,
      SetEfficientLlmProviderError,
      SetEfficientLlmProviderVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LLMProviderSuccessOut,
    SetEfficientLlmProviderError,
    SetEfficientLlmProviderVariables
  >({
    mutationFn: (variables: SetEfficientLlmProviderVariables) =>
      fetchSetEfficientLlmProvider({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteEfficientLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type DeleteEfficientLlmProviderVariables = ApiContext["fetcherOptions"];

export const fetchDeleteEfficientLlmProvider = (
  variables: DeleteEfficientLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderSuccessOut,
    DeleteEfficientLlmProviderError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/efficient-llm/",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteEfficientLlmProvider = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LLMProviderSuccessOut,
      DeleteEfficientLlmProviderError,
      DeleteEfficientLlmProviderVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LLMProviderSuccessOut,
    DeleteEfficientLlmProviderError,
    DeleteEfficientLlmProviderVariables
  >({
    mutationFn: (variables: DeleteEfficientLlmProviderVariables) =>
      fetchDeleteEfficientLlmProvider({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAutomationLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type GetAutomationLlmProviderVariables = ApiContext["fetcherOptions"];

export const fetchGetAutomationLlmProvider = (
  variables: GetAutomationLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderOut,
    GetAutomationLlmProviderError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/automation-llm/",
    method: "get",
    ...variables,
    signal,
  });

export const getAutomationLlmProviderQueryKey = (
  variables: GetAutomationLlmProviderVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/preferences/automation-llm/",
    operationId: "getAutomationLlmProvider",
    variables,
  });

export const useGetAutomationLlmProvider = <TData = Schemas.LLMProviderOut,>(
  variables: GetAutomationLlmProviderVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LLMProviderOut,
      GetAutomationLlmProviderError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/automation-llm/",
    operationId: "getAutomationLlmProvider",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LLMProviderOut,
    GetAutomationLlmProviderError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAutomationLlmProvider(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetAutomationLlmProvider = <
  TData = Schemas.LLMProviderOut,
>(
  variables: GetAutomationLlmProviderVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LLMProviderOut,
      GetAutomationLlmProviderError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/preferences/automation-llm/",
    operationId: "getAutomationLlmProvider",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LLMProviderOut,
    GetAutomationLlmProviderError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAutomationLlmProvider(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetAutomationLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type SetAutomationLlmProviderVariables = {
  body: Schemas.LLMProviderIn;
} & ApiContext["fetcherOptions"];

export const fetchSetAutomationLlmProvider = (
  variables: SetAutomationLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderSuccessOut,
    SetAutomationLlmProviderError,
    Schemas.LLMProviderIn,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/automation-llm/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetAutomationLlmProvider = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LLMProviderSuccessOut,
      SetAutomationLlmProviderError,
      SetAutomationLlmProviderVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LLMProviderSuccessOut,
    SetAutomationLlmProviderError,
    SetAutomationLlmProviderVariables
  >({
    mutationFn: (variables: SetAutomationLlmProviderVariables) =>
      fetchSetAutomationLlmProvider({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteAutomationLlmProviderError = Fetcher.ErrorWrapper<undefined>;

export type DeleteAutomationLlmProviderVariables = ApiContext["fetcherOptions"];

export const fetchDeleteAutomationLlmProvider = (
  variables: DeleteAutomationLlmProviderVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LLMProviderSuccessOut,
    DeleteAutomationLlmProviderError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/preferences/automation-llm/",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteAutomationLlmProvider = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LLMProviderSuccessOut,
      DeleteAutomationLlmProviderError,
      DeleteAutomationLlmProviderVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LLMProviderSuccessOut,
    DeleteAutomationLlmProviderError,
    DeleteAutomationLlmProviderVariables
  >({
    mutationFn: (variables: DeleteAutomationLlmProviderVariables) =>
      fetchDeleteAutomationLlmProvider({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateSummaryError = Fetcher.ErrorWrapper<undefined>;

export type CreateSummaryVariables = {
  body: Schemas.EditorPromptIn;
} & ApiContext["fetcherOptions"];

export const fetchCreateSummary = (
  variables: CreateSummaryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EditorPromptOut,
    CreateSummaryError,
    Schemas.EditorPromptIn,
    {},
    {},
    {}
  >({ url: "/ai/editor/summary/", method: "post", ...variables, signal });

export const useCreateSummary = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EditorPromptOut,
      CreateSummaryError,
      CreateSummaryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EditorPromptOut,
    CreateSummaryError,
    CreateSummaryVariables
  >({
    mutationFn: (variables: CreateSummaryVariables) =>
      fetchCreateSummary({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetFilterQueryParams = {
  query: string;
};

export type GetFilterError = Fetcher.ErrorWrapper<undefined>;

export type GetFilterVariables = {
  queryParams: GetFilterQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchGetFilter = (
  variables: GetFilterVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Filter,
    GetFilterError,
    undefined,
    {},
    GetFilterQueryParams,
    {}
  >({ url: "/ai/filters/filter/", method: "post", ...variables, signal });

export const useGetFilter = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Filter,
      GetFilterError,
      GetFilterVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Filter,
    GetFilterError,
    GetFilterVariables
  >({
    mutationFn: (variables: GetFilterVariables) =>
      fetchGetFilter({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetSortQueryParams = {
  query: string;
};

export type GetSortError = Fetcher.ErrorWrapper<undefined>;

export type GetSortVariables = {
  queryParams: GetSortQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchGetSort = (
  variables: GetSortVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.Sort, GetSortError, undefined, {}, GetSortQueryParams, {}>({
    url: "/ai/filters/sort/",
    method: "post",
    ...variables,
    signal,
  });

export const useGetSort = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.Sort, GetSortError, GetSortVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<Schemas.Sort, GetSortError, GetSortVariables>({
    mutationFn: (variables: GetSortVariables) =>
      fetchGetSort({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetPersonasError = Fetcher.ErrorWrapper<undefined>;

export type GetPersonasResponse = Schemas.AIPersonaOut[];

export type GetPersonasVariables = ApiContext["fetcherOptions"];

export const fetchGetPersonas = (
  variables: GetPersonasVariables,
  signal?: AbortSignal,
) =>
  apiFetch<GetPersonasResponse, GetPersonasError, undefined, {}, {}, {}>({
    url: "/ai/personas/",
    method: "get",
    ...variables,
    signal,
  });

export const getPersonasQueryKey = (
  variables: GetPersonasVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/personas/",
    operationId: "getPersonas",
    variables,
  });

export const useGetPersonas = <TData = GetPersonasResponse,>(
  variables: GetPersonasVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetPersonasResponse, GetPersonasError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/",
    operationId: "getPersonas",
    variables,
  });
  const result = reactQuery.useQuery<
    GetPersonasResponse,
    GetPersonasError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetPersonas({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetPersonas = <TData = GetPersonasResponse,>(
  variables: GetPersonasVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetPersonasResponse,
      GetPersonasError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/",
    operationId: "getPersonas",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetPersonasResponse,
    GetPersonasError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetPersonas({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CreatePersonaError = Fetcher.ErrorWrapper<undefined>;

export type CreatePersonaVariables = ApiContext["fetcherOptions"];

export const fetchCreatePersona = (
  variables: CreatePersonaVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.AIPersonaOut, CreatePersonaError, undefined, {}, {}, {}>({
    url: "/ai/personas/",
    method: "post",
    ...variables,
    signal,
  });

export const useCreatePersona = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AIPersonaOut,
      CreatePersonaError,
      CreatePersonaVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AIPersonaOut,
    CreatePersonaError,
    CreatePersonaVariables
  >({
    mutationFn: (variables: CreatePersonaVariables) =>
      fetchCreatePersona({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetPersonaPathParams = {
  personaId: string;
};

export type GetPersonaError = Fetcher.ErrorWrapper<undefined>;

export type GetPersonaVariables = {
  pathParams: GetPersonaPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetPersona = (
  variables: GetPersonaVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AIPersonaOut,
    GetPersonaError,
    undefined,
    {},
    {},
    GetPersonaPathParams
  >({ url: "/ai/personas/{personaId}/", method: "get", ...variables, signal });

export const getPersonaQueryKey = (
  variables: GetPersonaVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/personas/{personaId}/",
    operationId: "getPersona",
    variables,
  });

export const useGetPersona = <TData = Schemas.AIPersonaOut,>(
  variables: GetPersonaVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.AIPersonaOut, GetPersonaError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/",
    operationId: "getPersona",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AIPersonaOut,
    GetPersonaError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetPersona({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetPersona = <TData = Schemas.AIPersonaOut,>(
  variables: GetPersonaVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AIPersonaOut,
      GetPersonaError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/",
    operationId: "getPersona",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AIPersonaOut,
    GetPersonaError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetPersona({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type UpdatePersonaPathParams = {
  personaId: string;
};

export type UpdatePersonaError = Fetcher.ErrorWrapper<undefined>;

export type UpdatePersonaVariables = {
  body: Schemas.AIPersonaUpdateIn;
  pathParams: UpdatePersonaPathParams;
} & ApiContext["fetcherOptions"];

export const fetchUpdatePersona = (
  variables: UpdatePersonaVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AIPersonaOut,
    UpdatePersonaError,
    Schemas.AIPersonaUpdateIn,
    {},
    {},
    UpdatePersonaPathParams
  >({ url: "/ai/personas/{personaId}/", method: "put", ...variables, signal });

export const useUpdatePersona = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AIPersonaOut,
      UpdatePersonaError,
      UpdatePersonaVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AIPersonaOut,
    UpdatePersonaError,
    UpdatePersonaVariables
  >({
    mutationFn: (variables: UpdatePersonaVariables) =>
      fetchUpdatePersona({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeletePersonaPathParams = {
  personaId: string;
};

export type DeletePersonaError = Fetcher.ErrorWrapper<undefined>;

export type DeletePersonaVariables = {
  pathParams: DeletePersonaPathParams;
} & ApiContext["fetcherOptions"];

export const fetchDeletePersona = (
  variables: DeletePersonaVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DeletePersonaError,
    undefined,
    {},
    {},
    DeletePersonaPathParams
  >({
    url: "/ai/personas/{personaId}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeletePersona = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeletePersonaError,
      DeletePersonaVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeletePersonaError,
    DeletePersonaVariables
  >({
    mutationFn: (variables: DeletePersonaVariables) =>
      fetchDeletePersona({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetIncludedFiltersPathParams = {
  personaId: string;
};

export type GetIncludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type GetIncludedFiltersResponse = Schemas.Filter[];

export type GetIncludedFiltersVariables = {
  pathParams: GetIncludedFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetIncludedFilters = (
  variables: GetIncludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetIncludedFiltersResponse,
    GetIncludedFiltersError,
    undefined,
    {},
    {},
    GetIncludedFiltersPathParams
  >({
    url: "/ai/personas/{personaId}/included_filters/",
    method: "get",
    ...variables,
    signal,
  });

export const getIncludedFiltersQueryKey = (
  variables: GetIncludedFiltersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/personas/{personaId}/included_filters/",
    operationId: "getIncludedFilters",
    variables,
  });

export const useGetIncludedFilters = <TData = GetIncludedFiltersResponse,>(
  variables: GetIncludedFiltersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetIncludedFiltersResponse,
      GetIncludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/included_filters/",
    operationId: "getIncludedFilters",
    variables,
  });
  const result = reactQuery.useQuery<
    GetIncludedFiltersResponse,
    GetIncludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetIncludedFilters({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetIncludedFilters = <
  TData = GetIncludedFiltersResponse,
>(
  variables: GetIncludedFiltersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetIncludedFiltersResponse,
      GetIncludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/included_filters/",
    operationId: "getIncludedFilters",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetIncludedFiltersResponse,
    GetIncludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetIncludedFilters({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetIncludedFiltersPathParams = {
  personaId: string;
};

export type SetIncludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type SetIncludedFiltersRequestBody = Schemas.Filter[];

export type SetIncludedFiltersVariables = {
  body?: SetIncludedFiltersRequestBody;
  pathParams: SetIncludedFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSetIncludedFilters = (
  variables: SetIncludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetIncludedFiltersError,
    SetIncludedFiltersRequestBody,
    {},
    {},
    SetIncludedFiltersPathParams
  >({
    url: "/ai/personas/{personaId}/included_filters/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetIncludedFilters = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetIncludedFiltersError,
      SetIncludedFiltersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetIncludedFiltersError,
    SetIncludedFiltersVariables
  >({
    mutationFn: (variables: SetIncludedFiltersVariables) =>
      fetchSetIncludedFilters({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetExcludedFiltersPathParams = {
  personaId: string;
};

export type GetExcludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type GetExcludedFiltersResponse = Schemas.Filter[];

export type GetExcludedFiltersVariables = {
  pathParams: GetExcludedFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetExcludedFilters = (
  variables: GetExcludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetExcludedFiltersResponse,
    GetExcludedFiltersError,
    undefined,
    {},
    {},
    GetExcludedFiltersPathParams
  >({
    url: "/ai/personas/{personaId}/excluded_filters/",
    method: "get",
    ...variables,
    signal,
  });

export const getExcludedFiltersQueryKey = (
  variables: GetExcludedFiltersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/personas/{personaId}/excluded_filters/",
    operationId: "getExcludedFilters",
    variables,
  });

export const useGetExcludedFilters = <TData = GetExcludedFiltersResponse,>(
  variables: GetExcludedFiltersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetExcludedFiltersResponse,
      GetExcludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/excluded_filters/",
    operationId: "getExcludedFilters",
    variables,
  });
  const result = reactQuery.useQuery<
    GetExcludedFiltersResponse,
    GetExcludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetExcludedFilters({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetExcludedFilters = <
  TData = GetExcludedFiltersResponse,
>(
  variables: GetExcludedFiltersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetExcludedFiltersResponse,
      GetExcludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/excluded_filters/",
    operationId: "getExcludedFilters",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetExcludedFiltersResponse,
    GetExcludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetExcludedFilters({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetExcludedFiltersPathParams = {
  personaId: string;
};

export type SetExcludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type SetExcludedFiltersRequestBody = Schemas.Filter[];

export type SetExcludedFiltersVariables = {
  body?: SetExcludedFiltersRequestBody;
  pathParams: SetExcludedFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSetExcludedFilters = (
  variables: SetExcludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetExcludedFiltersError,
    SetExcludedFiltersRequestBody,
    {},
    {},
    SetExcludedFiltersPathParams
  >({
    url: "/ai/personas/{personaId}/excluded_filters/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetExcludedFilters = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetExcludedFiltersError,
      SetExcludedFiltersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetExcludedFiltersError,
    SetExcludedFiltersVariables
  >({
    mutationFn: (variables: SetExcludedFiltersVariables) =>
      fetchSetExcludedFilters({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetRunSqlIncludedFiltersPathParams = {
  personaId: string;
};

export type GetRunSqlIncludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type GetRunSqlIncludedFiltersResponse = Schemas.Filter[];

export type GetRunSqlIncludedFiltersVariables = {
  pathParams: GetRunSqlIncludedFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetRunSqlIncludedFilters = (
  variables: GetRunSqlIncludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetRunSqlIncludedFiltersResponse,
    GetRunSqlIncludedFiltersError,
    undefined,
    {},
    {},
    GetRunSqlIncludedFiltersPathParams
  >({
    url: "/ai/personas/{personaId}/run_sql_included_filters/",
    method: "get",
    ...variables,
    signal,
  });

export const getRunSqlIncludedFiltersQueryKey = (
  variables: GetRunSqlIncludedFiltersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/personas/{personaId}/run_sql_included_filters/",
    operationId: "getRunSqlIncludedFilters",
    variables,
  });

export const useGetRunSqlIncludedFilters = <
  TData = GetRunSqlIncludedFiltersResponse,
>(
  variables: GetRunSqlIncludedFiltersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetRunSqlIncludedFiltersResponse,
      GetRunSqlIncludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/run_sql_included_filters/",
    operationId: "getRunSqlIncludedFilters",
    variables,
  });
  const result = reactQuery.useQuery<
    GetRunSqlIncludedFiltersResponse,
    GetRunSqlIncludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetRunSqlIncludedFilters(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetRunSqlIncludedFilters = <
  TData = GetRunSqlIncludedFiltersResponse,
>(
  variables: GetRunSqlIncludedFiltersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetRunSqlIncludedFiltersResponse,
      GetRunSqlIncludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/run_sql_included_filters/",
    operationId: "getRunSqlIncludedFilters",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetRunSqlIncludedFiltersResponse,
    GetRunSqlIncludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetRunSqlIncludedFilters(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetRunSqlIncludedFiltersPathParams = {
  personaId: string;
};

export type SetRunSqlIncludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type SetRunSqlIncludedFiltersRequestBody = Schemas.Filter[];

export type SetRunSqlIncludedFiltersVariables = {
  body?: SetRunSqlIncludedFiltersRequestBody;
  pathParams: SetRunSqlIncludedFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSetRunSqlIncludedFilters = (
  variables: SetRunSqlIncludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetRunSqlIncludedFiltersError,
    SetRunSqlIncludedFiltersRequestBody,
    {},
    {},
    SetRunSqlIncludedFiltersPathParams
  >({
    url: "/ai/personas/{personaId}/run_sql_included_filters/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetRunSqlIncludedFilters = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetRunSqlIncludedFiltersError,
      SetRunSqlIncludedFiltersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetRunSqlIncludedFiltersError,
    SetRunSqlIncludedFiltersVariables
  >({
    mutationFn: (variables: SetRunSqlIncludedFiltersVariables) =>
      fetchSetRunSqlIncludedFilters({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetRunSqlExcludedFiltersPathParams = {
  personaId: string;
};

export type GetRunSqlExcludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type GetRunSqlExcludedFiltersResponse = Schemas.Filter[];

export type GetRunSqlExcludedFiltersVariables = {
  pathParams: GetRunSqlExcludedFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetRunSqlExcludedFilters = (
  variables: GetRunSqlExcludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetRunSqlExcludedFiltersResponse,
    GetRunSqlExcludedFiltersError,
    undefined,
    {},
    {},
    GetRunSqlExcludedFiltersPathParams
  >({
    url: "/ai/personas/{personaId}/run_sql_excluded_filters/",
    method: "get",
    ...variables,
    signal,
  });

export const getRunSqlExcludedFiltersQueryKey = (
  variables: GetRunSqlExcludedFiltersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/personas/{personaId}/run_sql_excluded_filters/",
    operationId: "getRunSqlExcludedFilters",
    variables,
  });

export const useGetRunSqlExcludedFilters = <
  TData = GetRunSqlExcludedFiltersResponse,
>(
  variables: GetRunSqlExcludedFiltersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetRunSqlExcludedFiltersResponse,
      GetRunSqlExcludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/run_sql_excluded_filters/",
    operationId: "getRunSqlExcludedFilters",
    variables,
  });
  const result = reactQuery.useQuery<
    GetRunSqlExcludedFiltersResponse,
    GetRunSqlExcludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetRunSqlExcludedFilters(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetRunSqlExcludedFilters = <
  TData = GetRunSqlExcludedFiltersResponse,
>(
  variables: GetRunSqlExcludedFiltersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetRunSqlExcludedFiltersResponse,
      GetRunSqlExcludedFiltersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/run_sql_excluded_filters/",
    operationId: "getRunSqlExcludedFilters",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetRunSqlExcludedFiltersResponse,
    GetRunSqlExcludedFiltersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetRunSqlExcludedFilters(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetRunSqlExcludedFiltersPathParams = {
  personaId: string;
};

export type SetRunSqlExcludedFiltersError = Fetcher.ErrorWrapper<undefined>;

export type SetRunSqlExcludedFiltersRequestBody = Schemas.Filter[];

export type SetRunSqlExcludedFiltersVariables = {
  body?: SetRunSqlExcludedFiltersRequestBody;
  pathParams: SetRunSqlExcludedFiltersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchSetRunSqlExcludedFilters = (
  variables: SetRunSqlExcludedFiltersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetRunSqlExcludedFiltersError,
    SetRunSqlExcludedFiltersRequestBody,
    {},
    {},
    SetRunSqlExcludedFiltersPathParams
  >({
    url: "/ai/personas/{personaId}/run_sql_excluded_filters/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetRunSqlExcludedFilters = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetRunSqlExcludedFiltersError,
      SetRunSqlExcludedFiltersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetRunSqlExcludedFiltersError,
    SetRunSqlExcludedFiltersVariables
  >({
    mutationFn: (variables: SetRunSqlExcludedFiltersVariables) =>
      fetchSetRunSqlExcludedFilters({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UploadAvatarPathParams = {
  personaId: string;
};

export type UploadAvatarError = Fetcher.ErrorWrapper<undefined>;

export type UploadAvatarRequestBody = {
  /**
   * @format binary
   */
  file: Blob;
};

export type UploadAvatarVariables = {
  body: UploadAvatarRequestBody;
  pathParams: UploadAvatarPathParams;
} & ApiContext["fetcherOptions"];

export const fetchUploadAvatar = (
  variables: UploadAvatarVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AIPersonaOut,
    UploadAvatarError,
    UploadAvatarRequestBody,
    {},
    {},
    UploadAvatarPathParams
  >({
    url: "/ai/personas/{personaId}/upload/",
    method: "post",
    ...variables,
    signal,
  });

export const useUploadAvatar = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AIPersonaOut,
      UploadAvatarError,
      UploadAvatarVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AIPersonaOut,
    UploadAvatarError,
    UploadAvatarVariables
  >({
    mutationFn: (variables: UploadAvatarVariables) =>
      fetchUploadAvatar({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetPersonaAgentToolsPathParams = {
  personaId: string;
};

export type GetPersonaAgentToolsError = Fetcher.ErrorWrapper<undefined>;

export type GetPersonaAgentToolsVariables = {
  pathParams: GetPersonaAgentToolsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetPersonaAgentTools = (
  variables: GetPersonaAgentToolsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AgentToolsOut,
    GetPersonaAgentToolsError,
    undefined,
    {},
    {},
    GetPersonaAgentToolsPathParams
  >({
    url: "/ai/personas/{personaId}/tools/",
    method: "get",
    ...variables,
    signal,
  });

export const getPersonaAgentToolsQueryKey = (
  variables: GetPersonaAgentToolsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/personas/{personaId}/tools/",
    operationId: "getPersonaAgentTools",
    variables,
  });

export const useGetPersonaAgentTools = <TData = Schemas.AgentToolsOut,>(
  variables: GetPersonaAgentToolsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AgentToolsOut,
      GetPersonaAgentToolsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/tools/",
    operationId: "getPersonaAgentTools",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AgentToolsOut,
    GetPersonaAgentToolsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetPersonaAgentTools({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetPersonaAgentTools = <TData = Schemas.AgentToolsOut,>(
  variables: GetPersonaAgentToolsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AgentToolsOut,
      GetPersonaAgentToolsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/personas/{personaId}/tools/",
    operationId: "getPersonaAgentTools",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AgentToolsOut,
    GetPersonaAgentToolsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetPersonaAgentTools({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type EnablePersonaAgentToolPathParams = {
  personaId: string;
  toolName: string;
};

export type EnablePersonaAgentToolError = Fetcher.ErrorWrapper<undefined>;

export type EnablePersonaAgentToolVariables = {
  pathParams: EnablePersonaAgentToolPathParams;
} & ApiContext["fetcherOptions"];

export const fetchEnablePersonaAgentTool = (
  variables: EnablePersonaAgentToolVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    EnablePersonaAgentToolError,
    undefined,
    {},
    {},
    EnablePersonaAgentToolPathParams
  >({
    url: "/ai/personas/{personaId}/tools/{toolName}/enable/",
    method: "post",
    ...variables,
    signal,
  });

export const useEnablePersonaAgentTool = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      EnablePersonaAgentToolError,
      EnablePersonaAgentToolVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    EnablePersonaAgentToolError,
    EnablePersonaAgentToolVariables
  >({
    mutationFn: (variables: EnablePersonaAgentToolVariables) =>
      fetchEnablePersonaAgentTool({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DisablePersonaAgentToolPathParams = {
  personaId: string;
  toolName: string;
};

export type DisablePersonaAgentToolError = Fetcher.ErrorWrapper<undefined>;

export type DisablePersonaAgentToolVariables = {
  pathParams: DisablePersonaAgentToolPathParams;
} & ApiContext["fetcherOptions"];

export const fetchDisablePersonaAgentTool = (
  variables: DisablePersonaAgentToolVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DisablePersonaAgentToolError,
    undefined,
    {},
    {},
    DisablePersonaAgentToolPathParams
  >({
    url: "/ai/personas/{personaId}/tools/{toolName}/disable/",
    method: "post",
    ...variables,
    signal,
  });

export const useDisablePersonaAgentTool = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DisablePersonaAgentToolError,
      DisablePersonaAgentToolVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DisablePersonaAgentToolError,
    DisablePersonaAgentToolVariables
  >({
    mutationFn: (variables: DisablePersonaAgentToolVariables) =>
      fetchDisablePersonaAgentTool({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PresignUploadQueryParams = {
  unique_file_key?: string;
  /**
   * @default default
   */
  path?: string;
};

export type PresignUploadError = Fetcher.ErrorWrapper<undefined>;

export type PresignUploadResponse = {
  [key: string]: any;
};

export type PresignUploadVariables = {
  queryParams?: PresignUploadQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchPresignUpload = (
  variables: PresignUploadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    PresignUploadResponse,
    PresignUploadError,
    undefined,
    {},
    PresignUploadQueryParams,
    {}
  >({ url: "/ai/file/presign_upload/", method: "get", ...variables, signal });

export const presignUploadQueryKey = (
  variables: PresignUploadVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/file/presign_upload/",
    operationId: "presignUpload",
    variables,
  });

export const usePresignUpload = <TData = PresignUploadResponse,>(
  variables: PresignUploadVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      PresignUploadResponse,
      PresignUploadError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/file/presign_upload/",
    operationId: "presignUpload",
    variables,
  });
  const result = reactQuery.useQuery<
    PresignUploadResponse,
    PresignUploadError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchPresignUpload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspensePresignUpload = <TData = PresignUploadResponse,>(
  variables: PresignUploadVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      PresignUploadResponse,
      PresignUploadError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/file/presign_upload/",
    operationId: "presignUpload",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    PresignUploadResponse,
    PresignUploadError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchPresignUpload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type PresignDownloadQueryParams = {
  unique_file_key?: string;
  /**
   * @default default
   */
  path?: string;
  /**
   * @default Secoda
   */
  original_name?: string;
};

export type PresignDownloadError = Fetcher.ErrorWrapper<undefined>;

export type PresignDownloadVariables = {
  queryParams?: PresignDownloadQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchPresignDownload = (
  variables: PresignDownloadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    PresignDownloadError,
    undefined,
    {},
    PresignDownloadQueryParams,
    {}
  >({ url: "/ai/file/presign_download/", method: "get", ...variables, signal });

export const presignDownloadQueryKey = (
  variables: PresignDownloadVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/file/presign_download/",
    operationId: "presignDownload",
    variables,
  });

export const usePresignDownload = <TData = string,>(
  variables: PresignDownloadVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, PresignDownloadError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/file/presign_download/",
    operationId: "presignDownload",
    variables,
  });
  const result = reactQuery.useQuery<string, PresignDownloadError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchPresignDownload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspensePresignDownload = <TData = string,>(
  variables: PresignDownloadVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<string, PresignDownloadError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/file/presign_download/",
    operationId: "presignDownload",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    string,
    PresignDownloadError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchPresignDownload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetMemoriesQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type GetMemoriesError = Fetcher.ErrorWrapper<undefined>;

export type GetMemoriesVariables = {
  queryParams?: GetMemoriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List all memories for the user
 */
export const fetchGetMemories = (
  variables: GetMemoriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedAIMemoryOut,
    GetMemoriesError,
    undefined,
    {},
    GetMemoriesQueryParams,
    {}
  >({ url: "/ai/memory/", method: "get", ...variables, signal });

export const getMemoriesQueryKey = (
  variables: GetMemoriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/memory/",
    operationId: "getMemories",
    variables,
  });

/**
 * List all memories for the user
 */
export const useGetMemories = <TData = Schemas.PagedAIMemoryOut,>(
  variables: GetMemoriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedAIMemoryOut,
      GetMemoriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/memory/",
    operationId: "getMemories",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedAIMemoryOut,
    GetMemoriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetMemories({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List all memories for the user
 */
export const useSuspenseGetMemories = <TData = Schemas.PagedAIMemoryOut,>(
  variables: GetMemoriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedAIMemoryOut,
      GetMemoriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/memory/",
    operationId: "getMemories",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedAIMemoryOut,
    GetMemoriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetMemories({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type DeleteAllMemoriesError = Fetcher.ErrorWrapper<undefined>;

export type DeleteAllMemoriesVariables = ApiContext["fetcherOptions"];

/**
 * Delete all memories for the user
 */
export const fetchDeleteAllMemories = (
  variables: DeleteAllMemoriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<undefined, DeleteAllMemoriesError, undefined, {}, {}, {}>({
    url: "/ai/memory/delete_all/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Delete all memories for the user
 */
export const useDeleteAllMemories = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteAllMemoriesError,
      DeleteAllMemoriesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteAllMemoriesError,
    DeleteAllMemoriesVariables
  >({
    mutationFn: (variables: DeleteAllMemoriesVariables) =>
      fetchDeleteAllMemories({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteMemoryPathParams = {
  memoryId: string;
};

export type DeleteMemoryError = Fetcher.ErrorWrapper<undefined>;

export type DeleteMemoryVariables = {
  pathParams: DeleteMemoryPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete a single memory by ID
 */
export const fetchDeleteMemory = (
  variables: DeleteMemoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DeleteMemoryError,
    undefined,
    {},
    {},
    DeleteMemoryPathParams
  >({ url: "/ai/memory/{memoryId}/", method: "delete", ...variables, signal });

/**
 * Delete a single memory by ID
 */
export const useDeleteMemory = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteMemoryError,
      DeleteMemoryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteMemoryError,
    DeleteMemoryVariables
  >({
    mutationFn: (variables: DeleteMemoryVariables) =>
      fetchDeleteMemory({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAiUsageStatsQueryParams = {
  /**
   * @default 30
   */
  days?: number;
};

export type GetAiUsageStatsError = Fetcher.ErrorWrapper<undefined>;

export type GetAiUsageStatsVariables = {
  queryParams?: GetAiUsageStatsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchGetAiUsageStats = (
  variables: GetAiUsageStatsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AIChatTelemetryStatsOut,
    GetAiUsageStatsError,
    undefined,
    {},
    GetAiUsageStatsQueryParams,
    {}
  >({ url: "/ai/billing/usage/", method: "get", ...variables, signal });

export const getAiUsageStatsQueryKey = (
  variables: GetAiUsageStatsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/billing/usage/",
    operationId: "getAiUsageStats",
    variables,
  });

export const useGetAiUsageStats = <TData = Schemas.AIChatTelemetryStatsOut,>(
  variables: GetAiUsageStatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AIChatTelemetryStatsOut,
      GetAiUsageStatsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/billing/usage/",
    operationId: "getAiUsageStats",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AIChatTelemetryStatsOut,
    GetAiUsageStatsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiUsageStats({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetAiUsageStats = <
  TData = Schemas.AIChatTelemetryStatsOut,
>(
  variables: GetAiUsageStatsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AIChatTelemetryStatsOut,
      GetAiUsageStatsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/billing/usage/",
    operationId: "getAiUsageStats",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AIChatTelemetryStatsOut,
    GetAiUsageStatsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetAiUsageStats({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPromptCompletionsQueryParams = {
  q: string;
};

export type ApiGetPromptCompletionsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPromptCompletionsVariables = {
  queryParams: ApiGetPromptCompletionsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get prompt completion suggestions based on the selected prompt category
 */
export const fetchApiGetPromptCompletions = (
  variables: ApiGetPromptCompletionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PromptCompletionResponse,
    ApiGetPromptCompletionsError,
    undefined,
    {},
    ApiGetPromptCompletionsQueryParams,
    {}
  >({ url: "/ai/prompt_completions/", method: "get", ...variables, signal });

export const apiGetPromptCompletionsQueryKey = (
  variables: ApiGetPromptCompletionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/prompt_completions/",
    operationId: "apiGetPromptCompletions",
    variables,
  });

/**
 * Get prompt completion suggestions based on the selected prompt category
 */
export const useApiGetPromptCompletions = <
  TData = Schemas.PromptCompletionResponse,
>(
  variables: ApiGetPromptCompletionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PromptCompletionResponse,
      ApiGetPromptCompletionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/prompt_completions/",
    operationId: "apiGetPromptCompletions",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PromptCompletionResponse,
    ApiGetPromptCompletionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPromptCompletions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get prompt completion suggestions based on the selected prompt category
 */
export const useSuspenseApiGetPromptCompletions = <
  TData = Schemas.PromptCompletionResponse,
>(
  variables: ApiGetPromptCompletionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PromptCompletionResponse,
      ApiGetPromptCompletionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/prompt_completions/",
    operationId: "apiGetPromptCompletions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PromptCompletionResponse,
    ApiGetPromptCompletionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPromptCompletions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetGeneralPromptExamplesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetGeneralPromptExamplesVariables = ApiContext["fetcherOptions"];

/**
 * Get general prompt examples for onboarding and new users
 */
export const fetchApiGetGeneralPromptExamples = (
  variables: ApiGetGeneralPromptExamplesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PromptCompletionResponse,
    ApiGetGeneralPromptExamplesError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/prompt_completions/general/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetGeneralPromptExamplesQueryKey = (
  variables: ApiGetGeneralPromptExamplesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/prompt_completions/general/",
    operationId: "apiGetGeneralPromptExamples",
    variables,
  });

/**
 * Get general prompt examples for onboarding and new users
 */
export const useApiGetGeneralPromptExamples = <
  TData = Schemas.PromptCompletionResponse,
>(
  variables: ApiGetGeneralPromptExamplesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PromptCompletionResponse,
      ApiGetGeneralPromptExamplesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/prompt_completions/general/",
    operationId: "apiGetGeneralPromptExamples",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PromptCompletionResponse,
    ApiGetGeneralPromptExamplesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetGeneralPromptExamples(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get general prompt examples for onboarding and new users
 */
export const useSuspenseApiGetGeneralPromptExamples = <
  TData = Schemas.PromptCompletionResponse,
>(
  variables: ApiGetGeneralPromptExamplesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PromptCompletionResponse,
      ApiGetGeneralPromptExamplesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/prompt_completions/general/",
    operationId: "apiGetGeneralPromptExamples",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PromptCompletionResponse,
    ApiGetGeneralPromptExamplesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetGeneralPromptExamples(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ChartPresignDownloadQueryParams = {
  chart_id: string;
};

export type ChartPresignDownloadError = Fetcher.ErrorWrapper<undefined>;

export type ChartPresignDownloadVariables = {
  queryParams: ChartPresignDownloadQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchChartPresignDownload = (
  variables: ChartPresignDownloadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    ChartPresignDownloadError,
    undefined,
    {},
    ChartPresignDownloadQueryParams,
    {}
  >({
    url: "/ai/charts/presign_download/",
    method: "get",
    ...variables,
    signal,
  });

export const chartPresignDownloadQueryKey = (
  variables: ChartPresignDownloadVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/charts/presign_download/",
    operationId: "chartPresignDownload",
    variables,
  });

export const useChartPresignDownload = <TData = string,>(
  variables: ChartPresignDownloadVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, ChartPresignDownloadError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/charts/presign_download/",
    operationId: "chartPresignDownload",
    variables,
  });
  const result = reactQuery.useQuery<string, ChartPresignDownloadError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchChartPresignDownload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseChartPresignDownload = <TData = string,>(
  variables: ChartPresignDownloadVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      string,
      ChartPresignDownloadError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/charts/presign_download/",
    operationId: "chartPresignDownload",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    string,
    ChartPresignDownloadError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchChartPresignDownload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ArtifactPresignDownloadQueryParams = {
  artifact_id: string;
};

export type ArtifactPresignDownloadError = Fetcher.ErrorWrapper<undefined>;

export type ArtifactPresignDownloadVariables = {
  queryParams: ArtifactPresignDownloadQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchArtifactPresignDownload = (
  variables: ArtifactPresignDownloadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ArtifactOut,
    ArtifactPresignDownloadError,
    undefined,
    {},
    ArtifactPresignDownloadQueryParams,
    {}
  >({
    url: "/ai/artifacts/presign_download/",
    method: "get",
    ...variables,
    signal,
  });

export const artifactPresignDownloadQueryKey = (
  variables: ArtifactPresignDownloadVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/artifacts/presign_download/",
    operationId: "artifactPresignDownload",
    variables,
  });

export const useArtifactPresignDownload = <TData = Schemas.ArtifactOut,>(
  variables: ArtifactPresignDownloadVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ArtifactOut,
      ArtifactPresignDownloadError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/artifacts/presign_download/",
    operationId: "artifactPresignDownload",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ArtifactOut,
    ArtifactPresignDownloadError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchArtifactPresignDownload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseArtifactPresignDownload = <
  TData = Schemas.ArtifactOut,
>(
  variables: ArtifactPresignDownloadVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ArtifactOut,
      ArtifactPresignDownloadError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/artifacts/presign_download/",
    operationId: "artifactPresignDownload",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ArtifactOut,
    ArtifactPresignDownloadError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchArtifactPresignDownload({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type McpListToolsError = Fetcher.ErrorWrapper<undefined>;

export type McpListToolsVariables = ApiContext["fetcherOptions"];

/**
 * List available tools according to MCP specification
 */
export const fetchMcpListTools = (
  variables: McpListToolsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MCPListToolsResponse,
    McpListToolsError,
    undefined,
    {},
    {},
    {}
  >({ url: "/ai/mcp/tools/list/", method: "get", ...variables, signal });

export const mcpListToolsQueryKey = (
  variables: McpListToolsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/mcp/tools/list/",
    operationId: "mcpListTools",
    variables,
  });

/**
 * List available tools according to MCP specification
 */
export const useMcpListTools = <TData = Schemas.MCPListToolsResponse,>(
  variables: McpListToolsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.MCPListToolsResponse,
      McpListToolsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/mcp/tools/list/",
    operationId: "mcpListTools",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.MCPListToolsResponse,
    McpListToolsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchMcpListTools({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List available tools according to MCP specification
 */
export const useSuspenseMcpListTools = <TData = Schemas.MCPListToolsResponse,>(
  variables: McpListToolsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.MCPListToolsResponse,
      McpListToolsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/mcp/tools/list/",
    operationId: "mcpListTools",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.MCPListToolsResponse,
    McpListToolsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchMcpListTools({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type McpCallToolError = Fetcher.ErrorWrapper<undefined>;

export type McpCallToolVariables = {
  body: Schemas.MCPCallToolRequest;
} & ApiContext["fetcherOptions"];

export const fetchMcpCallTool = (
  variables: McpCallToolVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MCPToolCallResponse,
    McpCallToolError,
    Schemas.MCPCallToolRequest,
    {},
    {},
    {}
  >({ url: "/ai/mcp/tools/call/", method: "post", ...variables, signal });

export const useMcpCallTool = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MCPToolCallResponse,
      McpCallToolError,
      McpCallToolVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MCPToolCallResponse,
    McpCallToolError,
    McpCallToolVariables
  >({
    mutationFn: (variables: McpCallToolVariables) =>
      fetchMcpCallTool({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetProposalsGenerationResultQueryParams = {
  gen_type:
    | "glossaries_for_workspace"
    | "missing_descriptions_for_resources"
    | "monitors_for_workspace"
    | "monitors_for_table"
    | "monitors_for_integration";
  table_id?: string | null;
  integration_id?: string | null;
};

export type ApiGetProposalsGenerationResultError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetProposalsGenerationResultVariables = {
  queryParams: ApiGetProposalsGenerationResultQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetProposalsGenerationResult = (
  variables: ApiGetProposalsGenerationResultVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ProposalsGenerationResultOut,
    ApiGetProposalsGenerationResultError,
    undefined,
    {},
    ApiGetProposalsGenerationResultQueryParams,
    {}
  >({
    url: "/ai/proposals/proposals_generation/get_by_identifier/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetProposalsGenerationResultQueryKey = (
  variables: ApiGetProposalsGenerationResultVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/proposals/proposals_generation/get_by_identifier/",
    operationId: "apiGetProposalsGenerationResult",
    variables,
  });

export const useApiGetProposalsGenerationResult = <
  TData = Schemas.ProposalsGenerationResultOut,
>(
  variables: ApiGetProposalsGenerationResultVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ProposalsGenerationResultOut,
      ApiGetProposalsGenerationResultError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/proposals/proposals_generation/get_by_identifier/",
    operationId: "apiGetProposalsGenerationResult",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ProposalsGenerationResultOut,
    ApiGetProposalsGenerationResultError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetProposalsGenerationResult(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetProposalsGenerationResult = <
  TData = Schemas.ProposalsGenerationResultOut,
>(
  variables: ApiGetProposalsGenerationResultVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ProposalsGenerationResultOut,
      ApiGetProposalsGenerationResultError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/proposals/proposals_generation/get_by_identifier/",
    operationId: "apiGetProposalsGenerationResult",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ProposalsGenerationResultOut,
    ApiGetProposalsGenerationResultError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetProposalsGenerationResult(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiForceRefreshProposalsGenerationError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiForceRefreshProposalsGenerationVariables = {
  body: Schemas.GenerateProposalsRequest;
} & ApiContext["fetcherOptions"];

export const fetchApiForceRefreshProposalsGeneration = (
  variables: ApiForceRefreshProposalsGenerationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiForceRefreshProposalsGenerationError,
    Schemas.GenerateProposalsRequest,
    {},
    {},
    {}
  >({
    url: "/ai/proposals/proposals_generation/force_refresh/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiForceRefreshProposalsGeneration = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiForceRefreshProposalsGenerationError,
      ApiForceRefreshProposalsGenerationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiForceRefreshProposalsGenerationError,
    ApiForceRefreshProposalsGenerationVariables
  >({
    mutationFn: (variables: ApiForceRefreshProposalsGenerationVariables) =>
      fetchApiForceRefreshProposalsGeneration({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiGetProposalPathParams = {
  proposalId: string;
};

export type ApiGetProposalError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetProposalVariables = {
  pathParams: ApiGetProposalPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetProposal = (
  variables: ApiGetProposalVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaAIProposalOut,
    ApiGetProposalError,
    undefined,
    {},
    {},
    ApiGetProposalPathParams
  >({
    url: "/ai/proposals/{proposalId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetProposalQueryKey = (
  variables: ApiGetProposalVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/proposals/{proposalId}/",
    operationId: "apiGetProposal",
    variables,
  });

export const useApiGetProposal = <TData = Schemas.SecodaAIProposalOut,>(
  variables: ApiGetProposalVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SecodaAIProposalOut,
      ApiGetProposalError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/proposals/{proposalId}/",
    operationId: "apiGetProposal",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SecodaAIProposalOut,
    ApiGetProposalError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetProposal({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetProposal = <TData = Schemas.SecodaAIProposalOut,>(
  variables: ApiGetProposalVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SecodaAIProposalOut,
      ApiGetProposalError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/proposals/{proposalId}/",
    operationId: "apiGetProposal",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SecodaAIProposalOut,
    ApiGetProposalError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetProposal({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetProposalsByGroupPathParams = {
  proposalGroup: string;
};

export type ApiGetProposalsByGroupError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetProposalsByGroupResponse = Schemas.SecodaAIProposalOut[];

export type ApiGetProposalsByGroupVariables = {
  pathParams: ApiGetProposalsByGroupPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetProposalsByGroup = (
  variables: ApiGetProposalsByGroupVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetProposalsByGroupResponse,
    ApiGetProposalsByGroupError,
    undefined,
    {},
    {},
    ApiGetProposalsByGroupPathParams
  >({
    url: "/ai/proposals/by_group/{proposalGroup}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetProposalsByGroupQueryKey = (
  variables: ApiGetProposalsByGroupVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/proposals/by_group/{proposalGroup}/",
    operationId: "apiGetProposalsByGroup",
    variables,
  });

export const useApiGetProposalsByGroup = <
  TData = ApiGetProposalsByGroupResponse,
>(
  variables: ApiGetProposalsByGroupVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetProposalsByGroupResponse,
      ApiGetProposalsByGroupError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/proposals/by_group/{proposalGroup}/",
    operationId: "apiGetProposalsByGroup",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetProposalsByGroupResponse,
    ApiGetProposalsByGroupError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetProposalsByGroup({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetProposalsByGroup = <
  TData = ApiGetProposalsByGroupResponse,
>(
  variables: ApiGetProposalsByGroupVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetProposalsByGroupResponse,
      ApiGetProposalsByGroupError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/proposals/by_group/{proposalGroup}/",
    operationId: "apiGetProposalsByGroup",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetProposalsByGroupResponse,
    ApiGetProposalsByGroupError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetProposalsByGroup({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiApproveProposalPathParams = {
  proposalId: string;
};

export type ApiApproveProposalError = Fetcher.ErrorWrapper<undefined>;

export type ApiApproveProposalVariables = {
  body: Schemas.ApproveProposalIn;
  pathParams: ApiApproveProposalPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiApproveProposal = (
  variables: ApiApproveProposalVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaAIProposalOut,
    ApiApproveProposalError,
    Schemas.ApproveProposalIn,
    {},
    {},
    ApiApproveProposalPathParams
  >({
    url: "/ai/proposals/{proposalId}/approve/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiApproveProposal = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SecodaAIProposalOut,
      ApiApproveProposalError,
      ApiApproveProposalVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SecodaAIProposalOut,
    ApiApproveProposalError,
    ApiApproveProposalVariables
  >({
    mutationFn: (variables: ApiApproveProposalVariables) =>
      fetchApiApproveProposal({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRejectProposalPathParams = {
  proposalId: string;
};

export type ApiRejectProposalError = Fetcher.ErrorWrapper<undefined>;

export type ApiRejectProposalVariables = {
  body: Schemas.RejectProposalIn;
  pathParams: ApiRejectProposalPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRejectProposal = (
  variables: ApiRejectProposalVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaAIProposalOut,
    ApiRejectProposalError,
    Schemas.RejectProposalIn,
    {},
    {},
    ApiRejectProposalPathParams
  >({
    url: "/ai/proposals/{proposalId}/reject/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiRejectProposal = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SecodaAIProposalOut,
      ApiRejectProposalError,
      ApiRejectProposalVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SecodaAIProposalOut,
    ApiRejectProposalError,
    ApiRejectProposalVariables
  >({
    mutationFn: (variables: ApiRejectProposalVariables) =>
      fetchApiRejectProposal({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetAiTokenUsageMetricsQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
};

export type ApiGetAiTokenUsageMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiTokenUsageMetricsVariables = {
  queryParams?: ApiGetAiTokenUsageMetricsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get AI token usage metrics for the workspace.
 */
export const fetchApiGetAiTokenUsageMetrics = (
  variables: ApiGetAiTokenUsageMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiTokenUsageMetrics,
    ApiGetAiTokenUsageMetricsError,
    undefined,
    {},
    ApiGetAiTokenUsageMetricsQueryParams,
    {}
  >({ url: "/ai/token-usage/metrics/", method: "get", ...variables, signal });

export const apiGetAiTokenUsageMetricsQueryKey = (
  variables: ApiGetAiTokenUsageMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/token-usage/metrics/",
    operationId: "apiGetAiTokenUsageMetrics",
    variables,
  });

/**
 * Get AI token usage metrics for the workspace.
 */
export const useApiGetAiTokenUsageMetrics = <
  TData = Schemas.AiTokenUsageMetrics,
>(
  variables: ApiGetAiTokenUsageMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiTokenUsageMetrics,
      ApiGetAiTokenUsageMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/token-usage/metrics/",
    operationId: "apiGetAiTokenUsageMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiTokenUsageMetrics,
    ApiGetAiTokenUsageMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiTokenUsageMetrics(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get AI token usage metrics for the workspace.
 */
export const useSuspenseApiGetAiTokenUsageMetrics = <
  TData = Schemas.AiTokenUsageMetrics,
>(
  variables: ApiGetAiTokenUsageMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiTokenUsageMetrics,
      ApiGetAiTokenUsageMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/token-usage/metrics/",
    operationId: "apiGetAiTokenUsageMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiTokenUsageMetrics,
    ApiGetAiTokenUsageMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiTokenUsageMetrics(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiTokenUsageTimeseriesQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  start_date?: string | null;
  end_date?: string | null;
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
  /**
   * @default user_id
   */
  group_by?: "user_id" | "model_name";
};

export type ApiGetAiTokenUsageTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiTokenUsageTimeseriesVariables = {
  queryParams?: ApiGetAiTokenUsageTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get AI token usage timeseries data for the workspace.
 */
export const fetchApiGetAiTokenUsageTimeseries = (
  variables: ApiGetAiTokenUsageTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiTokenUsageTimeSeries,
    ApiGetAiTokenUsageTimeseriesError,
    undefined,
    {},
    ApiGetAiTokenUsageTimeseriesQueryParams,
    {}
  >({
    url: "/ai/token-usage/timeseries/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAiTokenUsageTimeseriesQueryKey = (
  variables: ApiGetAiTokenUsageTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/token-usage/timeseries/",
    operationId: "apiGetAiTokenUsageTimeseries",
    variables,
  });

/**
 * Get AI token usage timeseries data for the workspace.
 */
export const useApiGetAiTokenUsageTimeseries = <
  TData = Schemas.AiTokenUsageTimeSeries,
>(
  variables: ApiGetAiTokenUsageTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiTokenUsageTimeSeries,
      ApiGetAiTokenUsageTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/token-usage/timeseries/",
    operationId: "apiGetAiTokenUsageTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiTokenUsageTimeSeries,
    ApiGetAiTokenUsageTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiTokenUsageTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get AI token usage timeseries data for the workspace.
 */
export const useSuspenseApiGetAiTokenUsageTimeseries = <
  TData = Schemas.AiTokenUsageTimeSeries,
>(
  variables: ApiGetAiTokenUsageTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiTokenUsageTimeSeries,
      ApiGetAiTokenUsageTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/token-usage/timeseries/",
    operationId: "apiGetAiTokenUsageTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiTokenUsageTimeSeries,
    ApiGetAiTokenUsageTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiTokenUsageTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiChatMetricsQueryParams = {
  /**
   * Time range to aggregate metrics over
   *
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
};

export type ApiGetAiChatMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiChatMetricsVariables = {
  queryParams?: ApiGetAiChatMetricsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve aggregate AI chat metrics for the workspace, including the total number of chat conversations within the specified time range.
 */
export const fetchApiGetAiChatMetrics = (
  variables: ApiGetAiChatMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiChatPoint,
    ApiGetAiChatMetricsError,
    undefined,
    {},
    ApiGetAiChatMetricsQueryParams,
    {}
  >({ url: "/ai/chat-usage/metrics/", method: "get", ...variables, signal });

export const apiGetAiChatMetricsQueryKey = (
  variables: ApiGetAiChatMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/chat-usage/metrics/",
    operationId: "apiGetAiChatMetrics",
    variables,
  });

/**
 * Retrieve aggregate AI chat metrics for the workspace, including the total number of chat conversations within the specified time range.
 */
export const useApiGetAiChatMetrics = <TData = Schemas.AiChatPoint,>(
  variables: ApiGetAiChatMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiChatPoint,
      ApiGetAiChatMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/metrics/",
    operationId: "apiGetAiChatMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiChatPoint,
    ApiGetAiChatMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve aggregate AI chat metrics for the workspace, including the total number of chat conversations within the specified time range.
 */
export const useSuspenseApiGetAiChatMetrics = <TData = Schemas.AiChatPoint,>(
  variables: ApiGetAiChatMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiChatPoint,
      ApiGetAiChatMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/metrics/",
    operationId: "apiGetAiChatMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiChatPoint,
    ApiGetAiChatMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiChatTimeseriesQueryParams = {
  /**
   * Time range for the timeseries data
   *
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * Custom start date (ISO 8601 format)
   *
   * @format date-time
   */
  start_date?: string;
  /**
   * Custom end date (ISO 8601 format)
   *
   * @format date-time
   */
  end_date?: string;
  /**
   * Granularity of time buckets
   *
   * @default day
   */
  view_option?: "day" | "week" | "month";
  /**
   * Field to group timeseries data by
   *
   * @default user_id
   */
  group_by?: "user_id";
};

export type ApiGetAiChatTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiChatTimeseriesVariables = {
  queryParams?: ApiGetAiChatTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve time-bucketed AI chat usage data for the workspace. Returns a list of data points showing chat counts over time, useful for visualizing adoption trends and usage patterns.
 */
export const fetchApiGetAiChatTimeseries = (
  variables: ApiGetAiChatTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiChatTimeSeries,
    ApiGetAiChatTimeseriesError,
    undefined,
    {},
    ApiGetAiChatTimeseriesQueryParams,
    {}
  >({ url: "/ai/chat-usage/timeseries/", method: "get", ...variables, signal });

export const apiGetAiChatTimeseriesQueryKey = (
  variables: ApiGetAiChatTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/chat-usage/timeseries/",
    operationId: "apiGetAiChatTimeseries",
    variables,
  });

/**
 * Retrieve time-bucketed AI chat usage data for the workspace. Returns a list of data points showing chat counts over time, useful for visualizing adoption trends and usage patterns.
 */
export const useApiGetAiChatTimeseries = <TData = Schemas.AiChatTimeSeries,>(
  variables: ApiGetAiChatTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiChatTimeSeries,
      ApiGetAiChatTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/timeseries/",
    operationId: "apiGetAiChatTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiChatTimeSeries,
    ApiGetAiChatTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatTimeseries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve time-bucketed AI chat usage data for the workspace. Returns a list of data points showing chat counts over time, useful for visualizing adoption trends and usage patterns.
 */
export const useSuspenseApiGetAiChatTimeseries = <
  TData = Schemas.AiChatTimeSeries,
>(
  variables: ApiGetAiChatTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiChatTimeSeries,
      ApiGetAiChatTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/timeseries/",
    operationId: "apiGetAiChatTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiChatTimeSeries,
    ApiGetAiChatTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatTimeseries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiChatListQueryParams = {
  /**
   * @default 20
   */
  limit?: number;
  /**
   * @default 0
   */
  offset?: number;
  /**
   * @default newest
   */
  sort_order?: "newest" | "oldest";
  /**
   * @default 30d
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
};

export type ApiGetAiChatListError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiChatListVariables = {
  queryParams?: ApiGetAiChatListQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a list of AI chats with scores and filtering.
 */
export const fetchApiGetAiChatList = (
  variables: ApiGetAiChatListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiChatList,
    ApiGetAiChatListError,
    undefined,
    {},
    ApiGetAiChatListQueryParams,
    {}
  >({ url: "/ai/chat-usage/list/", method: "get", ...variables, signal });

export const apiGetAiChatListQueryKey = (
  variables: ApiGetAiChatListVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/chat-usage/list/",
    operationId: "apiGetAiChatList",
    variables,
  });

/**
 * Get a list of AI chats with scores and filtering.
 */
export const useApiGetAiChatList = <TData = Schemas.AiChatList,>(
  variables: ApiGetAiChatListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiChatList,
      ApiGetAiChatListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/list/",
    operationId: "apiGetAiChatList",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiChatList,
    ApiGetAiChatListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a list of AI chats with scores and filtering.
 */
export const useSuspenseApiGetAiChatList = <TData = Schemas.AiChatList,>(
  variables: ApiGetAiChatListVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiChatList,
      ApiGetAiChatListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/list/",
    operationId: "apiGetAiChatList",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiChatList,
    ApiGetAiChatListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiChatDetailedListQueryParams = {
  /**
   * Maximum number of results per page
   *
   * @default 20
   */
  limit?: number;
  /**
   * Number of results to skip for pagination
   *
   * @default 0
   */
  offset?: number;
  /**
   * Page number for paginated results
   *
   * @default 1
   */
  page?: number;
  /**
   * Sort order for results
   *
   * @default newest
   */
  sort_order?: "newest" | "oldest";
  /**
   * Field to sort results by
   *
   * @default created_at
   */
  sort_by?: "created_at" | "time_saved_hours";
  /**
   * Time range to filter chats by
   *
   * @default 30d
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * Filter by specific user IDs
   */
  user_ids?: string[];
  /**
   * Filter by creation date upper bound
   */
  created_at?: string;
  /**
   * A serialized JSON object to define filters. Supports filtering by users, teams, system_rating, feedback sentiment, date, AI persona, and time savings category.
   */
  filter?: string;
  /**
   * Alias for the filter parameter
   */
  filters?: string;
  /**
   * Search term to filter by chat title or prompt content
   */
  search_term?: string;
  /**
   * Filter by user feedback sentiment
   */
  sentiment_filter?: "positive" | "negative";
};

export type ApiGetAiChatDetailedListError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiChatDetailedListResponse = {
  [key: string]: any;
};

export type ApiGetAiChatDetailedListVariables = {
  body?: string[] | null;
  queryParams?: ApiGetAiChatDetailedListQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve a paginated list of AI chat conversations in the workspace with detailed analytics data.
 *
 * Each result includes the user's prompts, feedback sentiments, queried resources, time savings, complexity, system rating, and the teams the user belongs to.
 *
 * Results can be filtered by users, teams, date range, sentiment, and searched by title or prompt content.
 */
export const fetchApiGetAiChatDetailedList = (
  variables: ApiGetAiChatDetailedListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetAiChatDetailedListResponse,
    ApiGetAiChatDetailedListError,
    string[] | null,
    {},
    ApiGetAiChatDetailedListQueryParams,
    {}
  >({
    url: "/ai/chat-usage/detailed-list/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAiChatDetailedListQueryKey = (
  variables: ApiGetAiChatDetailedListVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/chat-usage/detailed-list/",
    operationId: "apiGetAiChatDetailedList",
    variables,
  });

/**
 * Retrieve a paginated list of AI chat conversations in the workspace with detailed analytics data.
 *
 * Each result includes the user's prompts, feedback sentiments, queried resources, time savings, complexity, system rating, and the teams the user belongs to.
 *
 * Results can be filtered by users, teams, date range, sentiment, and searched by title or prompt content.
 */
export const useApiGetAiChatDetailedList = <
  TData = ApiGetAiChatDetailedListResponse,
>(
  variables: ApiGetAiChatDetailedListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetAiChatDetailedListResponse,
      ApiGetAiChatDetailedListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/detailed-list/",
    operationId: "apiGetAiChatDetailedList",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetAiChatDetailedListResponse,
    ApiGetAiChatDetailedListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatDetailedList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve a paginated list of AI chat conversations in the workspace with detailed analytics data.
 *
 * Each result includes the user's prompts, feedback sentiments, queried resources, time savings, complexity, system rating, and the teams the user belongs to.
 *
 * Results can be filtered by users, teams, date range, sentiment, and searched by title or prompt content.
 */
export const useSuspenseApiGetAiChatDetailedList = <
  TData = ApiGetAiChatDetailedListResponse,
>(
  variables: ApiGetAiChatDetailedListVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetAiChatDetailedListResponse,
      ApiGetAiChatDetailedListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/detailed-list/",
    operationId: "apiGetAiChatDetailedList",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetAiChatDetailedListResponse,
    ApiGetAiChatDetailedListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatDetailedList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiChatRatedMessagesQueryParams = {
  /**
   * Maximum number of results per page
   *
   * @default 20
   */
  limit?: number;
  /**
   * Number of results to skip for pagination
   *
   * @default 0
   */
  offset?: number;
  /**
   * Sort order for results
   *
   * @default newest
   */
  sort_order?: "newest" | "oldest";
  /**
   * Time range to filter chats by
   *
   * @default 30d
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * Filter by feedback sentiment
   */
  sentiment_filter?: "positive" | "negative";
};

export type ApiGetAiChatRatedMessagesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiChatRatedMessagesVariables = {
  queryParams?: ApiGetAiChatRatedMessagesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve a paginated list of AI chat conversations that have received user feedback ratings (thumbs up or thumbs down). Useful for analyzing prompt quality and identifying areas for improvement.
 */
export const fetchApiGetAiChatRatedMessages = (
  variables: ApiGetAiChatRatedMessagesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiChatRatedMessages,
    ApiGetAiChatRatedMessagesError,
    undefined,
    {},
    ApiGetAiChatRatedMessagesQueryParams,
    {}
  >({
    url: "/ai/chat-usage/rated-messages/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAiChatRatedMessagesQueryKey = (
  variables: ApiGetAiChatRatedMessagesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/chat-usage/rated-messages/",
    operationId: "apiGetAiChatRatedMessages",
    variables,
  });

/**
 * Retrieve a paginated list of AI chat conversations that have received user feedback ratings (thumbs up or thumbs down). Useful for analyzing prompt quality and identifying areas for improvement.
 */
export const useApiGetAiChatRatedMessages = <
  TData = Schemas.AiChatRatedMessages,
>(
  variables: ApiGetAiChatRatedMessagesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiChatRatedMessages,
      ApiGetAiChatRatedMessagesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/rated-messages/",
    operationId: "apiGetAiChatRatedMessages",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiChatRatedMessages,
    ApiGetAiChatRatedMessagesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatRatedMessages(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve a paginated list of AI chat conversations that have received user feedback ratings (thumbs up or thumbs down). Useful for analyzing prompt quality and identifying areas for improvement.
 */
export const useSuspenseApiGetAiChatRatedMessages = <
  TData = Schemas.AiChatRatedMessages,
>(
  variables: ApiGetAiChatRatedMessagesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiChatRatedMessages,
      ApiGetAiChatRatedMessagesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/rated-messages/",
    operationId: "apiGetAiChatRatedMessages",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiChatRatedMessages,
    ApiGetAiChatRatedMessagesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiChatRatedMessages(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiPromptsByMemberListQueryParams = {
  /**
   * Maximum number of members to return
   *
   * @default 20
   */
  limit?: number;
  /**
   * Number of members to skip for pagination
   *
   * @default 0
   */
  offset?: number;
  /**
   * Sort members by prompt count
   *
   * @default most_active
   */
  sort_order?: "most_active" | "least_active";
  /**
   * Time range to count prompts within
   *
   * @default 30d
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
};

export type ApiGetAiPromptsByMemberListError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiPromptsByMemberListVariables = {
  queryParams?: ApiGetAiPromptsByMemberListQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve a paginated list of workspace members with their AI prompt counts. Useful for measuring per-user adoption and identifying power users.
 */
export const fetchApiGetAiPromptsByMemberList = (
  variables: ApiGetAiPromptsByMemberListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiPromptsByMemberList,
    ApiGetAiPromptsByMemberListError,
    undefined,
    {},
    ApiGetAiPromptsByMemberListQueryParams,
    {}
  >({
    url: "/ai/chat-usage/prompts-by-member/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAiPromptsByMemberListQueryKey = (
  variables: ApiGetAiPromptsByMemberListVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/chat-usage/prompts-by-member/",
    operationId: "apiGetAiPromptsByMemberList",
    variables,
  });

/**
 * Retrieve a paginated list of workspace members with their AI prompt counts. Useful for measuring per-user adoption and identifying power users.
 */
export const useApiGetAiPromptsByMemberList = <
  TData = Schemas.AiPromptsByMemberList,
>(
  variables: ApiGetAiPromptsByMemberListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiPromptsByMemberList,
      ApiGetAiPromptsByMemberListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/prompts-by-member/",
    operationId: "apiGetAiPromptsByMemberList",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiPromptsByMemberList,
    ApiGetAiPromptsByMemberListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiPromptsByMemberList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve a paginated list of workspace members with their AI prompt counts. Useful for measuring per-user adoption and identifying power users.
 */
export const useSuspenseApiGetAiPromptsByMemberList = <
  TData = Schemas.AiPromptsByMemberList,
>(
  variables: ApiGetAiPromptsByMemberListVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiPromptsByMemberList,
      ApiGetAiPromptsByMemberListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/prompts-by-member/",
    operationId: "apiGetAiPromptsByMemberList",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiPromptsByMemberList,
    ApiGetAiPromptsByMemberListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiPromptsByMemberList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiExportAiChatCsvQueryParams = {
  search_term?: string | null;
  /**
   * @default newest
   */
  sort_order?: "newest" | "oldest";
  /**
   * @default 30d
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  filter?: string | null;
  sentiment_filter?: ("positive" | "negative") | null;
};

export type ApiExportAiChatCsvError = Fetcher.ErrorWrapper<undefined>;

export type ApiExportAiChatCsvVariables = {
  queryParams?: ApiExportAiChatCsvQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Export AI chat data to CSV via a background job.
 */
export const fetchApiExportAiChatCsv = (
  variables: ApiExportAiChatCsvVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    ApiExportAiChatCsvError,
    undefined,
    {},
    ApiExportAiChatCsvQueryParams,
    {}
  >({ url: "/ai/chat-usage/export/", method: "get", ...variables, signal });

export const apiExportAiChatCsvQueryKey = (
  variables: ApiExportAiChatCsvVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/chat-usage/export/",
    operationId: "apiExportAiChatCsv",
    variables,
  });

/**
 * Export AI chat data to CSV via a background job.
 */
export const useApiExportAiChatCsv = <TData = Schemas.BackgroundJobOut,>(
  variables: ApiExportAiChatCsvVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BackgroundJobOut,
      ApiExportAiChatCsvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/export/",
    operationId: "apiExportAiChatCsv",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.BackgroundJobOut,
    ApiExportAiChatCsvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiExportAiChatCsv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Export AI chat data to CSV via a background job.
 */
export const useSuspenseApiExportAiChatCsv = <
  TData = Schemas.BackgroundJobOut,
>(
  variables: ApiExportAiChatCsvVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.BackgroundJobOut,
      ApiExportAiChatCsvError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/chat-usage/export/",
    operationId: "apiExportAiChatCsv",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.BackgroundJobOut,
    ApiExportAiChatCsvError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiExportAiChatCsv({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiTimeSavingsTimeseriesQueryParams = {
  /**
   * @default 30d
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  start_date?: string | null;
  end_date?: string | null;
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
};

export type ApiGetAiTimeSavingsTimeseriesError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiTimeSavingsTimeseriesVariables = {
  queryParams?: ApiGetAiTimeSavingsTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get AI time savings timeseries data by category for the workspace.
 */
export const fetchApiGetAiTimeSavingsTimeseries = (
  variables: ApiGetAiTimeSavingsTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiTimeSavingsTimeSeries,
    ApiGetAiTimeSavingsTimeseriesError,
    undefined,
    {},
    ApiGetAiTimeSavingsTimeseriesQueryParams,
    {}
  >({
    url: "/ai/time-savings/timeseries/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAiTimeSavingsTimeseriesQueryKey = (
  variables: ApiGetAiTimeSavingsTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/time-savings/timeseries/",
    operationId: "apiGetAiTimeSavingsTimeseries",
    variables,
  });

/**
 * Get AI time savings timeseries data by category for the workspace.
 */
export const useApiGetAiTimeSavingsTimeseries = <
  TData = Schemas.AiTimeSavingsTimeSeries,
>(
  variables: ApiGetAiTimeSavingsTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiTimeSavingsTimeSeries,
      ApiGetAiTimeSavingsTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/time-savings/timeseries/",
    operationId: "apiGetAiTimeSavingsTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiTimeSavingsTimeSeries,
    ApiGetAiTimeSavingsTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiTimeSavingsTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get AI time savings timeseries data by category for the workspace.
 */
export const useSuspenseApiGetAiTimeSavingsTimeseries = <
  TData = Schemas.AiTimeSavingsTimeSeries,
>(
  variables: ApiGetAiTimeSavingsTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiTimeSavingsTimeSeries,
      ApiGetAiTimeSavingsTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/time-savings/timeseries/",
    operationId: "apiGetAiTimeSavingsTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiTimeSavingsTimeSeries,
    ApiGetAiTimeSavingsTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiTimeSavingsTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAiImpactMetricsQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  start_date?: string | null;
  end_date?: string | null;
};

export type ApiGetAiImpactMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAiImpactMetricsVariables = {
  queryParams?: ApiGetAiImpactMetricsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetAiImpactMetrics = (
  variables: ApiGetAiImpactMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiImpactPoint,
    ApiGetAiImpactMetricsError,
    undefined,
    {},
    ApiGetAiImpactMetricsQueryParams,
    {}
  >({ url: "/ai/impact/metrics/", method: "get", ...variables, signal });

export const apiGetAiImpactMetricsQueryKey = (
  variables: ApiGetAiImpactMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/impact/metrics/",
    operationId: "apiGetAiImpactMetrics",
    variables,
  });

export const useApiGetAiImpactMetrics = <TData = Schemas.AiImpactPoint,>(
  variables: ApiGetAiImpactMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiImpactPoint,
      ApiGetAiImpactMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/impact/metrics/",
    operationId: "apiGetAiImpactMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiImpactPoint,
    ApiGetAiImpactMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiImpactMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetAiImpactMetrics = <
  TData = Schemas.AiImpactPoint,
>(
  variables: ApiGetAiImpactMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiImpactPoint,
      ApiGetAiImpactMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/impact/metrics/",
    operationId: "apiGetAiImpactMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiImpactPoint,
    ApiGetAiImpactMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAiImpactMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ListAiTasksQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ListAiTasksError = Fetcher.ErrorWrapper<undefined>;

export type ListAiTasksVariables = {
  queryParams?: ListAiTasksQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List all AI tasks for the user's workspace, sorted by created_at descending
 */
export const fetchListAiTasks = (
  variables: ListAiTasksVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedAiTaskOut,
    ListAiTasksError,
    undefined,
    {},
    ListAiTasksQueryParams,
    {}
  >({ url: "/ai/tasks/", method: "get", ...variables, signal });

export const listAiTasksQueryKey = (
  variables: ListAiTasksVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/tasks/",
    operationId: "listAiTasks",
    variables,
  });

/**
 * List all AI tasks for the user's workspace, sorted by created_at descending
 */
export const useListAiTasks = <TData = Schemas.PagedAiTaskOut,>(
  variables: ListAiTasksVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.PagedAiTaskOut, ListAiTasksError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/tasks/",
    operationId: "listAiTasks",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedAiTaskOut,
    ListAiTasksError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListAiTasks({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List all AI tasks for the user's workspace, sorted by created_at descending
 */
export const useSuspenseListAiTasks = <TData = Schemas.PagedAiTaskOut,>(
  variables: ListAiTasksVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedAiTaskOut,
      ListAiTasksError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/tasks/",
    operationId: "listAiTasks",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedAiTaskOut,
    ListAiTasksError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListAiTasks({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CreateAiTaskError = Fetcher.ErrorWrapper<undefined>;

export type CreateAiTaskVariables = {
  body: Schemas.AiTaskUpdateIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a new AI task
 */
export const fetchCreateAiTask = (
  variables: CreateAiTaskVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiTaskOut,
    CreateAiTaskError,
    Schemas.AiTaskUpdateIn,
    {},
    {},
    {}
  >({ url: "/ai/tasks/", method: "post", ...variables, signal });

/**
 * Create a new AI task
 */
export const useCreateAiTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AiTaskOut,
      CreateAiTaskError,
      CreateAiTaskVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AiTaskOut,
    CreateAiTaskError,
    CreateAiTaskVariables
  >({
    mutationFn: (variables: CreateAiTaskVariables) =>
      fetchCreateAiTask({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RetrieveAiTaskPathParams = {
  taskId: string;
};

export type RetrieveAiTaskError = Fetcher.ErrorWrapper<undefined>;

export type RetrieveAiTaskVariables = {
  pathParams: RetrieveAiTaskPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Retrieve an AI task by id
 */
export const fetchRetrieveAiTask = (
  variables: RetrieveAiTaskVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiTaskOut,
    RetrieveAiTaskError,
    undefined,
    {},
    {},
    RetrieveAiTaskPathParams
  >({ url: "/ai/tasks/{taskId}/", method: "get", ...variables, signal });

export const retrieveAiTaskQueryKey = (
  variables: RetrieveAiTaskVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/tasks/{taskId}/",
    operationId: "retrieveAiTask",
    variables,
  });

/**
 * Retrieve an AI task by id
 */
export const useRetrieveAiTask = <TData = Schemas.AiTaskOut,>(
  variables: RetrieveAiTaskVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.AiTaskOut, RetrieveAiTaskError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/tasks/{taskId}/",
    operationId: "retrieveAiTask",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AiTaskOut,
    RetrieveAiTaskError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveAiTask({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Retrieve an AI task by id
 */
export const useSuspenseRetrieveAiTask = <TData = Schemas.AiTaskOut,>(
  variables: RetrieveAiTaskVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AiTaskOut,
      RetrieveAiTaskError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/tasks/{taskId}/",
    operationId: "retrieveAiTask",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AiTaskOut,
    RetrieveAiTaskError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveAiTask({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type UpdateAiTaskPathParams = {
  taskId: string;
};

export type UpdateAiTaskError = Fetcher.ErrorWrapper<undefined>;

export type UpdateAiTaskVariables = {
  body: Schemas.AiTaskUpdateIn;
  pathParams: UpdateAiTaskPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update an AI task
 */
export const fetchUpdateAiTask = (
  variables: UpdateAiTaskVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiTaskOut,
    UpdateAiTaskError,
    Schemas.AiTaskUpdateIn,
    {},
    {},
    UpdateAiTaskPathParams
  >({ url: "/ai/tasks/{taskId}/", method: "patch", ...variables, signal });

/**
 * Update an AI task
 */
export const useUpdateAiTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AiTaskOut,
      UpdateAiTaskError,
      UpdateAiTaskVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AiTaskOut,
    UpdateAiTaskError,
    UpdateAiTaskVariables
  >({
    mutationFn: (variables: UpdateAiTaskVariables) =>
      fetchUpdateAiTask({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteAiTaskPathParams = {
  taskId: string;
};

export type DeleteAiTaskError = Fetcher.ErrorWrapper<undefined>;

export type DeleteAiTaskVariables = {
  pathParams: DeleteAiTaskPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete an AI task
 */
export const fetchDeleteAiTask = (
  variables: DeleteAiTaskVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DeleteAiTaskError,
    undefined,
    {},
    {},
    DeleteAiTaskPathParams
  >({ url: "/ai/tasks/{taskId}/", method: "delete", ...variables, signal });

/**
 * Delete an AI task
 */
export const useDeleteAiTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteAiTaskError,
      DeleteAiTaskVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteAiTaskError,
    DeleteAiTaskVariables
  >({
    mutationFn: (variables: DeleteAiTaskVariables) =>
      fetchDeleteAiTask({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RunAiTaskPathParams = {
  taskId: string;
};

export type RunAiTaskError = Fetcher.ErrorWrapper<undefined>;

export type RunAiTaskVariables = {
  pathParams: RunAiTaskPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Trigger the AI task to run
 */
export const fetchRunAiTask = (
  variables: RunAiTaskVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiTaskRunOut,
    RunAiTaskError,
    undefined,
    {},
    {},
    RunAiTaskPathParams
  >({ url: "/ai/tasks/{taskId}/run/", method: "post", ...variables, signal });

/**
 * Trigger the AI task to run
 */
export const useRunAiTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AiTaskRunOut,
      RunAiTaskError,
      RunAiTaskVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AiTaskRunOut,
    RunAiTaskError,
    RunAiTaskVariables
  >({
    mutationFn: (variables: RunAiTaskVariables) =>
      fetchRunAiTask({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ListAiTaskEmbeddedPromptsPathParams = {
  taskId: string;
};

export type ListAiTaskEmbeddedPromptsQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ListAiTaskEmbeddedPromptsError = Fetcher.ErrorWrapper<undefined>;

export type ListAiTaskEmbeddedPromptsVariables = {
  pathParams: ListAiTaskEmbeddedPromptsPathParams;
  queryParams?: ListAiTaskEmbeddedPromptsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List all embedded prompts for an AI task, sorted chronologically (oldest first)
 */
export const fetchListAiTaskEmbeddedPrompts = (
  variables: ListAiTaskEmbeddedPromptsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedAiTaskEmbeddedPromptOut,
    ListAiTaskEmbeddedPromptsError,
    undefined,
    {},
    ListAiTaskEmbeddedPromptsQueryParams,
    ListAiTaskEmbeddedPromptsPathParams
  >({
    url: "/ai/tasks/{taskId}/embedded-prompts/",
    method: "get",
    ...variables,
    signal,
  });

export const listAiTaskEmbeddedPromptsQueryKey = (
  variables: ListAiTaskEmbeddedPromptsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/tasks/{taskId}/embedded-prompts/",
    operationId: "listAiTaskEmbeddedPrompts",
    variables,
  });

/**
 * List all embedded prompts for an AI task, sorted chronologically (oldest first)
 */
export const useListAiTaskEmbeddedPrompts = <
  TData = Schemas.PagedAiTaskEmbeddedPromptOut,
>(
  variables: ListAiTaskEmbeddedPromptsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedAiTaskEmbeddedPromptOut,
      ListAiTaskEmbeddedPromptsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/tasks/{taskId}/embedded-prompts/",
    operationId: "listAiTaskEmbeddedPrompts",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedAiTaskEmbeddedPromptOut,
    ListAiTaskEmbeddedPromptsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListAiTaskEmbeddedPrompts(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List all embedded prompts for an AI task, sorted chronologically (oldest first)
 */
export const useSuspenseListAiTaskEmbeddedPrompts = <
  TData = Schemas.PagedAiTaskEmbeddedPromptOut,
>(
  variables: ListAiTaskEmbeddedPromptsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedAiTaskEmbeddedPromptOut,
      ListAiTaskEmbeddedPromptsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/tasks/{taskId}/embedded-prompts/",
    operationId: "listAiTaskEmbeddedPrompts",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedAiTaskEmbeddedPromptOut,
    ListAiTaskEmbeddedPromptsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListAiTaskEmbeddedPrompts(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSuggestedAiTasksError = Fetcher.ErrorWrapper<undefined>;

export type ApiSuggestedAiTasksVariables = ApiContext["fetcherOptions"];

/**
 * Get suggested AI tasks for the user's workspace
 */
export const fetchApiSuggestedAiTasks = (
  variables: ApiSuggestedAiTasksVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SuggestedAiTasksOut,
    ApiSuggestedAiTasksError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/ai/tasks/suggestion/suggestions/",
    method: "get",
    ...variables,
    signal,
  });

export const apiSuggestedAiTasksQueryKey = (
  variables: ApiSuggestedAiTasksVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/tasks/suggestion/suggestions/",
    operationId: "apiSuggestedAiTasks",
    variables,
  });

/**
 * Get suggested AI tasks for the user's workspace
 */
export const useApiSuggestedAiTasks = <TData = Schemas.SuggestedAiTasksOut,>(
  variables: ApiSuggestedAiTasksVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SuggestedAiTasksOut,
      ApiSuggestedAiTasksError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/tasks/suggestion/suggestions/",
    operationId: "apiSuggestedAiTasks",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SuggestedAiTasksOut,
    ApiSuggestedAiTasksError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuggestedAiTasks({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get suggested AI tasks for the user's workspace
 */
export const useSuspenseApiSuggestedAiTasks = <
  TData = Schemas.SuggestedAiTasksOut,
>(
  variables: ApiSuggestedAiTasksVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SuggestedAiTasksOut,
      ApiSuggestedAiTasksError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/tasks/suggestion/suggestions/",
    operationId: "apiSuggestedAiTasks",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SuggestedAiTasksOut,
    ApiSuggestedAiTasksError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuggestedAiTasks({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListAiQueriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListAiQueriesResponse = Schemas.AiQueryOut[];

export type ApiListAiQueriesVariables = ApiContext["fetcherOptions"];

/**
 * List AI queries for the current workspace
 */
export const fetchApiListAiQueries = (
  variables: ApiListAiQueriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiListAiQueriesResponse,
    ApiListAiQueriesError,
    undefined,
    {},
    {},
    {}
  >({ url: "/ai/ai_query/", method: "get", ...variables, signal });

export const apiListAiQueriesQueryKey = (
  variables: ApiListAiQueriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/ai_query/",
    operationId: "apiListAiQueries",
    variables,
  });

/**
 * List AI queries for the current workspace
 */
export const useApiListAiQueries = <TData = ApiListAiQueriesResponse,>(
  variables: ApiListAiQueriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiListAiQueriesResponse,
      ApiListAiQueriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/ai_query/",
    operationId: "apiListAiQueries",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiListAiQueriesResponse,
    ApiListAiQueriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListAiQueries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List AI queries for the current workspace
 */
export const useSuspenseApiListAiQueries = <TData = ApiListAiQueriesResponse,>(
  variables: ApiListAiQueriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiListAiQueriesResponse,
      ApiListAiQueriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/ai_query/",
    operationId: "apiListAiQueries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiListAiQueriesResponse,
    ApiListAiQueriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListAiQueries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateAiQueryError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAiQueryVariables = {
  body: Schemas.AiQueryUpdateIn;
} & ApiContext["fetcherOptions"];

/**
 * Update an existing AI query
 */
export const fetchApiUpdateAiQuery = (
  variables: ApiUpdateAiQueryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AiQueryOut,
    ApiUpdateAiQueryError,
    Schemas.AiQueryUpdateIn,
    {},
    {},
    {}
  >({ url: "/ai/ai_query/", method: "put", ...variables, signal });

/**
 * Update an existing AI query
 */
export const useApiUpdateAiQuery = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AiQueryOut,
      ApiUpdateAiQueryError,
      ApiUpdateAiQueryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AiQueryOut,
    ApiUpdateAiQueryError,
    ApiUpdateAiQueryVariables
  >({
    mutationFn: (variables: ApiUpdateAiQueryVariables) =>
      fetchApiUpdateAiQuery({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiLlmStatusError = Fetcher.ErrorWrapper<undefined>;

export type ApiLlmStatusVariables = ApiContext["fetcherOptions"];

export const fetchApiLlmStatus = (
  variables: ApiLlmStatusVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.LlmStatusResponse, ApiLlmStatusError, undefined, {}, {}, {}>(
    { url: "/ai/llm_status/status/", method: "get", ...variables, signal },
  );

export const apiLlmStatusQueryKey = (
  variables: ApiLlmStatusVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/ai/llm_status/status/",
    operationId: "apiLlmStatus",
    variables,
  });

export const useApiLlmStatus = <TData = Schemas.LlmStatusResponse,>(
  variables: ApiLlmStatusVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LlmStatusResponse,
      ApiLlmStatusError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/llm_status/status/",
    operationId: "apiLlmStatus",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LlmStatusResponse,
    ApiLlmStatusError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiLlmStatus({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiLlmStatus = <TData = Schemas.LlmStatusResponse,>(
  variables: ApiLlmStatusVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LlmStatusResponse,
      ApiLlmStatusError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/ai/llm_status/status/",
    operationId: "apiLlmStatus",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LlmStatusResponse,
    ApiLlmStatusError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiLlmStatus({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateAiOutputFeedbackError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateAiOutputFeedbackVariables = {
  body: Schemas.AIOutputBlockFeedbackIn;
} & ApiContext["fetcherOptions"];

/**
 * Create feedback for AI Output Block preview.
 *
 * This endpoint allows users to provide thumbs up/down feedback
 * on AI-generated output during automation setup.
 */
export const fetchApiCreateAiOutputFeedback = (
  variables: ApiCreateAiOutputFeedbackVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AIOutputBlockFeedbackOut,
    ApiCreateAiOutputFeedbackError,
    Schemas.AIOutputBlockFeedbackIn,
    {},
    {},
    {}
  >({ url: "/ai/ai_output_feedback/", method: "post", ...variables, signal });

/**
 * Create feedback for AI Output Block preview.
 *
 * This endpoint allows users to provide thumbs up/down feedback
 * on AI-generated output during automation setup.
 */
export const useApiCreateAiOutputFeedback = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AIOutputBlockFeedbackOut,
      ApiCreateAiOutputFeedbackError,
      ApiCreateAiOutputFeedbackVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AIOutputBlockFeedbackOut,
    ApiCreateAiOutputFeedbackError,
    ApiCreateAiOutputFeedbackVariables
  >({
    mutationFn: (variables: ApiCreateAiOutputFeedbackVariables) =>
      fetchApiCreateAiOutputFeedback({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetCreationQueryPathParams = {
  entityId: string;
};

export type ApiGetCreationQueryError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetCreationQueryVariables = {
  pathParams: ApiGetCreationQueryPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the creation query of an entity.
 */
export const fetchApiGetCreationQuery = (
  variables: ApiGetCreationQueryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LiteQueryOut | null,
    ApiGetCreationQueryError,
    undefined,
    {},
    {},
    ApiGetCreationQueryPathParams
  >({
    url: "/query/queries/creation_query/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetCreationQueryQueryKey = (
  variables: ApiGetCreationQueryVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/query/queries/creation_query/{entityId}/",
    operationId: "apiGetCreationQuery",
    variables,
  });

/**
 * Get the creation query of an entity.
 */
export const useApiGetCreationQuery = <TData = Schemas.LiteQueryOut | null,>(
  variables: ApiGetCreationQueryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LiteQueryOut | null,
      ApiGetCreationQueryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/creation_query/{entityId}/",
    operationId: "apiGetCreationQuery",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LiteQueryOut | null,
    ApiGetCreationQueryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCreationQuery({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the creation query of an entity.
 */
export const useSuspenseApiGetCreationQuery = <
  TData = Schemas.LiteQueryOut | null,
>(
  variables: ApiGetCreationQueryVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LiteQueryOut | null,
      ApiGetCreationQueryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/creation_query/{entityId}/",
    operationId: "apiGetCreationQuery",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LiteQueryOut | null,
    ApiGetCreationQueryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCreationQuery({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetQueriesQueryParams = {
  /**
   * @default 1
   */
  page?: number;
  /**
   * @default 50
   */
  page_size?: number;
  search_term?: string | null;
  sort_by?: string | null;
  /**
   * @default 30
   */
  lookback_days?: number;
};

export type ApiGetQueriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetQueriesVariables = {
  queryParams?: ApiGetQueriesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetQueries = (
  variables: ApiGetQueriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QueryListOut,
    ApiGetQueriesError,
    undefined,
    {},
    ApiGetQueriesQueryParams,
    {}
  >({
    url: "/query/queries/v2/workspace/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetQueriesQueryKey = (
  variables: ApiGetQueriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/query/queries/v2/workspace/",
    operationId: "apiGetQueries",
    variables,
  });

export const useApiGetQueries = <TData = Schemas.QueryListOut,>(
  variables: ApiGetQueriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.QueryListOut, ApiGetQueriesError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/workspace/",
    operationId: "apiGetQueries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QueryListOut,
    ApiGetQueriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQueries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetQueries = <TData = Schemas.QueryListOut,>(
  variables: ApiGetQueriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QueryListOut,
      ApiGetQueriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/workspace/",
    operationId: "apiGetQueries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QueryListOut,
    ApiGetQueriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQueries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetEntityQueriesPathParams = {
  entityId: string;
};

export type ApiGetEntityQueriesQueryParams = {
  /**
   * @default 1
   */
  page?: number;
  /**
   * @default 10
   */
  page_size?: number;
  filters?: string | null;
  sort_by?: string | null;
  search_term?: string | null;
  /**
   * @default 7
   */
  lookback_days?: number;
};

export type ApiGetEntityQueriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetEntityQueriesVariables = {
  pathParams: ApiGetEntityQueriesPathParams;
  queryParams?: ApiGetEntityQueriesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetEntityQueries = (
  variables: ApiGetEntityQueriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QueryListOut,
    ApiGetEntityQueriesError,
    undefined,
    {},
    ApiGetEntityQueriesQueryParams,
    ApiGetEntityQueriesPathParams
  >({
    url: "/query/queries/v2/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetEntityQueriesQueryKey = (
  variables: ApiGetEntityQueriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/query/queries/v2/{entityId}/",
    operationId: "apiGetEntityQueries",
    variables,
  });

export const useApiGetEntityQueries = <TData = Schemas.QueryListOut,>(
  variables: ApiGetEntityQueriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QueryListOut,
      ApiGetEntityQueriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/{entityId}/",
    operationId: "apiGetEntityQueries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QueryListOut,
    ApiGetEntityQueriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityQueries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetEntityQueries = <TData = Schemas.QueryListOut,>(
  variables: ApiGetEntityQueriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QueryListOut,
      ApiGetEntityQueriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/{entityId}/",
    operationId: "apiGetEntityQueries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QueryListOut,
    ApiGetEntityQueriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityQueries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetQueryExecutionsPathParams = {
  queryId: string;
};

export type ApiGetQueryExecutionsQueryParams = {
  /**
   * @default 1
   */
  page?: number;
  /**
   * @default 50
   */
  page_size?: number;
  /**
   * @default 30
   */
  lookback_days?: number;
};

export type ApiGetQueryExecutionsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetQueryExecutionsVariables = {
  pathParams: ApiGetQueryExecutionsPathParams;
  queryParams?: ApiGetQueryExecutionsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetQueryExecutions = (
  variables: ApiGetQueryExecutionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QueryExecutionListOut,
    ApiGetQueryExecutionsError,
    undefined,
    {},
    ApiGetQueryExecutionsQueryParams,
    ApiGetQueryExecutionsPathParams
  >({
    url: "/query/queries/v2/{queryId}/executions/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetQueryExecutionsQueryKey = (
  variables: ApiGetQueryExecutionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/query/queries/v2/{queryId}/executions/",
    operationId: "apiGetQueryExecutions",
    variables,
  });

export const useApiGetQueryExecutions = <
  TData = Schemas.QueryExecutionListOut,
>(
  variables: ApiGetQueryExecutionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QueryExecutionListOut,
      ApiGetQueryExecutionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/{queryId}/executions/",
    operationId: "apiGetQueryExecutions",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QueryExecutionListOut,
    ApiGetQueryExecutionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQueryExecutions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetQueryExecutions = <
  TData = Schemas.QueryExecutionListOut,
>(
  variables: ApiGetQueryExecutionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QueryExecutionListOut,
      ApiGetQueryExecutionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/{queryId}/executions/",
    operationId: "apiGetQueryExecutions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QueryExecutionListOut,
    ApiGetQueryExecutionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQueryExecutions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetQueryMetadataPathParams = {
  queryId: string;
};

export type ApiGetQueryMetadataQueryParams = {
  /**
   * @default 30
   */
  lookback_days?: number;
};

export type ApiGetQueryMetadataError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetQueryMetadataVariables = {
  pathParams: ApiGetQueryMetadataPathParams;
  queryParams?: ApiGetQueryMetadataQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get metadata for a specific query including execution statistics.
 */
export const fetchApiGetQueryMetadata = (
  variables: ApiGetQueryMetadataVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QueryMetadata,
    ApiGetQueryMetadataError,
    undefined,
    {},
    ApiGetQueryMetadataQueryParams,
    ApiGetQueryMetadataPathParams
  >({
    url: "/query/queries/v2/{queryId}/metadata/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetQueryMetadataQueryKey = (
  variables: ApiGetQueryMetadataVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/query/queries/v2/{queryId}/metadata/",
    operationId: "apiGetQueryMetadata",
    variables,
  });

/**
 * Get metadata for a specific query including execution statistics.
 */
export const useApiGetQueryMetadata = <TData = Schemas.QueryMetadata,>(
  variables: ApiGetQueryMetadataVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QueryMetadata,
      ApiGetQueryMetadataError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/{queryId}/metadata/",
    operationId: "apiGetQueryMetadata",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QueryMetadata,
    ApiGetQueryMetadataError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQueryMetadata({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get metadata for a specific query including execution statistics.
 */
export const useSuspenseApiGetQueryMetadata = <TData = Schemas.QueryMetadata,>(
  variables: ApiGetQueryMetadataVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QueryMetadata,
      ApiGetQueryMetadataError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/{queryId}/metadata/",
    operationId: "apiGetQueryMetadata",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QueryMetadata,
    ApiGetQueryMetadataError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQueryMetadata({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetQueryChartsPathParams = {
  queryId: string;
};

export type ApiGetQueryChartsQueryParams = {
  /**
   * @default 30
   */
  lookback_days?: number;
};

export type ApiGetQueryChartsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetQueryChartsResponse = Schemas.QueryChart[];

export type ApiGetQueryChartsVariables = {
  pathParams: ApiGetQueryChartsPathParams;
  queryParams?: ApiGetQueryChartsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetQueryCharts = (
  variables: ApiGetQueryChartsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetQueryChartsResponse,
    ApiGetQueryChartsError,
    undefined,
    {},
    ApiGetQueryChartsQueryParams,
    ApiGetQueryChartsPathParams
  >({
    url: "/query/queries/v2/{queryId}/charts/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetQueryChartsQueryKey = (
  variables: ApiGetQueryChartsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/query/queries/v2/{queryId}/charts/",
    operationId: "apiGetQueryCharts",
    variables,
  });

export const useApiGetQueryCharts = <TData = ApiGetQueryChartsResponse,>(
  variables: ApiGetQueryChartsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetQueryChartsResponse,
      ApiGetQueryChartsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/{queryId}/charts/",
    operationId: "apiGetQueryCharts",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetQueryChartsResponse,
    ApiGetQueryChartsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQueryCharts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetQueryCharts = <
  TData = ApiGetQueryChartsResponse,
>(
  variables: ApiGetQueryChartsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetQueryChartsResponse,
      ApiGetQueryChartsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/queries/v2/{queryId}/charts/",
    operationId: "apiGetQueryCharts",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetQueryChartsResponse,
    ApiGetQueryChartsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetQueryCharts({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateQueryTitlePathParams = {
  queryId: string;
};

export type ApiUpdateQueryTitleError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateQueryTitleVariables = {
  body: Schemas.QueryTitleIn;
  pathParams: ApiUpdateQueryTitlePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateQueryTitle = (
  variables: ApiUpdateQueryTitleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiUpdateQueryTitleError,
    Schemas.QueryTitleIn,
    {},
    {},
    ApiUpdateQueryTitlePathParams
  >({
    url: "/query/queries/v2/{queryId}/title/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiUpdateQueryTitle = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiUpdateQueryTitleError,
      ApiUpdateQueryTitleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiUpdateQueryTitleError,
    ApiUpdateQueryTitleVariables
  >({
    mutationFn: (variables: ApiUpdateQueryTitleVariables) =>
      fetchApiUpdateQueryTitle({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateQueryDescriptionPathParams = {
  queryId: string;
};

export type ApiUpdateQueryDescriptionError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateQueryDescriptionVariables = {
  body: Schemas.QueryDescriptionIn;
  pathParams: ApiUpdateQueryDescriptionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateQueryDescription = (
  variables: ApiUpdateQueryDescriptionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiUpdateQueryDescriptionError,
    Schemas.QueryDescriptionIn,
    {},
    {},
    ApiUpdateQueryDescriptionPathParams
  >({
    url: "/query/queries/v2/{queryId}/description/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiUpdateQueryDescription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiUpdateQueryDescriptionError,
      ApiUpdateQueryDescriptionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiUpdateQueryDescriptionError,
    ApiUpdateQueryDescriptionVariables
  >({
    mutationFn: (variables: ApiUpdateQueryDescriptionVariables) =>
      fetchApiUpdateQueryDescription({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetEntityJoinsPathParams = {
  entityId: string;
};

export type ApiGetEntityJoinsQueryParams = {
  search_term?: string | null;
  filter?: string | null;
  page?: number | null;
  page_size?: number | null;
};

export type ApiGetEntityJoinsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetEntityJoinsVariables = {
  pathParams: ApiGetEntityJoinsPathParams;
  queryParams?: ApiGetEntityJoinsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get joins for a specific entity with optional search filtering and pagination.
 */
export const fetchApiGetEntityJoins = (
  variables: ApiGetEntityJoinsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityJoinOut,
    ApiGetEntityJoinsError,
    undefined,
    {},
    ApiGetEntityJoinsQueryParams,
    ApiGetEntityJoinsPathParams
  >({ url: "/query/joins/{entityId}/", method: "get", ...variables, signal });

export const apiGetEntityJoinsQueryKey = (
  variables: ApiGetEntityJoinsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/query/joins/{entityId}/",
    operationId: "apiGetEntityJoins",
    variables,
  });

/**
 * Get joins for a specific entity with optional search filtering and pagination.
 */
export const useApiGetEntityJoins = <TData = Schemas.EntityJoinOut,>(
  variables: ApiGetEntityJoinsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EntityJoinOut,
      ApiGetEntityJoinsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/joins/{entityId}/",
    operationId: "apiGetEntityJoins",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.EntityJoinOut,
    ApiGetEntityJoinsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityJoins({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get joins for a specific entity with optional search filtering and pagination.
 */
export const useSuspenseApiGetEntityJoins = <TData = Schemas.EntityJoinOut,>(
  variables: ApiGetEntityJoinsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.EntityJoinOut,
      ApiGetEntityJoinsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/query/joins/{entityId}/",
    operationId: "apiGetEntityJoins",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.EntityJoinOut,
    ApiGetEntityJoinsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityJoins({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type IsJiraIntegratedError = Fetcher.ErrorWrapper<undefined>;

export type IsJiraIntegratedVariables = ApiContext["fetcherOptions"];

export const fetchIsJiraIntegrated = (
  variables: IsJiraIntegratedVariables,
  signal?: AbortSignal,
) =>
  apiFetch<boolean, IsJiraIntegratedError, undefined, {}, {}, {}>({
    url: "/monitor/incidents/jira/is_jira_integrated/",
    method: "get",
    ...variables,
    signal,
  });

export const isJiraIntegratedQueryKey = (
  variables: IsJiraIntegratedVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/incidents/jira/is_jira_integrated/",
    operationId: "isJiraIntegrated",
    variables,
  });

export const useIsJiraIntegrated = <TData = boolean,>(
  variables: IsJiraIntegratedVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<boolean, IsJiraIntegratedError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/incidents/jira/is_jira_integrated/",
    operationId: "isJiraIntegrated",
    variables,
  });
  const result = reactQuery.useQuery<boolean, IsJiraIntegratedError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchIsJiraIntegrated({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseIsJiraIntegrated = <TData = boolean,>(
  variables: IsJiraIntegratedVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<boolean, IsJiraIntegratedError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/incidents/jira/is_jira_integrated/",
    operationId: "isJiraIntegrated",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    boolean,
    IsJiraIntegratedError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchIsJiraIntegrated({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetJiraInformationError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.JiraError;
}>;

export type GetJiraInformationVariables = ApiContext["fetcherOptions"];

export const fetchGetJiraInformation = (
  variables: GetJiraInformationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.GetJiraInfoOut,
    GetJiraInformationError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/monitor/incidents/jira/get_jira_information/",
    method: "get",
    ...variables,
    signal,
  });

export const getJiraInformationQueryKey = (
  variables: GetJiraInformationVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/incidents/jira/get_jira_information/",
    operationId: "getJiraInformation",
    variables,
  });

export const useGetJiraInformation = <TData = Schemas.GetJiraInfoOut,>(
  variables: GetJiraInformationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetJiraInfoOut,
      GetJiraInformationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/incidents/jira/get_jira_information/",
    operationId: "getJiraInformation",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.GetJiraInfoOut,
    GetJiraInformationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetJiraInformation({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetJiraInformation = <TData = Schemas.GetJiraInfoOut,>(
  variables: GetJiraInformationVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.GetJiraInfoOut,
      GetJiraInformationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/incidents/jira/get_jira_information/",
    operationId: "getJiraInformation",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.GetJiraInfoOut,
    GetJiraInformationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetJiraInformation({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type LinkJiraIssuePathParams = {
  entityId: string;
};

export type LinkJiraIssueError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.JiraError;
}>;

export type LinkJiraIssueVariables = {
  body: Schemas.JiraLinkIn;
  pathParams: LinkJiraIssuePathParams;
} & ApiContext["fetcherOptions"];

export const fetchLinkJiraIssue = (
  variables: LinkJiraIssueVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    LinkJiraIssueError,
    Schemas.JiraLinkIn,
    {},
    {},
    LinkJiraIssuePathParams
  >({
    url: "/monitor/incidents/jira/{entityId}/link_jira_issue/",
    method: "post",
    ...variables,
    signal,
  });

export const useLinkJiraIssue = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      LinkJiraIssueError,
      LinkJiraIssueVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    LinkJiraIssueError,
    LinkJiraIssueVariables
  >({
    mutationFn: (variables: LinkJiraIssueVariables) =>
      fetchLinkJiraIssue({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateJiraIssuePathParams = {
  entityId: string;
};

export type CreateJiraIssueError = Fetcher.ErrorWrapper<undefined>;

export type CreateJiraIssueVariables = {
  body: Schemas.IssueCreateIn;
  pathParams: CreateJiraIssuePathParams;
} & ApiContext["fetcherOptions"];

export const fetchCreateJiraIssue = (
  variables: CreateJiraIssueVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    CreateJiraIssueError,
    Schemas.IssueCreateIn,
    {},
    {},
    CreateJiraIssuePathParams
  >({
    url: "/monitor/incidents/jira/{entityId}/create_jira_issue/",
    method: "post",
    ...variables,
    signal,
  });

export const useCreateJiraIssue = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CreateJiraIssueError,
      CreateJiraIssueVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    CreateJiraIssueError,
    CreateJiraIssueVariables
  >({
    mutationFn: (variables: CreateJiraIssueVariables) =>
      fetchCreateJiraIssue({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UnlinkJiraIssuePathParams = {
  entityId: string;
};

export type UnlinkJiraIssueError = Fetcher.ErrorWrapper<undefined>;

export type UnlinkJiraIssueVariables = {
  pathParams: UnlinkJiraIssuePathParams;
} & ApiContext["fetcherOptions"];

export const fetchUnlinkJiraIssue = (
  variables: UnlinkJiraIssueVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    UnlinkJiraIssueError,
    undefined,
    {},
    {},
    UnlinkJiraIssuePathParams
  >({
    url: "/monitor/incidents/jira/{entityId}/unlink_jira_issue/",
    method: "post",
    ...variables,
    signal,
  });

export const useUnlinkJiraIssue = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UnlinkJiraIssueError,
      UnlinkJiraIssueVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    UnlinkJiraIssueError,
    UnlinkJiraIssueVariables
  >({
    mutationFn: (variables: UnlinkJiraIssueVariables) =>
      fetchUnlinkJiraIssue({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetSupportedMonitorsQueryParams = {
  integration_id?: string | null;
  upstream_of?: string | null;
};

export type ApiGetSupportedMonitorsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetSupportedMonitorsResponse = (
  | Schemas.SuggestDirectMonitorOut
  | Schemas.SuggestAnalyticsMonitorOut
)[];

export type ApiGetSupportedMonitorsVariables = {
  queryParams?: ApiGetSupportedMonitorsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get all the supported monitors in the workspace.
 * If given integration_id, only return the supported monitors for that integration.
 * If given upstream_of, only return the supported monitors for integrations
 * that have upstream entities of the given entity.
 *
 * Args:
 *     integration_id (str): The integration id to filter the supported monitors by.
 *     upstream_of (str): Entity ID to get upstream entities' integrations from.
 * Returns:
 *     typing.List[MetricType]: The supported monitors.
 */
export const fetchApiGetSupportedMonitors = (
  variables: ApiGetSupportedMonitorsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetSupportedMonitorsResponse,
    ApiGetSupportedMonitorsError,
    undefined,
    {},
    ApiGetSupportedMonitorsQueryParams,
    {}
  >({
    url: "/monitor/recommend/supported_monitors/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetSupportedMonitorsQueryKey = (
  variables: ApiGetSupportedMonitorsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/recommend/supported_monitors/",
    operationId: "apiGetSupportedMonitors",
    variables,
  });

/**
 * Get all the supported monitors in the workspace.
 * If given integration_id, only return the supported monitors for that integration.
 * If given upstream_of, only return the supported monitors for integrations
 * that have upstream entities of the given entity.
 *
 * Args:
 *     integration_id (str): The integration id to filter the supported monitors by.
 *     upstream_of (str): Entity ID to get upstream entities' integrations from.
 * Returns:
 *     typing.List[MetricType]: The supported monitors.
 */
export const useApiGetSupportedMonitors = <
  TData = ApiGetSupportedMonitorsResponse,
>(
  variables: ApiGetSupportedMonitorsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetSupportedMonitorsResponse,
      ApiGetSupportedMonitorsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/recommend/supported_monitors/",
    operationId: "apiGetSupportedMonitors",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetSupportedMonitorsResponse,
    ApiGetSupportedMonitorsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetSupportedMonitors({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all the supported monitors in the workspace.
 * If given integration_id, only return the supported monitors for that integration.
 * If given upstream_of, only return the supported monitors for integrations
 * that have upstream entities of the given entity.
 *
 * Args:
 *     integration_id (str): The integration id to filter the supported monitors by.
 *     upstream_of (str): Entity ID to get upstream entities' integrations from.
 * Returns:
 *     typing.List[MetricType]: The supported monitors.
 */
export const useSuspenseApiGetSupportedMonitors = <
  TData = ApiGetSupportedMonitorsResponse,
>(
  variables: ApiGetSupportedMonitorsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetSupportedMonitorsResponse,
      ApiGetSupportedMonitorsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/recommend/supported_monitors/",
    operationId: "apiGetSupportedMonitors",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetSupportedMonitorsResponse,
    ApiGetSupportedMonitorsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetSupportedMonitors({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetSupportedIntegrationsQueryParams = {
  metric_type:
    | "row_count"
    | "cardinality"
    | "mean"
    | "max"
    | "min"
    | "unique_percentage"
    | "null_percentage"
    | "freshness"
    | "custom_sql"
    | "analytics"
    | "job_success_rate"
    | "job_error_rate"
    | "job_duration";
  integration_metric?: Schemas.AnalyticsMetricType | null;
};

export type ApiGetSupportedIntegrationsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetSupportedIntegrationsResponse = Schemas.LiteIntegration[];

export type ApiGetSupportedIntegrationsVariables = {
  queryParams: ApiGetSupportedIntegrationsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get all the supported integrations for monitoring
 */
export const fetchApiGetSupportedIntegrations = (
  variables: ApiGetSupportedIntegrationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetSupportedIntegrationsResponse,
    ApiGetSupportedIntegrationsError,
    undefined,
    {},
    ApiGetSupportedIntegrationsQueryParams,
    {}
  >({
    url: "/monitor/recommend/supported_integrations/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetSupportedIntegrationsQueryKey = (
  variables: ApiGetSupportedIntegrationsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/recommend/supported_integrations/",
    operationId: "apiGetSupportedIntegrations",
    variables,
  });

/**
 * Get all the supported integrations for monitoring
 */
export const useApiGetSupportedIntegrations = <
  TData = ApiGetSupportedIntegrationsResponse,
>(
  variables: ApiGetSupportedIntegrationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetSupportedIntegrationsResponse,
      ApiGetSupportedIntegrationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/recommend/supported_integrations/",
    operationId: "apiGetSupportedIntegrations",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetSupportedIntegrationsResponse,
    ApiGetSupportedIntegrationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetSupportedIntegrations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all the supported integrations for monitoring
 */
export const useSuspenseApiGetSupportedIntegrations = <
  TData = ApiGetSupportedIntegrationsResponse,
>(
  variables: ApiGetSupportedIntegrationsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetSupportedIntegrationsResponse,
      ApiGetSupportedIntegrationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/recommend/supported_integrations/",
    operationId: "apiGetSupportedIntegrations",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetSupportedIntegrationsResponse,
    ApiGetSupportedIntegrationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetSupportedIntegrations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetSupportedEntitiesQueryParams = {
  search: string;
  filters: string;
  metric_type:
    | "row_count"
    | "cardinality"
    | "mean"
    | "max"
    | "min"
    | "unique_percentage"
    | "null_percentage"
    | "freshness"
    | "custom_sql"
    | "analytics"
    | "job_success_rate"
    | "job_error_rate"
    | "job_duration";
  /**
   * @default 1
   */
  page?: number;
  upstream_of?: string | null;
  /**
   * @default 5
   */
  upstream_depth?: number;
};

export type ApiGetSupportedEntitiesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetSupportedEntitiesVariables = {
  queryParams: ApiGetSupportedEntitiesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get all entities that support the given metric type for monitor creation.
 *
 * Args:
 *     search: Search term to filter entities by name.
 *     filters: JSON string of catalog filters.
 *     metric_type: The type of metric to filter entities by.
 *     page: Page number for pagination.
 *     upstream_of: Optional entity ID to filter to only upstream entities of.
 *         When provided, only entities that are upstream of this entity
 *         (based on lineage) will be returned. Useful for creating monitors
 *         from downstream entities like Power BI dashboards/charts.
 *     upstream_depth: Maximum depth to traverse upstream lineage (1-5, default 5).
 *
 * Returns:
 *     Paginated list of entities that support the given metric type.
 */
export const fetchApiGetSupportedEntities = (
  variables: ApiGetSupportedEntitiesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaNinjaPaginationOutputSuggestMonitorEntityOut,
    ApiGetSupportedEntitiesError,
    undefined,
    {},
    ApiGetSupportedEntitiesQueryParams,
    {}
  >({
    url: "/monitor/recommend/supported_entities/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetSupportedEntitiesQueryKey = (
  variables: ApiGetSupportedEntitiesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/recommend/supported_entities/",
    operationId: "apiGetSupportedEntities",
    variables,
  });

/**
 * Get all entities that support the given metric type for monitor creation.
 *
 * Args:
 *     search: Search term to filter entities by name.
 *     filters: JSON string of catalog filters.
 *     metric_type: The type of metric to filter entities by.
 *     page: Page number for pagination.
 *     upstream_of: Optional entity ID to filter to only upstream entities of.
 *         When provided, only entities that are upstream of this entity
 *         (based on lineage) will be returned. Useful for creating monitors
 *         from downstream entities like Power BI dashboards/charts.
 *     upstream_depth: Maximum depth to traverse upstream lineage (1-5, default 5).
 *
 * Returns:
 *     Paginated list of entities that support the given metric type.
 */
export const useApiGetSupportedEntities = <
  TData = Schemas.SecodaNinjaPaginationOutputSuggestMonitorEntityOut,
>(
  variables: ApiGetSupportedEntitiesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputSuggestMonitorEntityOut,
      ApiGetSupportedEntitiesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/recommend/supported_entities/",
    operationId: "apiGetSupportedEntities",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SecodaNinjaPaginationOutputSuggestMonitorEntityOut,
    ApiGetSupportedEntitiesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetSupportedEntities({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get all entities that support the given metric type for monitor creation.
 *
 * Args:
 *     search: Search term to filter entities by name.
 *     filters: JSON string of catalog filters.
 *     metric_type: The type of metric to filter entities by.
 *     page: Page number for pagination.
 *     upstream_of: Optional entity ID to filter to only upstream entities of.
 *         When provided, only entities that are upstream of this entity
 *         (based on lineage) will be returned. Useful for creating monitors
 *         from downstream entities like Power BI dashboards/charts.
 *     upstream_depth: Maximum depth to traverse upstream lineage (1-5, default 5).
 *
 * Returns:
 *     Paginated list of entities that support the given metric type.
 */
export const useSuspenseApiGetSupportedEntities = <
  TData = Schemas.SecodaNinjaPaginationOutputSuggestMonitorEntityOut,
>(
  variables: ApiGetSupportedEntitiesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputSuggestMonitorEntityOut,
      ApiGetSupportedEntitiesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/recommend/supported_entities/",
    operationId: "apiGetSupportedEntities",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SecodaNinjaPaginationOutputSuggestMonitorEntityOut,
    ApiGetSupportedEntitiesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetSupportedEntities({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetDbtModelNamesQueryParams = {
  integration_id: string;
};

export type ApiGetDbtModelNamesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetDbtModelNamesResponse = string[];

export type ApiGetDbtModelNamesVariables = {
  queryParams: ApiGetDbtModelNamesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get available dbt model names from analytics data for a specific integration.
 */
export const fetchApiGetDbtModelNames = (
  variables: ApiGetDbtModelNamesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetDbtModelNamesResponse,
    ApiGetDbtModelNamesError,
    undefined,
    {},
    ApiGetDbtModelNamesQueryParams,
    {}
  >({
    url: "/monitor/recommend/dbt_model_names/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetDbtModelNamesQueryKey = (
  variables: ApiGetDbtModelNamesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/recommend/dbt_model_names/",
    operationId: "apiGetDbtModelNames",
    variables,
  });

/**
 * Get available dbt model names from analytics data for a specific integration.
 */
export const useApiGetDbtModelNames = <TData = ApiGetDbtModelNamesResponse,>(
  variables: ApiGetDbtModelNamesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetDbtModelNamesResponse,
      ApiGetDbtModelNamesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/recommend/dbt_model_names/",
    operationId: "apiGetDbtModelNames",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetDbtModelNamesResponse,
    ApiGetDbtModelNamesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetDbtModelNames({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get available dbt model names from analytics data for a specific integration.
 */
export const useSuspenseApiGetDbtModelNames = <
  TData = ApiGetDbtModelNamesResponse,
>(
  variables: ApiGetDbtModelNamesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetDbtModelNamesResponse,
      ApiGetDbtModelNamesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/recommend/dbt_model_names/",
    operationId: "apiGetDbtModelNames",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetDbtModelNamesResponse,
    ApiGetDbtModelNamesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetDbtModelNames({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMonitorJobResourcesQueryParams = {
  monitor_id: string;
};

export type ApiGetMonitorJobResourcesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetMonitorJobResourcesResponse = Schemas.MonitorJobResource[];

export type ApiGetMonitorJobResourcesVariables = {
  queryParams: ApiGetMonitorJobResourcesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMonitorJobResources = (
  variables: ApiGetMonitorJobResourcesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetMonitorJobResourcesResponse,
    ApiGetMonitorJobResourcesError,
    undefined,
    {},
    ApiGetMonitorJobResourcesQueryParams,
    {}
  >({ url: "/monitor/jobs/", method: "get", ...variables, signal });

export const apiGetMonitorJobResourcesQueryKey = (
  variables: ApiGetMonitorJobResourcesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/jobs/",
    operationId: "apiGetMonitorJobResources",
    variables,
  });

export const useApiGetMonitorJobResources = <
  TData = ApiGetMonitorJobResourcesResponse,
>(
  variables: ApiGetMonitorJobResourcesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetMonitorJobResourcesResponse,
      ApiGetMonitorJobResourcesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/jobs/",
    operationId: "apiGetMonitorJobResources",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetMonitorJobResourcesResponse,
    ApiGetMonitorJobResourcesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorJobResources(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMonitorJobResources = <
  TData = ApiGetMonitorJobResourcesResponse,
>(
  variables: ApiGetMonitorJobResourcesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetMonitorJobResourcesResponse,
      ApiGetMonitorJobResourcesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/jobs/",
    operationId: "apiGetMonitorJobResources",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetMonitorJobResourcesResponse,
    ApiGetMonitorJobResourcesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorJobResources(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ListNotificationRulesQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ListNotificationRulesError = Fetcher.ErrorWrapper<undefined>;

export type ListNotificationRulesVariables = {
  queryParams?: ListNotificationRulesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchListNotificationRules = (
  variables: ListNotificationRulesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedNotificationRuleOut,
    ListNotificationRulesError,
    undefined,
    {},
    ListNotificationRulesQueryParams,
    {}
  >({ url: "/monitor/rules/", method: "get", ...variables, signal });

export const listNotificationRulesQueryKey = (
  variables: ListNotificationRulesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/rules/",
    operationId: "listNotificationRules",
    variables,
  });

export const useListNotificationRules = <
  TData = Schemas.PagedNotificationRuleOut,
>(
  variables: ListNotificationRulesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedNotificationRuleOut,
      ListNotificationRulesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/rules/",
    operationId: "listNotificationRules",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedNotificationRuleOut,
    ListNotificationRulesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListNotificationRules({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseListNotificationRules = <
  TData = Schemas.PagedNotificationRuleOut,
>(
  variables: ListNotificationRulesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedNotificationRuleOut,
      ListNotificationRulesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/rules/",
    operationId: "listNotificationRules",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedNotificationRuleOut,
    ListNotificationRulesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListNotificationRules({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type CreateNotificationRuleError = Fetcher.ErrorWrapper<undefined>;

export type CreateNotificationRuleVariables = {
  body: Schemas.NotificationRuleIn;
} & ApiContext["fetcherOptions"];

export const fetchCreateNotificationRule = (
  variables: CreateNotificationRuleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.NotificationRuleOut,
    CreateNotificationRuleError,
    Schemas.NotificationRuleIn,
    {},
    {},
    {}
  >({ url: "/monitor/rules/", method: "post", ...variables, signal });

export const useCreateNotificationRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.NotificationRuleOut,
      CreateNotificationRuleError,
      CreateNotificationRuleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.NotificationRuleOut,
    CreateNotificationRuleError,
    CreateNotificationRuleVariables
  >({
    mutationFn: (variables: CreateNotificationRuleVariables) =>
      fetchCreateNotificationRule({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetNotificationRulePathParams = {
  ruleId: string;
};

export type GetNotificationRuleError = Fetcher.ErrorWrapper<undefined>;

export type GetNotificationRuleVariables = {
  pathParams: GetNotificationRulePathParams;
} & ApiContext["fetcherOptions"];

export const fetchGetNotificationRule = (
  variables: GetNotificationRuleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.NotificationRuleOut,
    GetNotificationRuleError,
    undefined,
    {},
    {},
    GetNotificationRulePathParams
  >({ url: "/monitor/rules/{ruleId}/", method: "get", ...variables, signal });

export const getNotificationRuleQueryKey = (
  variables: GetNotificationRuleVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/rules/{ruleId}/",
    operationId: "getNotificationRule",
    variables,
  });

export const useGetNotificationRule = <TData = Schemas.NotificationRuleOut,>(
  variables: GetNotificationRuleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.NotificationRuleOut,
      GetNotificationRuleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/rules/{ruleId}/",
    operationId: "getNotificationRule",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.NotificationRuleOut,
    GetNotificationRuleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetNotificationRule({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetNotificationRule = <
  TData = Schemas.NotificationRuleOut,
>(
  variables: GetNotificationRuleVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.NotificationRuleOut,
      GetNotificationRuleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/rules/{ruleId}/",
    operationId: "getNotificationRule",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.NotificationRuleOut,
    GetNotificationRuleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetNotificationRule({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type UpdateNotificationRulePathParams = {
  ruleId: string;
};

export type UpdateNotificationRuleError = Fetcher.ErrorWrapper<undefined>;

export type UpdateNotificationRuleVariables = {
  body: Schemas.NotificationRuleIn;
  pathParams: UpdateNotificationRulePathParams;
} & ApiContext["fetcherOptions"];

export const fetchUpdateNotificationRule = (
  variables: UpdateNotificationRuleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.NotificationRuleOut,
    UpdateNotificationRuleError,
    Schemas.NotificationRuleIn,
    {},
    {},
    UpdateNotificationRulePathParams
  >({ url: "/monitor/rules/{ruleId}/", method: "patch", ...variables, signal });

export const useUpdateNotificationRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.NotificationRuleOut,
      UpdateNotificationRuleError,
      UpdateNotificationRuleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.NotificationRuleOut,
    UpdateNotificationRuleError,
    UpdateNotificationRuleVariables
  >({
    mutationFn: (variables: UpdateNotificationRuleVariables) =>
      fetchUpdateNotificationRule({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteNotificationRulePathParams = {
  ruleId: string;
};

export type DeleteNotificationRuleError = Fetcher.ErrorWrapper<undefined>;

export type DeleteNotificationRuleVariables = {
  pathParams: DeleteNotificationRulePathParams;
} & ApiContext["fetcherOptions"];

export const fetchDeleteNotificationRule = (
  variables: DeleteNotificationRuleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    DeleteNotificationRuleError,
    undefined,
    {},
    {},
    DeleteNotificationRulePathParams
  >({
    url: "/monitor/rules/{ruleId}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useDeleteNotificationRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteNotificationRuleError,
      DeleteNotificationRuleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteNotificationRuleError,
    DeleteNotificationRuleVariables
  >({
    mutationFn: (variables: DeleteNotificationRuleVariables) =>
      fetchDeleteNotificationRule({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiStartJobError = Fetcher.ErrorWrapper<undefined>;

export type ApiStartJobVariables = {
  body: Schemas.ImportJobIn;
} & ApiContext["fetcherOptions"];

export const fetchApiStartJob = (
  variables: ApiStartJobVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ImportJobOut,
    ApiStartJobError,
    Schemas.ImportJobIn,
    {},
    {},
    {}
  >({ url: "/monitor/import/job/", method: "post", ...variables, signal });

export const useApiStartJob = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ImportJobOut,
      ApiStartJobError,
      ApiStartJobVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ImportJobOut,
    ApiStartJobError,
    ApiStartJobVariables
  >({
    mutationFn: (variables: ApiStartJobVariables) =>
      fetchApiStartJob({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetJobResultPathParams = {
  jobId: string;
};

export type ApiGetJobResultError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetJobResultVariables = {
  pathParams: ApiGetJobResultPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetJobResult = (
  variables: ApiGetJobResultVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ImportResultOut,
    ApiGetJobResultError,
    undefined,
    {},
    {},
    ApiGetJobResultPathParams
  >({
    url: "/monitor/import/job/{jobId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetJobResultQueryKey = (
  variables: ApiGetJobResultVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/import/job/{jobId}/",
    operationId: "apiGetJobResult",
    variables,
  });

export const useApiGetJobResult = <TData = Schemas.ImportResultOut,>(
  variables: ApiGetJobResultVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ImportResultOut,
      ApiGetJobResultError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/import/job/{jobId}/",
    operationId: "apiGetJobResult",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ImportResultOut,
    ApiGetJobResultError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetJobResult({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetJobResult = <TData = Schemas.ImportResultOut,>(
  variables: ApiGetJobResultVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ImportResultOut,
      ApiGetJobResultError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/import/job/{jobId}/",
    operationId: "apiGetJobResult",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ImportResultOut,
    ApiGetJobResultError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetJobResult({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateMonitorsFromJobPathParams = {
  jobId: string;
};

export type ApiCreateMonitorsFromJobError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateMonitorsFromJobVariables = {
  body: Schemas.ImportCreateIn;
  pathParams: ApiCreateMonitorsFromJobPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateMonitorsFromJob = (
  variables: ApiCreateMonitorsFromJobVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ImportCreateOut,
    ApiCreateMonitorsFromJobError,
    Schemas.ImportCreateIn,
    {},
    {},
    ApiCreateMonitorsFromJobPathParams
  >({
    url: "/monitor/import/job/{jobId}/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCreateMonitorsFromJob = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ImportCreateOut,
      ApiCreateMonitorsFromJobError,
      ApiCreateMonitorsFromJobVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.ImportCreateOut,
    ApiCreateMonitorsFromJobError,
    ApiCreateMonitorsFromJobVariables
  >({
    mutationFn: (variables: ApiCreateMonitorsFromJobVariables) =>
      fetchApiCreateMonitorsFromJob({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiMonitorNotifyDownstreamPathParams = {
  monitorId: string;
};

export type ApiMonitorNotifyDownstreamError = Fetcher.ErrorWrapper<undefined>;

export type ApiMonitorNotifyDownstreamResponse = Schemas.LiteSecodaEntity[];

export type ApiMonitorNotifyDownstreamVariables = {
  body: Schemas.MonitorNotifyDownstreamIn;
  pathParams: ApiMonitorNotifyDownstreamPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiMonitorNotifyDownstream = (
  variables: ApiMonitorNotifyDownstreamVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiMonitorNotifyDownstreamResponse,
    ApiMonitorNotifyDownstreamError,
    Schemas.MonitorNotifyDownstreamIn,
    {},
    {},
    ApiMonitorNotifyDownstreamPathParams
  >({
    url: "/monitor/{monitorId}/notify_downstream/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiMonitorNotifyDownstream = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiMonitorNotifyDownstreamResponse,
      ApiMonitorNotifyDownstreamError,
      ApiMonitorNotifyDownstreamVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiMonitorNotifyDownstreamResponse,
    ApiMonitorNotifyDownstreamError,
    ApiMonitorNotifyDownstreamVariables
  >({
    mutationFn: (variables: ApiMonitorNotifyDownstreamVariables) =>
      fetchApiMonitorNotifyDownstream({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetMonitorPreviewMeasurementsPathParams = {
  monitorId: string;
};

export type ApiGetMonitorPreviewMeasurementsQueryParams = {
  algorithm: string;
  /**
   * @default medium
   */
  sensitivity?: string;
};

export type ApiGetMonitorPreviewMeasurementsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetMonitorPreviewMeasurementsResponse =
  Schemas.MeasurementChartData[];

export type ApiGetMonitorPreviewMeasurementsVariables = {
  pathParams: ApiGetMonitorPreviewMeasurementsPathParams;
  queryParams: ApiGetMonitorPreviewMeasurementsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMonitorPreviewMeasurements = (
  variables: ApiGetMonitorPreviewMeasurementsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetMonitorPreviewMeasurementsResponse,
    ApiGetMonitorPreviewMeasurementsError,
    undefined,
    {},
    ApiGetMonitorPreviewMeasurementsQueryParams,
    ApiGetMonitorPreviewMeasurementsPathParams
  >({
    url: "/monitor/{monitorId}/preview_measurements/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetMonitorPreviewMeasurementsQueryKey = (
  variables: ApiGetMonitorPreviewMeasurementsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/{monitorId}/preview_measurements/",
    operationId: "apiGetMonitorPreviewMeasurements",
    variables,
  });

export const useApiGetMonitorPreviewMeasurements = <
  TData = ApiGetMonitorPreviewMeasurementsResponse,
>(
  variables: ApiGetMonitorPreviewMeasurementsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetMonitorPreviewMeasurementsResponse,
      ApiGetMonitorPreviewMeasurementsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/{monitorId}/preview_measurements/",
    operationId: "apiGetMonitorPreviewMeasurements",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetMonitorPreviewMeasurementsResponse,
    ApiGetMonitorPreviewMeasurementsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorPreviewMeasurements(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMonitorPreviewMeasurements = <
  TData = ApiGetMonitorPreviewMeasurementsResponse,
>(
  variables: ApiGetMonitorPreviewMeasurementsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetMonitorPreviewMeasurementsResponse,
      ApiGetMonitorPreviewMeasurementsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/{monitorId}/preview_measurements/",
    operationId: "apiGetMonitorPreviewMeasurements",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetMonitorPreviewMeasurementsResponse,
    ApiGetMonitorPreviewMeasurementsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorPreviewMeasurements(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMonitorRelatedResourcesPathParams = {
  monitorId: string;
};

export type ApiGetMonitorRelatedResourcesError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetMonitorRelatedResourcesResponse = Schemas.LiteSecodaEntity[];

export type ApiGetMonitorRelatedResourcesVariables = {
  pathParams: ApiGetMonitorRelatedResourcesPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMonitorRelatedResources = (
  variables: ApiGetMonitorRelatedResourcesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetMonitorRelatedResourcesResponse,
    ApiGetMonitorRelatedResourcesError,
    undefined,
    {},
    {},
    ApiGetMonitorRelatedResourcesPathParams
  >({
    url: "/monitor/{monitorId}/related_resources/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetMonitorRelatedResourcesQueryKey = (
  variables: ApiGetMonitorRelatedResourcesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/{monitorId}/related_resources/",
    operationId: "apiGetMonitorRelatedResources",
    variables,
  });

export const useApiGetMonitorRelatedResources = <
  TData = ApiGetMonitorRelatedResourcesResponse,
>(
  variables: ApiGetMonitorRelatedResourcesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetMonitorRelatedResourcesResponse,
      ApiGetMonitorRelatedResourcesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/{monitorId}/related_resources/",
    operationId: "apiGetMonitorRelatedResources",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetMonitorRelatedResourcesResponse,
    ApiGetMonitorRelatedResourcesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorRelatedResources(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMonitorRelatedResources = <
  TData = ApiGetMonitorRelatedResourcesResponse,
>(
  variables: ApiGetMonitorRelatedResourcesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetMonitorRelatedResourcesResponse,
      ApiGetMonitorRelatedResourcesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/{monitorId}/related_resources/",
    operationId: "apiGetMonitorRelatedResources",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetMonitorRelatedResourcesResponse,
    ApiGetMonitorRelatedResourcesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorRelatedResources(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMonitorMetricsQueryParams = {
  /**
   * @default all
   */
  filter_type?: string;
  time_range?: string | null;
  start_date?: string | null;
  end_date?: string | null;
};

export type ApiGetMonitorMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetMonitorMetricsVariables = {
  queryParams?: ApiGetMonitorMetricsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get monitor metrics filtered by ownership type and time range
 */
export const fetchApiGetMonitorMetrics = (
  variables: ApiGetMonitorMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MonitorMetrics,
    ApiGetMonitorMetricsError,
    undefined,
    {},
    ApiGetMonitorMetricsQueryParams,
    {}
  >({ url: "/monitor/metrics/", method: "get", ...variables, signal });

export const apiGetMonitorMetricsQueryKey = (
  variables: ApiGetMonitorMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/metrics/",
    operationId: "apiGetMonitorMetrics",
    variables,
  });

/**
 * Get monitor metrics filtered by ownership type and time range
 */
export const useApiGetMonitorMetrics = <TData = Schemas.MonitorMetrics,>(
  variables: ApiGetMonitorMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.MonitorMetrics,
      ApiGetMonitorMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/metrics/",
    operationId: "apiGetMonitorMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.MonitorMetrics,
    ApiGetMonitorMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get monitor metrics filtered by ownership type and time range
 */
export const useSuspenseApiGetMonitorMetrics = <
  TData = Schemas.MonitorMetrics,
>(
  variables: ApiGetMonitorMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.MonitorMetrics,
      ApiGetMonitorMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/metrics/",
    operationId: "apiGetMonitorMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.MonitorMetrics,
    ApiGetMonitorMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMonitorTimeseriesQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * @default all
   */
  filter_type?: string;
  start_date?: string | null;
  end_date?: string | null;
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
};

export type ApiGetMonitorTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetMonitorTimeseriesVariables = {
  queryParams?: ApiGetMonitorTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get monitor metrics time series data filtered by ownership type
 */
export const fetchApiGetMonitorTimeseries = (
  variables: ApiGetMonitorTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MonitorTimeSeries,
    ApiGetMonitorTimeseriesError,
    undefined,
    {},
    ApiGetMonitorTimeseriesQueryParams,
    {}
  >({ url: "/monitor/timeseries/", method: "get", ...variables, signal });

export const apiGetMonitorTimeseriesQueryKey = (
  variables: ApiGetMonitorTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/monitor/timeseries/",
    operationId: "apiGetMonitorTimeseries",
    variables,
  });

/**
 * Get monitor metrics time series data filtered by ownership type
 */
export const useApiGetMonitorTimeseries = <TData = Schemas.MonitorTimeSeries,>(
  variables: ApiGetMonitorTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.MonitorTimeSeries,
      ApiGetMonitorTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/timeseries/",
    operationId: "apiGetMonitorTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.MonitorTimeSeries,
    ApiGetMonitorTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorTimeseries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get monitor metrics time series data filtered by ownership type
 */
export const useSuspenseApiGetMonitorTimeseries = <
  TData = Schemas.MonitorTimeSeries,
>(
  variables: ApiGetMonitorTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.MonitorTimeSeries,
      ApiGetMonitorTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/monitor/timeseries/",
    operationId: "apiGetMonitorTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.MonitorTimeSeries,
    ApiGetMonitorTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMonitorTimeseries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiBulkUpdateMonitorsError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Schemas.MonitorBulkUpdateOut;
    }
  | {
      status: 403;
      payload: Schemas.MonitorBulkUpdateOut;
    }
  | {
      status: 404;
      payload: Schemas.MonitorBulkUpdateOut;
    }
>;

export type ApiBulkUpdateMonitorsVariables = {
  body: Schemas.MonitorBulkUpdateIn;
} & ApiContext["fetcherOptions"];

/**
 * Bulk update monitors in a single request.
 *
 * payload.updates should be of the format:
 * {
 *     monitor_id: {
 *         field_name: updated_field_value,
 *         ...
 *     },
 *     ...
 * }
 *
 * Where updated_field_value can be any corresponding monitor field value.
 */
export const fetchApiBulkUpdateMonitors = (
  variables: ApiBulkUpdateMonitorsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MonitorBulkUpdateOut,
    ApiBulkUpdateMonitorsError,
    Schemas.MonitorBulkUpdateIn,
    {},
    {},
    {}
  >({ url: "/monitor/bulk_update/", method: "patch", ...variables, signal });

/**
 * Bulk update monitors in a single request.
 *
 * payload.updates should be of the format:
 * {
 *     monitor_id: {
 *         field_name: updated_field_value,
 *         ...
 *     },
 *     ...
 * }
 *
 * Where updated_field_value can be any corresponding monitor field value.
 */
export const useApiBulkUpdateMonitors = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MonitorBulkUpdateOut,
      ApiBulkUpdateMonitorsError,
      ApiBulkUpdateMonitorsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MonitorBulkUpdateOut,
    ApiBulkUpdateMonitorsError,
    ApiBulkUpdateMonitorsVariables
  >({
    mutationFn: (variables: ApiBulkUpdateMonitorsVariables) =>
      fetchApiBulkUpdateMonitors({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiCreateMarketplaceIntegrationSpecError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiCreateMarketplaceIntegrationSpecVariables = {
  body: Schemas.MarketplaceIntegrationSpecIn;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateMarketplaceIntegrationSpec = (
  variables: ApiCreateMarketplaceIntegrationSpecVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MarketplaceIntegrationSpecOut,
    ApiCreateMarketplaceIntegrationSpecError,
    Schemas.MarketplaceIntegrationSpecIn,
    {},
    {},
    {}
  >({
    url: "/integration/marketplace/specs/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCreateMarketplaceIntegrationSpec = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MarketplaceIntegrationSpecOut,
      ApiCreateMarketplaceIntegrationSpecError,
      ApiCreateMarketplaceIntegrationSpecVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MarketplaceIntegrationSpecOut,
    ApiCreateMarketplaceIntegrationSpecError,
    ApiCreateMarketplaceIntegrationSpecVariables
  >({
    mutationFn: (variables: ApiCreateMarketplaceIntegrationSpecVariables) =>
      fetchApiCreateMarketplaceIntegrationSpec({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiListMarketplaceIntegrationSpecsQueryParams = {
  /**
   * @default false
   */
  browsing?: boolean;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListMarketplaceIntegrationSpecsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiListMarketplaceIntegrationSpecsVariables = {
  queryParams?: ApiListMarketplaceIntegrationSpecsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * @param browsing: If browsing, we also return specs from other workspaces, but only
 * those that have at least one version approved.
 */
export const fetchApiListMarketplaceIntegrationSpecs = (
  variables: ApiListMarketplaceIntegrationSpecsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedMarketplaceIntegrationSpecOut,
    ApiListMarketplaceIntegrationSpecsError,
    undefined,
    {},
    ApiListMarketplaceIntegrationSpecsQueryParams,
    {}
  >({
    url: "/integration/marketplace/specs/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListMarketplaceIntegrationSpecsQueryKey = (
  variables: ApiListMarketplaceIntegrationSpecsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/marketplace/specs/",
    operationId: "apiListMarketplaceIntegrationSpecs",
    variables,
  });

/**
 * @param browsing: If browsing, we also return specs from other workspaces, but only
 * those that have at least one version approved.
 */
export const useApiListMarketplaceIntegrationSpecs = <
  TData = Schemas.PagedMarketplaceIntegrationSpecOut,
>(
  variables: ApiListMarketplaceIntegrationSpecsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedMarketplaceIntegrationSpecOut,
      ApiListMarketplaceIntegrationSpecsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/",
    operationId: "apiListMarketplaceIntegrationSpecs",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedMarketplaceIntegrationSpecOut,
    ApiListMarketplaceIntegrationSpecsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListMarketplaceIntegrationSpecs(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * @param browsing: If browsing, we also return specs from other workspaces, but only
 * those that have at least one version approved.
 */
export const useSuspenseApiListMarketplaceIntegrationSpecs = <
  TData = Schemas.PagedMarketplaceIntegrationSpecOut,
>(
  variables: ApiListMarketplaceIntegrationSpecsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedMarketplaceIntegrationSpecOut,
      ApiListMarketplaceIntegrationSpecsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/",
    operationId: "apiListMarketplaceIntegrationSpecs",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedMarketplaceIntegrationSpecOut,
    ApiListMarketplaceIntegrationSpecsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListMarketplaceIntegrationSpecs(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMarketplaceIntegrationSpecPathParams = {
  specId: string;
};

export type ApiGetMarketplaceIntegrationSpecError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetMarketplaceIntegrationSpecVariables = {
  pathParams: ApiGetMarketplaceIntegrationSpecPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMarketplaceIntegrationSpec = (
  variables: ApiGetMarketplaceIntegrationSpecVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MarketplaceIntegrationSpecOut,
    ApiGetMarketplaceIntegrationSpecError,
    undefined,
    {},
    {},
    ApiGetMarketplaceIntegrationSpecPathParams
  >({
    url: "/integration/marketplace/specs/{specId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetMarketplaceIntegrationSpecQueryKey = (
  variables: ApiGetMarketplaceIntegrationSpecVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/",
    operationId: "apiGetMarketplaceIntegrationSpec",
    variables,
  });

export const useApiGetMarketplaceIntegrationSpec = <
  TData = Schemas.MarketplaceIntegrationSpecOut,
>(
  variables: ApiGetMarketplaceIntegrationSpecVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.MarketplaceIntegrationSpecOut,
      ApiGetMarketplaceIntegrationSpecError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/",
    operationId: "apiGetMarketplaceIntegrationSpec",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.MarketplaceIntegrationSpecOut,
    ApiGetMarketplaceIntegrationSpecError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMarketplaceIntegrationSpec(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMarketplaceIntegrationSpec = <
  TData = Schemas.MarketplaceIntegrationSpecOut,
>(
  variables: ApiGetMarketplaceIntegrationSpecVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.MarketplaceIntegrationSpecOut,
      ApiGetMarketplaceIntegrationSpecError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/",
    operationId: "apiGetMarketplaceIntegrationSpec",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.MarketplaceIntegrationSpecOut,
    ApiGetMarketplaceIntegrationSpecError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMarketplaceIntegrationSpec(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiDeleteMarketplaceIntegrationSpecPathParams = {
  specId: string;
};

export type ApiDeleteMarketplaceIntegrationSpecError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteMarketplaceIntegrationSpecVariables = {
  pathParams: ApiDeleteMarketplaceIntegrationSpecPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiDeleteMarketplaceIntegrationSpec = (
  variables: ApiDeleteMarketplaceIntegrationSpecVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteMarketplaceIntegrationSpecError,
    undefined,
    {},
    {},
    ApiDeleteMarketplaceIntegrationSpecPathParams
  >({
    url: "/integration/marketplace/specs/{specId}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiDeleteMarketplaceIntegrationSpec = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteMarketplaceIntegrationSpecError,
      ApiDeleteMarketplaceIntegrationSpecVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteMarketplaceIntegrationSpecError,
    ApiDeleteMarketplaceIntegrationSpecVariables
  >({
    mutationFn: (variables: ApiDeleteMarketplaceIntegrationSpecVariables) =>
      fetchApiDeleteMarketplaceIntegrationSpec({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiGetMarketplaceIntegrationSpecVersionsPathParams = {
  specId: string;
};

export type ApiGetMarketplaceIntegrationSpecVersionsQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiGetMarketplaceIntegrationSpecVersionsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetMarketplaceIntegrationSpecVersionsVariables = {
  pathParams: ApiGetMarketplaceIntegrationSpecVersionsPathParams;
  queryParams?: ApiGetMarketplaceIntegrationSpecVersionsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMarketplaceIntegrationSpecVersions = (
  variables: ApiGetMarketplaceIntegrationSpecVersionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedMarketplaceIntegrationSpecVersionOut,
    ApiGetMarketplaceIntegrationSpecVersionsError,
    undefined,
    {},
    ApiGetMarketplaceIntegrationSpecVersionsQueryParams,
    ApiGetMarketplaceIntegrationSpecVersionsPathParams
  >({
    url: "/integration/marketplace/specs/{specId}/versions/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetMarketplaceIntegrationSpecVersionsQueryKey = (
  variables: ApiGetMarketplaceIntegrationSpecVersionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/",
    operationId: "apiGetMarketplaceIntegrationSpecVersions",
    variables,
  });

export const useApiGetMarketplaceIntegrationSpecVersions = <
  TData = Schemas.PagedMarketplaceIntegrationSpecVersionOut,
>(
  variables: ApiGetMarketplaceIntegrationSpecVersionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedMarketplaceIntegrationSpecVersionOut,
      ApiGetMarketplaceIntegrationSpecVersionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/",
    operationId: "apiGetMarketplaceIntegrationSpecVersions",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedMarketplaceIntegrationSpecVersionOut,
    ApiGetMarketplaceIntegrationSpecVersionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMarketplaceIntegrationSpecVersions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMarketplaceIntegrationSpecVersions = <
  TData = Schemas.PagedMarketplaceIntegrationSpecVersionOut,
>(
  variables: ApiGetMarketplaceIntegrationSpecVersionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedMarketplaceIntegrationSpecVersionOut,
      ApiGetMarketplaceIntegrationSpecVersionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/",
    operationId: "apiGetMarketplaceIntegrationSpecVersions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedMarketplaceIntegrationSpecVersionOut,
    ApiGetMarketplaceIntegrationSpecVersionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMarketplaceIntegrationSpecVersions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateMarketplaceIntegrationSpecVersionPathParams = {
  specId: string;
};

export type ApiCreateMarketplaceIntegrationSpecVersionError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiCreateMarketplaceIntegrationSpecVersionRequestBody = {
  /**
   * @format binary
   */
  code_file: Blob;
  detail: Schemas.CreateOrUpdateMarketplaceIntegrationSpecVersionDetail;
};

export type ApiCreateMarketplaceIntegrationSpecVersionVariables = {
  body: ApiCreateMarketplaceIntegrationSpecVersionRequestBody;
  pathParams: ApiCreateMarketplaceIntegrationSpecVersionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateMarketplaceIntegrationSpecVersion = (
  variables: ApiCreateMarketplaceIntegrationSpecVersionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiCreateMarketplaceIntegrationSpecVersionError,
    ApiCreateMarketplaceIntegrationSpecVersionRequestBody,
    {},
    {},
    ApiCreateMarketplaceIntegrationSpecVersionPathParams
  >({
    url: "/integration/marketplace/specs/{specId}/versions/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCreateMarketplaceIntegrationSpecVersion = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MarketplaceIntegrationSpecVersionOut,
      ApiCreateMarketplaceIntegrationSpecVersionError,
      ApiCreateMarketplaceIntegrationSpecVersionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiCreateMarketplaceIntegrationSpecVersionError,
    ApiCreateMarketplaceIntegrationSpecVersionVariables
  >({
    mutationFn: (
      variables: ApiCreateMarketplaceIntegrationSpecVersionVariables,
    ) =>
      fetchApiCreateMarketplaceIntegrationSpecVersion({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiGetMarketplaceIntegrationSpecVersionPathParams = {
  specId: string;
  versionId: string;
};

export type ApiGetMarketplaceIntegrationSpecVersionError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetMarketplaceIntegrationSpecVersionVariables = {
  pathParams: ApiGetMarketplaceIntegrationSpecVersionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetMarketplaceIntegrationSpecVersion = (
  variables: ApiGetMarketplaceIntegrationSpecVersionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiGetMarketplaceIntegrationSpecVersionError,
    undefined,
    {},
    {},
    ApiGetMarketplaceIntegrationSpecVersionPathParams
  >({
    url: "/integration/marketplace/specs/{specId}/versions/{versionId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetMarketplaceIntegrationSpecVersionQueryKey = (
  variables: ApiGetMarketplaceIntegrationSpecVersionVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/{versionId}/",
    operationId: "apiGetMarketplaceIntegrationSpecVersion",
    variables,
  });

export const useApiGetMarketplaceIntegrationSpecVersion = <
  TData = Schemas.MarketplaceIntegrationSpecVersionOut,
>(
  variables: ApiGetMarketplaceIntegrationSpecVersionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.MarketplaceIntegrationSpecVersionOut,
      ApiGetMarketplaceIntegrationSpecVersionError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/{versionId}/",
    operationId: "apiGetMarketplaceIntegrationSpecVersion",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiGetMarketplaceIntegrationSpecVersionError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMarketplaceIntegrationSpecVersion(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMarketplaceIntegrationSpecVersion = <
  TData = Schemas.MarketplaceIntegrationSpecVersionOut,
>(
  variables: ApiGetMarketplaceIntegrationSpecVersionVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.MarketplaceIntegrationSpecVersionOut,
      ApiGetMarketplaceIntegrationSpecVersionError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/{versionId}/",
    operationId: "apiGetMarketplaceIntegrationSpecVersion",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiGetMarketplaceIntegrationSpecVersionError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMarketplaceIntegrationSpecVersion(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateMarketplaceIntegrationSpecVersionPathParams = {
  specId: string;
  versionId: string;
};

export type ApiUpdateMarketplaceIntegrationSpecVersionError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateMarketplaceIntegrationSpecVersionRequestBody = {
  /**
   * @format binary
   */
  code_file?: Blob;
  detail: Schemas.CreateOrUpdateMarketplaceIntegrationSpecVersionDetail;
};

export type ApiUpdateMarketplaceIntegrationSpecVersionVariables = {
  body: ApiUpdateMarketplaceIntegrationSpecVersionRequestBody;
  pathParams: ApiUpdateMarketplaceIntegrationSpecVersionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateMarketplaceIntegrationSpecVersion = (
  variables: ApiUpdateMarketplaceIntegrationSpecVersionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiUpdateMarketplaceIntegrationSpecVersionError,
    ApiUpdateMarketplaceIntegrationSpecVersionRequestBody,
    {},
    {},
    ApiUpdateMarketplaceIntegrationSpecVersionPathParams
  >({
    url: "/integration/marketplace/specs/{specId}/versions/{versionId}/edit/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateMarketplaceIntegrationSpecVersion = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MarketplaceIntegrationSpecVersionOut,
      ApiUpdateMarketplaceIntegrationSpecVersionError,
      ApiUpdateMarketplaceIntegrationSpecVersionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiUpdateMarketplaceIntegrationSpecVersionError,
    ApiUpdateMarketplaceIntegrationSpecVersionVariables
  >({
    mutationFn: (
      variables: ApiUpdateMarketplaceIntegrationSpecVersionVariables,
    ) =>
      fetchApiUpdateMarketplaceIntegrationSpecVersion({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiPreviewMarketplaceIntegrationSpecVersionCodePathParams = {
  specId: string;
  versionId: string;
};

export type ApiPreviewMarketplaceIntegrationSpecVersionCodeError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiPreviewMarketplaceIntegrationSpecVersionCodeVariables = {
  pathParams: ApiPreviewMarketplaceIntegrationSpecVersionCodePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiPreviewMarketplaceIntegrationSpecVersionCode = (
  variables: ApiPreviewMarketplaceIntegrationSpecVersionCodeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    string,
    ApiPreviewMarketplaceIntegrationSpecVersionCodeError,
    undefined,
    {},
    {},
    ApiPreviewMarketplaceIntegrationSpecVersionCodePathParams
  >({
    url: "/integration/marketplace/specs/{specId}/versions/{versionId}/code/",
    method: "get",
    ...variables,
    signal,
  });

export const apiPreviewMarketplaceIntegrationSpecVersionCodeQueryKey = (
  variables: ApiPreviewMarketplaceIntegrationSpecVersionCodeVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/{versionId}/code/",
    operationId: "apiPreviewMarketplaceIntegrationSpecVersionCode",
    variables,
  });

export const useApiPreviewMarketplaceIntegrationSpecVersionCode = <
  TData = string,
>(
  variables: ApiPreviewMarketplaceIntegrationSpecVersionCodeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      string,
      ApiPreviewMarketplaceIntegrationSpecVersionCodeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/{versionId}/code/",
    operationId: "apiPreviewMarketplaceIntegrationSpecVersionCode",
    variables,
  });
  const result = reactQuery.useQuery<
    string,
    ApiPreviewMarketplaceIntegrationSpecVersionCodeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiPreviewMarketplaceIntegrationSpecVersionCode(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiPreviewMarketplaceIntegrationSpecVersionCode = <
  TData = string,
>(
  variables: ApiPreviewMarketplaceIntegrationSpecVersionCodeVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      string,
      ApiPreviewMarketplaceIntegrationSpecVersionCodeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/specs/{specId}/versions/{versionId}/code/",
    operationId: "apiPreviewMarketplaceIntegrationSpecVersionCode",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    string,
    ApiPreviewMarketplaceIntegrationSpecVersionCodeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiPreviewMarketplaceIntegrationSpecVersionCode(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSubmitMarketplaceIntegrationSpecVersionPathParams = {
  specId: string;
  versionId: string;
  action: string;
};

export type ApiSubmitMarketplaceIntegrationSpecVersionError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiSubmitMarketplaceIntegrationSpecVersionVariables = {
  pathParams: ApiSubmitMarketplaceIntegrationSpecVersionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiSubmitMarketplaceIntegrationSpecVersion = (
  variables: ApiSubmitMarketplaceIntegrationSpecVersionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiSubmitMarketplaceIntegrationSpecVersionError,
    undefined,
    {},
    {},
    ApiSubmitMarketplaceIntegrationSpecVersionPathParams
  >({
    url: "/integration/marketplace/specs/{specId}/versions/{versionId}/submission/{action}/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiSubmitMarketplaceIntegrationSpecVersion = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MarketplaceIntegrationSpecVersionOut,
      ApiSubmitMarketplaceIntegrationSpecVersionError,
      ApiSubmitMarketplaceIntegrationSpecVersionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiSubmitMarketplaceIntegrationSpecVersionError,
    ApiSubmitMarketplaceIntegrationSpecVersionVariables
  >({
    mutationFn: (
      variables: ApiSubmitMarketplaceIntegrationSpecVersionVariables,
    ) =>
      fetchApiSubmitMarketplaceIntegrationSpecVersion({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiListMarketplaceSpecVersionsInternallyQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListMarketplaceSpecVersionsInternallyError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiListMarketplaceSpecVersionsInternallyVariables = {
  queryParams?: ApiListMarketplaceSpecVersionsInternallyQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListMarketplaceSpecVersionsInternally = (
  variables: ApiListMarketplaceSpecVersionsInternallyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedMarketplaceIntegrationSpecVersionOut,
    ApiListMarketplaceSpecVersionsInternallyError,
    undefined,
    {},
    ApiListMarketplaceSpecVersionsInternallyQueryParams,
    {}
  >({
    url: "/integration/marketplace/versions_for_review/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListMarketplaceSpecVersionsInternallyQueryKey = (
  variables: ApiListMarketplaceSpecVersionsInternallyVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/integration/marketplace/versions_for_review/",
    operationId: "apiListMarketplaceSpecVersionsInternally",
    variables,
  });

export const useApiListMarketplaceSpecVersionsInternally = <
  TData = Schemas.PagedMarketplaceIntegrationSpecVersionOut,
>(
  variables: ApiListMarketplaceSpecVersionsInternallyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedMarketplaceIntegrationSpecVersionOut,
      ApiListMarketplaceSpecVersionsInternallyError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/versions_for_review/",
    operationId: "apiListMarketplaceSpecVersionsInternally",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedMarketplaceIntegrationSpecVersionOut,
    ApiListMarketplaceSpecVersionsInternallyError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListMarketplaceSpecVersionsInternally(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListMarketplaceSpecVersionsInternally = <
  TData = Schemas.PagedMarketplaceIntegrationSpecVersionOut,
>(
  variables: ApiListMarketplaceSpecVersionsInternallyVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedMarketplaceIntegrationSpecVersionOut,
      ApiListMarketplaceSpecVersionsInternallyError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/integration/marketplace/versions_for_review/",
    operationId: "apiListMarketplaceSpecVersionsInternally",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedMarketplaceIntegrationSpecVersionOut,
    ApiListMarketplaceSpecVersionsInternallyError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListMarketplaceSpecVersionsInternally(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiReviewMarketplaceIntegrationSpecVersionPathParams = {
  specId: string;
  versionId: string;
};

export type ApiReviewMarketplaceIntegrationSpecVersionError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiReviewMarketplaceIntegrationSpecVersionVariables = {
  body: Schemas.ReviewMarketplaceIntegrationSpecVersionRequest;
  pathParams: ApiReviewMarketplaceIntegrationSpecVersionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiReviewMarketplaceIntegrationSpecVersion = (
  variables: ApiReviewMarketplaceIntegrationSpecVersionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiReviewMarketplaceIntegrationSpecVersionError,
    Schemas.ReviewMarketplaceIntegrationSpecVersionRequest,
    {},
    {},
    ApiReviewMarketplaceIntegrationSpecVersionPathParams
  >({
    url: "/integration/marketplace/specs/{specId}/versions/{versionId}/review/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiReviewMarketplaceIntegrationSpecVersion = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MarketplaceIntegrationSpecVersionOut,
      ApiReviewMarketplaceIntegrationSpecVersionError,
      ApiReviewMarketplaceIntegrationSpecVersionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.MarketplaceIntegrationSpecVersionOut,
    ApiReviewMarketplaceIntegrationSpecVersionError,
    ApiReviewMarketplaceIntegrationSpecVersionVariables
  >({
    mutationFn: (
      variables: ApiReviewMarketplaceIntegrationSpecVersionVariables,
    ) =>
      fetchApiReviewMarketplaceIntegrationSpecVersion({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiCheckValidUrlError = Fetcher.ErrorWrapper<undefined>;

export type ApiCheckValidUrlVariables = {
  body: Schemas.CheckValidUrlRequest;
} & ApiContext["fetcherOptions"];

export const fetchApiCheckValidUrl = (
  variables: ApiCheckValidUrlVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CheckValidUrlResponse,
    ApiCheckValidUrlError,
    Schemas.CheckValidUrlRequest,
    {},
    {},
    {}
  >({
    url: "/integration/marketplace/check_valid_url/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCheckValidUrl = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CheckValidUrlResponse,
      ApiCheckValidUrlError,
      ApiCheckValidUrlVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.CheckValidUrlResponse,
    ApiCheckValidUrlError,
    ApiCheckValidUrlVariables
  >({
    mutationFn: (variables: ApiCheckValidUrlVariables) =>
      fetchApiCheckValidUrl({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AutomationJobRollbackAvailablePathParams = {
  jobId: string;
};

export type AutomationJobRollbackAvailableError =
  Fetcher.ErrorWrapper<undefined>;

export type AutomationJobRollbackAvailableVariables = {
  pathParams: AutomationJobRollbackAvailablePathParams;
} & ApiContext["fetcherOptions"];

export const fetchAutomationJobRollbackAvailable = (
  variables: AutomationJobRollbackAvailableVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AutomationRollbackStatus,
    AutomationJobRollbackAvailableError,
    undefined,
    {},
    {},
    AutomationJobRollbackAvailablePathParams
  >({
    url: "/automation/rollbacks/{jobId}/available/",
    method: "get",
    ...variables,
    signal,
  });

export const automationJobRollbackAvailableQueryKey = (
  variables: AutomationJobRollbackAvailableVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/automation/rollbacks/{jobId}/available/",
    operationId: "automationJobRollbackAvailable",
    variables,
  });

export const useAutomationJobRollbackAvailable = <
  TData = Schemas.AutomationRollbackStatus,
>(
  variables: AutomationJobRollbackAvailableVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AutomationRollbackStatus,
      AutomationJobRollbackAvailableError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/rollbacks/{jobId}/available/",
    operationId: "automationJobRollbackAvailable",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AutomationRollbackStatus,
    AutomationJobRollbackAvailableError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchAutomationJobRollbackAvailable(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseAutomationJobRollbackAvailable = <
  TData = Schemas.AutomationRollbackStatus,
>(
  variables: AutomationJobRollbackAvailableVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AutomationRollbackStatus,
      AutomationJobRollbackAvailableError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/rollbacks/{jobId}/available/",
    operationId: "automationJobRollbackAvailable",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AutomationRollbackStatus,
    AutomationJobRollbackAvailableError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchAutomationJobRollbackAvailable(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type PerformAutomationJobRollbackPathParams = {
  jobId: string;
};

export type PerformAutomationJobRollbackError = Fetcher.ErrorWrapper<undefined>;

export type PerformAutomationJobRollbackVariables = {
  pathParams: PerformAutomationJobRollbackPathParams;
} & ApiContext["fetcherOptions"];

export const fetchPerformAutomationJobRollback = (
  variables: PerformAutomationJobRollbackVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BackgroundJobOut,
    PerformAutomationJobRollbackError,
    undefined,
    {},
    {},
    PerformAutomationJobRollbackPathParams
  >({
    url: "/automation/rollbacks/{jobId}/perform/",
    method: "post",
    ...variables,
    signal,
  });

export const usePerformAutomationJobRollback = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BackgroundJobOut,
      PerformAutomationJobRollbackError,
      PerformAutomationJobRollbackVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BackgroundJobOut,
    PerformAutomationJobRollbackError,
    PerformAutomationJobRollbackVariables
  >({
    mutationFn: (variables: PerformAutomationJobRollbackVariables) =>
      fetchPerformAutomationJobRollback({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiAutomationGetEntityUpdateLogPathParams = {
  jobId: string;
};

export type ApiAutomationGetEntityUpdateLogQueryParams = {
  search_term?: string | null;
  /**
   * @default 1
   */
  page?: number;
};

export type ApiAutomationGetEntityUpdateLogError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiAutomationGetEntityUpdateLogVariables = {
  pathParams: ApiAutomationGetEntityUpdateLogPathParams;
  queryParams?: ApiAutomationGetEntityUpdateLogQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiAutomationGetEntityUpdateLog = (
  variables: ApiAutomationGetEntityUpdateLogVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaNinjaPaginationOutputAutomationEntityUpdateLogEntry,
    ApiAutomationGetEntityUpdateLogError,
    undefined,
    {},
    ApiAutomationGetEntityUpdateLogQueryParams,
    ApiAutomationGetEntityUpdateLogPathParams
  >({
    url: "/automation/history/{jobId}/update_log/",
    method: "get",
    ...variables,
    signal,
  });

export const apiAutomationGetEntityUpdateLogQueryKey = (
  variables: ApiAutomationGetEntityUpdateLogVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/automation/history/{jobId}/update_log/",
    operationId: "apiAutomationGetEntityUpdateLog",
    variables,
  });

export const useApiAutomationGetEntityUpdateLog = <
  TData = Schemas.SecodaNinjaPaginationOutputAutomationEntityUpdateLogEntry,
>(
  variables: ApiAutomationGetEntityUpdateLogVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputAutomationEntityUpdateLogEntry,
      ApiAutomationGetEntityUpdateLogError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/history/{jobId}/update_log/",
    operationId: "apiAutomationGetEntityUpdateLog",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SecodaNinjaPaginationOutputAutomationEntityUpdateLogEntry,
    ApiAutomationGetEntityUpdateLogError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiAutomationGetEntityUpdateLog(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiAutomationGetEntityUpdateLog = <
  TData = Schemas.SecodaNinjaPaginationOutputAutomationEntityUpdateLogEntry,
>(
  variables: ApiAutomationGetEntityUpdateLogVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputAutomationEntityUpdateLogEntry,
      ApiAutomationGetEntityUpdateLogError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/history/{jobId}/update_log/",
    operationId: "apiAutomationGetEntityUpdateLog",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SecodaNinjaPaginationOutputAutomationEntityUpdateLogEntry,
    ApiAutomationGetEntityUpdateLogError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiAutomationGetEntityUpdateLog(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAutomationMetricsQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
};

export type ApiGetAutomationMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAutomationMetricsVariables = {
  queryParams?: ApiGetAutomationMetricsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get automation metrics for the workspace.
 */
export const fetchApiGetAutomationMetrics = (
  variables: ApiGetAutomationMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AutomationMetrics,
    ApiGetAutomationMetricsError,
    undefined,
    {},
    ApiGetAutomationMetricsQueryParams,
    {}
  >({
    url: "/automation/metrics/metrics/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAutomationMetricsQueryKey = (
  variables: ApiGetAutomationMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/automation/metrics/metrics/",
    operationId: "apiGetAutomationMetrics",
    variables,
  });

/**
 * Get automation metrics for the workspace.
 */
export const useApiGetAutomationMetrics = <TData = Schemas.AutomationMetrics,>(
  variables: ApiGetAutomationMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AutomationMetrics,
      ApiGetAutomationMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/metrics/metrics/",
    operationId: "apiGetAutomationMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AutomationMetrics,
    ApiGetAutomationMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAutomationMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get automation metrics for the workspace.
 */
export const useSuspenseApiGetAutomationMetrics = <
  TData = Schemas.AutomationMetrics,
>(
  variables: ApiGetAutomationMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AutomationMetrics,
      ApiGetAutomationMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/metrics/metrics/",
    operationId: "apiGetAutomationMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AutomationMetrics,
    ApiGetAutomationMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAutomationMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAutomationTimeseriesQueryParams = {
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  start_date?: string | null;
  end_date?: string | null;
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
};

export type ApiGetAutomationTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAutomationTimeseriesVariables = {
  queryParams?: ApiGetAutomationTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get automation timeseries data for the workspace.
 */
export const fetchApiGetAutomationTimeseries = (
  variables: ApiGetAutomationTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AutomationTimeSeries,
    ApiGetAutomationTimeseriesError,
    undefined,
    {},
    ApiGetAutomationTimeseriesQueryParams,
    {}
  >({
    url: "/automation/metrics/timeseries/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAutomationTimeseriesQueryKey = (
  variables: ApiGetAutomationTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/automation/metrics/timeseries/",
    operationId: "apiGetAutomationTimeseries",
    variables,
  });

/**
 * Get automation timeseries data for the workspace.
 */
export const useApiGetAutomationTimeseries = <
  TData = Schemas.AutomationTimeSeries,
>(
  variables: ApiGetAutomationTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AutomationTimeSeries,
      ApiGetAutomationTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/metrics/timeseries/",
    operationId: "apiGetAutomationTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AutomationTimeSeries,
    ApiGetAutomationTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAutomationTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get automation timeseries data for the workspace.
 */
export const useSuspenseApiGetAutomationTimeseries = <
  TData = Schemas.AutomationTimeSeries,
>(
  variables: ApiGetAutomationTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AutomationTimeSeries,
      ApiGetAutomationTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/metrics/timeseries/",
    operationId: "apiGetAutomationTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AutomationTimeSeries,
    ApiGetAutomationTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAutomationTimeseries(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAutomationPathParams = {
  automationId: string;
};

export type ApiGetAutomationError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetAutomationVariables = {
  pathParams: ApiGetAutomationPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetAutomation = (
  variables: ApiGetAutomationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiGetAutomationError,
    undefined,
    {},
    {},
    ApiGetAutomationPathParams
  >({
    url: "/automation/automation/{automationId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAutomationQueryKey = (
  variables: ApiGetAutomationVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/automation/automation/{automationId}/",
    operationId: "apiGetAutomation",
    variables,
  });

export const useApiGetAutomation = <TData = Schemas.Automation,>(
  variables: ApiGetAutomationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.Automation,
      ApiGetAutomationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/automation/{automationId}/",
    operationId: "apiGetAutomation",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.Automation,
    ApiGetAutomationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAutomation({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetAutomation = <TData = Schemas.Automation,>(
  variables: ApiGetAutomationVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.Automation,
      ApiGetAutomationError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/automation/{automationId}/",
    operationId: "apiGetAutomation",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.Automation,
    ApiGetAutomationError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAutomation({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetAutomationDailyAiOutputRemainingPathParams = {
  automationId: string;
};

export type ApiGetAutomationDailyAiOutputRemainingError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetAutomationDailyAiOutputRemainingVariables = {
  pathParams: ApiGetAutomationDailyAiOutputRemainingPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetAutomationDailyAiOutputRemaining = (
  variables: ApiGetAutomationDailyAiOutputRemainingVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AutomationDailyAIOutputRemainingOut,
    ApiGetAutomationDailyAiOutputRemainingError,
    undefined,
    {},
    {},
    ApiGetAutomationDailyAiOutputRemainingPathParams
  >({
    url: "/automation/automation/{automationId}/daily_ai_output_remaining/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetAutomationDailyAiOutputRemainingQueryKey = (
  variables: ApiGetAutomationDailyAiOutputRemainingVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/automation/automation/{automationId}/daily_ai_output_remaining/",
    operationId: "apiGetAutomationDailyAiOutputRemaining",
    variables,
  });

export const useApiGetAutomationDailyAiOutputRemaining = <
  TData = Schemas.AutomationDailyAIOutputRemainingOut,
>(
  variables: ApiGetAutomationDailyAiOutputRemainingVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AutomationDailyAIOutputRemainingOut,
      ApiGetAutomationDailyAiOutputRemainingError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/automation/{automationId}/daily_ai_output_remaining/",
    operationId: "apiGetAutomationDailyAiOutputRemaining",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.AutomationDailyAIOutputRemainingOut,
    ApiGetAutomationDailyAiOutputRemainingError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAutomationDailyAiOutputRemaining(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetAutomationDailyAiOutputRemaining = <
  TData = Schemas.AutomationDailyAIOutputRemainingOut,
>(
  variables: ApiGetAutomationDailyAiOutputRemainingVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.AutomationDailyAIOutputRemainingOut,
      ApiGetAutomationDailyAiOutputRemainingError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/automation/{automationId}/daily_ai_output_remaining/",
    operationId: "apiGetAutomationDailyAiOutputRemaining",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.AutomationDailyAIOutputRemainingOut,
    ApiGetAutomationDailyAiOutputRemainingError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetAutomationDailyAiOutputRemaining(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateAutomationTriggerTypePathParams = {
  automationId: string;
};

export type ApiUpdateAutomationTriggerTypeError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationTriggerTypeVariables = {
  body: Schemas.TriggerTypeUpdateIn;
  pathParams: ApiUpdateAutomationTriggerTypePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationTriggerType = (
  variables: ApiUpdateAutomationTriggerTypeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationTriggerTypeError,
    Schemas.TriggerTypeUpdateIn,
    {},
    {},
    ApiUpdateAutomationTriggerTypePathParams
  >({
    url: "/automation/automation/{automationId}/trigger_type/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationTriggerType = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationTriggerTypeError,
      ApiUpdateAutomationTriggerTypeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationTriggerTypeError,
    ApiUpdateAutomationTriggerTypeVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationTriggerTypeVariables) =>
      fetchApiUpdateAutomationTriggerType({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateAutomationScheduleSettingsPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationScheduleSettingsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationScheduleSettingsVariables = {
  body: Schemas.ScheduleSettingsIn;
  pathParams: ApiUpdateAutomationScheduleSettingsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationScheduleSettings = (
  variables: ApiUpdateAutomationScheduleSettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationScheduleSettingsError,
    Schemas.ScheduleSettingsIn,
    {},
    {},
    ApiUpdateAutomationScheduleSettingsPathParams
  >({
    url: "/automation/automation/{automationId}/schedule/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationScheduleSettings = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationScheduleSettingsError,
      ApiUpdateAutomationScheduleSettingsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationScheduleSettingsError,
    ApiUpdateAutomationScheduleSettingsVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationScheduleSettingsVariables) =>
      fetchApiUpdateAutomationScheduleSettings({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateAutomationFilterSettingsPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationFilterSettingsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationFilterSettingsVariables = {
  body: Schemas.FilterSettingsIn;
  pathParams: ApiUpdateAutomationFilterSettingsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationFilterSettings = (
  variables: ApiUpdateAutomationFilterSettingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationFilterSettingsError,
    Schemas.FilterSettingsIn,
    {},
    {},
    ApiUpdateAutomationFilterSettingsPathParams
  >({
    url: "/automation/automation/{automationId}/filter_settings/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationFilterSettings = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationFilterSettingsError,
      ApiUpdateAutomationFilterSettingsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationFilterSettingsError,
    ApiUpdateAutomationFilterSettingsVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationFilterSettingsVariables) =>
      fetchApiUpdateAutomationFilterSettings({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateAutomationActionUpdateEntitiesPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationActionUpdateEntitiesError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationActionUpdateEntitiesVariables = {
  body: Schemas.ActionUpdateEntitiesIn;
  pathParams: ApiUpdateAutomationActionUpdateEntitiesPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationActionUpdateEntities = (
  variables: ApiUpdateAutomationActionUpdateEntitiesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationActionUpdateEntitiesError,
    Schemas.ActionUpdateEntitiesIn,
    {},
    {},
    ApiUpdateAutomationActionUpdateEntitiesPathParams
  >({
    url: "/automation/automation/{automationId}/action_update_entities/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationActionUpdateEntities = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationActionUpdateEntitiesError,
      ApiUpdateAutomationActionUpdateEntitiesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationActionUpdateEntitiesError,
    ApiUpdateAutomationActionUpdateEntitiesVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationActionUpdateEntitiesVariables) =>
      fetchApiUpdateAutomationActionUpdateEntities({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateAutomationActionSendEmailPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationActionSendEmailError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationActionSendEmailVariables = {
  body: Schemas.ActionSendEmailIn;
  pathParams: ApiUpdateAutomationActionSendEmailPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationActionSendEmail = (
  variables: ApiUpdateAutomationActionSendEmailVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationActionSendEmailError,
    Schemas.ActionSendEmailIn,
    {},
    {},
    ApiUpdateAutomationActionSendEmailPathParams
  >({
    url: "/automation/automation/{automationId}/action_send_email/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationActionSendEmail = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationActionSendEmailError,
      ApiUpdateAutomationActionSendEmailVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationActionSendEmailError,
    ApiUpdateAutomationActionSendEmailVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationActionSendEmailVariables) =>
      fetchApiUpdateAutomationActionSendEmail({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateAutomationActionSendAnnouncementPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationActionSendAnnouncementError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationActionSendAnnouncementVariables = {
  body: Schemas.ActionSendAnnouncementIn;
  pathParams: ApiUpdateAutomationActionSendAnnouncementPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationActionSendAnnouncement = (
  variables: ApiUpdateAutomationActionSendAnnouncementVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationActionSendAnnouncementError,
    Schemas.ActionSendAnnouncementIn,
    {},
    {},
    ApiUpdateAutomationActionSendAnnouncementPathParams
  >({
    url: "/automation/automation/{automationId}/action_send_announcement/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationActionSendAnnouncement = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationActionSendAnnouncementError,
      ApiUpdateAutomationActionSendAnnouncementVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationActionSendAnnouncementError,
    ApiUpdateAutomationActionSendAnnouncementVariables
  >({
    mutationFn: (
      variables: ApiUpdateAutomationActionSendAnnouncementVariables,
    ) =>
      fetchApiUpdateAutomationActionSendAnnouncement({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateAutomationActionSendSlackPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationActionSendSlackError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationActionSendSlackVariables = {
  body: Schemas.ActionSendSlackIn;
  pathParams: ApiUpdateAutomationActionSendSlackPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationActionSendSlack = (
  variables: ApiUpdateAutomationActionSendSlackVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationActionSendSlackError,
    Schemas.ActionSendSlackIn,
    {},
    {},
    ApiUpdateAutomationActionSendSlackPathParams
  >({
    url: "/automation/automation/{automationId}/action_send_slack/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationActionSendSlack = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationActionSendSlackError,
      ApiUpdateAutomationActionSendSlackVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationActionSendSlackError,
    ApiUpdateAutomationActionSendSlackVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationActionSendSlackVariables) =>
      fetchApiUpdateAutomationActionSendSlack({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateAutomationActionPropagateMetadataPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationActionPropagateMetadataError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationActionPropagateMetadataVariables = {
  body: Schemas.ActionPropagateMetadataIn;
  pathParams: ApiUpdateAutomationActionPropagateMetadataPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationActionPropagateMetadata = (
  variables: ApiUpdateAutomationActionPropagateMetadataVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationActionPropagateMetadataError,
    Schemas.ActionPropagateMetadataIn,
    {},
    {},
    ApiUpdateAutomationActionPropagateMetadataPathParams
  >({
    url: "/automation/automation/{automationId}/action_propagate_metadata/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationActionPropagateMetadata = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationActionPropagateMetadataError,
      ApiUpdateAutomationActionPropagateMetadataVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationActionPropagateMetadataError,
    ApiUpdateAutomationActionPropagateMetadataVariables
  >({
    mutationFn: (
      variables: ApiUpdateAutomationActionPropagateMetadataVariables,
    ) =>
      fetchApiUpdateAutomationActionPropagateMetadata({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateAutomationTitlePathParams = {
  automationId: string;
};

export type ApiUpdateAutomationTitleError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationTitleVariables = {
  body: Schemas.AutomationTitleIn;
  pathParams: ApiUpdateAutomationTitlePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationTitle = (
  variables: ApiUpdateAutomationTitleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationTitleError,
    Schemas.AutomationTitleIn,
    {},
    {},
    ApiUpdateAutomationTitlePathParams
  >({
    url: "/automation/automation/{automationId}/title/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationTitle = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationTitleError,
      ApiUpdateAutomationTitleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationTitleError,
    ApiUpdateAutomationTitleVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationTitleVariables) =>
      fetchApiUpdateAutomationTitle({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateAutomationDescriptionPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationDescriptionError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationDescriptionVariables = {
  body: Schemas.AutomationDescriptionIn;
  pathParams: ApiUpdateAutomationDescriptionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationDescription = (
  variables: ApiUpdateAutomationDescriptionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationDescriptionError,
    Schemas.AutomationDescriptionIn,
    {},
    {},
    ApiUpdateAutomationDescriptionPathParams
  >({
    url: "/automation/automation/{automationId}/description/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationDescription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationDescriptionError,
      ApiUpdateAutomationDescriptionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationDescriptionError,
    ApiUpdateAutomationDescriptionVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationDescriptionVariables) =>
      fetchApiUpdateAutomationDescription({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateAutomationIconPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationIconError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationIconVariables = {
  body: Schemas.AutomationIconIn;
  pathParams: ApiUpdateAutomationIconPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationIcon = (
  variables: ApiUpdateAutomationIconVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationIconError,
    Schemas.AutomationIconIn,
    {},
    {},
    ApiUpdateAutomationIconPathParams
  >({
    url: "/automation/automation/{automationId}/icon/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationIcon = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationIconError,
      ApiUpdateAutomationIconVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationIconError,
    ApiUpdateAutomationIconVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationIconVariables) =>
      fetchApiUpdateAutomationIcon({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateAutomationShouldOverwriteMetadataPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationShouldOverwriteMetadataError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationShouldOverwriteMetadataVariables = {
  body: Schemas.AutomationShouldOverwriteMetadataIn;
  pathParams: ApiUpdateAutomationShouldOverwriteMetadataPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationShouldOverwriteMetadata = (
  variables: ApiUpdateAutomationShouldOverwriteMetadataVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationShouldOverwriteMetadataError,
    Schemas.AutomationShouldOverwriteMetadataIn,
    {},
    {},
    ApiUpdateAutomationShouldOverwriteMetadataPathParams
  >({
    url: "/automation/automation/{automationId}/should_overwrite_metadata/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationShouldOverwriteMetadata = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationShouldOverwriteMetadataError,
      ApiUpdateAutomationShouldOverwriteMetadataVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationShouldOverwriteMetadataError,
    ApiUpdateAutomationShouldOverwriteMetadataVariables
  >({
    mutationFn: (
      variables: ApiUpdateAutomationShouldOverwriteMetadataVariables,
    ) =>
      fetchApiUpdateAutomationShouldOverwriteMetadata({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateAutomationAiSettingPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationAiSettingError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationAiSettingVariables = {
  body: Schemas.AutomationAiSettingIn;
  pathParams: ApiUpdateAutomationAiSettingPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationAiSetting = (
  variables: ApiUpdateAutomationAiSettingVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationAiSettingError,
    Schemas.AutomationAiSettingIn,
    {},
    {},
    ApiUpdateAutomationAiSettingPathParams
  >({
    url: "/automation/automation/{automationId}/ai_settings/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationAiSetting = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationAiSettingError,
      ApiUpdateAutomationAiSettingVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationAiSettingError,
    ApiUpdateAutomationAiSettingVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationAiSettingVariables) =>
      fetchApiUpdateAutomationAiSetting({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPreviewBulkAiGenerationPathParams = {
  automationId: string;
};

export type ApiPreviewBulkAiGenerationError = Fetcher.ErrorWrapper<undefined>;

export type ApiPreviewBulkAiGenerationVariables = {
  body: Schemas.AISetting;
  pathParams: ApiPreviewBulkAiGenerationPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Preview bulk AI generation for entities.
 *
 * Args:
 *     request: The HTTP request
 *     automation_id: The automation ID
 *     ai_setting: AISettings to use for preview
 *
 * Returns:
 *     PreviewBulkAiGenerationResponse with generated data based on the AI setting bindings
 */
export const fetchApiPreviewBulkAiGeneration = (
  variables: ApiPreviewBulkAiGenerationVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PreviewBulkAiGenerationResponse,
    ApiPreviewBulkAiGenerationError,
    Schemas.AISetting,
    {},
    {},
    ApiPreviewBulkAiGenerationPathParams
  >({
    url: "/automation/automation/{automationId}/preview_bulk_ai_generation/",
    method: "post",
    ...variables,
    signal,
  });

/**
 * Preview bulk AI generation for entities.
 *
 * Args:
 *     request: The HTTP request
 *     automation_id: The automation ID
 *     ai_setting: AISettings to use for preview
 *
 * Returns:
 *     PreviewBulkAiGenerationResponse with generated data based on the AI setting bindings
 */
export const useApiPreviewBulkAiGeneration = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PreviewBulkAiGenerationResponse,
      ApiPreviewBulkAiGenerationError,
      ApiPreviewBulkAiGenerationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PreviewBulkAiGenerationResponse,
    ApiPreviewBulkAiGenerationError,
    ApiPreviewBulkAiGenerationVariables
  >({
    mutationFn: (variables: ApiPreviewBulkAiGenerationVariables) =>
      fetchApiPreviewBulkAiGeneration({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateAutomationEnableAiOutputReviewPathParams = {
  automationId: string;
};

export type ApiUpdateAutomationEnableAiOutputReviewError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateAutomationEnableAiOutputReviewVariables = {
  body: Schemas.AutomationEnableAIOutputReviewIn;
  pathParams: ApiUpdateAutomationEnableAiOutputReviewPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateAutomationEnableAiOutputReview = (
  variables: ApiUpdateAutomationEnableAiOutputReviewVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.Automation,
    ApiUpdateAutomationEnableAiOutputReviewError,
    Schemas.AutomationEnableAIOutputReviewIn,
    {},
    {},
    ApiUpdateAutomationEnableAiOutputReviewPathParams
  >({
    url: "/automation/automation/{automationId}/enable_ai_output_review/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateAutomationEnableAiOutputReview = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.Automation,
      ApiUpdateAutomationEnableAiOutputReviewError,
      ApiUpdateAutomationEnableAiOutputReviewVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.Automation,
    ApiUpdateAutomationEnableAiOutputReviewError,
    ApiUpdateAutomationEnableAiOutputReviewVariables
  >({
    mutationFn: (variables: ApiUpdateAutomationEnableAiOutputReviewVariables) =>
      fetchApiUpdateAutomationEnableAiOutputReview({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateEntityAiOutputPathParams = {
  automationJobId: string;
};

export type ApiUpdateEntityAiOutputError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateEntityAiOutputVariables = {
  body: Schemas.AutomationUpdateEntityAIOutputIn;
  pathParams: ApiUpdateEntityAiOutputPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateEntityAiOutput = (
  variables: ApiUpdateEntityAiOutputVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AutomationUpdateEntityAIOutputResponse,
    ApiUpdateEntityAiOutputError,
    Schemas.AutomationUpdateEntityAIOutputIn,
    {},
    {},
    ApiUpdateEntityAiOutputPathParams
  >({
    url: "/automation/automation_job/{automationJobId}/update_entity_ai_output/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiUpdateEntityAiOutput = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AutomationUpdateEntityAIOutputResponse,
      ApiUpdateEntityAiOutputError,
      ApiUpdateEntityAiOutputVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AutomationUpdateEntityAIOutputResponse,
    ApiUpdateEntityAiOutputError,
    ApiUpdateEntityAiOutputVariables
  >({
    mutationFn: (variables: ApiUpdateEntityAiOutputVariables) =>
      fetchApiUpdateEntityAiOutput({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiCompleteAutomationReviewPathParams = {
  automationJobId: string;
};

export type ApiCompleteAutomationReviewError = Fetcher.ErrorWrapper<undefined>;

export type ApiCompleteAutomationReviewVariables = {
  pathParams: ApiCompleteAutomationReviewPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiCompleteAutomationReview = (
  variables: ApiCompleteAutomationReviewVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.AutomationCompleteReviewResponse,
    ApiCompleteAutomationReviewError,
    undefined,
    {},
    {},
    ApiCompleteAutomationReviewPathParams
  >({
    url: "/automation/automation_job/{automationJobId}/complete_automation_review/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCompleteAutomationReview = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.AutomationCompleteReviewResponse,
      ApiCompleteAutomationReviewError,
      ApiCompleteAutomationReviewVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.AutomationCompleteReviewResponse,
    ApiCompleteAutomationReviewError,
    ApiCompleteAutomationReviewVariables
  >({
    mutationFn: (variables: ApiCompleteAutomationReviewVariables) =>
      fetchApiCompleteAutomationReview({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiAutomationGetAiOutputResourcesPathParams = {
  automationJobId: string;
};

export type ApiAutomationGetAiOutputResourcesQueryParams = {
  search_term?: string | null;
  /**
   * @default 1
   */
  page?: number;
};

export type ApiAutomationGetAiOutputResourcesError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiAutomationGetAiOutputResourcesVariables = {
  pathParams: ApiAutomationGetAiOutputResourcesPathParams;
  queryParams?: ApiAutomationGetAiOutputResourcesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiAutomationGetAiOutputResources = (
  variables: ApiAutomationGetAiOutputResourcesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaNinjaPaginationOutputAutomationJobResourceAIOutputResponse,
    ApiAutomationGetAiOutputResourcesError,
    undefined,
    {},
    ApiAutomationGetAiOutputResourcesQueryParams,
    ApiAutomationGetAiOutputResourcesPathParams
  >({
    url: "/automation/automation_job/{automationJobId}/ai_output_resources/",
    method: "get",
    ...variables,
    signal,
  });

export const apiAutomationGetAiOutputResourcesQueryKey = (
  variables: ApiAutomationGetAiOutputResourcesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/automation/automation_job/{automationJobId}/ai_output_resources/",
    operationId: "apiAutomationGetAiOutputResources",
    variables,
  });

export const useApiAutomationGetAiOutputResources = <
  TData = Schemas.SecodaNinjaPaginationOutputAutomationJobResourceAIOutputResponse,
>(
  variables: ApiAutomationGetAiOutputResourcesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputAutomationJobResourceAIOutputResponse,
      ApiAutomationGetAiOutputResourcesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/automation_job/{automationJobId}/ai_output_resources/",
    operationId: "apiAutomationGetAiOutputResources",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SecodaNinjaPaginationOutputAutomationJobResourceAIOutputResponse,
    ApiAutomationGetAiOutputResourcesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiAutomationGetAiOutputResources(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiAutomationGetAiOutputResources = <
  TData = Schemas.SecodaNinjaPaginationOutputAutomationJobResourceAIOutputResponse,
>(
  variables: ApiAutomationGetAiOutputResourcesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputAutomationJobResourceAIOutputResponse,
      ApiAutomationGetAiOutputResourcesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/automation/automation_job/{automationJobId}/ai_output_resources/",
    operationId: "apiAutomationGetAiOutputResources",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SecodaNinjaPaginationOutputAutomationJobResourceAIOutputResponse,
    ApiAutomationGetAiOutputResourcesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiAutomationGetAiOutputResources(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type RetrieveAggregateQualityQueryParams = {
  team_id?: string | null;
  filters?: string | null;
};

export type RetrieveAggregateQualityError = Fetcher.ErrorWrapper<undefined>;

export type RetrieveAggregateQualityVariables = {
  queryParams?: RetrieveAggregateQualityQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchRetrieveAggregateQuality = (
  variables: RetrieveAggregateQualityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataQualityScore,
    RetrieveAggregateQualityError,
    undefined,
    {},
    RetrieveAggregateQualityQueryParams,
    {}
  >({ url: "/quality/", method: "get", ...variables, signal });

export const retrieveAggregateQualityQueryKey = (
  variables: RetrieveAggregateQualityVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/quality/",
    operationId: "retrieveAggregateQuality",
    variables,
  });

export const useRetrieveAggregateQuality = <TData = Schemas.DataQualityScore,>(
  variables: RetrieveAggregateQualityVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DataQualityScore,
      RetrieveAggregateQualityError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/",
    operationId: "retrieveAggregateQuality",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DataQualityScore,
    RetrieveAggregateQualityError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveAggregateQuality(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseRetrieveAggregateQuality = <
  TData = Schemas.DataQualityScore,
>(
  variables: RetrieveAggregateQualityVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DataQualityScore,
      RetrieveAggregateQualityError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/",
    operationId: "retrieveAggregateQuality",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DataQualityScore,
    RetrieveAggregateQualityError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveAggregateQuality(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type RetrieveTimeseriesQueryParams = {
  from_date: string;
  to_date: string;
  team_id?: string | null;
  integration_id?: string | null;
  group_id?: string | null;
};

export type RetrieveTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type RetrieveTimeseriesVariables = {
  queryParams: RetrieveTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchRetrieveTimeseries = (
  variables: RetrieveTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DataQualityTimeseries,
    RetrieveTimeseriesError,
    undefined,
    {},
    RetrieveTimeseriesQueryParams,
    {}
  >({ url: "/quality/timeseries/", method: "get", ...variables, signal });

export const retrieveTimeseriesQueryKey = (
  variables: RetrieveTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/quality/timeseries/",
    operationId: "retrieveTimeseries",
    variables,
  });

export const useRetrieveTimeseries = <TData = Schemas.DataQualityTimeseries,>(
  variables: RetrieveTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DataQualityTimeseries,
      RetrieveTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/timeseries/",
    operationId: "retrieveTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.DataQualityTimeseries,
    RetrieveTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveTimeseries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseRetrieveTimeseries = <
  TData = Schemas.DataQualityTimeseries,
>(
  variables: RetrieveTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.DataQualityTimeseries,
      RetrieveTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/timeseries/",
    operationId: "retrieveTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.DataQualityTimeseries,
    RetrieveTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveTimeseries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type RetrieveQualitySuggestionsQueryParams = {
  team_id?: string | null;
  filters?: string | null;
};

export type RetrieveQualitySuggestionsError = Fetcher.ErrorWrapper<undefined>;

export type RetrieveQualitySuggestionsResponse =
  Schemas.DataQualitySuggestion[];

export type RetrieveQualitySuggestionsVariables = {
  queryParams?: RetrieveQualitySuggestionsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchRetrieveQualitySuggestions = (
  variables: RetrieveQualitySuggestionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    RetrieveQualitySuggestionsResponse,
    RetrieveQualitySuggestionsError,
    undefined,
    {},
    RetrieveQualitySuggestionsQueryParams,
    {}
  >({ url: "/quality/suggestions/", method: "get", ...variables, signal });

export const retrieveQualitySuggestionsQueryKey = (
  variables: RetrieveQualitySuggestionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/quality/suggestions/",
    operationId: "retrieveQualitySuggestions",
    variables,
  });

export const useRetrieveQualitySuggestions = <
  TData = RetrieveQualitySuggestionsResponse,
>(
  variables: RetrieveQualitySuggestionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      RetrieveQualitySuggestionsResponse,
      RetrieveQualitySuggestionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/suggestions/",
    operationId: "retrieveQualitySuggestions",
    variables,
  });
  const result = reactQuery.useQuery<
    RetrieveQualitySuggestionsResponse,
    RetrieveQualitySuggestionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveQualitySuggestions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseRetrieveQualitySuggestions = <
  TData = RetrieveQualitySuggestionsResponse,
>(
  variables: RetrieveQualitySuggestionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      RetrieveQualitySuggestionsResponse,
      RetrieveQualitySuggestionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/suggestions/",
    operationId: "retrieveQualitySuggestions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    RetrieveQualitySuggestionsResponse,
    RetrieveQualitySuggestionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveQualitySuggestions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type RetrieveQualityEntitySuggestionsPathParams = {
  entityId: string;
};

export type RetrieveQualityEntitySuggestionsError =
  Fetcher.ErrorWrapper<undefined>;

export type RetrieveQualityEntitySuggestionsVariables = {
  pathParams: RetrieveQualityEntitySuggestionsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchRetrieveQualityEntitySuggestions = (
  variables: RetrieveQualityEntitySuggestionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityDataQuality,
    RetrieveQualityEntitySuggestionsError,
    undefined,
    {},
    {},
    RetrieveQualityEntitySuggestionsPathParams
  >({
    url: "/quality/{entityId}/suggestions/",
    method: "get",
    ...variables,
    signal,
  });

export const retrieveQualityEntitySuggestionsQueryKey = (
  variables: RetrieveQualityEntitySuggestionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/quality/{entityId}/suggestions/",
    operationId: "retrieveQualityEntitySuggestions",
    variables,
  });

export const useRetrieveQualityEntitySuggestions = <
  TData = Schemas.EntityDataQuality,
>(
  variables: RetrieveQualityEntitySuggestionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EntityDataQuality,
      RetrieveQualityEntitySuggestionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/{entityId}/suggestions/",
    operationId: "retrieveQualityEntitySuggestions",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.EntityDataQuality,
    RetrieveQualityEntitySuggestionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveQualityEntitySuggestions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseRetrieveQualityEntitySuggestions = <
  TData = Schemas.EntityDataQuality,
>(
  variables: RetrieveQualityEntitySuggestionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.EntityDataQuality,
      RetrieveQualityEntitySuggestionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/{entityId}/suggestions/",
    operationId: "retrieveQualityEntitySuggestions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.EntityDataQuality,
    RetrieveQualityEntitySuggestionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchRetrieveQualityEntitySuggestions(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GenerateDataQualityImageError = Fetcher.ErrorWrapper<undefined>;

export type GenerateDataQualityImageVariables = {
  body: Schemas.DataQualityScore;
} & ApiContext["fetcherOptions"];

export const fetchGenerateDataQualityImage = (
  variables: GenerateDataQualityImageVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Blob,
    GenerateDataQualityImageError,
    Schemas.DataQualityScore,
    {},
    {},
    {}
  >({ url: "/quality/image/", method: "post", ...variables, signal });

export const useGenerateDataQualityImage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Blob,
      GenerateDataQualityImageError,
      GenerateDataQualityImageVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Blob,
    GenerateDataQualityImageError,
    GenerateDataQualityImageVariables
  >({
    mutationFn: (variables: GenerateDataQualityImageVariables) =>
      fetchGenerateDataQualityImage({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetIncludedInQualityGovernanceError =
  Fetcher.ErrorWrapper<undefined>;

export type GetIncludedInQualityGovernanceResponse = Schemas.Filter[];

export type GetIncludedInQualityGovernanceVariables =
  ApiContext["fetcherOptions"];

export const fetchGetIncludedInQualityGovernance = (
  variables: GetIncludedInQualityGovernanceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetIncludedInQualityGovernanceResponse,
    GetIncludedInQualityGovernanceError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/quality/preferences/governance/included/",
    method: "get",
    ...variables,
    signal,
  });

export const getIncludedInQualityGovernanceQueryKey = (
  variables: GetIncludedInQualityGovernanceVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/quality/preferences/governance/included/",
    operationId: "getIncludedInQualityGovernance",
    variables,
  });

export const useGetIncludedInQualityGovernance = <
  TData = GetIncludedInQualityGovernanceResponse,
>(
  variables: GetIncludedInQualityGovernanceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetIncludedInQualityGovernanceResponse,
      GetIncludedInQualityGovernanceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/preferences/governance/included/",
    operationId: "getIncludedInQualityGovernance",
    variables,
  });
  const result = reactQuery.useQuery<
    GetIncludedInQualityGovernanceResponse,
    GetIncludedInQualityGovernanceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetIncludedInQualityGovernance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetIncludedInQualityGovernance = <
  TData = GetIncludedInQualityGovernanceResponse,
>(
  variables: GetIncludedInQualityGovernanceVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetIncludedInQualityGovernanceResponse,
      GetIncludedInQualityGovernanceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/preferences/governance/included/",
    operationId: "getIncludedInQualityGovernance",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetIncludedInQualityGovernanceResponse,
    GetIncludedInQualityGovernanceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetIncludedInQualityGovernance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetIncludedInQualityGovernanceError =
  Fetcher.ErrorWrapper<undefined>;

export type SetIncludedInQualityGovernanceRequestBody = Schemas.Filter[];

export type SetIncludedInQualityGovernanceVariables = {
  body?: SetIncludedInQualityGovernanceRequestBody;
} & ApiContext["fetcherOptions"];

export const fetchSetIncludedInQualityGovernance = (
  variables: SetIncludedInQualityGovernanceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetIncludedInQualityGovernanceError,
    SetIncludedInQualityGovernanceRequestBody,
    {},
    {},
    {}
  >({
    url: "/quality/preferences/governance/included/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetIncludedInQualityGovernance = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetIncludedInQualityGovernanceError,
      SetIncludedInQualityGovernanceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetIncludedInQualityGovernanceError,
    SetIncludedInQualityGovernanceVariables
  >({
    mutationFn: (variables: SetIncludedInQualityGovernanceVariables) =>
      fetchSetIncludedInQualityGovernance({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetExcludedFromQualityGovernanceError =
  Fetcher.ErrorWrapper<undefined>;

export type GetExcludedFromQualityGovernanceResponse = Schemas.Filter[];

export type GetExcludedFromQualityGovernanceVariables =
  ApiContext["fetcherOptions"];

export const fetchGetExcludedFromQualityGovernance = (
  variables: GetExcludedFromQualityGovernanceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetExcludedFromQualityGovernanceResponse,
    GetExcludedFromQualityGovernanceError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/quality/preferences/governance/excluded/",
    method: "get",
    ...variables,
    signal,
  });

export const getExcludedFromQualityGovernanceQueryKey = (
  variables: GetExcludedFromQualityGovernanceVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/quality/preferences/governance/excluded/",
    operationId: "getExcludedFromQualityGovernance",
    variables,
  });

export const useGetExcludedFromQualityGovernance = <
  TData = GetExcludedFromQualityGovernanceResponse,
>(
  variables: GetExcludedFromQualityGovernanceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetExcludedFromQualityGovernanceResponse,
      GetExcludedFromQualityGovernanceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/preferences/governance/excluded/",
    operationId: "getExcludedFromQualityGovernance",
    variables,
  });
  const result = reactQuery.useQuery<
    GetExcludedFromQualityGovernanceResponse,
    GetExcludedFromQualityGovernanceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetExcludedFromQualityGovernance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetExcludedFromQualityGovernance = <
  TData = GetExcludedFromQualityGovernanceResponse,
>(
  variables: GetExcludedFromQualityGovernanceVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetExcludedFromQualityGovernanceResponse,
      GetExcludedFromQualityGovernanceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/quality/preferences/governance/excluded/",
    operationId: "getExcludedFromQualityGovernance",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetExcludedFromQualityGovernanceResponse,
    GetExcludedFromQualityGovernanceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetExcludedFromQualityGovernance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetExcludedFromQualityGovernanceError =
  Fetcher.ErrorWrapper<undefined>;

export type SetExcludedFromQualityGovernanceRequestBody = Schemas.Filter[];

export type SetExcludedFromQualityGovernanceVariables = {
  body?: SetExcludedFromQualityGovernanceRequestBody;
} & ApiContext["fetcherOptions"];

export const fetchSetExcludedFromQualityGovernance = (
  variables: SetExcludedFromQualityGovernanceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetExcludedFromQualityGovernanceError,
    SetExcludedFromQualityGovernanceRequestBody,
    {},
    {},
    {}
  >({
    url: "/quality/preferences/governance/excluded/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetExcludedFromQualityGovernance = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetExcludedFromQualityGovernanceError,
      SetExcludedFromQualityGovernanceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetExcludedFromQualityGovernanceError,
    SetExcludedFromQualityGovernanceVariables
  >({
    mutationFn: (variables: SetExcludedFromQualityGovernanceVariables) =>
      fetchSetExcludedFromQualityGovernance({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiGetExtensionProductQueryParams = {
  url: string;
};

export type ApiGetExtensionProductError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetExtensionProductVariables = {
  queryParams: ApiGetExtensionProductQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetExtensionProduct = (
  variables: ApiGetExtensionProductVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ProductOut,
    ApiGetExtensionProductError,
    undefined,
    {},
    ApiGetExtensionProductQueryParams,
    {}
  >({ url: "/extension/product/", method: "get", ...variables, signal });

export const apiGetExtensionProductQueryKey = (
  variables: ApiGetExtensionProductVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/extension/product/",
    operationId: "apiGetExtensionProduct",
    variables,
  });

export const useApiGetExtensionProduct = <TData = Schemas.ProductOut,>(
  variables: ApiGetExtensionProductVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ProductOut,
      ApiGetExtensionProductError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/extension/product/",
    operationId: "apiGetExtensionProduct",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ProductOut,
    ApiGetExtensionProductError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetExtensionProduct({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetExtensionProduct = <TData = Schemas.ProductOut,>(
  variables: ApiGetExtensionProductVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ProductOut,
      ApiGetExtensionProductError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/extension/product/",
    operationId: "apiGetExtensionProduct",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ProductOut,
    ApiGetExtensionProductError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetExtensionProduct({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetExtensionEntityQueryParams = {
  url: string;
  product: string;
  dbt_model_name?: string | null;
};

export type ApiGetExtensionEntityError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetExtensionEntityVariables = {
  queryParams: ApiGetExtensionEntityQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetExtensionEntity = (
  variables: ApiGetExtensionEntityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ExtensionEntityOut | null,
    ApiGetExtensionEntityError,
    undefined,
    {},
    ApiGetExtensionEntityQueryParams,
    {}
  >({ url: "/extension/entity/", method: "get", ...variables, signal });

export const apiGetExtensionEntityQueryKey = (
  variables: ApiGetExtensionEntityVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/extension/entity/",
    operationId: "apiGetExtensionEntity",
    variables,
  });

export const useApiGetExtensionEntity = <
  TData = Schemas.ExtensionEntityOut | null,
>(
  variables: ApiGetExtensionEntityVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ExtensionEntityOut | null,
      ApiGetExtensionEntityError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/extension/entity/",
    operationId: "apiGetExtensionEntity",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ExtensionEntityOut | null,
    ApiGetExtensionEntityError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetExtensionEntity({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetExtensionEntity = <
  TData = Schemas.ExtensionEntityOut | null,
>(
  variables: ApiGetExtensionEntityVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ExtensionEntityOut | null,
      ApiGetExtensionEntityError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/extension/entity/",
    operationId: "apiGetExtensionEntity",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ExtensionEntityOut | null,
    ApiGetExtensionEntityError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetExtensionEntity({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetExtensionIsProductUrlQueryParams = {
  curr_url: string;
};

export type ApiGetExtensionIsProductUrlError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetExtensionIsProductUrlVariables = {
  queryParams: ApiGetExtensionIsProductUrlQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetExtensionIsProductUrl = (
  variables: ApiGetExtensionIsProductUrlVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ExtensionIsProductUrlOut | null,
    ApiGetExtensionIsProductUrlError,
    undefined,
    {},
    ApiGetExtensionIsProductUrlQueryParams,
    {}
  >({ url: "/extension/is_product_url/", method: "get", ...variables, signal });

export const apiGetExtensionIsProductUrlQueryKey = (
  variables: ApiGetExtensionIsProductUrlVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/extension/is_product_url/",
    operationId: "apiGetExtensionIsProductUrl",
    variables,
  });

export const useApiGetExtensionIsProductUrl = <
  TData = Schemas.ExtensionIsProductUrlOut | null,
>(
  variables: ApiGetExtensionIsProductUrlVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ExtensionIsProductUrlOut | null,
      ApiGetExtensionIsProductUrlError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/extension/is_product_url/",
    operationId: "apiGetExtensionIsProductUrl",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ExtensionIsProductUrlOut | null,
    ApiGetExtensionIsProductUrlError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetExtensionIsProductUrl(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetExtensionIsProductUrl = <
  TData = Schemas.ExtensionIsProductUrlOut | null,
>(
  variables: ApiGetExtensionIsProductUrlVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ExtensionIsProductUrlOut | null,
      ApiGetExtensionIsProductUrlError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/extension/is_product_url/",
    operationId: "apiGetExtensionIsProductUrl",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ExtensionIsProductUrlOut | null,
    ApiGetExtensionIsProductUrlError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetExtensionIsProductUrl(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetExtensionDbtCloudPatternError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetExtensionDbtCloudPatternVariables =
  ApiContext["fetcherOptions"];

export const fetchApiGetExtensionDbtCloudPattern = (
  variables: ApiGetExtensionDbtCloudPatternVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ExtensionDbtCloudPatternOut | null,
    ApiGetExtensionDbtCloudPatternError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/extension/dbt_cloud_pattern/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetExtensionDbtCloudPatternQueryKey = (
  variables: ApiGetExtensionDbtCloudPatternVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/extension/dbt_cloud_pattern/",
    operationId: "apiGetExtensionDbtCloudPattern",
    variables,
  });

export const useApiGetExtensionDbtCloudPattern = <
  TData = Schemas.ExtensionDbtCloudPatternOut | null,
>(
  variables: ApiGetExtensionDbtCloudPatternVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ExtensionDbtCloudPatternOut | null,
      ApiGetExtensionDbtCloudPatternError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/extension/dbt_cloud_pattern/",
    operationId: "apiGetExtensionDbtCloudPattern",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ExtensionDbtCloudPatternOut | null,
    ApiGetExtensionDbtCloudPatternError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetExtensionDbtCloudPattern(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetExtensionDbtCloudPattern = <
  TData = Schemas.ExtensionDbtCloudPatternOut | null,
>(
  variables: ApiGetExtensionDbtCloudPatternVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ExtensionDbtCloudPatternOut | null,
      ApiGetExtensionDbtCloudPatternError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/extension/dbt_cloud_pattern/",
    operationId: "apiGetExtensionDbtCloudPattern",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ExtensionDbtCloudPatternOut | null,
    ApiGetExtensionDbtCloudPatternError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetExtensionDbtCloudPattern(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ListAuditItemsPathParams = {
  resourceType: string;
  resourceId: string;
};

export type ListAuditItemsError = Fetcher.ErrorWrapper<undefined>;

export type ListAuditItemsResponse = Schemas.AuditItemOut[];

export type ListAuditItemsVariables = {
  pathParams: ListAuditItemsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchListAuditItems = (
  variables: ListAuditItemsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ListAuditItemsResponse,
    ListAuditItemsError,
    undefined,
    {},
    {},
    ListAuditItemsPathParams
  >({
    url: "/audit/{resourceType}/{resourceId}/",
    method: "get",
    ...variables,
    signal,
  });

export const listAuditItemsQueryKey = (
  variables: ListAuditItemsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/audit/{resourceType}/{resourceId}/",
    operationId: "listAuditItems",
    variables,
  });

export const useListAuditItems = <TData = ListAuditItemsResponse,>(
  variables: ListAuditItemsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ListAuditItemsResponse,
      ListAuditItemsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/audit/{resourceType}/{resourceId}/",
    operationId: "listAuditItems",
    variables,
  });
  const result = reactQuery.useQuery<
    ListAuditItemsResponse,
    ListAuditItemsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListAuditItems({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseListAuditItems = <TData = ListAuditItemsResponse,>(
  variables: ListAuditItemsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ListAuditItemsResponse,
      ListAuditItemsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/audit/{resourceType}/{resourceId}/",
    operationId: "listAuditItems",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ListAuditItemsResponse,
    ListAuditItemsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListAuditItems({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListIamRolesQueryParams = {
  search_term?: string | null;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListIamRolesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListIamRolesVariables = {
  queryParams?: ApiListIamRolesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListIamRoles = (
  variables: ApiListIamRolesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedIAMRoleOut,
    ApiListIamRolesError,
    undefined,
    {},
    ApiListIamRolesQueryParams,
    {}
  >({ url: "/iam/iam_roles/iam_role/", method: "get", ...variables, signal });

export const apiListIamRolesQueryKey = (
  variables: ApiListIamRolesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_roles/iam_role/",
    operationId: "apiListIamRoles",
    variables,
  });

export const useApiListIamRoles = <TData = Schemas.PagedIAMRoleOut,>(
  variables: ApiListIamRolesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedIAMRoleOut,
      ApiListIamRolesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/iam_role/",
    operationId: "apiListIamRoles",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedIAMRoleOut,
    ApiListIamRolesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListIamRoles({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListIamRoles = <TData = Schemas.PagedIAMRoleOut,>(
  variables: ApiListIamRolesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedIAMRoleOut,
      ApiListIamRolesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/iam_role/",
    operationId: "apiListIamRoles",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedIAMRoleOut,
    ApiListIamRolesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListIamRoles({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateIamRoleError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateIamRoleVariables = {
  body: Schemas.IAMRoleIn;
} & ApiContext["fetcherOptions"];

/**
 * Create a new IAM role.
 *
 * Note that minimum permissions (Integrations.Read, Teams.Read, Teams.Join, Users.Read, Resources.Read, Properties.Read) are enforced
 * by the IAMRoleIn.validate_with_request method. These permissions cannot be removed and
 * will be automatically added if missing.
 */
export const fetchApiCreateIamRole = (
  variables: ApiCreateIamRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IAMRoleOut,
    ApiCreateIamRoleError,
    Schemas.IAMRoleIn,
    {},
    {},
    {}
  >({ url: "/iam/iam_roles/iam_role/", method: "post", ...variables, signal });

/**
 * Create a new IAM role.
 *
 * Note that minimum permissions (Integrations.Read, Teams.Read, Teams.Join, Users.Read, Resources.Read, Properties.Read) are enforced
 * by the IAMRoleIn.validate_with_request method. These permissions cannot be removed and
 * will be automatically added if missing.
 */
export const useApiCreateIamRole = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.IAMRoleOut,
      ApiCreateIamRoleError,
      ApiCreateIamRoleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.IAMRoleOut,
    ApiCreateIamRoleError,
    ApiCreateIamRoleVariables
  >({
    mutationFn: (variables: ApiCreateIamRoleVariables) =>
      fetchApiCreateIamRole({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListIamRolesWithUsersQueryParams = {
  search_term?: string | null;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListIamRolesWithUsersError = Fetcher.ErrorWrapper<undefined>;

export type ApiListIamRolesWithUsersVariables = {
  queryParams?: ApiListIamRolesWithUsersQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListIamRolesWithUsers = (
  variables: ApiListIamRolesWithUsersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedAPIListIAMRolesWithUsersResponseSchema,
    ApiListIamRolesWithUsersError,
    undefined,
    {},
    ApiListIamRolesWithUsersQueryParams,
    {}
  >({
    url: "/iam/iam_roles/iam_role_with_users/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListIamRolesWithUsersQueryKey = (
  variables: ApiListIamRolesWithUsersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_roles/iam_role_with_users/",
    operationId: "apiListIamRolesWithUsers",
    variables,
  });

export const useApiListIamRolesWithUsers = <
  TData = Schemas.PagedAPIListIAMRolesWithUsersResponseSchema,
>(
  variables: ApiListIamRolesWithUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedAPIListIAMRolesWithUsersResponseSchema,
      ApiListIamRolesWithUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/iam_role_with_users/",
    operationId: "apiListIamRolesWithUsers",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedAPIListIAMRolesWithUsersResponseSchema,
    ApiListIamRolesWithUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListIamRolesWithUsers(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListIamRolesWithUsers = <
  TData = Schemas.PagedAPIListIAMRolesWithUsersResponseSchema,
>(
  variables: ApiListIamRolesWithUsersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedAPIListIAMRolesWithUsersResponseSchema,
      ApiListIamRolesWithUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/iam_role_with_users/",
    operationId: "apiListIamRolesWithUsers",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedAPIListIAMRolesWithUsersResponseSchema,
    ApiListIamRolesWithUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListIamRolesWithUsers(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateIamRolePathParams = {
  iamRoleId: string;
};

export type ApiUpdateIamRoleError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateIamRoleVariables = {
  body: Schemas.PartialIAMRoleIn;
  pathParams: ApiUpdateIamRolePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update an IAM role.
 *
 * Note that minimum permissions (Integrations.Read, Teams.Read, Teams.Join, Users.Read, Resources.Read, Properties.Read) are enforced
 * by the PartialIAMRoleIn.validate_with_request method. These permissions cannot be removed and
 * will be automatically added if missing from the update payload.
 */
export const fetchApiUpdateIamRole = (
  variables: ApiUpdateIamRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IAMRoleOut,
    ApiUpdateIamRoleError,
    Schemas.PartialIAMRoleIn,
    {},
    {},
    ApiUpdateIamRolePathParams
  >({
    url: "/iam/iam_roles/iam_role/{iamRoleId}/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update an IAM role.
 *
 * Note that minimum permissions (Integrations.Read, Teams.Read, Teams.Join, Users.Read, Resources.Read, Properties.Read) are enforced
 * by the PartialIAMRoleIn.validate_with_request method. These permissions cannot be removed and
 * will be automatically added if missing from the update payload.
 */
export const useApiUpdateIamRole = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.IAMRoleOut,
      ApiUpdateIamRoleError,
      ApiUpdateIamRoleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.IAMRoleOut,
    ApiUpdateIamRoleError,
    ApiUpdateIamRoleVariables
  >({
    mutationFn: (variables: ApiUpdateIamRoleVariables) =>
      fetchApiUpdateIamRole({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetIamRolePathParams = {
  iamRoleId: string;
};

export type ApiGetIamRoleError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetIamRoleVariables = {
  pathParams: ApiGetIamRolePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetIamRole = (
  variables: ApiGetIamRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IAMRoleOut,
    ApiGetIamRoleError,
    undefined,
    {},
    {},
    ApiGetIamRolePathParams
  >({
    url: "/iam/iam_roles/iam_role/{iamRoleId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIamRoleQueryKey = (
  variables: ApiGetIamRoleVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_roles/iam_role/{iamRoleId}/",
    operationId: "apiGetIamRole",
    variables,
  });

export const useApiGetIamRole = <TData = Schemas.IAMRoleOut,>(
  variables: ApiGetIamRoleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.IAMRoleOut, ApiGetIamRoleError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/iam_role/{iamRoleId}/",
    operationId: "apiGetIamRole",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.IAMRoleOut,
    ApiGetIamRoleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIamRole({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetIamRole = <TData = Schemas.IAMRoleOut,>(
  variables: ApiGetIamRoleVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.IAMRoleOut,
      ApiGetIamRoleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/iam_role/{iamRoleId}/",
    operationId: "apiGetIamRole",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.IAMRoleOut,
    ApiGetIamRoleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIamRole({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiDeleteIamRolePathParams = {
  iamRoleId: string;
};

export type ApiDeleteIamRoleError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteIamRoleVariables = {
  pathParams: ApiDeleteIamRolePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiDeleteIamRole = (
  variables: ApiDeleteIamRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteIamRoleError,
    undefined,
    {},
    {},
    ApiDeleteIamRolePathParams
  >({
    url: "/iam/iam_roles/iam_role/{iamRoleId}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiDeleteIamRole = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteIamRoleError,
      ApiDeleteIamRoleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteIamRoleError,
    ApiDeleteIamRoleVariables
  >({
    mutationFn: (variables: ApiDeleteIamRoleVariables) =>
      fetchApiDeleteIamRole({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetIamRoleUsersPathParams = {
  iamRoleId: string;
};

export type ApiGetIamRoleUsersError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetIamRoleUsersResponse = Schemas.LiteUserOut[];

export type ApiGetIamRoleUsersVariables = {
  pathParams: ApiGetIamRoleUsersPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetIamRoleUsers = (
  variables: ApiGetIamRoleUsersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetIamRoleUsersResponse,
    ApiGetIamRoleUsersError,
    undefined,
    {},
    {},
    ApiGetIamRoleUsersPathParams
  >({
    url: "/iam/iam_roles/iam_role/{iamRoleId}/users/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIamRoleUsersQueryKey = (
  variables: ApiGetIamRoleUsersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_roles/iam_role/{iamRoleId}/users/",
    operationId: "apiGetIamRoleUsers",
    variables,
  });

export const useApiGetIamRoleUsers = <TData = ApiGetIamRoleUsersResponse,>(
  variables: ApiGetIamRoleUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetIamRoleUsersResponse,
      ApiGetIamRoleUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/iam_role/{iamRoleId}/users/",
    operationId: "apiGetIamRoleUsers",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetIamRoleUsersResponse,
    ApiGetIamRoleUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIamRoleUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetIamRoleUsers = <
  TData = ApiGetIamRoleUsersResponse,
>(
  variables: ApiGetIamRoleUsersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetIamRoleUsersResponse,
      ApiGetIamRoleUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/iam_role/{iamRoleId}/users/",
    operationId: "apiGetIamRoleUsers",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetIamRoleUsersResponse,
    ApiGetIamRoleUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIamRoleUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCloneIamRolePathParams = {
  iamRoleId: string;
};

export type ApiCloneIamRoleError = Fetcher.ErrorWrapper<undefined>;

export type ApiCloneIamRoleVariables = {
  pathParams: ApiCloneIamRolePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiCloneIamRole = (
  variables: ApiCloneIamRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IAMRoleOut,
    ApiCloneIamRoleError,
    undefined,
    {},
    {},
    ApiCloneIamRolePathParams
  >({
    url: "/iam/iam_roles/iam_role/{iamRoleId}/clone/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCloneIamRole = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.IAMRoleOut,
      ApiCloneIamRoleError,
      ApiCloneIamRoleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.IAMRoleOut,
    ApiCloneIamRoleError,
    ApiCloneIamRoleVariables
  >({
    mutationFn: (variables: ApiCloneIamRoleVariables) =>
      fetchApiCloneIamRole({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiSetUserIamRoleError = Fetcher.ErrorWrapper<undefined>;

export type ApiSetUserIamRoleVariables = {
  body: Schemas.SetUserRoleRequest;
} & ApiContext["fetcherOptions"];

export const fetchApiSetUserIamRole = (
  variables: ApiSetUserIamRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IAMRoleUserOut,
    ApiSetUserIamRoleError,
    Schemas.SetUserRoleRequest,
    {},
    {},
    {}
  >({
    url: "/iam/iam_roles/users/set_user_role/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiSetUserIamRole = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.IAMRoleUserOut,
      ApiSetUserIamRoleError,
      ApiSetUserIamRoleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.IAMRoleUserOut,
    ApiSetUserIamRoleError,
    ApiSetUserIamRoleVariables
  >({
    mutationFn: (variables: ApiSetUserIamRoleVariables) =>
      fetchApiSetUserIamRole({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetUserIamRolePathParams = {
  userId: string;
};

export type ApiGetUserIamRoleError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetUserIamRoleVariables = {
  pathParams: ApiGetUserIamRolePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetUserIamRole = (
  variables: ApiGetUserIamRoleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IAMRoleOut,
    ApiGetUserIamRoleError,
    undefined,
    {},
    {},
    ApiGetUserIamRolePathParams
  >({
    url: "/iam/iam_roles/users/get_user_role/{userId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetUserIamRoleQueryKey = (
  variables: ApiGetUserIamRoleVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_roles/users/get_user_role/{userId}/",
    operationId: "apiGetUserIamRole",
    variables,
  });

export const useApiGetUserIamRole = <TData = Schemas.IAMRoleOut,>(
  variables: ApiGetUserIamRoleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IAMRoleOut,
      ApiGetUserIamRoleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/users/get_user_role/{userId}/",
    operationId: "apiGetUserIamRole",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.IAMRoleOut,
    ApiGetUserIamRoleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetUserIamRole({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetUserIamRole = <TData = Schemas.IAMRoleOut,>(
  variables: ApiGetUserIamRoleVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.IAMRoleOut,
      ApiGetUserIamRoleError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_roles/users/get_user_role/{userId}/",
    operationId: "apiGetUserIamRole",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.IAMRoleOut,
    ApiGetUserIamRoleError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetUserIamRole({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPermissionsTreeError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPermissionsTreeResponse = {
  [key: string]: Schemas.FeatureInformation;
};

export type ApiGetPermissionsTreeVariables = ApiContext["fetcherOptions"];

export const fetchApiGetPermissionsTree = (
  variables: ApiGetPermissionsTreeVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetPermissionsTreeResponse,
    ApiGetPermissionsTreeError,
    undefined,
    {},
    {},
    {}
  >({ url: "/iam/iam_permissions/", method: "get", ...variables, signal });

export const apiGetPermissionsTreeQueryKey = (
  variables: ApiGetPermissionsTreeVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_permissions/",
    operationId: "apiGetPermissionsTree",
    variables,
  });

export const useApiGetPermissionsTree = <
  TData = ApiGetPermissionsTreeResponse,
>(
  variables: ApiGetPermissionsTreeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetPermissionsTreeResponse,
      ApiGetPermissionsTreeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_permissions/",
    operationId: "apiGetPermissionsTree",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetPermissionsTreeResponse,
    ApiGetPermissionsTreeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPermissionsTree({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetPermissionsTree = <
  TData = ApiGetPermissionsTreeResponse,
>(
  variables: ApiGetPermissionsTreeVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetPermissionsTreeResponse,
      ApiGetPermissionsTreeError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_permissions/",
    operationId: "apiGetPermissionsTree",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetPermissionsTreeResponse,
    ApiGetPermissionsTreeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPermissionsTree({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCheckIamPermissionQueryParams = {
  permission:
    | "APIKeys.Manage"
    | "APIKeys.Read"
    | "APIKeys.Write"
    | "Analytics.Manage"
    | "Analytics.Read"
    | "Analytics.Write"
    | "Announcements.Manage"
    | "Announcements.Read"
    | "Announcements.Write"
    | "Automations.Create"
    | "Automations.Delete"
    | "Automations.Manage"
    | "Automations.Read"
    | "Automations.Run"
    | "Automations.Update"
    | "Billing.Manage"
    | "Billing.Read"
    | "Billing.Write"
    | "ColumnProfile.Manage"
    | "ColumnProfile.Read"
    | "ColumnProfile.Update"
    | "DQS.Manage"
    | "DQS.Read"
    | "DQS.Write"
    | "Dashboards.Create"
    | "Dashboards.Delete"
    | "Dashboards.Manage"
    | "Dashboards.Read"
    | "Dashboards.Update"
    | "DataAccessRequests.Create"
    | "DataAccessRequests.Delete"
    | "DataAccessRequests.Manage"
    | "DataAccessRequests.Read"
    | "DataAccessRequests.Update"
    | "Groups.Create"
    | "Groups.Delete"
    | "Groups.Manage"
    | "Groups.Read"
    | "Groups.Update"
    | "ImportExports.Manage"
    | "ImportExports.Read"
    | "ImportExports.Write"
    | "Integrations.Create"
    | "Integrations.Delete"
    | "Integrations.Manage"
    | "Integrations.Query"
    | "Integrations.Read"
    | "Integrations.Update"
    | "Lineage.Create"
    | "Lineage.Delete"
    | "Lineage.Manage"
    | "Lineage.Read"
    | "Lineage.Update"
    | "Monitors.Create"
    | "Monitors.Delete"
    | "Monitors.Manage"
    | "Monitors.Read"
    | "Monitors.Run"
    | "Monitors.Update"
    | "Policies.Create"
    | "Policies.Delete"
    | "Policies.Manage"
    | "Policies.Read"
    | "Policies.Update"
    | "Preview.Manage"
    | "Preview.Read"
    | "Preview.Write"
    | "Properties.Create"
    | "Properties.Delete"
    | "Properties.Manage"
    | "Properties.Read"
    | "Properties.Update"
    | "Queries.Manage"
    | "Queries.Read"
    | "Queries.Write"
    | "Questions.Create"
    | "Questions.Delete"
    | "Questions.Manage"
    | "Questions.Read"
    | "Questions.Update"
    | "Resources.Create"
    | "Resources.CreateInTeams"
    | "Resources.Delete"
    | "Resources.Manage"
    | "Resources.Read"
    | "Resources.Update"
    | "Roles.Create"
    | "Roles.Delete"
    | "Roles.Manage"
    | "Roles.Read"
    | "Roles.Update"
    | "SecodaAI.Manage"
    | "SecodaAI.Read"
    | "SecodaAI.Write"
    | "Tags.Create"
    | "Tags.Delete"
    | "Tags.Manage"
    | "Tags.Read"
    | "Tags.Update"
    | "Teams.Create"
    | "Teams.Delete"
    | "Teams.Join"
    | "Teams.Manage"
    | "Teams.Read"
    | "Teams.Update"
    | "Tests.Manage"
    | "Tests.Read"
    | "Tests.Write"
    | "Users.Create"
    | "Users.Delete"
    | "Users.Manage"
    | "Users.Read"
    | "Users.Update"
    | "Views.Create"
    | "Views.Delete"
    | "Views.Manage"
    | "Views.Read"
    | "Views.Update"
    | "Workspace.Manage"
    | "Workspace.Read"
    | "Workspace.Write";
  object_id?: string | null;
  object_type?: string | string | null;
};

export type ApiCheckIamPermissionError = Fetcher.ErrorWrapper<undefined>;

export type ApiCheckIamPermissionVariables = {
  queryParams: ApiCheckIamPermissionQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Check if the user has the given permission for the given object.
 * The object type is optional and if not provided, the object will be checked as a SecodaEntity.
 */
export const fetchApiCheckIamPermission = (
  variables: ApiCheckIamPermissionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CheckResult,
    ApiCheckIamPermissionError,
    undefined,
    {},
    ApiCheckIamPermissionQueryParams,
    {}
  >({
    url: "/iam/iam_permissions/check_permission/",
    method: "get",
    ...variables,
    signal,
  });

export const apiCheckIamPermissionQueryKey = (
  variables: ApiCheckIamPermissionVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_permissions/check_permission/",
    operationId: "apiCheckIamPermission",
    variables,
  });

/**
 * Check if the user has the given permission for the given object.
 * The object type is optional and if not provided, the object will be checked as a SecodaEntity.
 */
export const useApiCheckIamPermission = <TData = Schemas.CheckResult,>(
  variables: ApiCheckIamPermissionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CheckResult,
      ApiCheckIamPermissionError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_permissions/check_permission/",
    operationId: "apiCheckIamPermission",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CheckResult,
    ApiCheckIamPermissionError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiCheckIamPermission({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Check if the user has the given permission for the given object.
 * The object type is optional and if not provided, the object will be checked as a SecodaEntity.
 */
export const useSuspenseApiCheckIamPermission = <TData = Schemas.CheckResult,>(
  variables: ApiCheckIamPermissionVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CheckResult,
      ApiCheckIamPermissionError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_permissions/check_permission/",
    operationId: "apiCheckIamPermission",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CheckResult,
    ApiCheckIamPermissionError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiCheckIamPermission({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetMyPermissionsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetMyPermissionsResponse = Schemas.PrimitivePermissionType[];

export type ApiGetMyPermissionsVariables = ApiContext["fetcherOptions"];

export const fetchApiGetMyPermissions = (
  variables: ApiGetMyPermissionsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetMyPermissionsResponse,
    ApiGetMyPermissionsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/iam/iam_permissions/my_permissions/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetMyPermissionsQueryKey = (
  variables: ApiGetMyPermissionsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_permissions/my_permissions/",
    operationId: "apiGetMyPermissions",
    variables,
  });

export const useApiGetMyPermissions = <TData = ApiGetMyPermissionsResponse,>(
  variables: ApiGetMyPermissionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetMyPermissionsResponse,
      ApiGetMyPermissionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_permissions/my_permissions/",
    operationId: "apiGetMyPermissions",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetMyPermissionsResponse,
    ApiGetMyPermissionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMyPermissions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetMyPermissions = <
  TData = ApiGetMyPermissionsResponse,
>(
  variables: ApiGetMyPermissionsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetMyPermissionsResponse,
      ApiGetMyPermissionsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_permissions/my_permissions/",
    operationId: "apiGetMyPermissions",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetMyPermissionsResponse,
    ApiGetMyPermissionsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetMyPermissions({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetResourcePermissionsRoleSummaryPathParams = {
  /**
   * @format uuid
   */
  entityId: string;
};

export type ApiGetResourcePermissionsRoleSummaryError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetResourcePermissionsRoleSummaryResponse =
  Schemas.RoleSummary[];

export type ApiGetResourcePermissionsRoleSummaryVariables = {
  pathParams: ApiGetResourcePermissionsRoleSummaryPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetResourcePermissionsRoleSummary = (
  variables: ApiGetResourcePermissionsRoleSummaryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetResourcePermissionsRoleSummaryResponse,
    ApiGetResourcePermissionsRoleSummaryError,
    undefined,
    {},
    {},
    ApiGetResourcePermissionsRoleSummaryPathParams
  >({
    url: "/iam/iam_resource_policies/resources/{entityId}/role_summary/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetResourcePermissionsRoleSummaryQueryKey = (
  variables: ApiGetResourcePermissionsRoleSummaryVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_resource_policies/resources/{entityId}/role_summary/",
    operationId: "apiGetResourcePermissionsRoleSummary",
    variables,
  });

export const useApiGetResourcePermissionsRoleSummary = <
  TData = ApiGetResourcePermissionsRoleSummaryResponse,
>(
  variables: ApiGetResourcePermissionsRoleSummaryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetResourcePermissionsRoleSummaryResponse,
      ApiGetResourcePermissionsRoleSummaryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_resource_policies/resources/{entityId}/role_summary/",
    operationId: "apiGetResourcePermissionsRoleSummary",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetResourcePermissionsRoleSummaryResponse,
    ApiGetResourcePermissionsRoleSummaryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetResourcePermissionsRoleSummary(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetResourcePermissionsRoleSummary = <
  TData = ApiGetResourcePermissionsRoleSummaryResponse,
>(
  variables: ApiGetResourcePermissionsRoleSummaryVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetResourcePermissionsRoleSummaryResponse,
      ApiGetResourcePermissionsRoleSummaryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_resource_policies/resources/{entityId}/role_summary/",
    operationId: "apiGetResourcePermissionsRoleSummary",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetResourcePermissionsRoleSummaryResponse,
    ApiGetResourcePermissionsRoleSummaryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetResourcePermissionsRoleSummary(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetResourcePoliciesPathParams = {
  /**
   * @format uuid
   */
  entityId: string;
};

export type ApiGetResourcePoliciesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetResourcePoliciesResponse = Schemas.IAMResourcePolicyOut[];

export type ApiGetResourcePoliciesVariables = {
  pathParams: ApiGetResourcePoliciesPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetResourcePolicies = (
  variables: ApiGetResourcePoliciesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetResourcePoliciesResponse,
    ApiGetResourcePoliciesError,
    undefined,
    {},
    {},
    ApiGetResourcePoliciesPathParams
  >({
    url: "/iam/iam_resource_policies/resources/{entityId}/policies/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetResourcePoliciesQueryKey = (
  variables: ApiGetResourcePoliciesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/iam/iam_resource_policies/resources/{entityId}/policies/",
    operationId: "apiGetResourcePolicies",
    variables,
  });

export const useApiGetResourcePolicies = <
  TData = ApiGetResourcePoliciesResponse,
>(
  variables: ApiGetResourcePoliciesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetResourcePoliciesResponse,
      ApiGetResourcePoliciesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_resource_policies/resources/{entityId}/policies/",
    operationId: "apiGetResourcePolicies",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetResourcePoliciesResponse,
    ApiGetResourcePoliciesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetResourcePolicies({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetResourcePolicies = <
  TData = ApiGetResourcePoliciesResponse,
>(
  variables: ApiGetResourcePoliciesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetResourcePoliciesResponse,
      ApiGetResourcePoliciesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/iam/iam_resource_policies/resources/{entityId}/policies/",
    operationId: "apiGetResourcePolicies",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetResourcePoliciesResponse,
    ApiGetResourcePoliciesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetResourcePolicies({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiQuickAlterResourcePoliciesPathParams = {
  /**
   * @format uuid
   */
  entityId: string;
};

export type ApiQuickAlterResourcePoliciesError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiQuickAlterResourcePoliciesVariables = {
  body: Schemas.QuickAlterResourcePoliciesBody;
  pathParams: ApiQuickAlterResourcePoliciesPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiQuickAlterResourcePolicies = (
  variables: ApiQuickAlterResourcePoliciesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IAMResourcePolicyOut | null,
    ApiQuickAlterResourcePoliciesError,
    Schemas.QuickAlterResourcePoliciesBody,
    {},
    {},
    ApiQuickAlterResourcePoliciesPathParams
  >({
    url: "/iam/iam_resource_policies/resources/{entityId}/policies/quick_alter/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiQuickAlterResourcePolicies = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.IAMResourcePolicyOut | null,
      ApiQuickAlterResourcePoliciesError,
      ApiQuickAlterResourcePoliciesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.IAMResourcePolicyOut | null,
    ApiQuickAlterResourcePoliciesError,
    ApiQuickAlterResourcePoliciesVariables
  >({
    mutationFn: (variables: ApiQuickAlterResourcePoliciesVariables) =>
      fetchApiQuickAlterResourcePolicies({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiBulkAddResourcePoliciesPathParams = {
  /**
   * @format uuid
   */
  entityId: string;
};

export type ApiBulkAddResourcePoliciesError = Fetcher.ErrorWrapper<undefined>;

export type ApiBulkAddResourcePoliciesResponse = Schemas.IAMResourcePolicyOut[];

export type ApiBulkAddResourcePoliciesVariables = {
  body: Schemas.BulkAddResourcePoliciesBody;
  pathParams: ApiBulkAddResourcePoliciesPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiBulkAddResourcePolicies = (
  variables: ApiBulkAddResourcePoliciesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiBulkAddResourcePoliciesResponse,
    ApiBulkAddResourcePoliciesError,
    Schemas.BulkAddResourcePoliciesBody,
    {},
    {},
    ApiBulkAddResourcePoliciesPathParams
  >({
    url: "/iam/iam_resource_policies/resources/{entityId}/policies/bulk_add/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiBulkAddResourcePolicies = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiBulkAddResourcePoliciesResponse,
      ApiBulkAddResourcePoliciesError,
      ApiBulkAddResourcePoliciesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiBulkAddResourcePoliciesResponse,
    ApiBulkAddResourcePoliciesError,
    ApiBulkAddResourcePoliciesVariables
  >({
    mutationFn: (variables: ApiBulkAddResourcePoliciesVariables) =>
      fetchApiBulkAddResourcePolicies({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListResourceLogsQueryParams = {
  /**
   * ID of the resource to retrieve logs for
   */
  resource_id: string;
  /**
   * Page number for paginated results (default is 1)
   *
   * @default 1
   */
  page?: number;
};

export type ApiListResourceLogsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListResourceLogsVariables = {
  queryParams: ApiListResourceLogsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * This endpoint retrieves a list of logs for a specific resource, providing a history of changes and actions taken on that resource.
 */
export const fetchApiListResourceLogs = (
  variables: ApiListResourceLogsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ResourceActivityLogOutPaginated,
    ApiListResourceLogsError,
    undefined,
    {},
    ApiListResourceLogsQueryParams,
    {}
  >({
    url: "/activity_log/resource_logs/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListResourceLogsQueryKey = (
  variables: ApiListResourceLogsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/activity_log/resource_logs/",
    operationId: "apiListResourceLogs",
    variables,
  });

/**
 * This endpoint retrieves a list of logs for a specific resource, providing a history of changes and actions taken on that resource.
 */
export const useApiListResourceLogs = <
  TData = Schemas.ResourceActivityLogOutPaginated,
>(
  variables: ApiListResourceLogsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ResourceActivityLogOutPaginated,
      ApiListResourceLogsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/activity_log/resource_logs/",
    operationId: "apiListResourceLogs",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ResourceActivityLogOutPaginated,
    ApiListResourceLogsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListResourceLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * This endpoint retrieves a list of logs for a specific resource, providing a history of changes and actions taken on that resource.
 */
export const useSuspenseApiListResourceLogs = <
  TData = Schemas.ResourceActivityLogOutPaginated,
>(
  variables: ApiListResourceLogsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ResourceActivityLogOutPaginated,
      ApiListResourceLogsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/activity_log/resource_logs/",
    operationId: "apiListResourceLogs",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ResourceActivityLogOutPaginated,
    ApiListResourceLogsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListResourceLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListAuditLogsQueryParams = {
  /**
   * A serialized and URL encoded JSON object to define filters on the audit logs.
   * This follows the same pattern as catalog filters, allowing for complex filtering based on multiple criteria.
   */
  filter?: string;
  /**
   * A serialized and URL encoded JSON object to define the sort pattern on the audit logs.
   */
  sort?: string;
  /**
   * Page number for paginated results (default is 1)
   *
   * @default 1
   */
  page?: number;
};

export type ApiListAuditLogsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListAuditLogsVariables = {
  queryParams?: ApiListAuditLogsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * This endpoint retrieves a list of audit logs for the workspace, providing a comprehensive record of actions taken by users, systems, and integrations.
 *
 * The audit logs can be filtered and sorted using the advanced filter and sort query parameters, which allow for complex filtering based on multiple criteria.
 */
export const fetchApiListAuditLogs = (
  variables: ApiListAuditLogsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ActivityLogOutPaginated,
    ApiListAuditLogsError,
    undefined,
    {},
    ApiListAuditLogsQueryParams,
    {}
  >({ url: "/activity_log/audit_logs/", method: "get", ...variables, signal });

export const apiListAuditLogsQueryKey = (
  variables: ApiListAuditLogsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/activity_log/audit_logs/",
    operationId: "apiListAuditLogs",
    variables,
  });

/**
 * This endpoint retrieves a list of audit logs for the workspace, providing a comprehensive record of actions taken by users, systems, and integrations.
 *
 * The audit logs can be filtered and sorted using the advanced filter and sort query parameters, which allow for complex filtering based on multiple criteria.
 */
export const useApiListAuditLogs = <TData = Schemas.ActivityLogOutPaginated,>(
  variables: ApiListAuditLogsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ActivityLogOutPaginated,
      ApiListAuditLogsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/activity_log/audit_logs/",
    operationId: "apiListAuditLogs",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ActivityLogOutPaginated,
    ApiListAuditLogsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListAuditLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * This endpoint retrieves a list of audit logs for the workspace, providing a comprehensive record of actions taken by users, systems, and integrations.
 *
 * The audit logs can be filtered and sorted using the advanced filter and sort query parameters, which allow for complex filtering based on multiple criteria.
 */
export const useSuspenseApiListAuditLogs = <
  TData = Schemas.ActivityLogOutPaginated,
>(
  variables: ApiListAuditLogsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ActivityLogOutPaginated,
      ApiListAuditLogsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/activity_log/audit_logs/",
    operationId: "apiListAuditLogs",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ActivityLogOutPaginated,
    ApiListAuditLogsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListAuditLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListUserLogsQueryParams = {
  filter?: string | null;
  sort?: string | null;
  user_id: string;
  page?: number | null;
};

export type ApiListUserLogsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListUserLogsVariables = {
  queryParams: ApiListUserLogsQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListUserLogs = (
  variables: ApiListUserLogsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ActivityLogOutPaginated,
    ApiListUserLogsError,
    undefined,
    {},
    ApiListUserLogsQueryParams,
    {}
  >({ url: "/activity_log/user_logs/", method: "get", ...variables, signal });

export const apiListUserLogsQueryKey = (
  variables: ApiListUserLogsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/activity_log/user_logs/",
    operationId: "apiListUserLogs",
    variables,
  });

export const useApiListUserLogs = <TData = Schemas.ActivityLogOutPaginated,>(
  variables: ApiListUserLogsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ActivityLogOutPaginated,
      ApiListUserLogsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/activity_log/user_logs/",
    operationId: "apiListUserLogs",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.ActivityLogOutPaginated,
    ApiListUserLogsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListUserLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListUserLogs = <
  TData = Schemas.ActivityLogOutPaginated,
>(
  variables: ApiListUserLogsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.ActivityLogOutPaginated,
      ApiListUserLogsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/activity_log/user_logs/",
    operationId: "apiListUserLogs",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.ActivityLogOutPaginated,
    ApiListUserLogsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListUserLogs({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListVersionHistoriesQueryParams = {
  resource_id: string;
  page?: number | null;
};

export type ApiListVersionHistoriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListVersionHistoriesVariables = {
  queryParams: ApiListVersionHistoriesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListVersionHistories = (
  variables: ApiListVersionHistoriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.VersionHistoryOutPaginated,
    ApiListVersionHistoriesError,
    undefined,
    {},
    ApiListVersionHistoriesQueryParams,
    {}
  >({
    url: "/version_history/version_histories/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListVersionHistoriesQueryKey = (
  variables: ApiListVersionHistoriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/version_history/version_histories/",
    operationId: "apiListVersionHistories",
    variables,
  });

export const useApiListVersionHistories = <
  TData = Schemas.VersionHistoryOutPaginated,
>(
  variables: ApiListVersionHistoriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.VersionHistoryOutPaginated,
      ApiListVersionHistoriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/version_history/version_histories/",
    operationId: "apiListVersionHistories",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.VersionHistoryOutPaginated,
    ApiListVersionHistoriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListVersionHistories({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListVersionHistories = <
  TData = Schemas.VersionHistoryOutPaginated,
>(
  variables: ApiListVersionHistoriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.VersionHistoryOutPaginated,
      ApiListVersionHistoriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/version_history/version_histories/",
    operationId: "apiListVersionHistories",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.VersionHistoryOutPaginated,
    ApiListVersionHistoriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListVersionHistories({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetVersionHistoryQueryParams = {
  id: string;
};

export type ApiGetVersionHistoryError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetVersionHistoryVariables = {
  queryParams: ApiGetVersionHistoryQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetVersionHistory = (
  variables: ApiGetVersionHistoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.VersionHistoryOut,
    ApiGetVersionHistoryError,
    undefined,
    {},
    ApiGetVersionHistoryQueryParams,
    {}
  >({
    url: "/version_history/version_history/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetVersionHistoryQueryKey = (
  variables: ApiGetVersionHistoryVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/version_history/version_history/",
    operationId: "apiGetVersionHistory",
    variables,
  });

export const useApiGetVersionHistory = <TData = Schemas.VersionHistoryOut,>(
  variables: ApiGetVersionHistoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.VersionHistoryOut,
      ApiGetVersionHistoryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/version_history/version_history/",
    operationId: "apiGetVersionHistory",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.VersionHistoryOut,
    ApiGetVersionHistoryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetVersionHistory({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetVersionHistory = <
  TData = Schemas.VersionHistoryOut,
>(
  variables: ApiGetVersionHistoryVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.VersionHistoryOut,
      ApiGetVersionHistoryError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/version_history/version_history/",
    operationId: "apiGetVersionHistory",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.VersionHistoryOut,
    ApiGetVersionHistoryError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetVersionHistory({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiRevertToHistoryQueryParams = {
  id: string;
};

export type ApiRevertToHistoryError = Fetcher.ErrorWrapper<undefined>;

export type ApiRevertToHistoryVariables = {
  queryParams: ApiRevertToHistoryQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRevertToHistory = (
  variables: ApiRevertToHistoryVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityOut,
    ApiRevertToHistoryError,
    undefined,
    {},
    ApiRevertToHistoryQueryParams,
    {}
  >({
    url: "/version_history/revert_to_history/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiRevertToHistory = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EntityOut,
      ApiRevertToHistoryError,
      ApiRevertToHistoryVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.EntityOut,
    ApiRevertToHistoryError,
    ApiRevertToHistoryVariables
  >({
    mutationFn: (variables: ApiRevertToHistoryVariables) =>
      fetchApiRevertToHistory({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetPolicyMetricsQueryParams = {
  /**
   * @default all
   */
  filter_type?: "all" | "owned" | "subscribed";
  policy_id?: string | null;
  framework?: Schemas.PolicyFramework | null;
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
};

export type ApiGetPolicyMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPolicyMetricsVariables = {
  queryParams?: ApiGetPolicyMetricsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get current policy metrics
 */
export const fetchApiGetPolicyMetrics = (
  variables: ApiGetPolicyMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyMetricsOut,
    ApiGetPolicyMetricsError,
    undefined,
    {},
    ApiGetPolicyMetricsQueryParams,
    {}
  >({ url: "/policy/metrics/", method: "get", ...variables, signal });

export const apiGetPolicyMetricsQueryKey = (
  variables: ApiGetPolicyMetricsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/metrics/",
    operationId: "apiGetPolicyMetrics",
    variables,
  });

/**
 * Get current policy metrics
 */
export const useApiGetPolicyMetrics = <TData = Schemas.PolicyMetricsOut,>(
  variables: ApiGetPolicyMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PolicyMetricsOut,
      ApiGetPolicyMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/metrics/",
    operationId: "apiGetPolicyMetrics",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PolicyMetricsOut,
    ApiGetPolicyMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicyMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get current policy metrics
 */
export const useSuspenseApiGetPolicyMetrics = <
  TData = Schemas.PolicyMetricsOut,
>(
  variables: ApiGetPolicyMetricsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PolicyMetricsOut,
      ApiGetPolicyMetricsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/metrics/",
    operationId: "apiGetPolicyMetrics",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PolicyMetricsOut,
    ApiGetPolicyMetricsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicyMetrics({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPolicyTimeseriesQueryParams = {
  /**
   * @default all
   */
  filter_type?: "all" | "owned" | "subscribed";
  policy_id?: string | null;
  framework?: Schemas.PolicyFramework | null;
  /**
   * @default 24h
   */
  time_range?: "24h" | "7d" | "30d" | "90d" | "180d" | "365d" | "all";
  /**
   * @default day
   */
  view_option?: "hour" | "day" | "week" | "month" | "year";
};

export type ApiGetPolicyTimeseriesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPolicyTimeseriesVariables = {
  queryParams?: ApiGetPolicyTimeseriesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get policy metrics time series data
 */
export const fetchApiGetPolicyTimeseries = (
  variables: ApiGetPolicyTimeseriesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyTimeSeriesOut,
    ApiGetPolicyTimeseriesError,
    undefined,
    {},
    ApiGetPolicyTimeseriesQueryParams,
    {}
  >({
    url: "/policy/metrics/timeseries/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetPolicyTimeseriesQueryKey = (
  variables: ApiGetPolicyTimeseriesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/metrics/timeseries/",
    operationId: "apiGetPolicyTimeseries",
    variables,
  });

/**
 * Get policy metrics time series data
 */
export const useApiGetPolicyTimeseries = <TData = Schemas.PolicyTimeSeriesOut,>(
  variables: ApiGetPolicyTimeseriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PolicyTimeSeriesOut,
      ApiGetPolicyTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/metrics/timeseries/",
    operationId: "apiGetPolicyTimeseries",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PolicyTimeSeriesOut,
    ApiGetPolicyTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicyTimeseries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get policy metrics time series data
 */
export const useSuspenseApiGetPolicyTimeseries = <
  TData = Schemas.PolicyTimeSeriesOut,
>(
  variables: ApiGetPolicyTimeseriesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PolicyTimeSeriesOut,
      ApiGetPolicyTimeseriesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/metrics/timeseries/",
    operationId: "apiGetPolicyTimeseries",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PolicyTimeSeriesOut,
    ApiGetPolicyTimeseriesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicyTimeseries({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetScoreHistoryForWorkspaceQueryParams = {
  integration_id?: string | null;
  team_id?: string | null;
  tag_id?: string | null;
};

export type ApiGetScoreHistoryForWorkspaceError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiGetScoreHistoryForWorkspaceVariables = {
  queryParams?: ApiGetScoreHistoryForWorkspaceQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get day-by-day score history for the last 30 days for workspace.
 *
 * Optional filters:
 * - integration_id: Filter by specific integration
 * - team_id: Filter by specific team
 * - tag_id: Filter by specific tag
 */
export const fetchApiGetScoreHistoryForWorkspace = (
  variables: ApiGetScoreHistoryForWorkspaceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QualityScoreHistoryOut,
    ApiGetScoreHistoryForWorkspaceError,
    undefined,
    {},
    ApiGetScoreHistoryForWorkspaceQueryParams,
    {}
  >({
    url: "/policy/quality/score-history/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetScoreHistoryForWorkspaceQueryKey = (
  variables: ApiGetScoreHistoryForWorkspaceVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/quality/score-history/",
    operationId: "apiGetScoreHistoryForWorkspace",
    variables,
  });

/**
 * Get day-by-day score history for the last 30 days for workspace.
 *
 * Optional filters:
 * - integration_id: Filter by specific integration
 * - team_id: Filter by specific team
 * - tag_id: Filter by specific tag
 */
export const useApiGetScoreHistoryForWorkspace = <
  TData = Schemas.QualityScoreHistoryOut,
>(
  variables: ApiGetScoreHistoryForWorkspaceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QualityScoreHistoryOut,
      ApiGetScoreHistoryForWorkspaceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/quality/score-history/",
    operationId: "apiGetScoreHistoryForWorkspace",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QualityScoreHistoryOut,
    ApiGetScoreHistoryForWorkspaceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetScoreHistoryForWorkspace(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get day-by-day score history for the last 30 days for workspace.
 *
 * Optional filters:
 * - integration_id: Filter by specific integration
 * - team_id: Filter by specific team
 * - tag_id: Filter by specific tag
 */
export const useSuspenseApiGetScoreHistoryForWorkspace = <
  TData = Schemas.QualityScoreHistoryOut,
>(
  variables: ApiGetScoreHistoryForWorkspaceVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QualityScoreHistoryOut,
      ApiGetScoreHistoryForWorkspaceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/quality/score-history/",
    operationId: "apiGetScoreHistoryForWorkspace",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QualityScoreHistoryOut,
    ApiGetScoreHistoryForWorkspaceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetScoreHistoryForWorkspace(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListEntityPoliciesPathParams = {
  entityId: string;
};

export type ApiListEntityPoliciesQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListEntityPoliciesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListEntityPoliciesVariables = {
  pathParams: ApiListEntityPoliciesPathParams;
  queryParams?: ApiListEntityPoliciesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListEntityPolicies = (
  variables: ApiListEntityPoliciesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedEntityPolicyOut,
    ApiListEntityPoliciesError,
    undefined,
    {},
    ApiListEntityPoliciesQueryParams,
    ApiListEntityPoliciesPathParams
  >({ url: "/policy/entity/{entityId}/", method: "get", ...variables, signal });

export const apiListEntityPoliciesQueryKey = (
  variables: ApiListEntityPoliciesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/entity/{entityId}/",
    operationId: "apiListEntityPolicies",
    variables,
  });

export const useApiListEntityPolicies = <TData = Schemas.PagedEntityPolicyOut,>(
  variables: ApiListEntityPoliciesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedEntityPolicyOut,
      ApiListEntityPoliciesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/entity/{entityId}/",
    operationId: "apiListEntityPolicies",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedEntityPolicyOut,
    ApiListEntityPoliciesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListEntityPolicies({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListEntityPolicies = <
  TData = Schemas.PagedEntityPolicyOut,
>(
  variables: ApiListEntityPoliciesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedEntityPolicyOut,
      ApiListEntityPoliciesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/entity/{entityId}/",
    operationId: "apiListEntityPolicies",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedEntityPolicyOut,
    ApiListEntityPoliciesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListEntityPolicies({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListPolicyTemplatesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListPolicyTemplatesResponse = Schemas.PolicyTemplate[];

export type ApiListPolicyTemplatesVariables = ApiContext["fetcherOptions"];

export const fetchApiListPolicyTemplates = (
  variables: ApiListPolicyTemplatesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiListPolicyTemplatesResponse,
    ApiListPolicyTemplatesError,
    undefined,
    {},
    {},
    {}
  >({ url: "/policy/templates/", method: "get", ...variables, signal });

export const apiListPolicyTemplatesQueryKey = (
  variables: ApiListPolicyTemplatesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/templates/",
    operationId: "apiListPolicyTemplates",
    variables,
  });

export const useApiListPolicyTemplates = <
  TData = ApiListPolicyTemplatesResponse,
>(
  variables: ApiListPolicyTemplatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiListPolicyTemplatesResponse,
      ApiListPolicyTemplatesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/templates/",
    operationId: "apiListPolicyTemplates",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiListPolicyTemplatesResponse,
    ApiListPolicyTemplatesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicyTemplates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListPolicyTemplates = <
  TData = ApiListPolicyTemplatesResponse,
>(
  variables: ApiListPolicyTemplatesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiListPolicyTemplatesResponse,
      ApiListPolicyTemplatesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/templates/",
    operationId: "apiListPolicyTemplates",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiListPolicyTemplatesResponse,
    ApiListPolicyTemplatesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicyTemplates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPolicyTemplatesError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPolicyTemplatesResponse = Schemas.PolicyTemplateOut[];

export type ApiGetPolicyTemplatesVariables = ApiContext["fetcherOptions"];

export const fetchApiGetPolicyTemplates = (
  variables: ApiGetPolicyTemplatesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetPolicyTemplatesResponse,
    ApiGetPolicyTemplatesError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/policy/data-scanning-templates/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetPolicyTemplatesQueryKey = (
  variables: ApiGetPolicyTemplatesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/data-scanning-templates/",
    operationId: "apiGetPolicyTemplates",
    variables,
  });

export const useApiGetPolicyTemplates = <
  TData = ApiGetPolicyTemplatesResponse,
>(
  variables: ApiGetPolicyTemplatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetPolicyTemplatesResponse,
      ApiGetPolicyTemplatesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/data-scanning-templates/",
    operationId: "apiGetPolicyTemplates",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetPolicyTemplatesResponse,
    ApiGetPolicyTemplatesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicyTemplates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetPolicyTemplates = <
  TData = ApiGetPolicyTemplatesResponse,
>(
  variables: ApiGetPolicyTemplatesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetPolicyTemplatesResponse,
      ApiGetPolicyTemplatesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/data-scanning-templates/",
    operationId: "apiGetPolicyTemplates",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetPolicyTemplatesResponse,
    ApiGetPolicyTemplatesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicyTemplates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListClassifiersPathParams = {
  type: string;
};

export type ApiListClassifiersError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: {
    [key: string]: any;
  };
}>;

export type ApiListClassifiersResponse = Schemas.ClassifierCategoryOut[];

export type ApiListClassifiersVariables = {
  pathParams: ApiListClassifiersPathParams;
} & ApiContext["fetcherOptions"];

/**
 * List classifier categories for a given type (currently only 'pii' is supported)
 */
export const fetchApiListClassifiers = (
  variables: ApiListClassifiersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiListClassifiersResponse,
    ApiListClassifiersError,
    undefined,
    {},
    {},
    ApiListClassifiersPathParams
  >({
    url: "/policy/classifiers/{type}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListClassifiersQueryKey = (
  variables: ApiListClassifiersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/classifiers/{type}/",
    operationId: "apiListClassifiers",
    variables,
  });

/**
 * List classifier categories for a given type (currently only 'pii' is supported)
 */
export const useApiListClassifiers = <TData = ApiListClassifiersResponse,>(
  variables: ApiListClassifiersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiListClassifiersResponse,
      ApiListClassifiersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/classifiers/{type}/",
    operationId: "apiListClassifiers",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiListClassifiersResponse,
    ApiListClassifiersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListClassifiers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List classifier categories for a given type (currently only 'pii' is supported)
 */
export const useSuspenseApiListClassifiers = <
  TData = ApiListClassifiersResponse,
>(
  variables: ApiListClassifiersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiListClassifiersResponse,
      ApiListClassifiersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/classifiers/{type}/",
    operationId: "apiListClassifiers",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiListClassifiersResponse,
    ApiListClassifiersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListClassifiers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListPoliciesQueryParams = {
  search_term?: string | null;
  filter?: string | null;
  sort?: string | null;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListPoliciesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListPoliciesVariables = {
  queryParams?: ApiListPoliciesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListPolicies = (
  variables: ApiListPoliciesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedPolicyOut,
    ApiListPoliciesError,
    undefined,
    {},
    ApiListPoliciesQueryParams,
    {}
  >({ url: "/policy/", method: "get", ...variables, signal });

export const apiListPoliciesQueryKey = (
  variables: ApiListPoliciesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/",
    operationId: "apiListPolicies",
    variables,
  });

export const useApiListPolicies = <TData = Schemas.PagedPolicyOut,>(
  variables: ApiListPoliciesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedPolicyOut,
      ApiListPoliciesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/",
    operationId: "apiListPolicies",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedPolicyOut,
    ApiListPoliciesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicies({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListPolicies = <TData = Schemas.PagedPolicyOut,>(
  variables: ApiListPoliciesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedPolicyOut,
      ApiListPoliciesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/",
    operationId: "apiListPolicies",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedPolicyOut,
    ApiListPoliciesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicies({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreatePolicyError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreatePolicyVariables = {
  body: Schemas.PartialPolicyIn;
} & ApiContext["fetcherOptions"];

export const fetchApiCreatePolicy = (
  variables: ApiCreatePolicyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyOut,
    ApiCreatePolicyError,
    Schemas.PartialPolicyIn,
    {},
    {},
    {}
  >({ url: "/policy/", method: "post", ...variables, signal });

export const useApiCreatePolicy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyOut,
      ApiCreatePolicyError,
      ApiCreatePolicyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyOut,
    ApiCreatePolicyError,
    ApiCreatePolicyVariables
  >({
    mutationFn: (variables: ApiCreatePolicyVariables) =>
      fetchApiCreatePolicy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRunPolicyError = Fetcher.ErrorWrapper<undefined>;

export type ApiRunPolicyResponse = {
  [key: string]: any;
};

export type ApiRunPolicyVariables = {
  body: Schemas.RunPolicyIn;
} & ApiContext["fetcherOptions"];

/**
 * Run a policy scan on-demand.
 * Similar to automation run endpoint.
 */
export const fetchApiRunPolicy = (
  variables: ApiRunPolicyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiRunPolicyResponse,
    ApiRunPolicyError,
    Schemas.RunPolicyIn,
    {},
    {},
    {}
  >({ url: "/policy/run/", method: "post", ...variables, signal });

/**
 * Run a policy scan on-demand.
 * Similar to automation run endpoint.
 */
export const useApiRunPolicy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiRunPolicyResponse,
      ApiRunPolicyError,
      ApiRunPolicyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiRunPolicyResponse,
    ApiRunPolicyError,
    ApiRunPolicyVariables
  >({
    mutationFn: (variables: ApiRunPolicyVariables) =>
      fetchApiRunPolicy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetPolicyPathParams = {
  policyId: string;
};

export type ApiGetPolicyError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetPolicyVariables = {
  pathParams: ApiGetPolicyPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetPolicy = (
  variables: ApiGetPolicyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyOut,
    ApiGetPolicyError,
    undefined,
    {},
    {},
    ApiGetPolicyPathParams
  >({ url: "/policy/{policyId}/", method: "get", ...variables, signal });

export const apiGetPolicyQueryKey = (
  variables: ApiGetPolicyVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/{policyId}/",
    operationId: "apiGetPolicy",
    variables,
  });

export const useApiGetPolicy = <TData = Schemas.PolicyOut,>(
  variables: ApiGetPolicyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.PolicyOut, ApiGetPolicyError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/{policyId}/",
    operationId: "apiGetPolicy",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PolicyOut,
    ApiGetPolicyError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicy({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetPolicy = <TData = Schemas.PolicyOut,>(
  variables: ApiGetPolicyVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PolicyOut,
      ApiGetPolicyError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/{policyId}/",
    operationId: "apiGetPolicy",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PolicyOut,
    ApiGetPolicyError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicy({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiDeletePolicyPathParams = {
  policyId: string;
};

export type ApiDeletePolicyError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeletePolicyVariables = {
  pathParams: ApiDeletePolicyPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiDeletePolicy = (
  variables: ApiDeletePolicyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeletePolicyError,
    undefined,
    {},
    {},
    ApiDeletePolicyPathParams
  >({ url: "/policy/{policyId}/", method: "delete", ...variables, signal });

export const useApiDeletePolicy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeletePolicyError,
      ApiDeletePolicyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeletePolicyError,
    ApiDeletePolicyVariables
  >({
    mutationFn: (variables: ApiDeletePolicyVariables) =>
      fetchApiDeletePolicy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPatchPolicyPathParams = {
  policyId: string;
};

export type ApiPatchPolicyError = Fetcher.ErrorWrapper<undefined>;

export type ApiPatchPolicyVariables = {
  body: Schemas.PartialPolicyIn;
  pathParams: ApiPatchPolicyPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiPatchPolicy = (
  variables: ApiPatchPolicyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyOut,
    ApiPatchPolicyError,
    Schemas.PartialPolicyIn,
    {},
    {},
    ApiPatchPolicyPathParams
  >({ url: "/policy/{policyId}/", method: "patch", ...variables, signal });

export const useApiPatchPolicy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyOut,
      ApiPatchPolicyError,
      ApiPatchPolicyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyOut,
    ApiPatchPolicyError,
    ApiPatchPolicyVariables
  >({
    mutationFn: (variables: ApiPatchPolicyVariables) =>
      fetchApiPatchPolicy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDuplicatePolicyPathParams = {
  policyId: string;
};

export type ApiDuplicatePolicyError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: {
    [key: string]: any;
  };
}>;

export type ApiDuplicatePolicyVariables = {
  pathParams: ApiDuplicatePolicyPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiDuplicatePolicy = (
  variables: ApiDuplicatePolicyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyOut,
    ApiDuplicatePolicyError,
    undefined,
    {},
    {},
    ApiDuplicatePolicyPathParams
  >({
    url: "/policy/{policyId}/duplicate/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiDuplicatePolicy = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyOut,
      ApiDuplicatePolicyError,
      ApiDuplicatePolicyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyOut,
    ApiDuplicatePolicyError,
    ApiDuplicatePolicyVariables
  >({
    mutationFn: (variables: ApiDuplicatePolicyVariables) =>
      fetchApiDuplicatePolicy({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiTogglePolicyEnablePathParams = {
  policyId: string;
};

export type ApiTogglePolicyEnableError = Fetcher.ErrorWrapper<undefined>;

export type ApiTogglePolicyEnableVariables = {
  body: Schemas.TogglePolicyIn;
  pathParams: ApiTogglePolicyEnablePathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiTogglePolicyEnable = (
  variables: ApiTogglePolicyEnableVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyOut,
    ApiTogglePolicyEnableError,
    Schemas.TogglePolicyIn,
    {},
    {},
    ApiTogglePolicyEnablePathParams
  >({
    url: "/policy/{policyId}/toggle-enable/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiTogglePolicyEnable = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyOut,
      ApiTogglePolicyEnableError,
      ApiTogglePolicyEnableVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyOut,
    ApiTogglePolicyEnableError,
    ApiTogglePolicyEnableVariables
  >({
    mutationFn: (variables: ApiTogglePolicyEnableVariables) =>
      fetchApiTogglePolicyEnable({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListPolicyIssuesPathParams = {
  policyId: string;
};

export type ApiListPolicyIssuesQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListPolicyIssuesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListPolicyIssuesVariables = {
  pathParams: ApiListPolicyIssuesPathParams;
  queryParams?: ApiListPolicyIssuesQueryParams;
} & ApiContext["fetcherOptions"];

export const fetchApiListPolicyIssues = (
  variables: ApiListPolicyIssuesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedPolicyIssueOut,
    ApiListPolicyIssuesError,
    undefined,
    {},
    ApiListPolicyIssuesQueryParams,
    ApiListPolicyIssuesPathParams
  >({ url: "/policy/{policyId}/issues/", method: "get", ...variables, signal });

export const apiListPolicyIssuesQueryKey = (
  variables: ApiListPolicyIssuesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/{policyId}/issues/",
    operationId: "apiListPolicyIssues",
    variables,
  });

export const useApiListPolicyIssues = <TData = Schemas.PagedPolicyIssueOut,>(
  variables: ApiListPolicyIssuesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedPolicyIssueOut,
      ApiListPolicyIssuesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/{policyId}/issues/",
    operationId: "apiListPolicyIssues",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedPolicyIssueOut,
    ApiListPolicyIssuesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicyIssues({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiListPolicyIssues = <
  TData = Schemas.PagedPolicyIssueOut,
>(
  variables: ApiListPolicyIssuesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedPolicyIssueOut,
      ApiListPolicyIssuesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/{policyId}/issues/",
    operationId: "apiListPolicyIssues",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedPolicyIssueOut,
    ApiListPolicyIssuesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicyIssues({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListPolicyResultsPathParams = {
  policyId: string;
};

export type ApiListPolicyResultsQueryParams = {
  /**
   * @default 1
   */
  page?: number;
  parent_id?: string | null;
  /**
   * @default false
   */
  ignored?: boolean;
  tag_id?: string | null;
  integration_id?: string | null;
};

export type ApiListPolicyResultsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListPolicyResultsVariables = {
  pathParams: ApiListPolicyResultsPathParams;
  queryParams?: ApiListPolicyResultsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List policy results grouped by entity
 */
export const fetchApiListPolicyResults = (
  variables: ApiListPolicyResultsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SecodaNinjaPaginationOutputEntityViolationsOut,
    ApiListPolicyResultsError,
    undefined,
    {},
    ApiListPolicyResultsQueryParams,
    ApiListPolicyResultsPathParams
  >({
    url: "/policy/{policyId}/results/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListPolicyResultsQueryKey = (
  variables: ApiListPolicyResultsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/{policyId}/results/",
    operationId: "apiListPolicyResults",
    variables,
  });

/**
 * List policy results grouped by entity
 */
export const useApiListPolicyResults = <
  TData = Schemas.SecodaNinjaPaginationOutputEntityViolationsOut,
>(
  variables: ApiListPolicyResultsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputEntityViolationsOut,
      ApiListPolicyResultsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/{policyId}/results/",
    operationId: "apiListPolicyResults",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SecodaNinjaPaginationOutputEntityViolationsOut,
    ApiListPolicyResultsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicyResults({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List policy results grouped by entity
 */
export const useSuspenseApiListPolicyResults = <
  TData = Schemas.SecodaNinjaPaginationOutputEntityViolationsOut,
>(
  variables: ApiListPolicyResultsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SecodaNinjaPaginationOutputEntityViolationsOut,
      ApiListPolicyResultsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/{policyId}/results/",
    operationId: "apiListPolicyResults",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SecodaNinjaPaginationOutputEntityViolationsOut,
    ApiListPolicyResultsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicyResults({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListPolicyRulesPathParams = {
  policyId: string;
};

export type ApiListPolicyRulesQueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListPolicyRulesError = Fetcher.ErrorWrapper<undefined>;

export type ApiListPolicyRulesVariables = {
  pathParams: ApiListPolicyRulesPathParams;
  queryParams?: ApiListPolicyRulesQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List all rules for a specific policy
 */
export const fetchApiListPolicyRules = (
  variables: ApiListPolicyRulesVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedPolicyRuleOut,
    ApiListPolicyRulesError,
    undefined,
    {},
    ApiListPolicyRulesQueryParams,
    ApiListPolicyRulesPathParams
  >({ url: "/policy/{policyId}/rules/", method: "get", ...variables, signal });

export const apiListPolicyRulesQueryKey = (
  variables: ApiListPolicyRulesVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/{policyId}/rules/",
    operationId: "apiListPolicyRules",
    variables,
  });

/**
 * List all rules for a specific policy
 */
export const useApiListPolicyRules = <TData = Schemas.PagedPolicyRuleOut,>(
  variables: ApiListPolicyRulesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedPolicyRuleOut,
      ApiListPolicyRulesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/{policyId}/rules/",
    operationId: "apiListPolicyRules",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedPolicyRuleOut,
    ApiListPolicyRulesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicyRules({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List all rules for a specific policy
 */
export const useSuspenseApiListPolicyRules = <
  TData = Schemas.PagedPolicyRuleOut,
>(
  variables: ApiListPolicyRulesVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedPolicyRuleOut,
      ApiListPolicyRulesError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/{policyId}/rules/",
    operationId: "apiListPolicyRules",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedPolicyRuleOut,
    ApiListPolicyRulesError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListPolicyRules({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreatePolicyRulePathParams = {
  policyId: string;
};

export type ApiCreatePolicyRuleError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreatePolicyRuleVariables = {
  body: Schemas.PolicyRuleIn;
  pathParams: ApiCreatePolicyRulePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Create a new policy rule
 */
export const fetchApiCreatePolicyRule = (
  variables: ApiCreatePolicyRuleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyRuleOut,
    ApiCreatePolicyRuleError,
    Schemas.PolicyRuleIn,
    {},
    {},
    ApiCreatePolicyRulePathParams
  >({ url: "/policy/{policyId}/rules/", method: "post", ...variables, signal });

/**
 * Create a new policy rule
 */
export const useApiCreatePolicyRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyRuleOut,
      ApiCreatePolicyRuleError,
      ApiCreatePolicyRuleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyRuleOut,
    ApiCreatePolicyRuleError,
    ApiCreatePolicyRuleVariables
  >({
    mutationFn: (variables: ApiCreatePolicyRuleVariables) =>
      fetchApiCreatePolicyRule({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPatchPolicyRulePathParams = {
  policyId: string;
  ruleId: string;
};

export type ApiPatchPolicyRuleError = Fetcher.ErrorWrapper<undefined>;

export type ApiPatchPolicyRuleVariables = {
  body: Schemas.PartialPolicyRuleIn;
  pathParams: ApiPatchPolicyRulePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update a specific policy rule
 */
export const fetchApiPatchPolicyRule = (
  variables: ApiPatchPolicyRuleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyRuleOut,
    ApiPatchPolicyRuleError,
    Schemas.PartialPolicyRuleIn,
    {},
    {},
    ApiPatchPolicyRulePathParams
  >({
    url: "/policy/{policyId}/rules/{ruleId}/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Update a specific policy rule
 */
export const useApiPatchPolicyRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyRuleOut,
      ApiPatchPolicyRuleError,
      ApiPatchPolicyRuleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyRuleOut,
    ApiPatchPolicyRuleError,
    ApiPatchPolicyRuleVariables
  >({
    mutationFn: (variables: ApiPatchPolicyRuleVariables) =>
      fetchApiPatchPolicyRule({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDeletePolicyRulePathParams = {
  policyId: string;
  ruleId: string;
};

export type ApiDeletePolicyRuleError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeletePolicyRuleVariables = {
  pathParams: ApiDeletePolicyRulePathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete a specific policy rule
 */
export const fetchApiDeletePolicyRule = (
  variables: ApiDeletePolicyRuleVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeletePolicyRuleError,
    undefined,
    {},
    {},
    ApiDeletePolicyRulePathParams
  >({
    url: "/policy/{policyId}/rules/{ruleId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete a specific policy rule
 */
export const useApiDeletePolicyRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeletePolicyRuleError,
      ApiDeletePolicyRuleVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeletePolicyRuleError,
    ApiDeletePolicyRuleVariables
  >({
    mutationFn: (variables: ApiDeletePolicyRuleVariables) =>
      fetchApiDeletePolicyRule({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListEntityResultsByPolicyPathParams = {
  entityId: string;
};

export type ApiListEntityResultsByPolicyError = Fetcher.ErrorWrapper<undefined>;

export type ApiListEntityResultsByPolicyVariables = {
  pathParams: ApiListEntityResultsByPolicyPathParams;
} & ApiContext["fetcherOptions"];

/**
 * List results for an entity grouped by policy
 */
export const fetchApiListEntityResultsByPolicy = (
  variables: ApiListEntityResultsByPolicyVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityViolationsByPolicyOut,
    ApiListEntityResultsByPolicyError,
    undefined,
    {},
    {},
    ApiListEntityResultsByPolicyPathParams
  >({
    url: "/policy/results/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiListEntityResultsByPolicyQueryKey = (
  variables: ApiListEntityResultsByPolicyVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/results/{entityId}/",
    operationId: "apiListEntityResultsByPolicy",
    variables,
  });

/**
 * List results for an entity grouped by policy
 */
export const useApiListEntityResultsByPolicy = <
  TData = Schemas.EntityViolationsByPolicyOut,
>(
  variables: ApiListEntityResultsByPolicyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EntityViolationsByPolicyOut,
      ApiListEntityResultsByPolicyError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/results/{entityId}/",
    operationId: "apiListEntityResultsByPolicy",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.EntityViolationsByPolicyOut,
    ApiListEntityResultsByPolicyError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListEntityResultsByPolicy(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List results for an entity grouped by policy
 */
export const useSuspenseApiListEntityResultsByPolicy = <
  TData = Schemas.EntityViolationsByPolicyOut,
>(
  variables: ApiListEntityResultsByPolicyVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.EntityViolationsByPolicyOut,
      ApiListEntityResultsByPolicyError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/results/{entityId}/",
    operationId: "apiListEntityResultsByPolicy",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.EntityViolationsByPolicyOut,
    ApiListEntityResultsByPolicyError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListEntityResultsByPolicy(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetPolicyResultPathParams = {
  resultId: string;
};

export type ApiGetPolicyResultError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: {
    [key: string]: any;
  };
}>;

export type ApiGetPolicyResultVariables = {
  pathParams: ApiGetPolicyResultPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a single policy result
 */
export const fetchApiGetPolicyResult = (
  variables: ApiGetPolicyResultVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyViolationOut,
    ApiGetPolicyResultError,
    undefined,
    {},
    {},
    ApiGetPolicyResultPathParams
  >({ url: "/policy/result/{resultId}/", method: "get", ...variables, signal });

export const apiGetPolicyResultQueryKey = (
  variables: ApiGetPolicyResultVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/policy/result/{resultId}/",
    operationId: "apiGetPolicyResult",
    variables,
  });

/**
 * Get a single policy result
 */
export const useApiGetPolicyResult = <TData = Schemas.PolicyViolationOut,>(
  variables: ApiGetPolicyResultVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PolicyViolationOut,
      ApiGetPolicyResultError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/result/{resultId}/",
    operationId: "apiGetPolicyResult",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PolicyViolationOut,
    ApiGetPolicyResultError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicyResult({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a single policy result
 */
export const useSuspenseApiGetPolicyResult = <
  TData = Schemas.PolicyViolationOut,
>(
  variables: ApiGetPolicyResultVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PolicyViolationOut,
      ApiGetPolicyResultError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/policy/result/{resultId}/",
    operationId: "apiGetPolicyResult",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PolicyViolationOut,
    ApiGetPolicyResultError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetPolicyResult({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiIgnorePolicyResultPathParams = {
  resultId: string;
};

export type ApiIgnorePolicyResultError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type ApiIgnorePolicyResultVariables = {
  pathParams: ApiIgnorePolicyResultPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Mark a policy result as ignored
 */
export const fetchApiIgnorePolicyResult = (
  variables: ApiIgnorePolicyResultVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyViolationOut,
    ApiIgnorePolicyResultError,
    undefined,
    {},
    {},
    ApiIgnorePolicyResultPathParams
  >({
    url: "/policy/result/{resultId}/ignore/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Mark a policy result as ignored
 */
export const useApiIgnorePolicyResult = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyViolationOut,
      ApiIgnorePolicyResultError,
      ApiIgnorePolicyResultVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyViolationOut,
    ApiIgnorePolicyResultError,
    ApiIgnorePolicyResultVariables
  >({
    mutationFn: (variables: ApiIgnorePolicyResultVariables) =>
      fetchApiIgnorePolicyResult({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiAcknowledgePolicyResultPathParams = {
  resultId: string;
};

export type ApiAcknowledgePolicyResultError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type ApiAcknowledgePolicyResultVariables = {
  pathParams: ApiAcknowledgePolicyResultPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Mark a policy result as acknowledged
 */
export const fetchApiAcknowledgePolicyResult = (
  variables: ApiAcknowledgePolicyResultVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyViolationOut,
    ApiAcknowledgePolicyResultError,
    undefined,
    {},
    {},
    ApiAcknowledgePolicyResultPathParams
  >({
    url: "/policy/result/{resultId}/acknowledge/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Mark a policy result as acknowledged
 */
export const useApiAcknowledgePolicyResult = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyViolationOut,
      ApiAcknowledgePolicyResultError,
      ApiAcknowledgePolicyResultVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyViolationOut,
    ApiAcknowledgePolicyResultError,
    ApiAcknowledgePolicyResultVariables
  >({
    mutationFn: (variables: ApiAcknowledgePolicyResultVariables) =>
      fetchApiAcknowledgePolicyResult({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiResolvePolicyResultPathParams = {
  resultId: string;
};

export type ApiResolvePolicyResultError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type ApiResolvePolicyResultVariables = {
  pathParams: ApiResolvePolicyResultPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Mark a policy result as resolved
 */
export const fetchApiResolvePolicyResult = (
  variables: ApiResolvePolicyResultVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyViolationOut,
    ApiResolvePolicyResultError,
    undefined,
    {},
    {},
    ApiResolvePolicyResultPathParams
  >({
    url: "/policy/result/{resultId}/resolve/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Mark a policy result as resolved
 */
export const useApiResolvePolicyResult = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyViolationOut,
      ApiResolvePolicyResultError,
      ApiResolvePolicyResultVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyViolationOut,
    ApiResolvePolicyResultError,
    ApiResolvePolicyResultVariables
  >({
    mutationFn: (variables: ApiResolvePolicyResultVariables) =>
      fetchApiResolvePolicyResult({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiReopenPolicyResultPathParams = {
  resultId: string;
};

export type ApiReopenPolicyResultError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: {
        [key: string]: any;
      };
    }
  | {
      status: 404;
      payload: {
        [key: string]: any;
      };
    }
>;

export type ApiReopenPolicyResultVariables = {
  pathParams: ApiReopenPolicyResultPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Reopen a policy result by resetting all status timestamps
 */
export const fetchApiReopenPolicyResult = (
  variables: ApiReopenPolicyResultVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PolicyViolationOut,
    ApiReopenPolicyResultError,
    undefined,
    {},
    {},
    ApiReopenPolicyResultPathParams
  >({
    url: "/policy/result/{resultId}/reopen/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Reopen a policy result by resetting all status timestamps
 */
export const useApiReopenPolicyResult = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PolicyViolationOut,
      ApiReopenPolicyResultError,
      ApiReopenPolicyResultVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.PolicyViolationOut,
    ApiReopenPolicyResultError,
    ApiReopenPolicyResultVariables
  >({
    mutationFn: (variables: ApiReopenPolicyResultVariables) =>
      fetchApiReopenPolicyResult({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiCreateDraftBiMetricError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateDraftBiMetricVariables = ApiContext["fetcherOptions"];

export const fetchApiCreateDraftBiMetric = (
  variables: ApiCreateDraftBiMetricVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiMetricOut,
    ApiCreateDraftBiMetricError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/intelligence/bi_metrics/draft/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCreateDraftBiMetric = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiMetricOut,
      ApiCreateDraftBiMetricError,
      ApiCreateDraftBiMetricVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiMetricOut,
    ApiCreateDraftBiMetricError,
    ApiCreateDraftBiMetricVariables
  >({
    mutationFn: (variables: ApiCreateDraftBiMetricVariables) =>
      fetchApiCreateDraftBiMetric({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetBiMetricPathParams = {
  biMetricId: string;
};

export type ApiGetBiMetricError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetBiMetricVariables = {
  pathParams: ApiGetBiMetricPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetBiMetric = (
  variables: ApiGetBiMetricVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiMetricOut,
    ApiGetBiMetricError,
    undefined,
    {},
    {},
    ApiGetBiMetricPathParams
  >({
    url: "/intelligence/bi_metrics/{biMetricId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetBiMetricQueryKey = (
  variables: ApiGetBiMetricVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/intelligence/bi_metrics/{biMetricId}/",
    operationId: "apiGetBiMetric",
    variables,
  });

export const useApiGetBiMetric = <TData = Schemas.BiMetricOut,>(
  variables: ApiGetBiMetricVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.BiMetricOut, ApiGetBiMetricError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/intelligence/bi_metrics/{biMetricId}/",
    operationId: "apiGetBiMetric",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.BiMetricOut,
    ApiGetBiMetricError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBiMetric({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetBiMetric = <TData = Schemas.BiMetricOut,>(
  variables: ApiGetBiMetricVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.BiMetricOut,
      ApiGetBiMetricError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/intelligence/bi_metrics/{biMetricId}/",
    operationId: "apiGetBiMetric",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.BiMetricOut,
    ApiGetBiMetricError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBiMetric({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateBiMetricPathParams = {
  biMetricId: string;
};

export type ApiUpdateBiMetricError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateBiMetricVariables = {
  body: Schemas.BiMetricUpdateIn;
  pathParams: ApiUpdateBiMetricPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateBiMetric = (
  variables: ApiUpdateBiMetricVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiMetricOut,
    ApiUpdateBiMetricError,
    Schemas.BiMetricUpdateIn,
    {},
    {},
    ApiUpdateBiMetricPathParams
  >({
    url: "/intelligence/bi_metrics/{biMetricId}/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiUpdateBiMetric = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiMetricOut,
      ApiUpdateBiMetricError,
      ApiUpdateBiMetricVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiMetricOut,
    ApiUpdateBiMetricError,
    ApiUpdateBiMetricVariables
  >({
    mutationFn: (variables: ApiUpdateBiMetricVariables) =>
      fetchApiUpdateBiMetric({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDeleteBiMetricPathParams = {
  biMetricId: string;
};

export type ApiDeleteBiMetricError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteBiMetricVariables = {
  pathParams: ApiDeleteBiMetricPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete (archive) a BiMetric by marking its secoda_entity as archived.
 */
export const fetchApiDeleteBiMetric = (
  variables: ApiDeleteBiMetricVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteBiMetricError,
    undefined,
    {},
    {},
    ApiDeleteBiMetricPathParams
  >({
    url: "/intelligence/bi_metrics/{biMetricId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete (archive) a BiMetric by marking its secoda_entity as archived.
 */
export const useApiDeleteBiMetric = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteBiMetricError,
      ApiDeleteBiMetricVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteBiMetricError,
    ApiDeleteBiMetricVariables
  >({
    mutationFn: (variables: ApiDeleteBiMetricVariables) =>
      fetchApiDeleteBiMetric({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPatchBiMetricDashboardsPathParams = {
  biMetricId: string;
};

export type ApiPatchBiMetricDashboardsError = Fetcher.ErrorWrapper<undefined>;

export type ApiPatchBiMetricDashboardsVariables = {
  body: Schemas.BiMetricDashboardsIn;
  pathParams: ApiPatchBiMetricDashboardsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiPatchBiMetricDashboards = (
  variables: ApiPatchBiMetricDashboardsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiMetricOut,
    ApiPatchBiMetricDashboardsError,
    Schemas.BiMetricDashboardsIn,
    {},
    {},
    ApiPatchBiMetricDashboardsPathParams
  >({
    url: "/intelligence/bi_metrics/{biMetricId}/dashboards/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiPatchBiMetricDashboards = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiMetricOut,
      ApiPatchBiMetricDashboardsError,
      ApiPatchBiMetricDashboardsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiMetricOut,
    ApiPatchBiMetricDashboardsError,
    ApiPatchBiMetricDashboardsVariables
  >({
    mutationFn: (variables: ApiPatchBiMetricDashboardsVariables) =>
      fetchApiPatchBiMetricDashboards({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetBiMetricDashboardsPathParams = {
  biMetricId: string;
};

export type ApiGetBiMetricDashboardsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetBiMetricDashboardsResponse = Schemas.BiDashboardOut[];

export type ApiGetBiMetricDashboardsVariables = {
  pathParams: ApiGetBiMetricDashboardsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetBiMetricDashboards = (
  variables: ApiGetBiMetricDashboardsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetBiMetricDashboardsResponse,
    ApiGetBiMetricDashboardsError,
    undefined,
    {},
    {},
    ApiGetBiMetricDashboardsPathParams
  >({
    url: "/intelligence/bi_metrics/{biMetricId}/dashboards/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetBiMetricDashboardsQueryKey = (
  variables: ApiGetBiMetricDashboardsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/intelligence/bi_metrics/{biMetricId}/dashboards/",
    operationId: "apiGetBiMetricDashboards",
    variables,
  });

export const useApiGetBiMetricDashboards = <
  TData = ApiGetBiMetricDashboardsResponse,
>(
  variables: ApiGetBiMetricDashboardsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetBiMetricDashboardsResponse,
      ApiGetBiMetricDashboardsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/intelligence/bi_metrics/{biMetricId}/dashboards/",
    operationId: "apiGetBiMetricDashboards",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetBiMetricDashboardsResponse,
    ApiGetBiMetricDashboardsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBiMetricDashboards(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetBiMetricDashboards = <
  TData = ApiGetBiMetricDashboardsResponse,
>(
  variables: ApiGetBiMetricDashboardsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetBiMetricDashboardsResponse,
      ApiGetBiMetricDashboardsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/intelligence/bi_metrics/{biMetricId}/dashboards/",
    operationId: "apiGetBiMetricDashboards",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetBiMetricDashboardsResponse,
    ApiGetBiMetricDashboardsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBiMetricDashboards(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetBiDashboardPathParams = {
  biDashboardId: string;
};

export type ApiGetBiDashboardError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetBiDashboardVariables = {
  pathParams: ApiGetBiDashboardPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetBiDashboard = (
  variables: ApiGetBiDashboardVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiDashboardOut,
    ApiGetBiDashboardError,
    undefined,
    {},
    {},
    ApiGetBiDashboardPathParams
  >({
    url: "/intelligence/bi_dashboards/{biDashboardId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetBiDashboardQueryKey = (
  variables: ApiGetBiDashboardVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/intelligence/bi_dashboards/{biDashboardId}/",
    operationId: "apiGetBiDashboard",
    variables,
  });

export const useApiGetBiDashboard = <TData = Schemas.BiDashboardOut,>(
  variables: ApiGetBiDashboardVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BiDashboardOut,
      ApiGetBiDashboardError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/intelligence/bi_dashboards/{biDashboardId}/",
    operationId: "apiGetBiDashboard",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.BiDashboardOut,
    ApiGetBiDashboardError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBiDashboard({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetBiDashboard = <TData = Schemas.BiDashboardOut,>(
  variables: ApiGetBiDashboardVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.BiDashboardOut,
      ApiGetBiDashboardError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/intelligence/bi_dashboards/{biDashboardId}/",
    operationId: "apiGetBiDashboard",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.BiDashboardOut,
    ApiGetBiDashboardError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBiDashboard({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateBiDashboardPathParams = {
  biDashboardId: string;
};

export type ApiUpdateBiDashboardError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateBiDashboardVariables = {
  body: Schemas.BiDashboardUpdateIn;
  pathParams: ApiUpdateBiDashboardPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateBiDashboard = (
  variables: ApiUpdateBiDashboardVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiDashboardOut,
    ApiUpdateBiDashboardError,
    Schemas.BiDashboardUpdateIn,
    {},
    {},
    ApiUpdateBiDashboardPathParams
  >({
    url: "/intelligence/bi_dashboards/{biDashboardId}/",
    method: "put",
    ...variables,
    signal,
  });

export const useApiUpdateBiDashboard = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiDashboardOut,
      ApiUpdateBiDashboardError,
      ApiUpdateBiDashboardVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiDashboardOut,
    ApiUpdateBiDashboardError,
    ApiUpdateBiDashboardVariables
  >({
    mutationFn: (variables: ApiUpdateBiDashboardVariables) =>
      fetchApiUpdateBiDashboard({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiCreateBiDashboardError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateBiDashboardVariables = {
  body: Schemas.BiDashboardIn;
} & ApiContext["fetcherOptions"];

export const fetchApiCreateBiDashboard = (
  variables: ApiCreateBiDashboardVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiDashboardOut,
    ApiCreateBiDashboardError,
    Schemas.BiDashboardIn,
    {},
    {},
    {}
  >({
    url: "/intelligence/bi_dashboards/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiCreateBiDashboard = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiDashboardOut,
      ApiCreateBiDashboardError,
      ApiCreateBiDashboardVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiDashboardOut,
    ApiCreateBiDashboardError,
    ApiCreateBiDashboardVariables
  >({
    mutationFn: (variables: ApiCreateBiDashboardVariables) =>
      fetchApiCreateBiDashboard({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiAddBiDashboardMetricsPathParams = {
  biDashboardId: string;
};

export type ApiAddBiDashboardMetricsError = Fetcher.ErrorWrapper<undefined>;

export type ApiAddBiDashboardMetricsVariables = {
  body: Schemas.BiDashboardMetricsIn;
  pathParams: ApiAddBiDashboardMetricsPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiAddBiDashboardMetrics = (
  variables: ApiAddBiDashboardMetricsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiDashboardOut,
    ApiAddBiDashboardMetricsError,
    Schemas.BiDashboardMetricsIn,
    {},
    {},
    ApiAddBiDashboardMetricsPathParams
  >({
    url: "/intelligence/bi_dashboards/{biDashboardId}/metrics/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiAddBiDashboardMetrics = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiDashboardOut,
      ApiAddBiDashboardMetricsError,
      ApiAddBiDashboardMetricsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiDashboardOut,
    ApiAddBiDashboardMetricsError,
    ApiAddBiDashboardMetricsVariables
  >({
    mutationFn: (variables: ApiAddBiDashboardMetricsVariables) =>
      fetchApiAddBiDashboardMetrics({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRemoveBiDashboardMetricPathParams = {
  biDashboardId: string;
  biMetricId: string;
};

export type ApiRemoveBiDashboardMetricError = Fetcher.ErrorWrapper<undefined>;

export type ApiRemoveBiDashboardMetricVariables = {
  pathParams: ApiRemoveBiDashboardMetricPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRemoveBiDashboardMetric = (
  variables: ApiRemoveBiDashboardMetricVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiDashboardOut,
    ApiRemoveBiDashboardMetricError,
    undefined,
    {},
    {},
    ApiRemoveBiDashboardMetricPathParams
  >({
    url: "/intelligence/bi_dashboards/{biDashboardId}/metrics/{biMetricId}/",
    method: "delete",
    ...variables,
    signal,
  });

export const useApiRemoveBiDashboardMetric = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiDashboardOut,
      ApiRemoveBiDashboardMetricError,
      ApiRemoveBiDashboardMetricVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiDashboardOut,
    ApiRemoveBiDashboardMetricError,
    ApiRemoveBiDashboardMetricVariables
  >({
    mutationFn: (variables: ApiRemoveBiDashboardMetricVariables) =>
      fetchApiRemoveBiDashboardMetric({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetBiMetricVersionPathParams = {
  biMetricVersionId: string;
};

export type ApiGetBiMetricVersionError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetBiMetricVersionVariables = {
  pathParams: ApiGetBiMetricVersionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetBiMetricVersion = (
  variables: ApiGetBiMetricVersionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiMetricVersionOut,
    ApiGetBiMetricVersionError,
    undefined,
    {},
    {},
    ApiGetBiMetricVersionPathParams
  >({
    url: "/intelligence/bi_metric_versions/{biMetricVersionId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetBiMetricVersionQueryKey = (
  variables: ApiGetBiMetricVersionVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/intelligence/bi_metric_versions/{biMetricVersionId}/",
    operationId: "apiGetBiMetricVersion",
    variables,
  });

export const useApiGetBiMetricVersion = <TData = Schemas.BiMetricVersionOut,>(
  variables: ApiGetBiMetricVersionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BiMetricVersionOut,
      ApiGetBiMetricVersionError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/intelligence/bi_metric_versions/{biMetricVersionId}/",
    operationId: "apiGetBiMetricVersion",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.BiMetricVersionOut,
    ApiGetBiMetricVersionError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBiMetricVersion({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetBiMetricVersion = <
  TData = Schemas.BiMetricVersionOut,
>(
  variables: ApiGetBiMetricVersionVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.BiMetricVersionOut,
      ApiGetBiMetricVersionError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/intelligence/bi_metric_versions/{biMetricVersionId}/",
    operationId: "apiGetBiMetricVersion",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.BiMetricVersionOut,
    ApiGetBiMetricVersionError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetBiMetricVersion({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiResetSqlPlaygroundPathParams = {
  biMetricVersionId: string;
};

export type ApiResetSqlPlaygroundError = Fetcher.ErrorWrapper<undefined>;

export type ApiResetSqlPlaygroundVariables = {
  pathParams: ApiResetSqlPlaygroundPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiResetSqlPlayground = (
  variables: ApiResetSqlPlaygroundVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiMetricVersionOut,
    ApiResetSqlPlaygroundError,
    undefined,
    {},
    {},
    ApiResetSqlPlaygroundPathParams
  >({
    url: "/intelligence/bi_metric_versions/{biMetricVersionId}/reset-sql-playground/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiResetSqlPlayground = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiMetricVersionOut,
      ApiResetSqlPlaygroundError,
      ApiResetSqlPlaygroundVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiMetricVersionOut,
    ApiResetSqlPlaygroundError,
    ApiResetSqlPlaygroundVariables
  >({
    mutationFn: (variables: ApiResetSqlPlaygroundVariables) =>
      fetchApiResetSqlPlayground({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiRefreshBiMetricVersionPathParams = {
  biMetricVersionId: string;
};

export type ApiRefreshBiMetricVersionError = Fetcher.ErrorWrapper<undefined>;

export type ApiRefreshBiMetricVersionVariables = {
  pathParams: ApiRefreshBiMetricVersionPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiRefreshBiMetricVersion = (
  variables: ApiRefreshBiMetricVersionVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BiMetricVersionOut,
    ApiRefreshBiMetricVersionError,
    undefined,
    {},
    {},
    ApiRefreshBiMetricVersionPathParams
  >({
    url: "/intelligence/bi_metric_versions/{biMetricVersionId}/refresh/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiRefreshBiMetricVersion = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BiMetricVersionOut,
      ApiRefreshBiMetricVersionError,
      ApiRefreshBiMetricVersionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BiMetricVersionOut,
    ApiRefreshBiMetricVersionError,
    ApiRefreshBiMetricVersionVariables
  >({
    mutationFn: (variables: ApiRefreshBiMetricVersionVariables) =>
      fetchApiRefreshBiMetricVersion({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type QueryOperation =
  | {
      path: "/resource/all/{entityId}/permissions_v2/grouped_permissions/";
      operationId: "apiGetEntityGroupedPermissions";
      variables: ApiGetEntityGroupedPermissionsVariables;
    }
  | {
      path: "/resource/all/{entityId}/permissions_v2/has_custom/";
      operationId: "apiEntityHasCustomPermissions";
      variables: ApiEntityHasCustomPermissionsVariables;
    }
  | {
      path: "/resource/{entityId}/access_control/roles/";
      operationId: "getEntityAccessControlRoles";
      variables: GetEntityAccessControlRolesVariables;
    }
  | {
      path: "/resource/{entityId}/access_control/roles/{roleId}/";
      operationId: "getEntityAccessControlRole";
      variables: GetEntityAccessControlRoleVariables;
    }
  | {
      path: "/resource/preview_v2/table/{entityId}/";
      operationId: "apiGetTablePreview";
      variables: ApiGetTablePreviewVariables;
    }
  | {
      path: "/resource/preview_v2/url/{entityId}/";
      operationId: "apiGetUrlPreview";
      variables: ApiGetUrlPreviewVariables;
    }
  | {
      path: "/resource/all_v2/{entityId}/stakeholders/";
      operationId: "apiGetEntityStakeholders";
      variables: ApiGetEntityStakeholdersVariables;
    }
  | {
      path: "/resource/all_v2/entity/{entityId}/";
      operationId: "apiGetResourcePossibleArchived";
      variables: ApiGetResourcePossibleArchivedVariables;
    }
  | {
      path: "/resource/all_v2/monitor_preview/{monitorId}/";
      operationId: "apiGetMonitorPossibleStaled";
      variables: ApiGetMonitorPossibleStaledVariables;
    }
  | {
      path: "/resource/all_v2/user_queries/{entityId}/";
      operationId: "apiGetPopularityUserQueries";
      variables: ApiGetPopularityUserQueriesVariables;
    }
  | {
      path: "/resource/all_v2/custom_properties/";
      operationId: "listCustomProperties";
      variables: ListCustomPropertiesVariables;
    }
  | {
      path: "/resource/all_v2/custom_properties/{customPropertyId}/";
      operationId: "getCustomProperty";
      variables: GetCustomPropertyVariables;
    }
  | {
      path: "/resource/all_v2/async_export_csv/";
      operationId: "apiExportCatalogCsv";
      variables: ApiExportCatalogCsvVariables;
    }
  | {
      path: "/resource/all_v2/async_export_entity/{entityId}/";
      operationId: "apiExportEntity";
      variables: ApiExportEntityVariables;
    }
  | {
      path: "/resource/all_v2/inferred_tables_datatree/";
      operationId: "apiGetInferredTablesDatatree";
      variables: ApiGetInferredTablesDatatreeVariables;
    }
  | {
      path: "/resource/all_v2/bottom_up_catalog_tree_integrations/";
      operationId: "apiGetBottomUpCatalogTreeIntegrations";
      variables: ApiGetBottomUpCatalogTreeIntegrationsVariables;
    }
  | {
      path: "/resource/all_v2/bottom_up_datatree/";
      operationId: "apiGetBottomUpDatatree";
      variables: ApiGetBottomUpDatatreeVariables;
    }
  | {
      path: "/resource/all_v2/entity_counts/";
      operationId: "apiGetEntityCounts";
      variables: ApiGetEntityCountsVariables;
    }
  | {
      path: "/resource/all_v2/inherited_teams/";
      operationId: "apiGetEntityTeams";
      variables: ApiGetEntityTeamsVariables;
    }
  | {
      path: "/resource/breadcrumbs/{entityId}/team/";
      operationId: "apiGetBreadcrumbTeam";
      variables: ApiGetBreadcrumbTeamVariables;
    }
  | {
      path: "/s3_postgres/presign_download/";
      operationId: "apiGetPresignedDownload";
      variables: ApiGetPresignedDownloadVariables;
    }
  | {
      path: "/public/env/";
      operationId: "apiPublicEnv";
      variables: ApiPublicEnvVariables;
    }
  | {
      path: "/member/env/";
      operationId: "apiMemberEnv";
      variables: ApiMemberEnvVariables;
    }
  | {
      path: "/admin/background_job/";
      operationId: "apiGetBackgroundJob";
      variables: ApiGetBackgroundJobVariables;
    }
  | {
      path: "/admin/common/workspaces/";
      operationId: "apiSuperuserGetWorkspace";
      variables: ApiSuperuserGetWorkspaceVariables;
    }
  | {
      path: "/admin/common/integrations/";
      operationId: "apiSuperuserGetIntegration";
      variables: ApiSuperuserGetIntegrationVariables;
    }
  | {
      path: "/admin/common/users/";
      operationId: "apiSuperuserGetUsers";
      variables: ApiSuperuserGetUsersVariables;
    }
  | {
      path: "/admin/compute-cost/metrics/";
      operationId: "apiGetComputeCostMetrics";
      variables: ApiGetComputeCostMetricsVariables;
    }
  | {
      path: "/admin/compute-cost/timeseries/";
      operationId: "apiGetComputeCostTimeseries";
      variables: ApiGetComputeCostTimeseriesVariables;
    }
  | {
      path: "/admin/github/latest_git_info/";
      operationId: "getLatestGitInfo";
      variables: GetLatestGitInfoVariables;
    }
  | {
      path: "/admin/github/commit_info/{databuilderJobId}/";
      operationId: "getCommitInfo";
      variables: GetCommitInfoVariables;
    }
  | {
      path: "/admin/inspect_api/{integrationId}/";
      operationId: "apiGetIntegrationApiSpec";
      variables: ApiGetIntegrationApiSpecVariables;
    }
  | {
      path: "/admin/inspect_celery/worker/";
      operationId: "apiGetCeleryWorkers";
      variables: ApiGetCeleryWorkersVariables;
    }
  | {
      path: "/admin/inspect_celery/queue/";
      operationId: "apiGetCeleryQueues";
      variables: ApiGetCeleryQueuesVariables;
    }
  | {
      path: "/admin/inspect_celery/task/";
      operationId: "apiGetCeleryTasks";
      variables: ApiGetCeleryTasksVariables;
    }
  | {
      path: "/admin/metric/internal_database_objects/";
      operationId: "getDatabaseObjects";
      variables: GetDatabaseObjectsVariables;
    }
  | {
      path: "/admin/internal_integration_status/status/";
      operationId: "apiGetInternalIntegrationStatus";
      variables: ApiGetInternalIntegrationStatusVariables;
    }
  | {
      path: "/admin/internal_integration_status/aws_batch_job/{awsBatchJobId}/";
      operationId: "getAwsBatchJobDetail";
      variables: GetAwsBatchJobDetailVariables;
    }
  | {
      path: "/admin/internal_integration_status/in_trial_workspaces/";
      operationId: "getInTrialWorkspaces";
      variables: GetInTrialWorkspacesVariables;
    }
  | {
      path: "/admin/internal_integration_status/debug/{databuilderJobId}/";
      operationId: "getDebugLogs";
      variables: GetDebugLogsVariables;
    }
  | {
      path: "/admin/internal_integration_status/debug/{databuilderJobId}/{index}/";
      operationId: "getDebugLog";
      variables: GetDebugLogVariables;
    }
  | {
      path: "/admin/internal_query_actions/is_superadmin/";
      operationId: "isSuperadmin";
      variables: IsSuperadminVariables;
    }
  | {
      path: "/admin/internal_query_actions/download_s3_file/";
      operationId: "adminDownloadS3File";
      variables: AdminDownloadS3FileVariables;
    }
  | {
      path: "/admin/internal_query_actions/inspect_cache/{cacheKey}/";
      operationId: "inspectCache";
      variables: InspectCacheVariables;
    }
  | {
      path: "/admin/linear/get_linear_tickets/{title}/";
      operationId: "getLinearTickets";
      variables: GetLinearTicketsVariables;
    }
  | {
      path: "/admin/entity_lineage/lineage_graph/";
      operationId: "getEntityLineageGraph";
      variables: GetEntityLineageGraphVariables;
    }
  | {
      path: "/admin/entity_lineage/lineage_debug_info/{lineageId}/";
      operationId: "getLineageDebugInfo";
      variables: GetLineageDebugInfoVariables;
    }
  | {
      path: "/admin/ai_chats/chat/{promptId}/";
      operationId: "apiSuperuserGetAiChat";
      variables: ApiSuperuserGetAiChatVariables;
    }
  | {
      path: "/admin/ai_chats/for_user/{userId}/";
      operationId: "apiSuperuserGetAiChatsForUser";
      variables: ApiSuperuserGetAiChatsForUserVariables;
    }
  | {
      path: "/admin/automations/";
      operationId: "apiAdminGetRunningAutomations";
      variables: ApiAdminGetRunningAutomationsVariables;
    }
  | {
      path: "/admin/workspace_flags/{workspaceId}/";
      operationId: "getWorkspaceFlags";
      variables: GetWorkspaceFlagsVariables;
    }
  | {
      path: "/admin/workspace_memory/{workspaceId}/";
      operationId: "getWorkspaceMemory";
      variables: GetWorkspaceMemoryVariables;
    }
  | {
      path: "/admin/workspace_memory/{workspaceId}/condense/preview/{jobId}/";
      operationId: "getCondensedWorkspaceMemoryPreview";
      variables: GetCondensedWorkspaceMemoryPreviewVariables;
    }
  | {
      path: "/collection/collections/{entityId}/entities_count/";
      operationId: "apiGetCollectionEntitiesCount";
      variables: ApiGetCollectionEntitiesCountVariables;
    }
  | {
      path: "/search/v2/meta/";
      operationId: "getSearchMeta";
      variables: GetSearchMetaVariables;
    }
  | {
      path: "/search/v2/autocomplete/";
      operationId: "autocomplete";
      variables: AutocompleteVariables;
    }
  | {
      path: "/search/v2/suggestions/";
      operationId: "suggestions";
      variables: SuggestionsVariables;
    }
  | {
      path: "/search/v2/filters/entity_type/";
      operationId: "getSearchFiltersEntityType";
      variables: GetSearchFiltersEntityTypeVariables;
    }
  | {
      path: "/auth/teams/";
      operationId: "apiListTeamsV1";
      variables: ApiListTeamsV1Variables;
    }
  | {
      path: "/auth/teams/{teamId}/";
      operationId: "apiGetTeam";
      variables: ApiGetTeamVariables;
    }
  | {
      path: "/auth/teams/{teamId}/empty_state/";
      operationId: "apiGetTeamEmptyState";
      variables: ApiGetTeamEmptyStateVariables;
    }
  | {
      path: "/auth/teams/{teamId}/my_memberships/";
      operationId: "apiGetMyMemberships";
      variables: ApiGetMyMembershipsVariables;
    }
  | {
      path: "/auth/teams/{teamId}/users/";
      operationId: "apiGetTeamListUsers";
      variables: ApiGetTeamListUsersVariables;
    }
  | {
      path: "/auth/teams/{teamId}/memberships/";
      operationId: "apiListMemberships";
      variables: ApiListMembershipsVariables;
    }
  | {
      path: "/auth/api_keys/";
      operationId: "apiListApiKeysV1";
      variables: ApiListApiKeysV1Variables;
    }
  | {
      path: "/auth/domain/allowed_domains/";
      operationId: "apiListAllowedDomains";
      variables: ApiListAllowedDomainsVariables;
    }
  | {
      path: "/auth/saml/v2/";
      operationId: "apiListSamlConfigurations";
      variables: ApiListSamlConfigurationsVariables;
    }
  | {
      path: "/auth/saml/v2/{samlConfigId}/";
      operationId: "apiRetrieveSamlConfiguration";
      variables: ApiRetrieveSamlConfigurationVariables;
    }
  | {
      path: "/workspace/feature_access/v2/";
      operationId: "getWorkspaceFeatureAccess";
      variables: GetWorkspaceFeatureAccessVariables;
    }
  | {
      path: "/workspace/feature_access/v2/ai-balance/";
      operationId: "getRunningTotalAiTokenCost";
      variables: GetRunningTotalAiTokenCostVariables;
    }
  | {
      path: "/workspace/feature_access/v2/ai-auto-topup/";
      operationId: "getAiTokenAutoTopupSettings";
      variables: GetAiTokenAutoTopupSettingsVariables;
    }
  | {
      path: "/workspace/feature_access/v2/ai-credits/";
      operationId: "getAiTokenCredits";
      variables: GetAiTokenCreditsVariables;
    }
  | {
      path: "/workspace/feature_access/v2/card-details/";
      operationId: "getWorkspaceCardDetails";
      variables: GetWorkspaceCardDetailsVariables;
    }
  | {
      path: "/workspace/feature_access/v2/subscription-details/";
      operationId: "getWorkspaceSubscriptionDetails";
      variables: GetWorkspaceSubscriptionDetailsVariables;
    }
  | {
      path: "/workspace/feature_access/v2/budget/";
      operationId: "getWorkspaceBudgetSettings";
      variables: GetWorkspaceBudgetSettingsVariables;
    }
  | {
      path: "/workspace/feature_access/v2/ai-access-status/";
      operationId: "getAiAccessStatus";
      variables: GetAiAccessStatusVariables;
    }
  | {
      path: "/user/group/{groupId}/";
      operationId: "apiGetGroup";
      variables: ApiGetGroupVariables;
    }
  | {
      path: "/auth/preferences/";
      operationId: "apiGetPreferences";
      variables: ApiGetPreferencesVariables;
    }
  | {
      path: "/workspace/seats/used/";
      operationId: "getUsedWorkspaceSeats";
      variables: GetUsedWorkspaceSeatsVariables;
    }
  | {
      path: "/workspace/seats/limits/";
      operationId: "apiGetWorkspaceLimits";
      variables: ApiGetWorkspaceLimitsVariables;
    }
  | {
      path: "/auth/methods/allowed-auth-methods/";
      operationId: "apiGetAllowedAuthMethods";
      variables: ApiGetAllowedAuthMethodsVariables;
    }
  | {
      path: "/table/columns_v2/types/";
      operationId: "apiGetColumnTypes";
      variables: ApiGetColumnTypesVariables;
    }
  | {
      path: "/table/columns_v2/pii_word_list/";
      operationId: "apiGetPiiWordList";
      variables: ApiGetPiiWordListVariables;
    }
  | {
      path: "/table/columns_v2/pii/";
      operationId: "apiGetPiiColumns";
      variables: ApiGetPiiColumnsVariables;
    }
  | {
      path: "/integration_v2/integrations/{integrationId}/group_items/";
      operationId: "apiGetIntegrationGroupItems";
      variables: ApiGetIntegrationGroupItemsVariables;
    }
  | {
      path: "/integration_v2/integrations/group_items/refresh_support/";
      operationId: "apiGroupItemsRefreshSupport";
      variables: ApiGroupItemsRefreshSupportVariables;
    }
  | {
      path: "/integration_v2/integrations/lineage/node-specs/";
      operationId: "apiGetIntegrationLineageSpecs";
      variables: ApiGetIntegrationLineageSpecsVariables;
    }
  | {
      path: "/integration_v2/integrations/{integrationId}/has-preview-access/";
      operationId: "apiHasPreviewAccess";
      variables: ApiHasPreviewAccessVariables;
    }
  | {
      path: "/integration_v2/integrations/catalogtree/list/";
      operationId: "apiGetCatalogTreeIntegrations";
      variables: ApiGetCatalogTreeIntegrationsVariables;
    }
  | {
      path: "/integration_v2/integrations/{integrationId}/aggregate-entity-keys/";
      operationId: "apiAggregateEntityKeysForIntegration";
      variables: ApiAggregateEntityKeysForIntegrationVariables;
    }
  | {
      path: "/integration_v2/integrations/{integrationId}/query-execute-access/";
      operationId: "apiGetIntegrationQueryExecuteAccess";
      variables: ApiGetIntegrationQueryExecuteAccessVariables;
    }
  | {
      path: "/integration_v2/integrations/{integrationId}/user-credentials/";
      operationId: "apiGetIntegrationUserCredentials";
      variables: ApiGetIntegrationUserCredentialsVariables;
    }
  | {
      path: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/initiate/";
      operationId: "apiInitiateIntegrationOauth";
      variables: ApiInitiateIntegrationOauthVariables;
    }
  | {
      path: "/integration_v2/integrations/{integrationType}/oauth/callback/";
      operationId: "apiIntegrationOauthCallback";
      variables: ApiIntegrationOauthCallbackVariables;
    }
  | {
      path: "/integration_v2/integrations/{integrationId}/{integrationType}/oauth/status/";
      operationId: "apiIntegrationOauthStatus";
      variables: ApiIntegrationOauthStatusVariables;
    }
  | {
      path: "/integration_v2/slack/channel/oauth-scopes/";
      operationId: "checkSlackOauthScopes";
      variables: CheckSlackOauthScopesVariables;
    }
  | {
      path: "/integration_v2/slack/channel/conversations/";
      operationId: "getSlackConversations";
      variables: GetSlackConversationsVariables;
    }
  | {
      path: "/integration_v2/slack/channel/conversation/{channelId}/";
      operationId: "getSlackConversationFromId";
      variables: GetSlackConversationFromIdVariables;
    }
  | {
      path: "/integration_v2/slack/channel/";
      operationId: "getSlackChannels";
      variables: GetSlackChannelsVariables;
    }
  | {
      path: "/integration_v2/data-access-management/{integrationId}/roles/";
      operationId: "apiIntegrationShowRoles";
      variables: ApiIntegrationShowRolesVariables;
    }
  | {
      path: "/integration_v2/data-access-management/{integrationId}/users/";
      operationId: "apiIntegrationShowUsers";
      variables: ApiIntegrationShowUsersVariables;
    }
  | {
      path: "/integration_v2/data-access-management/{integrationId}/user-roles/";
      operationId: "apiIntegrationShowGrantsToSingleUser";
      variables: ApiIntegrationShowGrantsToSingleUserVariables;
    }
  | {
      path: "/integration_v2/data-access-management/{integrationId}/roles-with-privilege/";
      operationId: "apiIntegrationShowGrantsToRoleForResource";
      variables: ApiIntegrationShowGrantsToRoleForResourceVariables;
    }
  | {
      path: "/integration_v2/data-access-requests/";
      operationId: "listAccessRequests";
      variables: ListAccessRequestsVariables;
    }
  | {
      path: "/integration_v2/data-access-requests/pending-count/";
      operationId: "countPendingRequests";
      variables: CountPendingRequestsVariables;
    }
  | {
      path: "/integration_v2/data-access-requests/{requestId}/";
      operationId: "getAccessRequest";
      variables: GetAccessRequestVariables;
    }
  | {
      path: "/integration_v2/data-access/metrics/metrics/";
      operationId: "apiGetDataAccessRequestMetrics";
      variables: ApiGetDataAccessRequestMetricsVariables;
    }
  | {
      path: "/integration_v2/data-access/metrics/timeseries/";
      operationId: "apiGetDataAccessRequestTimeseries";
      variables: ApiGetDataAccessRequestTimeseriesVariables;
    }
  | {
      path: "/integration_v2/metrics/timeseries/";
      operationId: "apiGetIntegrationTimeseries";
      variables: ApiGetIntegrationTimeseriesVariables;
    }
  | {
      path: "/integration_v2/glean-preferences/included/";
      operationId: "apiGetIncludedFilters";
      variables: ApiGetIncludedFiltersVariables;
    }
  | {
      path: "/integration/dbt/{integrationId}/failing_tests/";
      operationId: "apiGetFailingTests";
      variables: ApiGetFailingTestsVariables;
    }
  | {
      path: "/integration/github/{integrationId}/pull-requests/{pullRequestId}/";
      operationId: "apiGithubPullRequest";
      variables: ApiGithubPullRequestVariables;
    }
  | {
      path: "/integration/github/{integrationId}/pull-requests/";
      operationId: "apiGithubPullRequests";
      variables: ApiGithubPullRequestsVariables;
    }
  | {
      path: "/question/metrics/metrics/";
      operationId: "apiGetQuestionMetrics";
      variables: ApiGetQuestionMetricsVariables;
    }
  | {
      path: "/question/metrics/timeseries/";
      operationId: "apiGetQuestionTimeseries";
      variables: ApiGetQuestionTimeseriesVariables;
    }
  | {
      path: "/lineage/flow/";
      operationId: "apiGetLineageFlow";
      variables: ApiGetLineageFlowVariables;
    }
  | {
      path: "/lineage/flow/v2/";
      operationId: "apiGetLineageFlowV2";
      variables: ApiGetLineageFlowV2Variables;
    }
  | {
      path: "/lineage/flow/multiple/";
      operationId: "apiGetMultipleLineageFlow";
      variables: ApiGetMultipleLineageFlowVariables;
    }
  | {
      path: "/lineage/flow/multiple/v2/";
      operationId: "apiGetMultipleLineageFlowV2";
      variables: ApiGetMultipleLineageFlowV2Variables;
    }
  | {
      path: "/lineage/flow/children/";
      operationId: "apiGetLineageFlowChildren";
      variables: ApiGetLineageFlowChildrenVariables;
    }
  | {
      path: "/lineage/flow/impacted-children/";
      operationId: "apiGetLineageFlowImpactedChildren";
      variables: ApiGetLineageFlowImpactedChildrenVariables;
    }
  | {
      path: "/lineage/flow/query/{queryId}/dag/";
      operationId: "apiGetLineageFlowQueryDag";
      variables: ApiGetLineageFlowQueryDagVariables;
    }
  | {
      path: "/lineage/has_lineage/";
      operationId: "apiEntityHasLineage";
      variables: ApiEntityHasLineageVariables;
    }
  | {
      path: "/lineage/";
      operationId: "apiListLineage";
      variables: ApiListLineageVariables;
    }
  | {
      path: "/lineage/impacted/{fromId}/ids/";
      operationId: "apiRetrieveImpactedIds";
      variables: ApiRetrieveImpactedIdsVariables;
    }
  | {
      path: "/lineage/impacted/{fromId}/paths/";
      operationId: "apiRetrieveImpactedPaths";
      variables: ApiRetrieveImpactedPathsVariables;
    }
  | {
      path: "/lineage/impacted/{fromId}/csv/";
      operationId: "apiExportImpactedCsv";
      variables: ApiExportImpactedCsvVariables;
    }
  | {
      path: "/lineage/relations/";
      operationId: "apiListResourceRelations";
      variables: ApiListResourceRelationsVariables;
    }
  | {
      path: "/lineage/relations/{relationId}/";
      operationId: "apiRetrieveResourceRelation";
      variables: ApiRetrieveResourceRelationVariables;
    }
  | {
      path: "/lineage/manual/";
      operationId: "apiListManualLineages";
      variables: ApiListManualLineagesVariables;
    }
  | {
      path: "/lineage/lineage_from_query/";
      operationId: "apiGetLineageFromQuery";
      variables: ApiGetLineageFromQueryVariables;
    }
  | {
      path: "/lineage/manual/{lineageId}/";
      operationId: "apiRetrieveManualLineage";
      variables: ApiRetrieveManualLineageVariables;
    }
  | {
      path: "/lineage/{lineageId}/";
      operationId: "apiRetrieveLineage";
      variables: ApiRetrieveLineageVariables;
    }
  | {
      path: "/erd_flow/{tableId}/";
      operationId: "apiGetErdFlow";
      variables: ApiGetErdFlowVariables;
    }
  | {
      path: "/report/{reportId}/create_csvs/";
      operationId: "createCsvs";
      variables: CreateCsvsVariables;
    }
  | {
      path: "/ai/embedded_prompt/";
      operationId: "listPrompts";
      variables: ListPromptsVariables;
    }
  | {
      path: "/ai/embedded_prompt/feedback/";
      operationId: "workspaceAiFeedback";
      variables: WorkspaceAiFeedbackVariables;
    }
  | {
      path: "/ai/embedded_prompt/workspace/";
      operationId: "listWorkspacePrompts";
      variables: ListWorkspacePromptsVariables;
    }
  | {
      path: "/ai/embedded_prompt/{promptId}/";
      operationId: "retrievePrompt";
      variables: RetrievePromptVariables;
    }
  | {
      path: "/ai/embedded_prompt/{promptId}/referenced-objects/";
      operationId: "apiListReferencedObjects";
      variables: ApiListReferencedObjectsVariables;
    }
  | {
      path: "/ai/embedded_prompt/{promptId}/referenced-objects/{objectId}/";
      operationId: "apiRetrieveReferencedObjectDetail";
      variables: ApiRetrieveReferencedObjectDetailVariables;
    }
  | {
      path: "/ai/preferences/instructions/";
      operationId: "getCustomInstructions";
      variables: GetCustomInstructionsVariables;
    }
  | {
      path: "/ai/preferences/descriptions/";
      operationId: "getCustomDescriptionStyle";
      variables: GetCustomDescriptionStyleVariables;
    }
  | {
      path: "/ai/preferences/model/";
      operationId: "getAiCustomModel";
      variables: GetAiCustomModelVariables;
    }
  | {
      path: "/ai/preferences/privacy/";
      operationId: "getAiPrivacySettings";
      variables: GetAiPrivacySettingsVariables;
    }
  | {
      path: "/ai/preferences/intelligent-llm/";
      operationId: "getIntelligentLlmProvider";
      variables: GetIntelligentLlmProviderVariables;
    }
  | {
      path: "/ai/preferences/efficient-llm/";
      operationId: "getEfficientLlmProvider";
      variables: GetEfficientLlmProviderVariables;
    }
  | {
      path: "/ai/preferences/automation-llm/";
      operationId: "getAutomationLlmProvider";
      variables: GetAutomationLlmProviderVariables;
    }
  | {
      path: "/ai/personas/";
      operationId: "getPersonas";
      variables: GetPersonasVariables;
    }
  | {
      path: "/ai/personas/{personaId}/";
      operationId: "getPersona";
      variables: GetPersonaVariables;
    }
  | {
      path: "/ai/personas/{personaId}/included_filters/";
      operationId: "getIncludedFilters";
      variables: GetIncludedFiltersVariables;
    }
  | {
      path: "/ai/personas/{personaId}/excluded_filters/";
      operationId: "getExcludedFilters";
      variables: GetExcludedFiltersVariables;
    }
  | {
      path: "/ai/personas/{personaId}/run_sql_included_filters/";
      operationId: "getRunSqlIncludedFilters";
      variables: GetRunSqlIncludedFiltersVariables;
    }
  | {
      path: "/ai/personas/{personaId}/run_sql_excluded_filters/";
      operationId: "getRunSqlExcludedFilters";
      variables: GetRunSqlExcludedFiltersVariables;
    }
  | {
      path: "/ai/personas/{personaId}/tools/";
      operationId: "getPersonaAgentTools";
      variables: GetPersonaAgentToolsVariables;
    }
  | {
      path: "/ai/file/presign_upload/";
      operationId: "presignUpload";
      variables: PresignUploadVariables;
    }
  | {
      path: "/ai/file/presign_download/";
      operationId: "presignDownload";
      variables: PresignDownloadVariables;
    }
  | {
      path: "/ai/memory/";
      operationId: "getMemories";
      variables: GetMemoriesVariables;
    }
  | {
      path: "/ai/billing/usage/";
      operationId: "getAiUsageStats";
      variables: GetAiUsageStatsVariables;
    }
  | {
      path: "/ai/prompt_completions/";
      operationId: "apiGetPromptCompletions";
      variables: ApiGetPromptCompletionsVariables;
    }
  | {
      path: "/ai/prompt_completions/general/";
      operationId: "apiGetGeneralPromptExamples";
      variables: ApiGetGeneralPromptExamplesVariables;
    }
  | {
      path: "/ai/charts/presign_download/";
      operationId: "chartPresignDownload";
      variables: ChartPresignDownloadVariables;
    }
  | {
      path: "/ai/artifacts/presign_download/";
      operationId: "artifactPresignDownload";
      variables: ArtifactPresignDownloadVariables;
    }
  | {
      path: "/ai/mcp/tools/list/";
      operationId: "mcpListTools";
      variables: McpListToolsVariables;
    }
  | {
      path: "/ai/proposals/proposals_generation/get_by_identifier/";
      operationId: "apiGetProposalsGenerationResult";
      variables: ApiGetProposalsGenerationResultVariables;
    }
  | {
      path: "/ai/proposals/{proposalId}/";
      operationId: "apiGetProposal";
      variables: ApiGetProposalVariables;
    }
  | {
      path: "/ai/proposals/by_group/{proposalGroup}/";
      operationId: "apiGetProposalsByGroup";
      variables: ApiGetProposalsByGroupVariables;
    }
  | {
      path: "/ai/token-usage/metrics/";
      operationId: "apiGetAiTokenUsageMetrics";
      variables: ApiGetAiTokenUsageMetricsVariables;
    }
  | {
      path: "/ai/token-usage/timeseries/";
      operationId: "apiGetAiTokenUsageTimeseries";
      variables: ApiGetAiTokenUsageTimeseriesVariables;
    }
  | {
      path: "/ai/chat-usage/metrics/";
      operationId: "apiGetAiChatMetrics";
      variables: ApiGetAiChatMetricsVariables;
    }
  | {
      path: "/ai/chat-usage/timeseries/";
      operationId: "apiGetAiChatTimeseries";
      variables: ApiGetAiChatTimeseriesVariables;
    }
  | {
      path: "/ai/chat-usage/list/";
      operationId: "apiGetAiChatList";
      variables: ApiGetAiChatListVariables;
    }
  | {
      path: "/ai/chat-usage/detailed-list/";
      operationId: "apiGetAiChatDetailedList";
      variables: ApiGetAiChatDetailedListVariables;
    }
  | {
      path: "/ai/chat-usage/rated-messages/";
      operationId: "apiGetAiChatRatedMessages";
      variables: ApiGetAiChatRatedMessagesVariables;
    }
  | {
      path: "/ai/chat-usage/prompts-by-member/";
      operationId: "apiGetAiPromptsByMemberList";
      variables: ApiGetAiPromptsByMemberListVariables;
    }
  | {
      path: "/ai/chat-usage/export/";
      operationId: "apiExportAiChatCsv";
      variables: ApiExportAiChatCsvVariables;
    }
  | {
      path: "/ai/time-savings/timeseries/";
      operationId: "apiGetAiTimeSavingsTimeseries";
      variables: ApiGetAiTimeSavingsTimeseriesVariables;
    }
  | {
      path: "/ai/impact/metrics/";
      operationId: "apiGetAiImpactMetrics";
      variables: ApiGetAiImpactMetricsVariables;
    }
  | {
      path: "/ai/tasks/";
      operationId: "listAiTasks";
      variables: ListAiTasksVariables;
    }
  | {
      path: "/ai/tasks/{taskId}/";
      operationId: "retrieveAiTask";
      variables: RetrieveAiTaskVariables;
    }
  | {
      path: "/ai/tasks/{taskId}/embedded-prompts/";
      operationId: "listAiTaskEmbeddedPrompts";
      variables: ListAiTaskEmbeddedPromptsVariables;
    }
  | {
      path: "/ai/tasks/suggestion/suggestions/";
      operationId: "apiSuggestedAiTasks";
      variables: ApiSuggestedAiTasksVariables;
    }
  | {
      path: "/ai/ai_query/";
      operationId: "apiListAiQueries";
      variables: ApiListAiQueriesVariables;
    }
  | {
      path: "/ai/llm_status/status/";
      operationId: "apiLlmStatus";
      variables: ApiLlmStatusVariables;
    }
  | {
      path: "/query/queries/creation_query/{entityId}/";
      operationId: "apiGetCreationQuery";
      variables: ApiGetCreationQueryVariables;
    }
  | {
      path: "/query/queries/v2/workspace/";
      operationId: "apiGetQueries";
      variables: ApiGetQueriesVariables;
    }
  | {
      path: "/query/queries/v2/{entityId}/";
      operationId: "apiGetEntityQueries";
      variables: ApiGetEntityQueriesVariables;
    }
  | {
      path: "/query/queries/v2/{queryId}/executions/";
      operationId: "apiGetQueryExecutions";
      variables: ApiGetQueryExecutionsVariables;
    }
  | {
      path: "/query/queries/v2/{queryId}/metadata/";
      operationId: "apiGetQueryMetadata";
      variables: ApiGetQueryMetadataVariables;
    }
  | {
      path: "/query/queries/v2/{queryId}/charts/";
      operationId: "apiGetQueryCharts";
      variables: ApiGetQueryChartsVariables;
    }
  | {
      path: "/query/joins/{entityId}/";
      operationId: "apiGetEntityJoins";
      variables: ApiGetEntityJoinsVariables;
    }
  | {
      path: "/monitor/incidents/jira/is_jira_integrated/";
      operationId: "isJiraIntegrated";
      variables: IsJiraIntegratedVariables;
    }
  | {
      path: "/monitor/incidents/jira/get_jira_information/";
      operationId: "getJiraInformation";
      variables: GetJiraInformationVariables;
    }
  | {
      path: "/monitor/recommend/supported_monitors/";
      operationId: "apiGetSupportedMonitors";
      variables: ApiGetSupportedMonitorsVariables;
    }
  | {
      path: "/monitor/recommend/supported_integrations/";
      operationId: "apiGetSupportedIntegrations";
      variables: ApiGetSupportedIntegrationsVariables;
    }
  | {
      path: "/monitor/recommend/supported_entities/";
      operationId: "apiGetSupportedEntities";
      variables: ApiGetSupportedEntitiesVariables;
    }
  | {
      path: "/monitor/recommend/dbt_model_names/";
      operationId: "apiGetDbtModelNames";
      variables: ApiGetDbtModelNamesVariables;
    }
  | {
      path: "/monitor/jobs/";
      operationId: "apiGetMonitorJobResources";
      variables: ApiGetMonitorJobResourcesVariables;
    }
  | {
      path: "/monitor/rules/";
      operationId: "listNotificationRules";
      variables: ListNotificationRulesVariables;
    }
  | {
      path: "/monitor/rules/{ruleId}/";
      operationId: "getNotificationRule";
      variables: GetNotificationRuleVariables;
    }
  | {
      path: "/monitor/import/job/{jobId}/";
      operationId: "apiGetJobResult";
      variables: ApiGetJobResultVariables;
    }
  | {
      path: "/monitor/{monitorId}/preview_measurements/";
      operationId: "apiGetMonitorPreviewMeasurements";
      variables: ApiGetMonitorPreviewMeasurementsVariables;
    }
  | {
      path: "/monitor/{monitorId}/related_resources/";
      operationId: "apiGetMonitorRelatedResources";
      variables: ApiGetMonitorRelatedResourcesVariables;
    }
  | {
      path: "/monitor/metrics/";
      operationId: "apiGetMonitorMetrics";
      variables: ApiGetMonitorMetricsVariables;
    }
  | {
      path: "/monitor/timeseries/";
      operationId: "apiGetMonitorTimeseries";
      variables: ApiGetMonitorTimeseriesVariables;
    }
  | {
      path: "/integration/marketplace/specs/";
      operationId: "apiListMarketplaceIntegrationSpecs";
      variables: ApiListMarketplaceIntegrationSpecsVariables;
    }
  | {
      path: "/integration/marketplace/specs/{specId}/";
      operationId: "apiGetMarketplaceIntegrationSpec";
      variables: ApiGetMarketplaceIntegrationSpecVariables;
    }
  | {
      path: "/integration/marketplace/specs/{specId}/versions/";
      operationId: "apiGetMarketplaceIntegrationSpecVersions";
      variables: ApiGetMarketplaceIntegrationSpecVersionsVariables;
    }
  | {
      path: "/integration/marketplace/specs/{specId}/versions/{versionId}/";
      operationId: "apiGetMarketplaceIntegrationSpecVersion";
      variables: ApiGetMarketplaceIntegrationSpecVersionVariables;
    }
  | {
      path: "/integration/marketplace/specs/{specId}/versions/{versionId}/code/";
      operationId: "apiPreviewMarketplaceIntegrationSpecVersionCode";
      variables: ApiPreviewMarketplaceIntegrationSpecVersionCodeVariables;
    }
  | {
      path: "/integration/marketplace/versions_for_review/";
      operationId: "apiListMarketplaceSpecVersionsInternally";
      variables: ApiListMarketplaceSpecVersionsInternallyVariables;
    }
  | {
      path: "/automation/rollbacks/{jobId}/available/";
      operationId: "automationJobRollbackAvailable";
      variables: AutomationJobRollbackAvailableVariables;
    }
  | {
      path: "/automation/history/{jobId}/update_log/";
      operationId: "apiAutomationGetEntityUpdateLog";
      variables: ApiAutomationGetEntityUpdateLogVariables;
    }
  | {
      path: "/automation/metrics/metrics/";
      operationId: "apiGetAutomationMetrics";
      variables: ApiGetAutomationMetricsVariables;
    }
  | {
      path: "/automation/metrics/timeseries/";
      operationId: "apiGetAutomationTimeseries";
      variables: ApiGetAutomationTimeseriesVariables;
    }
  | {
      path: "/automation/automation/{automationId}/";
      operationId: "apiGetAutomation";
      variables: ApiGetAutomationVariables;
    }
  | {
      path: "/automation/automation/{automationId}/daily_ai_output_remaining/";
      operationId: "apiGetAutomationDailyAiOutputRemaining";
      variables: ApiGetAutomationDailyAiOutputRemainingVariables;
    }
  | {
      path: "/automation/automation_job/{automationJobId}/ai_output_resources/";
      operationId: "apiAutomationGetAiOutputResources";
      variables: ApiAutomationGetAiOutputResourcesVariables;
    }
  | {
      path: "/quality/";
      operationId: "retrieveAggregateQuality";
      variables: RetrieveAggregateQualityVariables;
    }
  | {
      path: "/quality/timeseries/";
      operationId: "retrieveTimeseries";
      variables: RetrieveTimeseriesVariables;
    }
  | {
      path: "/quality/suggestions/";
      operationId: "retrieveQualitySuggestions";
      variables: RetrieveQualitySuggestionsVariables;
    }
  | {
      path: "/quality/{entityId}/suggestions/";
      operationId: "retrieveQualityEntitySuggestions";
      variables: RetrieveQualityEntitySuggestionsVariables;
    }
  | {
      path: "/quality/preferences/governance/included/";
      operationId: "getIncludedInQualityGovernance";
      variables: GetIncludedInQualityGovernanceVariables;
    }
  | {
      path: "/quality/preferences/governance/excluded/";
      operationId: "getExcludedFromQualityGovernance";
      variables: GetExcludedFromQualityGovernanceVariables;
    }
  | {
      path: "/extension/product/";
      operationId: "apiGetExtensionProduct";
      variables: ApiGetExtensionProductVariables;
    }
  | {
      path: "/extension/entity/";
      operationId: "apiGetExtensionEntity";
      variables: ApiGetExtensionEntityVariables;
    }
  | {
      path: "/extension/is_product_url/";
      operationId: "apiGetExtensionIsProductUrl";
      variables: ApiGetExtensionIsProductUrlVariables;
    }
  | {
      path: "/extension/dbt_cloud_pattern/";
      operationId: "apiGetExtensionDbtCloudPattern";
      variables: ApiGetExtensionDbtCloudPatternVariables;
    }
  | {
      path: "/audit/{resourceType}/{resourceId}/";
      operationId: "listAuditItems";
      variables: ListAuditItemsVariables;
    }
  | {
      path: "/iam/iam_roles/iam_role/";
      operationId: "apiListIamRoles";
      variables: ApiListIamRolesVariables;
    }
  | {
      path: "/iam/iam_roles/iam_role_with_users/";
      operationId: "apiListIamRolesWithUsers";
      variables: ApiListIamRolesWithUsersVariables;
    }
  | {
      path: "/iam/iam_roles/iam_role/{iamRoleId}/";
      operationId: "apiGetIamRole";
      variables: ApiGetIamRoleVariables;
    }
  | {
      path: "/iam/iam_roles/iam_role/{iamRoleId}/users/";
      operationId: "apiGetIamRoleUsers";
      variables: ApiGetIamRoleUsersVariables;
    }
  | {
      path: "/iam/iam_roles/users/get_user_role/{userId}/";
      operationId: "apiGetUserIamRole";
      variables: ApiGetUserIamRoleVariables;
    }
  | {
      path: "/iam/iam_permissions/";
      operationId: "apiGetPermissionsTree";
      variables: ApiGetPermissionsTreeVariables;
    }
  | {
      path: "/iam/iam_permissions/check_permission/";
      operationId: "apiCheckIamPermission";
      variables: ApiCheckIamPermissionVariables;
    }
  | {
      path: "/iam/iam_permissions/my_permissions/";
      operationId: "apiGetMyPermissions";
      variables: ApiGetMyPermissionsVariables;
    }
  | {
      path: "/iam/iam_resource_policies/resources/{entityId}/role_summary/";
      operationId: "apiGetResourcePermissionsRoleSummary";
      variables: ApiGetResourcePermissionsRoleSummaryVariables;
    }
  | {
      path: "/iam/iam_resource_policies/resources/{entityId}/policies/";
      operationId: "apiGetResourcePolicies";
      variables: ApiGetResourcePoliciesVariables;
    }
  | {
      path: "/activity_log/resource_logs/";
      operationId: "apiListResourceLogs";
      variables: ApiListResourceLogsVariables;
    }
  | {
      path: "/activity_log/audit_logs/";
      operationId: "apiListAuditLogs";
      variables: ApiListAuditLogsVariables;
    }
  | {
      path: "/activity_log/user_logs/";
      operationId: "apiListUserLogs";
      variables: ApiListUserLogsVariables;
    }
  | {
      path: "/version_history/version_histories/";
      operationId: "apiListVersionHistories";
      variables: ApiListVersionHistoriesVariables;
    }
  | {
      path: "/version_history/version_history/";
      operationId: "apiGetVersionHistory";
      variables: ApiGetVersionHistoryVariables;
    }
  | {
      path: "/policy/metrics/";
      operationId: "apiGetPolicyMetrics";
      variables: ApiGetPolicyMetricsVariables;
    }
  | {
      path: "/policy/metrics/timeseries/";
      operationId: "apiGetPolicyTimeseries";
      variables: ApiGetPolicyTimeseriesVariables;
    }
  | {
      path: "/policy/quality/score-history/";
      operationId: "apiGetScoreHistoryForWorkspace";
      variables: ApiGetScoreHistoryForWorkspaceVariables;
    }
  | {
      path: "/policy/entity/{entityId}/";
      operationId: "apiListEntityPolicies";
      variables: ApiListEntityPoliciesVariables;
    }
  | {
      path: "/policy/templates/";
      operationId: "apiListPolicyTemplates";
      variables: ApiListPolicyTemplatesVariables;
    }
  | {
      path: "/policy/data-scanning-templates/";
      operationId: "apiGetPolicyTemplates";
      variables: ApiGetPolicyTemplatesVariables;
    }
  | {
      path: "/policy/classifiers/{type}/";
      operationId: "apiListClassifiers";
      variables: ApiListClassifiersVariables;
    }
  | {
      path: "/policy/";
      operationId: "apiListPolicies";
      variables: ApiListPoliciesVariables;
    }
  | {
      path: "/policy/{policyId}/";
      operationId: "apiGetPolicy";
      variables: ApiGetPolicyVariables;
    }
  | {
      path: "/policy/{policyId}/issues/";
      operationId: "apiListPolicyIssues";
      variables: ApiListPolicyIssuesVariables;
    }
  | {
      path: "/policy/{policyId}/results/";
      operationId: "apiListPolicyResults";
      variables: ApiListPolicyResultsVariables;
    }
  | {
      path: "/policy/{policyId}/rules/";
      operationId: "apiListPolicyRules";
      variables: ApiListPolicyRulesVariables;
    }
  | {
      path: "/policy/results/{entityId}/";
      operationId: "apiListEntityResultsByPolicy";
      variables: ApiListEntityResultsByPolicyVariables;
    }
  | {
      path: "/policy/result/{resultId}/";
      operationId: "apiGetPolicyResult";
      variables: ApiGetPolicyResultVariables;
    }
  | {
      path: "/intelligence/bi_metrics/{biMetricId}/";
      operationId: "apiGetBiMetric";
      variables: ApiGetBiMetricVariables;
    }
  | {
      path: "/intelligence/bi_metrics/{biMetricId}/dashboards/";
      operationId: "apiGetBiMetricDashboards";
      variables: ApiGetBiMetricDashboardsVariables;
    }
  | {
      path: "/intelligence/bi_dashboards/{biDashboardId}/";
      operationId: "apiGetBiDashboard";
      variables: ApiGetBiDashboardVariables;
    }
  | {
      path: "/intelligence/bi_metric_versions/{biMetricVersionId}/";
      operationId: "apiGetBiMetricVersion";
      variables: ApiGetBiMetricVersionVariables;
    };
